(function () {
  'use strict';

  var global$1 = (typeof global !== "undefined" ? global :
    typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window : {});

  /*!
   * Vue.js v2.6.12
   * (c) 2014-2020 Evan You
   * Released under the MIT License.
   */
  /*  */

  var emptyObject$1 = Object.freeze({});

  // These helpers produce better VM code in JS engines due to their
  // explicitness and function inlining.
  function isUndef$1 (v) {
    return v === undefined || v === null
  }

  function isDef$1 (v) {
    return v !== undefined && v !== null
  }

  function isTrue$1 (v) {
    return v === true
  }

  function isFalse$1 (v) {
    return v === false
  }

  /**
   * Check if value is primitive.
   */
  function isPrimitive$1 (value) {
    return (
      typeof value === 'string' ||
      typeof value === 'number' ||
      // $flow-disable-line
      typeof value === 'symbol' ||
      typeof value === 'boolean'
    )
  }

  /**
   * Quick object check - this is primarily used to tell
   * Objects from primitive values when we know the value
   * is a JSON-compliant type.
   */
  function isObject$6 (obj) {
    return obj !== null && typeof obj === 'object'
  }

  /**
   * Get the raw type string of a value, e.g., [object Object].
   */
  var _toString$1 = Object.prototype.toString;

  function toRawType$1 (value) {
    return _toString$1.call(value).slice(8, -1)
  }

  /**
   * Strict object type check. Only returns true
   * for plain JavaScript objects.
   */
  function isPlainObject$2 (obj) {
    return _toString$1.call(obj) === '[object Object]'
  }

  function isRegExp$1 (v) {
    return _toString$1.call(v) === '[object RegExp]'
  }

  /**
   * Check if val is a valid array index.
   */
  function isValidArrayIndex$1 (val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val)
  }

  function isPromise$2 (val) {
    return (
      isDef$1(val) &&
      typeof val.then === 'function' &&
      typeof val.catch === 'function'
    )
  }

  /**
   * Convert a value to a string that is actually rendered.
   */
  function toString$2 (val) {
    return val == null
      ? ''
      : Array.isArray(val) || (isPlainObject$2(val) && val.toString === _toString$1)
        ? JSON.stringify(val, null, 2)
        : String(val)
  }

  /**
   * Convert an input value to a number for persistence.
   * If the conversion fails, return original string.
   */
  function toNumber$3 (val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n
  }

  /**
   * Make a map and return a function for checking if a key
   * is in that map.
   */
  function makeMap$1 (
    str,
    expectsLowerCase
  ) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
      map[list[i]] = true;
    }
    return expectsLowerCase
      ? function (val) { return map[val.toLowerCase()]; }
      : function (val) { return map[val]; }
  }

  /**
   * Check if a tag is a built-in tag.
   */
  var isBuiltInTag$1 = makeMap$1('slot,component', true);

  /**
   * Check if an attribute is a reserved attribute.
   */
  var isReservedAttribute$1 = makeMap$1('key,ref,slot,slot-scope,is');

  /**
   * Remove an item from an array.
   */
  function remove$3 (arr, item) {
    if (arr.length) {
      var index = arr.indexOf(item);
      if (index > -1) {
        return arr.splice(index, 1)
      }
    }
  }

  /**
   * Check whether an object has the property.
   */
  var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
  function hasOwn$1 (obj, key) {
    return hasOwnProperty$2.call(obj, key)
  }

  /**
   * Create a cached version of a pure function.
   */
  function cached$1 (fn) {
    var cache = Object.create(null);
    return (function cachedFn (str) {
      var hit = cache[str];
      return hit || (cache[str] = fn(str))
    })
  }

  /**
   * Camelize a hyphen-delimited string.
   */
  var camelizeRE$1 = /-(\w)/g;
  var camelize$1 = cached$1(function (str) {
    return str.replace(camelizeRE$1, function (_, c) { return c ? c.toUpperCase() : ''; })
  });

  /**
   * Capitalize a string.
   */
  var capitalize$1 = cached$1(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  });

  /**
   * Hyphenate a camelCase string.
   */
  var hyphenateRE$1 = /\B([A-Z])/g;
  var hyphenate$1 = cached$1(function (str) {
    return str.replace(hyphenateRE$1, '-$1').toLowerCase()
  });

  /**
   * Simple bind polyfill for environments that do not support it,
   * e.g., PhantomJS 1.x. Technically, we don't need this anymore
   * since native bind is now performant enough in most browsers.
   * But removing it would mean breaking code that was able to run in
   * PhantomJS 1.x, so this must be kept for backward compatibility.
   */

  /* istanbul ignore next */
  function polyfillBind$1 (fn, ctx) {
    function boundFn (a) {
      var l = arguments.length;
      return l
        ? l > 1
          ? fn.apply(ctx, arguments)
          : fn.call(ctx, a)
        : fn.call(ctx)
    }

    boundFn._length = fn.length;
    return boundFn
  }

  function nativeBind$1 (fn, ctx) {
    return fn.bind(ctx)
  }

  var bind$4 = Function.prototype.bind
    ? nativeBind$1
    : polyfillBind$1;

  /**
   * Convert an Array-like object to a real Array.
   */
  function toArray$1 (list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
      ret[i] = list[i + start];
    }
    return ret
  }

  /**
   * Mix properties into target object.
   */
  function extend$2 (to, _from) {
    for (var key in _from) {
      to[key] = _from[key];
    }
    return to
  }

  /**
   * Merge an Array of Objects into a single Object.
   */
  function toObject$1 (arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
      if (arr[i]) {
        extend$2(res, arr[i]);
      }
    }
    return res
  }

  /* eslint-disable no-unused-vars */

  /**
   * Perform no operation.
   * Stubbing args to make Flow happy without leaving useless transpiled code
   * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
   */
  function noop$2 (a, b, c) {}

  /**
   * Always return false.
   */
  var no$1 = function (a, b, c) { return false; };

  /* eslint-enable no-unused-vars */

  /**
   * Return the same value.
   */
  var identity$1 = function (_) { return _; };

  /**
   * Check if two values are loosely equal - that is,
   * if they are plain objects, do they have the same shape?
   */
  function looseEqual$1 (a, b) {
    if (a === b) { return true }
    var isObjectA = isObject$6(a);
    var isObjectB = isObject$6(b);
    if (isObjectA && isObjectB) {
      try {
        var isArrayA = Array.isArray(a);
        var isArrayB = Array.isArray(b);
        if (isArrayA && isArrayB) {
          return a.length === b.length && a.every(function (e, i) {
            return looseEqual$1(e, b[i])
          })
        } else if (a instanceof Date && b instanceof Date) {
          return a.getTime() === b.getTime()
        } else if (!isArrayA && !isArrayB) {
          var keysA = Object.keys(a);
          var keysB = Object.keys(b);
          return keysA.length === keysB.length && keysA.every(function (key) {
            return looseEqual$1(a[key], b[key])
          })
        } else {
          /* istanbul ignore next */
          return false
        }
      } catch (e) {
        /* istanbul ignore next */
        return false
      }
    } else if (!isObjectA && !isObjectB) {
      return String(a) === String(b)
    } else {
      return false
    }
  }

  /**
   * Return the first index at which a loosely equal value can be
   * found in the array (if value is a plain object, the array must
   * contain an object of the same shape), or -1 if it is not present.
   */
  function looseIndexOf$1 (arr, val) {
    for (var i = 0; i < arr.length; i++) {
      if (looseEqual$1(arr[i], val)) { return i }
    }
    return -1
  }

  /**
   * Ensure a function is called only once.
   */
  function once$2 (fn) {
    var called = false;
    return function () {
      if (!called) {
        called = true;
        fn.apply(this, arguments);
      }
    }
  }

  var SSR_ATTR$1 = 'data-server-rendered';

  var ASSET_TYPES$1 = [
    'component',
    'directive',
    'filter'
  ];

  var LIFECYCLE_HOOKS$1 = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch'
  ];

  /*  */



  var config$2 = ({
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),

    /**
     * Whether to suppress warnings.
     */
    silent: false,

    /**
     * Show production mode tip message on boot?
     */
    productionTip: "development" !== 'production',

    /**
     * Whether to enable devtools
     */
    devtools: "development" !== 'production',

    /**
     * Whether to record perf
     */
    performance: false,

    /**
     * Error handler for watcher errors
     */
    errorHandler: null,

    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,

    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],

    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),

    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no$1,

    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no$1,

    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no$1,

    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop$2,

    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity$1,

    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no$1,

    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,

    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS$1
  });

  /*  */

  /**
   * unicode letters used for parsing html tags, component names and property paths.
   * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
   * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
   */
  var unicodeRegExp$1 = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

  /**
   * Check if a string starts with $ or _
   */
  function isReserved$1 (str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5F
  }

  /**
   * Define a property.
   */
  function def$1 (obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
      value: val,
      enumerable: !!enumerable,
      writable: true,
      configurable: true
    });
  }

  /**
   * Parse simple path.
   */
  var bailRE$1 = new RegExp(("[^" + (unicodeRegExp$1.source) + ".$_\\d]"));
  function parsePath$1 (path) {
    if (bailRE$1.test(path)) {
      return
    }
    var segments = path.split('.');
    return function (obj) {
      for (var i = 0; i < segments.length; i++) {
        if (!obj) { return }
        obj = obj[segments[i]];
      }
      return obj
    }
  }

  /*  */

  // can we use __proto__?
  var hasProto$1 = '__proto__' in {};

  // Browser environment sniffing
  var inBrowser$1 = typeof window !== 'undefined';
  var inWeex$1 = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
  var weexPlatform$1 = inWeex$1 && WXEnvironment.platform.toLowerCase();
  var UA$1 = inBrowser$1 && window.navigator.userAgent.toLowerCase();
  var isIE$1 = UA$1 && /msie|trident/.test(UA$1);
  var isIE9$1 = UA$1 && UA$1.indexOf('msie 9.0') > 0;
  var isEdge$1 = UA$1 && UA$1.indexOf('edge/') > 0;
  (UA$1 && UA$1.indexOf('android') > 0) || (weexPlatform$1 === 'android');
  var isIOS$1 = (UA$1 && /iphone|ipad|ipod|ios/.test(UA$1)) || (weexPlatform$1 === 'ios');
  var isFF$1 = UA$1 && UA$1.match(/firefox\/(\d+)/);

  // Firefox has a "watch" function on Object.prototype...
  var nativeWatch$1 = ({}).watch;

  var supportsPassive$1 = false;
  if (inBrowser$1) {
    try {
      var opts$1 = {};
      Object.defineProperty(opts$1, 'passive', ({
        get: function get () {
          /* istanbul ignore next */
          supportsPassive$1 = true;
        }
      })); // https://github.com/facebook/flow/issues/285
      window.addEventListener('test-passive', null, opts$1);
    } catch (e) {}
  }

  // this needs to be lazy-evaled because vue may be required before
  // vue-server-renderer can set VUE_ENV
  var _isServer$1;
  var isServerRendering$1 = function () {
    if (_isServer$1 === undefined) {
      /* istanbul ignore if */
      if (!inBrowser$1 && !inWeex$1 && typeof global$1 !== 'undefined') {
        // detect presence of vue-server-renderer and avoid
        // Webpack shimming the process
        _isServer$1 = global$1['process'] && global$1['process'].env.VUE_ENV === 'server';
      } else {
        _isServer$1 = false;
      }
    }
    return _isServer$1
  };

  // detect devtools
  var devtools$1 = inBrowser$1 && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

  /* istanbul ignore next */
  function isNative$1 (Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
  }

  var hasSymbol$1 =
    typeof Symbol !== 'undefined' && isNative$1(Symbol) &&
    typeof Reflect !== 'undefined' && isNative$1(Reflect.ownKeys);

  var _Set$1;
  /* istanbul ignore if */ // $flow-disable-line
  if (typeof Set !== 'undefined' && isNative$1(Set)) {
    // use native Set when available.
    _Set$1 = Set;
  } else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set$1 = /*@__PURE__*/(function () {
      function Set () {
        this.set = Object.create(null);
      }
      Set.prototype.has = function has (key) {
        return this.set[key] === true
      };
      Set.prototype.add = function add (key) {
        this.set[key] = true;
      };
      Set.prototype.clear = function clear () {
        this.set = Object.create(null);
      };

      return Set;
    }());
  }

  /*  */

  var warn$3 = noop$2;
  var tip$1 = noop$2;
  var generateComponentTrace$1 = (noop$2); // work around flow check
  var formatComponentName$1 = (noop$2);

  {
    var hasConsole$1 = typeof console !== 'undefined';
    var classifyRE$1 = /(?:^|[-_])(\w)/g;
    var classify$1 = function (str) { return str
      .replace(classifyRE$1, function (c) { return c.toUpperCase(); })
      .replace(/[-_]/g, ''); };

    warn$3 = function (msg, vm) {
      var trace = vm ? generateComponentTrace$1(vm) : '';

      if (config$2.warnHandler) {
        config$2.warnHandler.call(null, msg, vm, trace);
      } else if (hasConsole$1 && (!config$2.silent)) {
        console.error(("[Vue warn]: " + msg + trace));
      }
    };

    tip$1 = function (msg, vm) {
      if (hasConsole$1 && (!config$2.silent)) {
        console.warn("[Vue tip]: " + msg + (
          vm ? generateComponentTrace$1(vm) : ''
        ));
      }
    };

    formatComponentName$1 = function (vm, includeFile) {
      if (vm.$root === vm) {
        return '<Root>'
      }
      var options = typeof vm === 'function' && vm.cid != null
        ? vm.options
        : vm._isVue
          ? vm.$options || vm.constructor.options
          : vm;
      var name = options.name || options._componentTag;
      var file = options.__file;
      if (!name && file) {
        var match = file.match(/([^/\\]+)\.vue$/);
        name = match && match[1];
      }

      return (
        (name ? ("<" + (classify$1(name)) + ">") : "<Anonymous>") +
        (file && includeFile !== false ? (" at " + file) : '')
      )
    };

    var repeat$2 = function (str, n) {
      var res = '';
      while (n) {
        if (n % 2 === 1) { res += str; }
        if (n > 1) { str += str; }
        n >>= 1;
      }
      return res
    };

    generateComponentTrace$1 = function (vm) {
      if (vm._isVue && vm.$parent) {
        var tree = [];
        var currentRecursiveSequence = 0;
        while (vm) {
          if (tree.length > 0) {
            var last = tree[tree.length - 1];
            if (last.constructor === vm.constructor) {
              currentRecursiveSequence++;
              vm = vm.$parent;
              continue
            } else if (currentRecursiveSequence > 0) {
              tree[tree.length - 1] = [last, currentRecursiveSequence];
              currentRecursiveSequence = 0;
            }
          }
          tree.push(vm);
          vm = vm.$parent;
        }
        return '\n\nfound in\n\n' + tree
          .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat$2(' ', 5 + i * 2)) + (Array.isArray(vm)
              ? ((formatComponentName$1(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
              : formatComponentName$1(vm))); })
          .join('\n')
      } else {
        return ("\n\n(found in " + (formatComponentName$1(vm)) + ")")
      }
    };
  }

  /*  */

  var uid$1 = 0;

  /**
   * A dep is an observable that can have multiple
   * directives subscribing to it.
   */
  var Dep$1 = function Dep () {
    this.id = uid$1++;
    this.subs = [];
  };

  Dep$1.prototype.addSub = function addSub (sub) {
    this.subs.push(sub);
  };

  Dep$1.prototype.removeSub = function removeSub (sub) {
    remove$3(this.subs, sub);
  };

  Dep$1.prototype.depend = function depend () {
    if (Dep$1.target) {
      Dep$1.target.addDep(this);
    }
  };

  Dep$1.prototype.notify = function notify () {
    // stabilize the subscriber list first
    var subs = this.subs.slice();
    if (!config$2.async) {
      // subs aren't sorted in scheduler if not running async
      // we need to sort them now to make sure they fire in correct
      // order
      subs.sort(function (a, b) { return a.id - b.id; });
    }
    for (var i = 0, l = subs.length; i < l; i++) {
      subs[i].update();
    }
  };

  // The current target watcher being evaluated.
  // This is globally unique because only one watcher
  // can be evaluated at a time.
  Dep$1.target = null;
  var targetStack$1 = [];

  function pushTarget$1 (target) {
    targetStack$1.push(target);
    Dep$1.target = target;
  }

  function popTarget$1 () {
    targetStack$1.pop();
    Dep$1.target = targetStack$1[targetStack$1.length - 1];
  }

  /*  */

  var VNode$1 = function VNode (
    tag,
    data,
    children,
    text,
    elm,
    context,
    componentOptions,
    asyncFactory
  ) {
    this.tag = tag;
    this.data = data;
    this.children = children;
    this.text = text;
    this.elm = elm;
    this.ns = undefined;
    this.context = context;
    this.fnContext = undefined;
    this.fnOptions = undefined;
    this.fnScopeId = undefined;
    this.key = data && data.key;
    this.componentOptions = componentOptions;
    this.componentInstance = undefined;
    this.parent = undefined;
    this.raw = false;
    this.isStatic = false;
    this.isRootInsert = true;
    this.isComment = false;
    this.isCloned = false;
    this.isOnce = false;
    this.asyncFactory = asyncFactory;
    this.asyncMeta = undefined;
    this.isAsyncPlaceholder = false;
  };

  var prototypeAccessors$3 = { child: { configurable: true } };

  // DEPRECATED: alias for componentInstance for backwards compat.
  /* istanbul ignore next */
  prototypeAccessors$3.child.get = function () {
    return this.componentInstance
  };

  Object.defineProperties( VNode$1.prototype, prototypeAccessors$3 );

  var createEmptyVNode$1 = function (text) {
    if ( text === void 0 ) text = '';

    var node = new VNode$1();
    node.text = text;
    node.isComment = true;
    return node
  };

  function createTextVNode$1 (val) {
    return new VNode$1(undefined, undefined, undefined, String(val))
  }

  // optimized shallow clone
  // used for static nodes and slot nodes because they may be reused across
  // multiple renders, cloning them avoids errors when DOM manipulations rely
  // on their elm reference.
  function cloneVNode$1 (vnode) {
    var cloned = new VNode$1(
      vnode.tag,
      vnode.data,
      // #7975
      // clone children array to avoid mutating original in case of cloning
      // a child.
      vnode.children && vnode.children.slice(),
      vnode.text,
      vnode.elm,
      vnode.context,
      vnode.componentOptions,
      vnode.asyncFactory
    );
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned
  }

  /*
   * not type checking this file because flow doesn't play well with
   * dynamically accessing methods on Array prototype
   */

  var arrayProto$1 = Array.prototype;
  var arrayMethods$1 = Object.create(arrayProto$1);

  var methodsToPatch$1 = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
  ];

  /**
   * Intercept mutating methods and emit events
   */
  methodsToPatch$1.forEach(function (method) {
    // cache original method
    var original = arrayProto$1[method];
    def$1(arrayMethods$1, method, function mutator () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var result = original.apply(this, args);
      var ob = this.__ob__;
      var inserted;
      switch (method) {
        case 'push':
        case 'unshift':
          inserted = args;
          break
        case 'splice':
          inserted = args.slice(2);
          break
      }
      if (inserted) { ob.observeArray(inserted); }
      // notify change
      ob.dep.notify();
      return result
    });
  });

  /*  */

  var arrayKeys$1 = Object.getOwnPropertyNames(arrayMethods$1);

  /**
   * In some cases we may want to disable observation inside a component's
   * update computation.
   */
  var shouldObserve$1 = true;

  function toggleObserving$1 (value) {
    shouldObserve$1 = value;
  }

  /**
   * Observer class that is attached to each observed
   * object. Once attached, the observer converts the target
   * object's property keys into getter/setters that
   * collect dependencies and dispatch updates.
   */
  var Observer$1 = function Observer (value) {
    this.value = value;
    this.dep = new Dep$1();
    this.vmCount = 0;
    def$1(value, '__ob__', this);
    if (Array.isArray(value)) {
      if (hasProto$1) {
        protoAugment$1(value, arrayMethods$1);
      } else {
        copyAugment$1(value, arrayMethods$1, arrayKeys$1);
      }
      this.observeArray(value);
    } else {
      this.walk(value);
    }
  };

  /**
   * Walk through all properties and convert them into
   * getter/setters. This method should only be called when
   * value type is Object.
   */
  Observer$1.prototype.walk = function walk (obj) {
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      defineReactive$$1$1(obj, keys[i]);
    }
  };

  /**
   * Observe a list of Array items.
   */
  Observer$1.prototype.observeArray = function observeArray (items) {
    for (var i = 0, l = items.length; i < l; i++) {
      observe$1(items[i]);
    }
  };

  // helpers

  /**
   * Augment a target Object or Array by intercepting
   * the prototype chain using __proto__
   */
  function protoAugment$1 (target, src) {
    /* eslint-disable no-proto */
    target.__proto__ = src;
    /* eslint-enable no-proto */
  }

  /**
   * Augment a target Object or Array by defining
   * hidden properties.
   */
  /* istanbul ignore next */
  function copyAugment$1 (target, src, keys) {
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      def$1(target, key, src[key]);
    }
  }

  /**
   * Attempt to create an observer instance for a value,
   * returns the new observer if successfully observed,
   * or the existing observer if the value already has one.
   */
  function observe$1 (value, asRootData) {
    if (!isObject$6(value) || value instanceof VNode$1) {
      return
    }
    var ob;
    if (hasOwn$1(value, '__ob__') && value.__ob__ instanceof Observer$1) {
      ob = value.__ob__;
    } else if (
      shouldObserve$1 &&
      !isServerRendering$1() &&
      (Array.isArray(value) || isPlainObject$2(value)) &&
      Object.isExtensible(value) &&
      !value._isVue
    ) {
      ob = new Observer$1(value);
    }
    if (asRootData && ob) {
      ob.vmCount++;
    }
    return ob
  }

  /**
   * Define a reactive property on an Object.
   */
  function defineReactive$$1$1 (
    obj,
    key,
    val,
    customSetter,
    shallow
  ) {
    var dep = new Dep$1();

    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
      return
    }

    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) && arguments.length === 2) {
      val = obj[key];
    }

    var childOb = !shallow && observe$1(val);
    Object.defineProperty(obj, key, {
      enumerable: true,
      configurable: true,
      get: function reactiveGetter () {
        var value = getter ? getter.call(obj) : val;
        if (Dep$1.target) {
          dep.depend();
          if (childOb) {
            childOb.dep.depend();
            if (Array.isArray(value)) {
              dependArray$1(value);
            }
          }
        }
        return value
      },
      set: function reactiveSetter (newVal) {
        var value = getter ? getter.call(obj) : val;
        /* eslint-disable no-self-compare */
        if (newVal === value || (newVal !== newVal && value !== value)) {
          return
        }
        /* eslint-enable no-self-compare */
        if (customSetter) {
          customSetter();
        }
        // #7981: for accessor properties without setter
        if (getter && !setter) { return }
        if (setter) {
          setter.call(obj, newVal);
        } else {
          val = newVal;
        }
        childOb = !shallow && observe$1(newVal);
        dep.notify();
      }
    });
  }

  /**
   * Set a property on an object. Adds the new property and
   * triggers change notification if the property doesn't
   * already exist.
   */
  function set$1 (target, key, val) {
    if ((isUndef$1(target) || isPrimitive$1(target))
    ) {
      warn$3(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
    }
    if (Array.isArray(target) && isValidArrayIndex$1(key)) {
      target.length = Math.max(target.length, key);
      target.splice(key, 1, val);
      return val
    }
    if (key in target && !(key in Object.prototype)) {
      target[key] = val;
      return val
    }
    var ob = (target).__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
      warn$3(
        'Avoid adding reactive properties to a Vue instance or its root $data ' +
        'at runtime - declare it upfront in the data option.'
      );
      return val
    }
    if (!ob) {
      target[key] = val;
      return val
    }
    defineReactive$$1$1(ob.value, key, val);
    ob.dep.notify();
    return val
  }

  /**
   * Delete a property and trigger change if necessary.
   */
  function del$1 (target, key) {
    if ((isUndef$1(target) || isPrimitive$1(target))
    ) {
      warn$3(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
    }
    if (Array.isArray(target) && isValidArrayIndex$1(key)) {
      target.splice(key, 1);
      return
    }
    var ob = (target).__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
      warn$3(
        'Avoid deleting properties on a Vue instance or its root $data ' +
        '- just set it to null.'
      );
      return
    }
    if (!hasOwn$1(target, key)) {
      return
    }
    delete target[key];
    if (!ob) {
      return
    }
    ob.dep.notify();
  }

  /**
   * Collect dependencies on array elements when the array is touched, since
   * we cannot intercept array element access like property getters.
   */
  function dependArray$1 (value) {
    for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
      e = value[i];
      e && e.__ob__ && e.__ob__.dep.depend();
      if (Array.isArray(e)) {
        dependArray$1(e);
      }
    }
  }

  /*  */

  /**
   * Option overwriting strategies are functions that handle
   * how to merge a parent option value and a child option
   * value into the final value.
   */
  var strats$1 = config$2.optionMergeStrategies;

  /**
   * Options with restrictions
   */
  {
    strats$1.el = strats$1.propsData = function (parent, child, vm, key) {
      if (!vm) {
        warn$3(
          "option \"" + key + "\" can only be used during instance " +
          'creation with the `new` keyword.'
        );
      }
      return defaultStrat$1(parent, child)
    };
  }

  /**
   * Helper that recursively merges two data objects together.
   */
  function mergeData$1 (to, from) {
    if (!from) { return to }
    var key, toVal, fromVal;

    var keys = hasSymbol$1
      ? Reflect.ownKeys(from)
      : Object.keys(from);

    for (var i = 0; i < keys.length; i++) {
      key = keys[i];
      // in case the object is already observed...
      if (key === '__ob__') { continue }
      toVal = to[key];
      fromVal = from[key];
      if (!hasOwn$1(to, key)) {
        set$1(to, key, fromVal);
      } else if (
        toVal !== fromVal &&
        isPlainObject$2(toVal) &&
        isPlainObject$2(fromVal)
      ) {
        mergeData$1(toVal, fromVal);
      }
    }
    return to
  }

  /**
   * Data
   */
  function mergeDataOrFn$1 (
    parentVal,
    childVal,
    vm
  ) {
    if (!vm) {
      // in a Vue.extend merge, both should be functions
      if (!childVal) {
        return parentVal
      }
      if (!parentVal) {
        return childVal
      }
      // when parentVal & childVal are both present,
      // we need to return a function that returns the
      // merged result of both functions... no need to
      // check if parentVal is a function here because
      // it has to be a function to pass previous merges.
      return function mergedDataFn () {
        return mergeData$1(
          typeof childVal === 'function' ? childVal.call(this, this) : childVal,
          typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
        )
      }
    } else {
      return function mergedInstanceDataFn () {
        // instance merge
        var instanceData = typeof childVal === 'function'
          ? childVal.call(vm, vm)
          : childVal;
        var defaultData = typeof parentVal === 'function'
          ? parentVal.call(vm, vm)
          : parentVal;
        if (instanceData) {
          return mergeData$1(instanceData, defaultData)
        } else {
          return defaultData
        }
      }
    }
  }

  strats$1.data = function (
    parentVal,
    childVal,
    vm
  ) {
    if (!vm) {
      if (childVal && typeof childVal !== 'function') {
        warn$3(
          'The "data" option should be a function ' +
          'that returns a per-instance value in component ' +
          'definitions.',
          vm
        );

        return parentVal
      }
      return mergeDataOrFn$1(parentVal, childVal)
    }

    return mergeDataOrFn$1(parentVal, childVal, vm)
  };

  /**
   * Hooks and props are merged as arrays.
   */
  function mergeHook$2 (
    parentVal,
    childVal
  ) {
    var res = childVal
      ? parentVal
        ? parentVal.concat(childVal)
        : Array.isArray(childVal)
          ? childVal
          : [childVal]
      : parentVal;
    return res
      ? dedupeHooks$1(res)
      : res
  }

  function dedupeHooks$1 (hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
      if (res.indexOf(hooks[i]) === -1) {
        res.push(hooks[i]);
      }
    }
    return res
  }

  LIFECYCLE_HOOKS$1.forEach(function (hook) {
    strats$1[hook] = mergeHook$2;
  });

  /**
   * Assets
   *
   * When a vm is present (instance creation), we need to do
   * a three-way merge between constructor options, instance
   * options and parent options.
   */
  function mergeAssets$1 (
    parentVal,
    childVal,
    vm,
    key
  ) {
    var res = Object.create(parentVal || null);
    if (childVal) {
      assertObjectType$1(key, childVal, vm);
      return extend$2(res, childVal)
    } else {
      return res
    }
  }

  ASSET_TYPES$1.forEach(function (type) {
    strats$1[type + 's'] = mergeAssets$1;
  });

  /**
   * Watchers.
   *
   * Watchers hashes should not overwrite one
   * another, so we merge them as arrays.
   */
  strats$1.watch = function (
    parentVal,
    childVal,
    vm,
    key
  ) {
    // work around Firefox's Object.prototype.watch...
    if (parentVal === nativeWatch$1) { parentVal = undefined; }
    if (childVal === nativeWatch$1) { childVal = undefined; }
    /* istanbul ignore if */
    if (!childVal) { return Object.create(parentVal || null) }
    {
      assertObjectType$1(key, childVal, vm);
    }
    if (!parentVal) { return childVal }
    var ret = {};
    extend$2(ret, parentVal);
    for (var key$1 in childVal) {
      var parent = ret[key$1];
      var child = childVal[key$1];
      if (parent && !Array.isArray(parent)) {
        parent = [parent];
      }
      ret[key$1] = parent
        ? parent.concat(child)
        : Array.isArray(child) ? child : [child];
    }
    return ret
  };

  /**
   * Other object hashes.
   */
  strats$1.props =
  strats$1.methods =
  strats$1.inject =
  strats$1.computed = function (
    parentVal,
    childVal,
    vm,
    key
  ) {
    if (childVal && "development" !== 'production') {
      assertObjectType$1(key, childVal, vm);
    }
    if (!parentVal) { return childVal }
    var ret = Object.create(null);
    extend$2(ret, parentVal);
    if (childVal) { extend$2(ret, childVal); }
    return ret
  };
  strats$1.provide = mergeDataOrFn$1;

  /**
   * Default strategy.
   */
  var defaultStrat$1 = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };

  /**
   * Validate component names
   */
  function checkComponents$1 (options) {
    for (var key in options.components) {
      validateComponentName$1(key);
    }
  }

  function validateComponentName$1 (name) {
    if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp$1.source) + "]*$")).test(name)) {
      warn$3(
        'Invalid component name: "' + name + '". Component names ' +
        'should conform to valid custom element name in html5 specification.'
      );
    }
    if (isBuiltInTag$1(name) || config$2.isReservedTag(name)) {
      warn$3(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + name
      );
    }
  }

  /**
   * Ensure all props option syntax are normalized into the
   * Object-based format.
   */
  function normalizeProps$1 (options, vm) {
    var props = options.props;
    if (!props) { return }
    var res = {};
    var i, val, name;
    if (Array.isArray(props)) {
      i = props.length;
      while (i--) {
        val = props[i];
        if (typeof val === 'string') {
          name = camelize$1(val);
          res[name] = { type: null };
        } else {
          warn$3('props must be strings when using array syntax.');
        }
      }
    } else if (isPlainObject$2(props)) {
      for (var key in props) {
        val = props[key];
        name = camelize$1(key);
        res[name] = isPlainObject$2(val)
          ? val
          : { type: val };
      }
    } else {
      warn$3(
        "Invalid value for option \"props\": expected an Array or an Object, " +
        "but got " + (toRawType$1(props)) + ".",
        vm
      );
    }
    options.props = res;
  }

  /**
   * Normalize all injections into Object-based format
   */
  function normalizeInject$1 (options, vm) {
    var inject = options.inject;
    if (!inject) { return }
    var normalized = options.inject = {};
    if (Array.isArray(inject)) {
      for (var i = 0; i < inject.length; i++) {
        normalized[inject[i]] = { from: inject[i] };
      }
    } else if (isPlainObject$2(inject)) {
      for (var key in inject) {
        var val = inject[key];
        normalized[key] = isPlainObject$2(val)
          ? extend$2({ from: key }, val)
          : { from: val };
      }
    } else {
      warn$3(
        "Invalid value for option \"inject\": expected an Array or an Object, " +
        "but got " + (toRawType$1(inject)) + ".",
        vm
      );
    }
  }

  /**
   * Normalize raw function directives into object format.
   */
  function normalizeDirectives$2 (options) {
    var dirs = options.directives;
    if (dirs) {
      for (var key in dirs) {
        var def$$1 = dirs[key];
        if (typeof def$$1 === 'function') {
          dirs[key] = { bind: def$$1, update: def$$1 };
        }
      }
    }
  }

  function assertObjectType$1 (name, value, vm) {
    if (!isPlainObject$2(value)) {
      warn$3(
        "Invalid value for option \"" + name + "\": expected an Object, " +
        "but got " + (toRawType$1(value)) + ".",
        vm
      );
    }
  }

  /**
   * Merge two option objects into a new one.
   * Core utility used in both instantiation and inheritance.
   */
  function mergeOptions$1 (
    parent,
    child,
    vm
  ) {
    {
      checkComponents$1(child);
    }

    if (typeof child === 'function') {
      child = child.options;
    }

    normalizeProps$1(child, vm);
    normalizeInject$1(child, vm);
    normalizeDirectives$2(child);

    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
      if (child.extends) {
        parent = mergeOptions$1(parent, child.extends, vm);
      }
      if (child.mixins) {
        for (var i = 0, l = child.mixins.length; i < l; i++) {
          parent = mergeOptions$1(parent, child.mixins[i], vm);
        }
      }
    }

    var options = {};
    var key;
    for (key in parent) {
      mergeField(key);
    }
    for (key in child) {
      if (!hasOwn$1(parent, key)) {
        mergeField(key);
      }
    }
    function mergeField (key) {
      var strat = strats$1[key] || defaultStrat$1;
      options[key] = strat(parent[key], child[key], vm, key);
    }
    return options
  }

  /**
   * Resolve an asset.
   * This function is used because child instances need access
   * to assets defined in its ancestor chain.
   */
  function resolveAsset$1 (
    options,
    type,
    id,
    warnMissing
  ) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
      return
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn$1(assets, id)) { return assets[id] }
    var camelizedId = camelize$1(id);
    if (hasOwn$1(assets, camelizedId)) { return assets[camelizedId] }
    var PascalCaseId = capitalize$1(camelizedId);
    if (hasOwn$1(assets, PascalCaseId)) { return assets[PascalCaseId] }
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (warnMissing && !res) {
      warn$3(
        'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
        options
      );
    }
    return res
  }

  /*  */



  function validateProp$1 (
    key,
    propOptions,
    propsData,
    vm
  ) {
    var prop = propOptions[key];
    var absent = !hasOwn$1(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex$1(Boolean, prop.type);
    if (booleanIndex > -1) {
      if (absent && !hasOwn$1(prop, 'default')) {
        value = false;
      } else if (value === '' || value === hyphenate$1(key)) {
        // only cast empty string / same name to boolean if
        // boolean has higher priority
        var stringIndex = getTypeIndex$1(String, prop.type);
        if (stringIndex < 0 || booleanIndex < stringIndex) {
          value = true;
        }
      }
    }
    // check default value
    if (value === undefined) {
      value = getPropDefaultValue$1(vm, prop, key);
      // since the default value is a fresh copy,
      // make sure to observe it.
      var prevShouldObserve = shouldObserve$1;
      toggleObserving$1(true);
      observe$1(value);
      toggleObserving$1(prevShouldObserve);
    }
    {
      assertProp$1(prop, key, value, vm, absent);
    }
    return value
  }

  /**
   * Get the default value of a prop.
   */
  function getPropDefaultValue$1 (vm, prop, key) {
    // no default, return undefined
    if (!hasOwn$1(prop, 'default')) {
      return undefined
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (isObject$6(def)) {
      warn$3(
        'Invalid default value for prop "' + key + '": ' +
        'Props with type Object/Array must use a factory function ' +
        'to return the default value.',
        vm
      );
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm && vm.$options.propsData &&
      vm.$options.propsData[key] === undefined &&
      vm._props[key] !== undefined
    ) {
      return vm._props[key]
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return typeof def === 'function' && getType$1(prop.type) !== 'Function'
      ? def.call(vm)
      : def
  }

  /**
   * Assert whether a prop is valid.
   */
  function assertProp$1 (
    prop,
    name,
    value,
    vm,
    absent
  ) {
    if (prop.required && absent) {
      warn$3(
        'Missing required prop: "' + name + '"',
        vm
      );
      return
    }
    if (value == null && !prop.required) {
      return
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
      if (!Array.isArray(type)) {
        type = [type];
      }
      for (var i = 0; i < type.length && !valid; i++) {
        var assertedType = assertType$1(value, type[i]);
        expectedTypes.push(assertedType.expectedType || '');
        valid = assertedType.valid;
      }
    }

    if (!valid) {
      warn$3(
        getInvalidTypeMessage$1(name, value, expectedTypes),
        vm
      );
      return
    }
    var validator = prop.validator;
    if (validator) {
      if (!validator(value)) {
        warn$3(
          'Invalid prop: custom validator check failed for prop "' + name + '".',
          vm
        );
      }
    }
  }

  var simpleCheckRE$1 = /^(String|Number|Boolean|Function|Symbol)$/;

  function assertType$1 (value, type) {
    var valid;
    var expectedType = getType$1(type);
    if (simpleCheckRE$1.test(expectedType)) {
      var t = typeof value;
      valid = t === expectedType.toLowerCase();
      // for primitive wrapper objects
      if (!valid && t === 'object') {
        valid = value instanceof type;
      }
    } else if (expectedType === 'Object') {
      valid = isPlainObject$2(value);
    } else if (expectedType === 'Array') {
      valid = Array.isArray(value);
    } else {
      valid = value instanceof type;
    }
    return {
      valid: valid,
      expectedType: expectedType
    }
  }

  /**
   * Use function string name to check built-in types,
   * because a simple equality check will fail when running
   * across different vms / iframes.
   */
  function getType$1 (fn) {
    var match = fn && fn.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ''
  }

  function isSameType$1 (a, b) {
    return getType$1(a) === getType$1(b)
  }

  function getTypeIndex$1 (type, expectedTypes) {
    if (!Array.isArray(expectedTypes)) {
      return isSameType$1(expectedTypes, type) ? 0 : -1
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
      if (isSameType$1(expectedTypes[i], type)) {
        return i
      }
    }
    return -1
  }

  function getInvalidTypeMessage$1 (name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize$1).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType$1(value);
    var expectedValue = styleValue$1(value, expectedType);
    var receivedValue = styleValue$1(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable$1(expectedType) &&
        !isBoolean$1(expectedType, receivedType)) {
      message += " with value " + expectedValue;
    }
    message += ", got " + receivedType + " ";
    // check if we need to specify received value
    if (isExplicable$1(receivedType)) {
      message += "with value " + receivedValue + ".";
    }
    return message
  }

  function styleValue$1 (value, type) {
    if (type === 'String') {
      return ("\"" + value + "\"")
    } else if (type === 'Number') {
      return ("" + (Number(value)))
    } else {
      return ("" + value)
    }
  }

  function isExplicable$1 (value) {
    var explicitTypes = ['string', 'number', 'boolean'];
    return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
  }

  function isBoolean$1 () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
  }

  /*  */

  function handleError$1 (err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget$1();
    try {
      if (vm) {
        var cur = vm;
        while ((cur = cur.$parent)) {
          var hooks = cur.$options.errorCaptured;
          if (hooks) {
            for (var i = 0; i < hooks.length; i++) {
              try {
                var capture = hooks[i].call(cur, err, vm, info) === false;
                if (capture) { return }
              } catch (e) {
                globalHandleError$1(e, cur, 'errorCaptured hook');
              }
            }
          }
        }
      }
      globalHandleError$1(err, vm, info);
    } finally {
      popTarget$1();
    }
  }

  function invokeWithErrorHandling$1 (
    handler,
    context,
    args,
    vm,
    info
  ) {
    var res;
    try {
      res = args ? handler.apply(context, args) : handler.call(context);
      if (res && !res._isVue && isPromise$2(res) && !res._handled) {
        res.catch(function (e) { return handleError$1(e, vm, info + " (Promise/async)"); });
        // issue #9511
        // avoid catch triggering multiple times when nested calls
        res._handled = true;
      }
    } catch (e) {
      handleError$1(e, vm, info);
    }
    return res
  }

  function globalHandleError$1 (err, vm, info) {
    if (config$2.errorHandler) {
      try {
        return config$2.errorHandler.call(null, err, vm, info)
      } catch (e) {
        // if the user intentionally throws the original error in the handler,
        // do not log it twice
        if (e !== err) {
          logError$1(e, null, 'config.errorHandler');
        }
      }
    }
    logError$1(err, vm, info);
  }

  function logError$1 (err, vm, info) {
    {
      warn$3(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
    }
    /* istanbul ignore else */
    if ((inBrowser$1 || inWeex$1) && typeof console !== 'undefined') {
      console.error(err);
    } else {
      throw err
    }
  }

  /*  */

  var isUsingMicroTask$1 = false;

  var callbacks$1 = [];
  var pending$1 = false;

  function flushCallbacks$1 () {
    pending$1 = false;
    var copies = callbacks$1.slice(0);
    callbacks$1.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // Here we have async deferring wrappers using microtasks.
  // In 2.5 we used (macro) tasks (in combination with microtasks).
  // However, it has subtle problems when state is changed right before repaint
  // (e.g. #6813, out-in transitions).
  // Also, using (macro) tasks in event handler would cause some weird behaviors
  // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
  // So we now use microtasks everywhere, again.
  // A major drawback of this tradeoff is that there are some scenarios
  // where microtasks have too high a priority and fire in between supposedly
  // sequential events (e.g. #4521, #6690, which have workarounds)
  // or even between bubbling of the same event (#6566).
  var timerFunc$1;

  // The nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore next, $flow-disable-line */
  if (typeof Promise !== 'undefined' && isNative$1(Promise)) {
    var p$1 = Promise.resolve();
    timerFunc$1 = function () {
      p$1.then(flushCallbacks$1);
      // In problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS$1) { setTimeout(noop$2); }
    };
    isUsingMicroTask$1 = true;
  } else if (!isIE$1 && typeof MutationObserver !== 'undefined' && (
    isNative$1(MutationObserver) ||
    // PhantomJS and iOS 7.x
    MutationObserver.toString() === '[object MutationObserverConstructor]'
  )) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter$1 = 1;
    var observer$1 = new MutationObserver(flushCallbacks$1);
    var textNode$1 = document.createTextNode(String(counter$1));
    observer$1.observe(textNode$1, {
      characterData: true
    });
    timerFunc$1 = function () {
      counter$1 = (counter$1 + 1) % 2;
      textNode$1.data = String(counter$1);
    };
    isUsingMicroTask$1 = true;
  } else if (typeof setImmediate !== 'undefined' && isNative$1(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc$1 = function () {
      setImmediate(flushCallbacks$1);
    };
  } else {
    // Fallback to setTimeout.
    timerFunc$1 = function () {
      setTimeout(flushCallbacks$1, 0);
    };
  }

  function nextTick$2 (cb, ctx) {
    var _resolve;
    callbacks$1.push(function () {
      if (cb) {
        try {
          cb.call(ctx);
        } catch (e) {
          handleError$1(e, ctx, 'nextTick');
        }
      } else if (_resolve) {
        _resolve(ctx);
      }
    });
    if (!pending$1) {
      pending$1 = true;
      timerFunc$1();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
      return new Promise(function (resolve) {
        _resolve = resolve;
      })
    }
  }

  /*  */

  /* not type checking this file because flow doesn't play well with Proxy */

  var initProxy$1;

  {
    var allowedGlobals$1 = makeMap$1(
      'Infinity,undefined,NaN,isFinite,isNaN,' +
      'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
      'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
      'require' // for Webpack/Browserify
    );

    var warnNonPresent$1 = function (target, key) {
      warn$3(
        "Property or method \"" + key + "\" is not defined on the instance but " +
        'referenced during render. Make sure that this property is reactive, ' +
        'either in the data option, or for class-based components, by ' +
        'initializing the property. ' +
        'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
        target
      );
    };

    var warnReservedPrefix$1 = function (target, key) {
      warn$3(
        "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
        'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
        'prevent conflicts with Vue internals. ' +
        'See: https://vuejs.org/v2/api/#data',
        target
      );
    };

    var hasProxy$1 =
      typeof Proxy !== 'undefined' && isNative$1(Proxy);

    if (hasProxy$1) {
      var isBuiltInModifier$1 = makeMap$1('stop,prevent,self,ctrl,shift,alt,meta,exact');
      config$2.keyCodes = new Proxy(config$2.keyCodes, {
        set: function set (target, key, value) {
          if (isBuiltInModifier$1(key)) {
            warn$3(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
            return false
          } else {
            target[key] = value;
            return true
          }
        }
      });
    }

    var hasHandler$1 = {
      has: function has (target, key) {
        var has = key in target;
        var isAllowed = allowedGlobals$1(key) ||
          (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
        if (!has && !isAllowed) {
          if (key in target.$data) { warnReservedPrefix$1(target, key); }
          else { warnNonPresent$1(target, key); }
        }
        return has || !isAllowed
      }
    };

    var getHandler$1 = {
      get: function get (target, key) {
        if (typeof key === 'string' && !(key in target)) {
          if (key in target.$data) { warnReservedPrefix$1(target, key); }
          else { warnNonPresent$1(target, key); }
        }
        return target[key]
      }
    };

    initProxy$1 = function initProxy (vm) {
      if (hasProxy$1) {
        // determine which proxy handler to use
        var options = vm.$options;
        var handlers = options.render && options.render._withStripped
          ? getHandler$1
          : hasHandler$1;
        vm._renderProxy = new Proxy(vm, handlers);
      } else {
        vm._renderProxy = vm;
      }
    };
  }

  /*  */

  var seenObjects$1 = new _Set$1();

  /**
   * Recursively traverse an object to evoke all converted
   * getters, so that every nested property inside the object
   * is collected as a "deep" dependency.
   */
  function traverse$1 (val) {
    _traverse$1(val, seenObjects$1);
    seenObjects$1.clear();
  }

  function _traverse$1 (val, seen) {
    var i, keys;
    var isA = Array.isArray(val);
    if ((!isA && !isObject$6(val)) || Object.isFrozen(val) || val instanceof VNode$1) {
      return
    }
    if (val.__ob__) {
      var depId = val.__ob__.dep.id;
      if (seen.has(depId)) {
        return
      }
      seen.add(depId);
    }
    if (isA) {
      i = val.length;
      while (i--) { _traverse$1(val[i], seen); }
    } else {
      keys = Object.keys(val);
      i = keys.length;
      while (i--) { _traverse$1(val[keys[i]], seen); }
    }
  }

  var mark$1;
  var measure$1;

  {
    var perf$1 = inBrowser$1 && window.performance;
    /* istanbul ignore if */
    if (
      perf$1 &&
      perf$1.mark &&
      perf$1.measure &&
      perf$1.clearMarks &&
      perf$1.clearMeasures
    ) {
      mark$1 = function (tag) { return perf$1.mark(tag); };
      measure$1 = function (name, startTag, endTag) {
        perf$1.measure(name, startTag, endTag);
        perf$1.clearMarks(startTag);
        perf$1.clearMarks(endTag);
        // perf.clearMeasures(name)
      };
    }
  }

  /*  */

  var normalizeEvent$1 = cached$1(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once$$1 ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
      name: name,
      once: once$$1,
      capture: capture,
      passive: passive
    }
  });

  function createFnInvoker$1 (fns, vm) {
    function invoker () {
      var arguments$1 = arguments;

      var fns = invoker.fns;
      if (Array.isArray(fns)) {
        var cloned = fns.slice();
        for (var i = 0; i < cloned.length; i++) {
          invokeWithErrorHandling$1(cloned[i], null, arguments$1, vm, "v-on handler");
        }
      } else {
        // return handler return value for single handlers
        return invokeWithErrorHandling$1(fns, null, arguments, vm, "v-on handler")
      }
    }
    invoker.fns = fns;
    return invoker
  }

  function updateListeners$1 (
    on,
    oldOn,
    add,
    remove$$1,
    createOnceHandler,
    vm
  ) {
    var name, cur, old, event;
    for (name in on) {
      cur = on[name];
      old = oldOn[name];
      event = normalizeEvent$1(name);
      if (isUndef$1(cur)) {
        warn$3(
          "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
          vm
        );
      } else if (isUndef$1(old)) {
        if (isUndef$1(cur.fns)) {
          cur = on[name] = createFnInvoker$1(cur, vm);
        }
        if (isTrue$1(event.once)) {
          cur = on[name] = createOnceHandler(event.name, cur, event.capture);
        }
        add(event.name, cur, event.capture, event.passive, event.params);
      } else if (cur !== old) {
        old.fns = cur;
        on[name] = old;
      }
    }
    for (name in oldOn) {
      if (isUndef$1(on[name])) {
        event = normalizeEvent$1(name);
        remove$$1(event.name, oldOn[name], event.capture);
      }
    }
  }

  /*  */

  function mergeVNodeHook$1 (def, hookKey, hook) {
    if (def instanceof VNode$1) {
      def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];

    function wrappedHook () {
      hook.apply(this, arguments);
      // important: remove merged hook to ensure it's called only once
      // and prevent memory leak
      remove$3(invoker.fns, wrappedHook);
    }

    if (isUndef$1(oldHook)) {
      // no existing hook
      invoker = createFnInvoker$1([wrappedHook]);
    } else {
      /* istanbul ignore if */
      if (isDef$1(oldHook.fns) && isTrue$1(oldHook.merged)) {
        // already a merged invoker
        invoker = oldHook;
        invoker.fns.push(wrappedHook);
      } else {
        // existing plain hook
        invoker = createFnInvoker$1([oldHook, wrappedHook]);
      }
    }

    invoker.merged = true;
    def[hookKey] = invoker;
  }

  /*  */

  function extractPropsFromVNodeData$1 (
    data,
    Ctor,
    tag
  ) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef$1(propOptions)) {
      return
    }
    var res = {};
    var attrs = data.attrs;
    var props = data.props;
    if (isDef$1(attrs) || isDef$1(props)) {
      for (var key in propOptions) {
        var altKey = hyphenate$1(key);
        {
          var keyInLowerCase = key.toLowerCase();
          if (
            key !== keyInLowerCase &&
            attrs && hasOwn$1(attrs, keyInLowerCase)
          ) {
            tip$1(
              "Prop \"" + keyInLowerCase + "\" is passed to component " +
              (formatComponentName$1(tag || Ctor)) + ", but the declared prop name is" +
              " \"" + key + "\". " +
              "Note that HTML attributes are case-insensitive and camelCased " +
              "props need to use their kebab-case equivalents when using in-DOM " +
              "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
            );
          }
        }
        checkProp$1(res, props, key, altKey, true) ||
        checkProp$1(res, attrs, key, altKey, false);
      }
    }
    return res
  }

  function checkProp$1 (
    res,
    hash,
    key,
    altKey,
    preserve
  ) {
    if (isDef$1(hash)) {
      if (hasOwn$1(hash, key)) {
        res[key] = hash[key];
        if (!preserve) {
          delete hash[key];
        }
        return true
      } else if (hasOwn$1(hash, altKey)) {
        res[key] = hash[altKey];
        if (!preserve) {
          delete hash[altKey];
        }
        return true
      }
    }
    return false
  }

  /*  */

  // The template compiler attempts to minimize the need for normalization by
  // statically analyzing the template at compile time.
  //
  // For plain HTML markup, normalization can be completely skipped because the
  // generated render function is guaranteed to return Array<VNode>. There are
  // two cases where extra normalization is needed:

  // 1. When the children contains components - because a functional component
  // may return an Array instead of a single root. In this case, just a simple
  // normalization is needed - if any child is an Array, we flatten the whole
  // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
  // because functional components already normalize their own children.
  function simpleNormalizeChildren$1 (children) {
    for (var i = 0; i < children.length; i++) {
      if (Array.isArray(children[i])) {
        return Array.prototype.concat.apply([], children)
      }
    }
    return children
  }

  // 2. When the children contains constructs that always generated nested Arrays,
  // e.g. <template>, <slot>, v-for, or when the children is provided by user
  // with hand-written render functions / JSX. In such cases a full normalization
  // is needed to cater to all possible types of children values.
  function normalizeChildren$1 (children) {
    return isPrimitive$1(children)
      ? [createTextVNode$1(children)]
      : Array.isArray(children)
        ? normalizeArrayChildren$1(children)
        : undefined
  }

  function isTextNode$1 (node) {
    return isDef$1(node) && isDef$1(node.text) && isFalse$1(node.isComment)
  }

  function normalizeArrayChildren$1 (children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
      c = children[i];
      if (isUndef$1(c) || typeof c === 'boolean') { continue }
      lastIndex = res.length - 1;
      last = res[lastIndex];
      //  nested
      if (Array.isArray(c)) {
        if (c.length > 0) {
          c = normalizeArrayChildren$1(c, ((nestedIndex || '') + "_" + i));
          // merge adjacent text nodes
          if (isTextNode$1(c[0]) && isTextNode$1(last)) {
            res[lastIndex] = createTextVNode$1(last.text + (c[0]).text);
            c.shift();
          }
          res.push.apply(res, c);
        }
      } else if (isPrimitive$1(c)) {
        if (isTextNode$1(last)) {
          // merge adjacent text nodes
          // this is necessary for SSR hydration because text nodes are
          // essentially merged when rendered to HTML strings
          res[lastIndex] = createTextVNode$1(last.text + c);
        } else if (c !== '') {
          // convert primitive to vnode
          res.push(createTextVNode$1(c));
        }
      } else {
        if (isTextNode$1(c) && isTextNode$1(last)) {
          // merge adjacent text nodes
          res[lastIndex] = createTextVNode$1(last.text + c.text);
        } else {
          // default key for nested array children (likely generated by v-for)
          if (isTrue$1(children._isVList) &&
            isDef$1(c.tag) &&
            isUndef$1(c.key) &&
            isDef$1(nestedIndex)) {
            c.key = "__vlist" + nestedIndex + "_" + i + "__";
          }
          res.push(c);
        }
      }
    }
    return res
  }

  /*  */

  function initProvide$1 (vm) {
    var provide = vm.$options.provide;
    if (provide) {
      vm._provided = typeof provide === 'function'
        ? provide.call(vm)
        : provide;
    }
  }

  function initInjections$1 (vm) {
    var result = resolveInject$1(vm.$options.inject, vm);
    if (result) {
      toggleObserving$1(false);
      Object.keys(result).forEach(function (key) {
        /* istanbul ignore else */
        {
          defineReactive$$1$1(vm, key, result[key], function () {
            warn$3(
              "Avoid mutating an injected value directly since the changes will be " +
              "overwritten whenever the provided component re-renders. " +
              "injection being mutated: \"" + key + "\"",
              vm
            );
          });
        }
      });
      toggleObserving$1(true);
    }
  }

  function resolveInject$1 (inject, vm) {
    if (inject) {
      // inject is :any because flow is not smart enough to figure out cached
      var result = Object.create(null);
      var keys = hasSymbol$1
        ? Reflect.ownKeys(inject)
        : Object.keys(inject);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        // #6574 in case the inject object is observed...
        if (key === '__ob__') { continue }
        var provideKey = inject[key].from;
        var source = vm;
        while (source) {
          if (source._provided && hasOwn$1(source._provided, provideKey)) {
            result[key] = source._provided[provideKey];
            break
          }
          source = source.$parent;
        }
        if (!source) {
          if ('default' in inject[key]) {
            var provideDefault = inject[key].default;
            result[key] = typeof provideDefault === 'function'
              ? provideDefault.call(vm)
              : provideDefault;
          } else {
            warn$3(("Injection \"" + key + "\" not found"), vm);
          }
        }
      }
      return result
    }
  }

  /*  */



  /**
   * Runtime helper for resolving raw children VNodes into a slot object.
   */
  function resolveSlots$1 (
    children,
    context
  ) {
    if (!children || !children.length) {
      return {}
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
      var child = children[i];
      var data = child.data;
      // remove slot attribute if the node is resolved as a Vue slot node
      if (data && data.attrs && data.attrs.slot) {
        delete data.attrs.slot;
      }
      // named slots should only be respected if the vnode was rendered in the
      // same context.
      if ((child.context === context || child.fnContext === context) &&
        data && data.slot != null
      ) {
        var name = data.slot;
        var slot = (slots[name] || (slots[name] = []));
        if (child.tag === 'template') {
          slot.push.apply(slot, child.children || []);
        } else {
          slot.push(child);
        }
      } else {
        (slots.default || (slots.default = [])).push(child);
      }
    }
    // ignore slots that contains only whitespace
    for (var name$1 in slots) {
      if (slots[name$1].every(isWhitespace$1)) {
        delete slots[name$1];
      }
    }
    return slots
  }

  function isWhitespace$1 (node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' '
  }

  /*  */

  function normalizeScopedSlots$1 (
    slots,
    normalSlots,
    prevSlots
  ) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = slots ? !!slots.$stable : !hasNormalSlots;
    var key = slots && slots.$key;
    if (!slots) {
      res = {};
    } else if (slots._normalized) {
      // fast path 1: child component re-render only, parent did not change
      return slots._normalized
    } else if (
      isStable &&
      prevSlots &&
      prevSlots !== emptyObject$1 &&
      key === prevSlots.$key &&
      !hasNormalSlots &&
      !prevSlots.$hasNormal
    ) {
      // fast path 2: stable scoped slots w/ no normal slots to proxy,
      // only need to normalize once
      return prevSlots
    } else {
      res = {};
      for (var key$1 in slots) {
        if (slots[key$1] && key$1[0] !== '$') {
          res[key$1] = normalizeScopedSlot$1(normalSlots, key$1, slots[key$1]);
        }
      }
    }
    // expose normal slots on scopedSlots
    for (var key$2 in normalSlots) {
      if (!(key$2 in res)) {
        res[key$2] = proxyNormalSlot$1(normalSlots, key$2);
      }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (slots && Object.isExtensible(slots)) {
      (slots)._normalized = res;
    }
    def$1(res, '$stable', isStable);
    def$1(res, '$key', key);
    def$1(res, '$hasNormal', hasNormalSlots);
    return res
  }

  function normalizeScopedSlot$1(normalSlots, key, fn) {
    var normalized = function () {
      var res = arguments.length ? fn.apply(null, arguments) : fn({});
      res = res && typeof res === 'object' && !Array.isArray(res)
        ? [res] // single vnode
        : normalizeChildren$1(res);
      return res && (
        res.length === 0 ||
        (res.length === 1 && res[0].isComment) // #9658
      ) ? undefined
        : res
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
      Object.defineProperty(normalSlots, key, {
        get: normalized,
        enumerable: true,
        configurable: true
      });
    }
    return normalized
  }

  function proxyNormalSlot$1(slots, key) {
    return function () { return slots[key]; }
  }

  /*  */

  /**
   * Runtime helper for rendering v-for lists.
   */
  function renderList$1 (
    val,
    render
  ) {
    var ret, i, l, keys, key;
    if (Array.isArray(val) || typeof val === 'string') {
      ret = new Array(val.length);
      for (i = 0, l = val.length; i < l; i++) {
        ret[i] = render(val[i], i);
      }
    } else if (typeof val === 'number') {
      ret = new Array(val);
      for (i = 0; i < val; i++) {
        ret[i] = render(i + 1, i);
      }
    } else if (isObject$6(val)) {
      if (hasSymbol$1 && val[Symbol.iterator]) {
        ret = [];
        var iterator = val[Symbol.iterator]();
        var result = iterator.next();
        while (!result.done) {
          ret.push(render(result.value, ret.length));
          result = iterator.next();
        }
      } else {
        keys = Object.keys(val);
        ret = new Array(keys.length);
        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          ret[i] = render(val[key], key, i);
        }
      }
    }
    if (!isDef$1(ret)) {
      ret = [];
    }
    (ret)._isVList = true;
    return ret
  }

  /*  */

  /**
   * Runtime helper for rendering <slot>
   */
  function renderSlot$1 (
    name,
    fallback,
    props,
    bindObject
  ) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) { // scoped slot
      props = props || {};
      if (bindObject) {
        if (!isObject$6(bindObject)) {
          warn$3(
            'slot v-bind without argument expects an Object',
            this
          );
        }
        props = extend$2(extend$2({}, bindObject), props);
      }
      nodes = scopedSlotFn(props) || fallback;
    } else {
      nodes = this.$slots[name] || fallback;
    }

    var target = props && props.slot;
    if (target) {
      return this.$createElement('template', { slot: target }, nodes)
    } else {
      return nodes
    }
  }

  /*  */

  /**
   * Runtime helper for resolving filters
   */
  function resolveFilter$1 (id) {
    return resolveAsset$1(this.$options, 'filters', id, true) || identity$1
  }

  /*  */

  function isKeyNotMatch$1 (expect, actual) {
    if (Array.isArray(expect)) {
      return expect.indexOf(actual) === -1
    } else {
      return expect !== actual
    }
  }

  /**
   * Runtime helper for checking keyCodes from config.
   * exposed as Vue.prototype._k
   * passing in eventKeyName as last argument separately for backwards compat
   */
  function checkKeyCodes$1 (
    eventKeyCode,
    key,
    builtInKeyCode,
    eventKeyName,
    builtInKeyName
  ) {
    var mappedKeyCode = config$2.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config$2.keyCodes[key]) {
      return isKeyNotMatch$1(builtInKeyName, eventKeyName)
    } else if (mappedKeyCode) {
      return isKeyNotMatch$1(mappedKeyCode, eventKeyCode)
    } else if (eventKeyName) {
      return hyphenate$1(eventKeyName) !== key
    }
  }

  /*  */

  /**
   * Runtime helper for merging v-bind="object" into a VNode's data.
   */
  function bindObjectProps$1 (
    data,
    tag,
    value,
    asProp,
    isSync
  ) {
    if (value) {
      if (!isObject$6(value)) {
        warn$3(
          'v-bind without argument expects an Object or Array value',
          this
        );
      } else {
        if (Array.isArray(value)) {
          value = toObject$1(value);
        }
        var hash;
        var loop = function ( key ) {
          if (
            key === 'class' ||
            key === 'style' ||
            isReservedAttribute$1(key)
          ) {
            hash = data;
          } else {
            var type = data.attrs && data.attrs.type;
            hash = asProp || config$2.mustUseProp(tag, type, key)
              ? data.domProps || (data.domProps = {})
              : data.attrs || (data.attrs = {});
          }
          var camelizedKey = camelize$1(key);
          var hyphenatedKey = hyphenate$1(key);
          if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
            hash[key] = value[key];

            if (isSync) {
              var on = data.on || (data.on = {});
              on[("update:" + key)] = function ($event) {
                value[key] = $event;
              };
            }
          }
        };

        for (var key in value) loop( key );
      }
    }
    return data
  }

  /*  */

  /**
   * Runtime helper for rendering static trees.
   */
  function renderStatic$1 (
    index,
    isInFor
  ) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
      return tree
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(
      this._renderProxy,
      null,
      this // for render fns generated for functional component templates
    );
    markStatic$2(tree, ("__static__" + index), false);
    return tree
  }

  /**
   * Runtime helper for v-once.
   * Effectively it means marking the node as static with a unique key.
   */
  function markOnce$1 (
    tree,
    index,
    key
  ) {
    markStatic$2(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
    return tree
  }

  function markStatic$2 (
    tree,
    key,
    isOnce
  ) {
    if (Array.isArray(tree)) {
      for (var i = 0; i < tree.length; i++) {
        if (tree[i] && typeof tree[i] !== 'string') {
          markStaticNode$1(tree[i], (key + "_" + i), isOnce);
        }
      }
    } else {
      markStaticNode$1(tree, key, isOnce);
    }
  }

  function markStaticNode$1 (node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
  }

  /*  */

  function bindObjectListeners$1 (data, value) {
    if (value) {
      if (!isPlainObject$2(value)) {
        warn$3(
          'v-on without argument expects an Object value',
          this
        );
      } else {
        var on = data.on = data.on ? extend$2({}, data.on) : {};
        for (var key in value) {
          var existing = on[key];
          var ours = value[key];
          on[key] = existing ? [].concat(existing, ours) : ours;
        }
      }
    }
    return data
  }

  /*  */

  function resolveScopedSlots$1 (
    fns, // see flow/vnode
    res,
    // the following are added in 2.6
    hasDynamicKeys,
    contentHashKey
  ) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
      var slot = fns[i];
      if (Array.isArray(slot)) {
        resolveScopedSlots$1(slot, res, hasDynamicKeys);
      } else if (slot) {
        // marker for reverse proxying v-slot without scope on this.$slots
        if (slot.proxy) {
          slot.fn.proxy = true;
        }
        res[slot.key] = slot.fn;
      }
    }
    if (contentHashKey) {
      (res).$key = contentHashKey;
    }
    return res
  }

  /*  */

  function bindDynamicKeys$1 (baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
      var key = values[i];
      if (typeof key === 'string' && key) {
        baseObj[values[i]] = values[i + 1];
      } else if (key !== '' && key !== null) {
        // null is a special value for explicitly removing a binding
        warn$3(
          ("Invalid value for dynamic directive argument (expected string or null): " + key),
          this
        );
      }
    }
    return baseObj
  }

  // helper to dynamically append modifier runtime markers to event names.
  // ensure only append when value is already string, otherwise it will be cast
  // to string and cause the type check to miss.
  function prependModifier$1 (value, symbol) {
    return typeof value === 'string' ? symbol + value : value
  }

  /*  */

  function installRenderHelpers$1 (target) {
    target._o = markOnce$1;
    target._n = toNumber$3;
    target._s = toString$2;
    target._l = renderList$1;
    target._t = renderSlot$1;
    target._q = looseEqual$1;
    target._i = looseIndexOf$1;
    target._m = renderStatic$1;
    target._f = resolveFilter$1;
    target._k = checkKeyCodes$1;
    target._b = bindObjectProps$1;
    target._v = createTextVNode$1;
    target._e = createEmptyVNode$1;
    target._u = resolveScopedSlots$1;
    target._g = bindObjectListeners$1;
    target._d = bindDynamicKeys$1;
    target._p = prependModifier$1;
  }

  /*  */

  function FunctionalRenderContext$1 (
    data,
    props,
    children,
    parent,
    Ctor
  ) {
    var this$1$1 = this;

    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn$1(parent, '_uid')) {
      contextVm = Object.create(parent);
      // $flow-disable-line
      contextVm._original = parent;
    } else {
      // the context vm passed in is a functional context as well.
      // in this case we want to make sure we are able to get a hold to the
      // real context instance.
      contextVm = parent;
      // $flow-disable-line
      parent = parent._original;
    }
    var isCompiled = isTrue$1(options._compiled);
    var needNormalization = !isCompiled;

    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject$1;
    this.injections = resolveInject$1(options.inject, parent);
    this.slots = function () {
      if (!this$1$1.$slots) {
        normalizeScopedSlots$1(
          data.scopedSlots,
          this$1$1.$slots = resolveSlots$1(children, parent)
        );
      }
      return this$1$1.$slots
    };

    Object.defineProperty(this, 'scopedSlots', ({
      enumerable: true,
      get: function get () {
        return normalizeScopedSlots$1(data.scopedSlots, this.slots())
      }
    }));

    // support for compiled functional template
    if (isCompiled) {
      // exposing $options for renderStatic()
      this.$options = options;
      // pre-resolve slots for renderSlot()
      this.$slots = this.slots();
      this.$scopedSlots = normalizeScopedSlots$1(data.scopedSlots, this.$slots);
    }

    if (options._scopeId) {
      this._c = function (a, b, c, d) {
        var vnode = createElement$2(contextVm, a, b, c, d, needNormalization);
        if (vnode && !Array.isArray(vnode)) {
          vnode.fnScopeId = options._scopeId;
          vnode.fnContext = parent;
        }
        return vnode
      };
    } else {
      this._c = function (a, b, c, d) { return createElement$2(contextVm, a, b, c, d, needNormalization); };
    }
  }

  installRenderHelpers$1(FunctionalRenderContext$1.prototype);

  function createFunctionalComponent$1 (
    Ctor,
    propsData,
    data,
    contextVm,
    children
  ) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef$1(propOptions)) {
      for (var key in propOptions) {
        props[key] = validateProp$1(key, propOptions, propsData || emptyObject$1);
      }
    } else {
      if (isDef$1(data.attrs)) { mergeProps$1(props, data.attrs); }
      if (isDef$1(data.props)) { mergeProps$1(props, data.props); }
    }

    var renderContext = new FunctionalRenderContext$1(
      data,
      props,
      children,
      contextVm,
      Ctor
    );

    var vnode = options.render.call(null, renderContext._c, renderContext);

    if (vnode instanceof VNode$1) {
      return cloneAndMarkFunctionalResult$1(vnode, data, renderContext.parent, options, renderContext)
    } else if (Array.isArray(vnode)) {
      var vnodes = normalizeChildren$1(vnode) || [];
      var res = new Array(vnodes.length);
      for (var i = 0; i < vnodes.length; i++) {
        res[i] = cloneAndMarkFunctionalResult$1(vnodes[i], data, renderContext.parent, options, renderContext);
      }
      return res
    }
  }

  function cloneAndMarkFunctionalResult$1 (vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode$1(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    {
      (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
    }
    if (data.slot) {
      (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone
  }

  function mergeProps$1 (to, from) {
    for (var key in from) {
      to[camelize$1(key)] = from[key];
    }
  }

  /*  */

  /*  */

  /*  */

  /*  */

  // inline hooks to be invoked on component VNodes during patch
  var componentVNodeHooks$1 = {
    init: function init (vnode, hydrating) {
      if (
        vnode.componentInstance &&
        !vnode.componentInstance._isDestroyed &&
        vnode.data.keepAlive
      ) {
        // kept-alive components, treat as a patch
        var mountedNode = vnode; // work around flow
        componentVNodeHooks$1.prepatch(mountedNode, mountedNode);
      } else {
        var child = vnode.componentInstance = createComponentInstanceForVnode$1(
          vnode,
          activeInstance$1
        );
        child.$mount(hydrating ? vnode.elm : undefined, hydrating);
      }
    },

    prepatch: function prepatch (oldVnode, vnode) {
      var options = vnode.componentOptions;
      var child = vnode.componentInstance = oldVnode.componentInstance;
      updateChildComponent$1(
        child,
        options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
      );
    },

    insert: function insert (vnode) {
      var context = vnode.context;
      var componentInstance = vnode.componentInstance;
      if (!componentInstance._isMounted) {
        componentInstance._isMounted = true;
        callHook$2(componentInstance, 'mounted');
      }
      if (vnode.data.keepAlive) {
        if (context._isMounted) {
          // vue-router#1212
          // During updates, a kept-alive component's child components may
          // change, so directly walking the tree here may call activated hooks
          // on incorrect children. Instead we push them into a queue which will
          // be processed after the whole patch process ended.
          queueActivatedComponent$1(componentInstance);
        } else {
          activateChildComponent$1(componentInstance, true /* direct */);
        }
      }
    },

    destroy: function destroy (vnode) {
      var componentInstance = vnode.componentInstance;
      if (!componentInstance._isDestroyed) {
        if (!vnode.data.keepAlive) {
          componentInstance.$destroy();
        } else {
          deactivateChildComponent$1(componentInstance, true /* direct */);
        }
      }
    }
  };

  var hooksToMerge$1 = Object.keys(componentVNodeHooks$1);

  function createComponent$1 (
    Ctor,
    data,
    context,
    children,
    tag
  ) {
    if (isUndef$1(Ctor)) {
      return
    }

    var baseCtor = context.$options._base;

    // plain options object: turn it into a constructor
    if (isObject$6(Ctor)) {
      Ctor = baseCtor.extend(Ctor);
    }

    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
      {
        warn$3(("Invalid Component definition: " + (String(Ctor))), context);
      }
      return
    }

    // async component
    var asyncFactory;
    if (isUndef$1(Ctor.cid)) {
      asyncFactory = Ctor;
      Ctor = resolveAsyncComponent$1(asyncFactory, baseCtor);
      if (Ctor === undefined) {
        // return a placeholder node for async component, which is rendered
        // as a comment node but preserves all the raw information for the node.
        // the information will be used for async server-rendering and hydration.
        return createAsyncPlaceholder$1(
          asyncFactory,
          data,
          context,
          children,
          tag
        )
      }
    }

    data = data || {};

    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions$1(Ctor);

    // transform component v-model data into props & events
    if (isDef$1(data.model)) {
      transformModel$1(Ctor.options, data);
    }

    // extract props
    var propsData = extractPropsFromVNodeData$1(data, Ctor, tag);

    // functional component
    if (isTrue$1(Ctor.options.functional)) {
      return createFunctionalComponent$1(Ctor, propsData, data, context, children)
    }

    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;

    if (isTrue$1(Ctor.options.abstract)) {
      // abstract components do not keep anything
      // other than props & listeners & slot

      // work around flow
      var slot = data.slot;
      data = {};
      if (slot) {
        data.slot = slot;
      }
    }

    // install component management hooks onto the placeholder node
    installComponentHooks$1(data);

    // return a placeholder vnode
    var name = Ctor.options.name || tag;
    var vnode = new VNode$1(
      ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
      data, undefined, undefined, undefined, context,
      { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
      asyncFactory
    );

    return vnode
  }

  function createComponentInstanceForVnode$1 (
    vnode, // we know it's MountedComponentVNode but flow doesn't
    parent // activeInstance in lifecycle state
  ) {
    var options = {
      _isComponent: true,
      _parentVnode: vnode,
      parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef$1(inlineTemplate)) {
      options.render = inlineTemplate.render;
      options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options)
  }

  function installComponentHooks$1 (data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge$1.length; i++) {
      var key = hooksToMerge$1[i];
      var existing = hooks[key];
      var toMerge = componentVNodeHooks$1[key];
      if (existing !== toMerge && !(existing && existing._merged)) {
        hooks[key] = existing ? mergeHook$1$1(toMerge, existing) : toMerge;
      }
    }
  }

  function mergeHook$1$1 (f1, f2) {
    var merged = function (a, b) {
      // flow complains about extra args which is why we use any
      f1(a, b);
      f2(a, b);
    };
    merged._merged = true;
    return merged
  }

  // transform component v-model info (value and callback) into
  // prop and event handler respectively.
  function transformModel$1 (options, data) {
    var prop = (options.model && options.model.prop) || 'value';
    var event = (options.model && options.model.event) || 'input'
    ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef$1(existing)) {
      if (
        Array.isArray(existing)
          ? existing.indexOf(callback) === -1
          : existing !== callback
      ) {
        on[event] = [callback].concat(existing);
      }
    } else {
      on[event] = callback;
    }
  }

  /*  */

  var SIMPLE_NORMALIZE$1 = 1;
  var ALWAYS_NORMALIZE$1 = 2;

  // wrapper function for providing a more flexible interface
  // without getting yelled at by flow
  function createElement$2 (
    context,
    tag,
    data,
    children,
    normalizationType,
    alwaysNormalize
  ) {
    if (Array.isArray(data) || isPrimitive$1(data)) {
      normalizationType = children;
      children = data;
      data = undefined;
    }
    if (isTrue$1(alwaysNormalize)) {
      normalizationType = ALWAYS_NORMALIZE$1;
    }
    return _createElement$1(context, tag, data, children, normalizationType)
  }

  function _createElement$1 (
    context,
    tag,
    data,
    children,
    normalizationType
  ) {
    if (isDef$1(data) && isDef$1((data).__ob__)) {
      warn$3(
        "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
        'Always create fresh vnode data objects in each render!',
        context
      );
      return createEmptyVNode$1()
    }
    // object syntax in v-bind
    if (isDef$1(data) && isDef$1(data.is)) {
      tag = data.is;
    }
    if (!tag) {
      // in case of component :is set to falsy value
      return createEmptyVNode$1()
    }
    // warn against non-primitive key
    if (isDef$1(data) && isDef$1(data.key) && !isPrimitive$1(data.key)
    ) {
      {
        warn$3(
          'Avoid using non-primitive value as key, ' +
          'use string/number value instead.',
          context
        );
      }
    }
    // support single function children as default scoped slot
    if (Array.isArray(children) &&
      typeof children[0] === 'function'
    ) {
      data = data || {};
      data.scopedSlots = { default: children[0] };
      children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE$1) {
      children = normalizeChildren$1(children);
    } else if (normalizationType === SIMPLE_NORMALIZE$1) {
      children = simpleNormalizeChildren$1(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
      var Ctor;
      ns = (context.$vnode && context.$vnode.ns) || config$2.getTagNamespace(tag);
      if (config$2.isReservedTag(tag)) {
        // platform built-in elements
        if (isDef$1(data) && isDef$1(data.nativeOn)) {
          warn$3(
            ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
            context
          );
        }
        vnode = new VNode$1(
          config$2.parsePlatformTagName(tag), data, children,
          undefined, undefined, context
        );
      } else if ((!data || !data.pre) && isDef$1(Ctor = resolveAsset$1(context.$options, 'components', tag))) {
        // component
        vnode = createComponent$1(Ctor, data, context, children, tag);
      } else {
        // unknown or unlisted namespaced elements
        // check at runtime because it may get assigned a namespace when its
        // parent normalizes children
        vnode = new VNode$1(
          tag, data, children,
          undefined, undefined, context
        );
      }
    } else {
      // direct component options / constructor
      vnode = createComponent$1(tag, data, context, children);
    }
    if (Array.isArray(vnode)) {
      return vnode
    } else if (isDef$1(vnode)) {
      if (isDef$1(ns)) { applyNS$1(vnode, ns); }
      if (isDef$1(data)) { registerDeepBindings$1(data); }
      return vnode
    } else {
      return createEmptyVNode$1()
    }
  }

  function applyNS$1 (vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
      // use default namespace inside foreignObject
      ns = undefined;
      force = true;
    }
    if (isDef$1(vnode.children)) {
      for (var i = 0, l = vnode.children.length; i < l; i++) {
        var child = vnode.children[i];
        if (isDef$1(child.tag) && (
          isUndef$1(child.ns) || (isTrue$1(force) && child.tag !== 'svg'))) {
          applyNS$1(child, ns, force);
        }
      }
    }
  }

  // ref #5318
  // necessary to ensure parent re-render when deep bindings like :style and
  // :class are used on slot nodes
  function registerDeepBindings$1 (data) {
    if (isObject$6(data.style)) {
      traverse$1(data.style);
    }
    if (isObject$6(data.class)) {
      traverse$1(data.class);
    }
  }

  /*  */

  function initRender$1 (vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots$1(options._renderChildren, renderContext);
    vm.$scopedSlots = emptyObject$1;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    vm._c = function (a, b, c, d) { return createElement$2(vm, a, b, c, d, false); };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    vm.$createElement = function (a, b, c, d) { return createElement$2(vm, a, b, c, d, true); };

    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;

    /* istanbul ignore else */
    {
      defineReactive$$1$1(vm, '$attrs', parentData && parentData.attrs || emptyObject$1, function () {
        !isUpdatingChildComponent$1 && warn$3("$attrs is readonly.", vm);
      }, true);
      defineReactive$$1$1(vm, '$listeners', options._parentListeners || emptyObject$1, function () {
        !isUpdatingChildComponent$1 && warn$3("$listeners is readonly.", vm);
      }, true);
    }
  }

  var currentRenderingInstance$1 = null;

  function renderMixin$1 (Vue) {
    // install runtime convenience helpers
    installRenderHelpers$1(Vue.prototype);

    Vue.prototype.$nextTick = function (fn) {
      return nextTick$2(fn, this)
    };

    Vue.prototype._render = function () {
      var vm = this;
      var ref = vm.$options;
      var render = ref.render;
      var _parentVnode = ref._parentVnode;

      if (_parentVnode) {
        vm.$scopedSlots = normalizeScopedSlots$1(
          _parentVnode.data.scopedSlots,
          vm.$slots,
          vm.$scopedSlots
        );
      }

      // set parent vnode. this allows render functions to have access
      // to the data on the placeholder node.
      vm.$vnode = _parentVnode;
      // render self
      var vnode;
      try {
        // There's no need to maintain a stack because all render fns are called
        // separately from one another. Nested component's render fns are called
        // when parent component is patched.
        currentRenderingInstance$1 = vm;
        vnode = render.call(vm._renderProxy, vm.$createElement);
      } catch (e) {
        handleError$1(e, vm, "render");
        // return error render result,
        // or previous vnode to prevent render error causing blank component
        /* istanbul ignore else */
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError$1(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } finally {
        currentRenderingInstance$1 = null;
      }
      // if the returned array contains only a single node, allow it
      if (Array.isArray(vnode) && vnode.length === 1) {
        vnode = vnode[0];
      }
      // return empty vnode in case the render function errored out
      if (!(vnode instanceof VNode$1)) {
        if (Array.isArray(vnode)) {
          warn$3(
            'Multiple root nodes returned from render function. Render function ' +
            'should return a single root node.',
            vm
          );
        }
        vnode = createEmptyVNode$1();
      }
      // set parent
      vnode.parent = _parentVnode;
      return vnode
    };
  }

  /*  */

  function ensureCtor$1 (comp, base) {
    if (
      comp.__esModule ||
      (hasSymbol$1 && comp[Symbol.toStringTag] === 'Module')
    ) {
      comp = comp.default;
    }
    return isObject$6(comp)
      ? base.extend(comp)
      : comp
  }

  function createAsyncPlaceholder$1 (
    factory,
    data,
    context,
    children,
    tag
  ) {
    var node = createEmptyVNode$1();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node
  }

  function resolveAsyncComponent$1 (
    factory,
    baseCtor
  ) {
    if (isTrue$1(factory.error) && isDef$1(factory.errorComp)) {
      return factory.errorComp
    }

    if (isDef$1(factory.resolved)) {
      return factory.resolved
    }

    var owner = currentRenderingInstance$1;
    if (owner && isDef$1(factory.owners) && factory.owners.indexOf(owner) === -1) {
      // already pending
      factory.owners.push(owner);
    }

    if (isTrue$1(factory.loading) && isDef$1(factory.loadingComp)) {
      return factory.loadingComp
    }

    if (owner && !isDef$1(factory.owners)) {
      var owners = factory.owners = [owner];
      var sync = true;
      var timerLoading = null;
      var timerTimeout = null

      ;(owner).$on('hook:destroyed', function () { return remove$3(owners, owner); });

      var forceRender = function (renderCompleted) {
        for (var i = 0, l = owners.length; i < l; i++) {
          (owners[i]).$forceUpdate();
        }

        if (renderCompleted) {
          owners.length = 0;
          if (timerLoading !== null) {
            clearTimeout(timerLoading);
            timerLoading = null;
          }
          if (timerTimeout !== null) {
            clearTimeout(timerTimeout);
            timerTimeout = null;
          }
        }
      };

      var resolve = once$2(function (res) {
        // cache resolved
        factory.resolved = ensureCtor$1(res, baseCtor);
        // invoke callbacks only if this is not a synchronous resolve
        // (async resolves are shimmed as synchronous during SSR)
        if (!sync) {
          forceRender(true);
        } else {
          owners.length = 0;
        }
      });

      var reject = once$2(function (reason) {
        warn$3(
          "Failed to resolve async component: " + (String(factory)) +
          (reason ? ("\nReason: " + reason) : '')
        );
        if (isDef$1(factory.errorComp)) {
          factory.error = true;
          forceRender(true);
        }
      });

      var res = factory(resolve, reject);

      if (isObject$6(res)) {
        if (isPromise$2(res)) {
          // () => Promise
          if (isUndef$1(factory.resolved)) {
            res.then(resolve, reject);
          }
        } else if (isPromise$2(res.component)) {
          res.component.then(resolve, reject);

          if (isDef$1(res.error)) {
            factory.errorComp = ensureCtor$1(res.error, baseCtor);
          }

          if (isDef$1(res.loading)) {
            factory.loadingComp = ensureCtor$1(res.loading, baseCtor);
            if (res.delay === 0) {
              factory.loading = true;
            } else {
              timerLoading = setTimeout(function () {
                timerLoading = null;
                if (isUndef$1(factory.resolved) && isUndef$1(factory.error)) {
                  factory.loading = true;
                  forceRender(false);
                }
              }, res.delay || 200);
            }
          }

          if (isDef$1(res.timeout)) {
            timerTimeout = setTimeout(function () {
              timerTimeout = null;
              if (isUndef$1(factory.resolved)) {
                reject(
                  ("timeout (" + (res.timeout) + "ms)")
                    
                );
              }
            }, res.timeout);
          }
        }
      }

      sync = false;
      // return in case resolved synchronously
      return factory.loading
        ? factory.loadingComp
        : factory.resolved
    }
  }

  /*  */

  function isAsyncPlaceholder$1 (node) {
    return node.isComment && node.asyncFactory
  }

  /*  */

  function getFirstComponentChild$1 (children) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; i++) {
        var c = children[i];
        if (isDef$1(c) && (isDef$1(c.componentOptions) || isAsyncPlaceholder$1(c))) {
          return c
        }
      }
    }
  }

  /*  */

  /*  */

  function initEvents$1 (vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
      updateComponentListeners$1(vm, listeners);
    }
  }

  var target$2;

  function add$2 (event, fn) {
    target$2.$on(event, fn);
  }

  function remove$1$1 (event, fn) {
    target$2.$off(event, fn);
  }

  function createOnceHandler$2 (event, fn) {
    var _target = target$2;
    return function onceHandler () {
      var res = fn.apply(null, arguments);
      if (res !== null) {
        _target.$off(event, onceHandler);
      }
    }
  }

  function updateComponentListeners$1 (
    vm,
    listeners,
    oldListeners
  ) {
    target$2 = vm;
    updateListeners$1(listeners, oldListeners || {}, add$2, remove$1$1, createOnceHandler$2, vm);
    target$2 = undefined;
  }

  function eventsMixin$1 (Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
      var vm = this;
      if (Array.isArray(event)) {
        for (var i = 0, l = event.length; i < l; i++) {
          vm.$on(event[i], fn);
        }
      } else {
        (vm._events[event] || (vm._events[event] = [])).push(fn);
        // optimize hook:event cost by using a boolean flag marked at registration
        // instead of a hash lookup
        if (hookRE.test(event)) {
          vm._hasHookEvent = true;
        }
      }
      return vm
    };

    Vue.prototype.$once = function (event, fn) {
      var vm = this;
      function on () {
        vm.$off(event, on);
        fn.apply(vm, arguments);
      }
      on.fn = fn;
      vm.$on(event, on);
      return vm
    };

    Vue.prototype.$off = function (event, fn) {
      var vm = this;
      // all
      if (!arguments.length) {
        vm._events = Object.create(null);
        return vm
      }
      // array of events
      if (Array.isArray(event)) {
        for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
          vm.$off(event[i$1], fn);
        }
        return vm
      }
      // specific event
      var cbs = vm._events[event];
      if (!cbs) {
        return vm
      }
      if (!fn) {
        vm._events[event] = null;
        return vm
      }
      // specific handler
      var cb;
      var i = cbs.length;
      while (i--) {
        cb = cbs[i];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i, 1);
          break
        }
      }
      return vm
    };

    Vue.prototype.$emit = function (event) {
      var vm = this;
      {
        var lowerCaseEvent = event.toLowerCase();
        if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
          tip$1(
            "Event \"" + lowerCaseEvent + "\" is emitted in component " +
            (formatComponentName$1(vm)) + " but the handler is registered for \"" + event + "\". " +
            "Note that HTML attributes are case-insensitive and you cannot use " +
            "v-on to listen to camelCase events when using in-DOM templates. " +
            "You should probably use \"" + (hyphenate$1(event)) + "\" instead of \"" + event + "\"."
          );
        }
      }
      var cbs = vm._events[event];
      if (cbs) {
        cbs = cbs.length > 1 ? toArray$1(cbs) : cbs;
        var args = toArray$1(arguments, 1);
        var info = "event handler for \"" + event + "\"";
        for (var i = 0, l = cbs.length; i < l; i++) {
          invokeWithErrorHandling$1(cbs[i], vm, args, vm, info);
        }
      }
      return vm
    };
  }

  /*  */

  var activeInstance$1 = null;
  var isUpdatingChildComponent$1 = false;

  function setActiveInstance$1(vm) {
    var prevActiveInstance = activeInstance$1;
    activeInstance$1 = vm;
    return function () {
      activeInstance$1 = prevActiveInstance;
    }
  }

  function initLifecycle$1 (vm) {
    var options = vm.$options;

    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
      while (parent.$options.abstract && parent.$parent) {
        parent = parent.$parent;
      }
      parent.$children.push(vm);
    }

    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;

    vm.$children = [];
    vm.$refs = {};

    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
  }

  function lifecycleMixin$1 (Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
      var vm = this;
      var prevEl = vm.$el;
      var prevVnode = vm._vnode;
      var restoreActiveInstance = setActiveInstance$1(vm);
      vm._vnode = vnode;
      // Vue.prototype.__patch__ is injected in entry points
      // based on the rendering backend used.
      if (!prevVnode) {
        // initial render
        vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
      } else {
        // updates
        vm.$el = vm.__patch__(prevVnode, vnode);
      }
      restoreActiveInstance();
      // update __vue__ reference
      if (prevEl) {
        prevEl.__vue__ = null;
      }
      if (vm.$el) {
        vm.$el.__vue__ = vm;
      }
      // if parent is an HOC, update its $el as well
      if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
        vm.$parent.$el = vm.$el;
      }
      // updated hook is called by the scheduler to ensure that children are
      // updated in a parent's updated hook.
    };

    Vue.prototype.$forceUpdate = function () {
      var vm = this;
      if (vm._watcher) {
        vm._watcher.update();
      }
    };

    Vue.prototype.$destroy = function () {
      var vm = this;
      if (vm._isBeingDestroyed) {
        return
      }
      callHook$2(vm, 'beforeDestroy');
      vm._isBeingDestroyed = true;
      // remove self from parent
      var parent = vm.$parent;
      if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
        remove$3(parent.$children, vm);
      }
      // teardown watchers
      if (vm._watcher) {
        vm._watcher.teardown();
      }
      var i = vm._watchers.length;
      while (i--) {
        vm._watchers[i].teardown();
      }
      // remove reference from data ob
      // frozen object may not have observer.
      if (vm._data.__ob__) {
        vm._data.__ob__.vmCount--;
      }
      // call the last hook...
      vm._isDestroyed = true;
      // invoke destroy hooks on current rendered tree
      vm.__patch__(vm._vnode, null);
      // fire destroyed hook
      callHook$2(vm, 'destroyed');
      // turn off all instance listeners.
      vm.$off();
      // remove __vue__ reference
      if (vm.$el) {
        vm.$el.__vue__ = null;
      }
      // release circular reference (#6759)
      if (vm.$vnode) {
        vm.$vnode.parent = null;
      }
    };
  }

  function mountComponent$1 (
    vm,
    el,
    hydrating
  ) {
    vm.$el = el;
    if (!vm.$options.render) {
      vm.$options.render = createEmptyVNode$1;
      {
        /* istanbul ignore if */
        if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
          vm.$options.el || el) {
          warn$3(
            'You are using the runtime-only build of Vue where the template ' +
            'compiler is not available. Either pre-compile the templates into ' +
            'render functions, or use the compiler-included build.',
            vm
          );
        } else {
          warn$3(
            'Failed to mount component: template or render function not defined.',
            vm
          );
        }
      }
    }
    callHook$2(vm, 'beforeMount');

    var updateComponent;
    /* istanbul ignore if */
    if (config$2.performance && mark$1) {
      updateComponent = function () {
        var name = vm._name;
        var id = vm._uid;
        var startTag = "vue-perf-start:" + id;
        var endTag = "vue-perf-end:" + id;

        mark$1(startTag);
        var vnode = vm._render();
        mark$1(endTag);
        measure$1(("vue " + name + " render"), startTag, endTag);

        mark$1(startTag);
        vm._update(vnode, hydrating);
        mark$1(endTag);
        measure$1(("vue " + name + " patch"), startTag, endTag);
      };
    } else {
      updateComponent = function () {
        vm._update(vm._render(), hydrating);
      };
    }

    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher$1(vm, updateComponent, noop$2, {
      before: function before () {
        if (vm._isMounted && !vm._isDestroyed) {
          callHook$2(vm, 'beforeUpdate');
        }
      }
    }, true /* isRenderWatcher */);
    hydrating = false;

    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
      vm._isMounted = true;
      callHook$2(vm, 'mounted');
    }
    return vm
  }

  function updateChildComponent$1 (
    vm,
    propsData,
    listeners,
    parentVnode,
    renderChildren
  ) {
    {
      isUpdatingChildComponent$1 = true;
    }

    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.

    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!(
      (newScopedSlots && !newScopedSlots.$stable) ||
      (oldScopedSlots !== emptyObject$1 && !oldScopedSlots.$stable) ||
      (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
    );

    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(
      renderChildren ||               // has new static slots
      vm.$options._renderChildren ||  // has old static slots
      hasDynamicScopedSlot
    );

    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render

    if (vm._vnode) { // update child tree's parent
      vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;

    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    vm.$attrs = parentVnode.data.attrs || emptyObject$1;
    vm.$listeners = listeners || emptyObject$1;

    // update props
    if (propsData && vm.$options.props) {
      toggleObserving$1(false);
      var props = vm._props;
      var propKeys = vm.$options._propKeys || [];
      for (var i = 0; i < propKeys.length; i++) {
        var key = propKeys[i];
        var propOptions = vm.$options.props; // wtf flow?
        props[key] = validateProp$1(key, propOptions, propsData, vm);
      }
      toggleObserving$1(true);
      // keep a copy of raw propsData
      vm.$options.propsData = propsData;
    }

    // update listeners
    listeners = listeners || emptyObject$1;
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners$1(vm, listeners, oldListeners);

    // resolve slots + force update if has children
    if (needsForceUpdate) {
      vm.$slots = resolveSlots$1(renderChildren, parentVnode.context);
      vm.$forceUpdate();
    }

    {
      isUpdatingChildComponent$1 = false;
    }
  }

  function isInInactiveTree$1 (vm) {
    while (vm && (vm = vm.$parent)) {
      if (vm._inactive) { return true }
    }
    return false
  }

  function activateChildComponent$1 (vm, direct) {
    if (direct) {
      vm._directInactive = false;
      if (isInInactiveTree$1(vm)) {
        return
      }
    } else if (vm._directInactive) {
      return
    }
    if (vm._inactive || vm._inactive === null) {
      vm._inactive = false;
      for (var i = 0; i < vm.$children.length; i++) {
        activateChildComponent$1(vm.$children[i]);
      }
      callHook$2(vm, 'activated');
    }
  }

  function deactivateChildComponent$1 (vm, direct) {
    if (direct) {
      vm._directInactive = true;
      if (isInInactiveTree$1(vm)) {
        return
      }
    }
    if (!vm._inactive) {
      vm._inactive = true;
      for (var i = 0; i < vm.$children.length; i++) {
        deactivateChildComponent$1(vm.$children[i]);
      }
      callHook$2(vm, 'deactivated');
    }
  }

  function callHook$2 (vm, hook) {
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget$1();
    var handlers = vm.$options[hook];
    var info = hook + " hook";
    if (handlers) {
      for (var i = 0, j = handlers.length; i < j; i++) {
        invokeWithErrorHandling$1(handlers[i], vm, null, vm, info);
      }
    }
    if (vm._hasHookEvent) {
      vm.$emit('hook:' + hook);
    }
    popTarget$1();
  }

  /*  */

  var MAX_UPDATE_COUNT$1 = 100;

  var queue$2 = [];
  var activatedChildren$1 = [];
  var has$1 = {};
  var circular$1 = {};
  var waiting$1 = false;
  var flushing$1 = false;
  var index$2 = 0;

  /**
   * Reset the scheduler's state.
   */
  function resetSchedulerState$1 () {
    index$2 = queue$2.length = activatedChildren$1.length = 0;
    has$1 = {};
    {
      circular$1 = {};
    }
    waiting$1 = flushing$1 = false;
  }

  // Async edge case #6566 requires saving the timestamp when event listeners are
  // attached. However, calling performance.now() has a perf overhead especially
  // if the page has thousands of event listeners. Instead, we take a timestamp
  // every time the scheduler flushes and use that for all event listeners
  // attached during that flush.
  var currentFlushTimestamp$1 = 0;

  // Async edge case fix requires storing an event listener's attach timestamp.
  var getNow$1 = Date.now;

  // Determine what event timestamp the browser is using. Annoyingly, the
  // timestamp can either be hi-res (relative to page load) or low-res
  // (relative to UNIX epoch), so in order to compare time we have to use the
  // same timestamp type when saving the flush timestamp.
  // All IE versions use low-res event timestamps, and have problematic clock
  // implementations (#9632)
  if (inBrowser$1 && !isIE$1) {
    var performance$2 = window.performance;
    if (
      performance$2 &&
      typeof performance$2.now === 'function' &&
      getNow$1() > document.createEvent('Event').timeStamp
    ) {
      // if the event timestamp, although evaluated AFTER the Date.now(), is
      // smaller than it, it means the event is using a hi-res timestamp,
      // and we need to use the hi-res version for event listener timestamps as
      // well.
      getNow$1 = function () { return performance$2.now(); };
    }
  }

  /**
   * Flush both queues and run the watchers.
   */
  function flushSchedulerQueue$1 () {
    currentFlushTimestamp$1 = getNow$1();
    flushing$1 = true;
    var watcher, id;

    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue$2.sort(function (a, b) { return a.id - b.id; });

    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index$2 = 0; index$2 < queue$2.length; index$2++) {
      watcher = queue$2[index$2];
      if (watcher.before) {
        watcher.before();
      }
      id = watcher.id;
      has$1[id] = null;
      watcher.run();
      // in dev build, check and stop circular updates.
      if (has$1[id] != null) {
        circular$1[id] = (circular$1[id] || 0) + 1;
        if (circular$1[id] > MAX_UPDATE_COUNT$1) {
          warn$3(
            'You may have an infinite update loop ' + (
              watcher.user
                ? ("in watcher with expression \"" + (watcher.expression) + "\"")
                : "in a component render function."
            ),
            watcher.vm
          );
          break
        }
      }
    }

    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren$1.slice();
    var updatedQueue = queue$2.slice();

    resetSchedulerState$1();

    // call component updated and activated hooks
    callActivatedHooks$1(activatedQueue);
    callUpdatedHooks$1(updatedQueue);

    // devtool hook
    /* istanbul ignore if */
    if (devtools$1 && config$2.devtools) {
      devtools$1.emit('flush');
    }
  }

  function callUpdatedHooks$1 (queue) {
    var i = queue.length;
    while (i--) {
      var watcher = queue[i];
      var vm = watcher.vm;
      if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
        callHook$2(vm, 'updated');
      }
    }
  }

  /**
   * Queue a kept-alive component that was activated during patch.
   * The queue will be processed after the entire tree has been patched.
   */
  function queueActivatedComponent$1 (vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren$1.push(vm);
  }

  function callActivatedHooks$1 (queue) {
    for (var i = 0; i < queue.length; i++) {
      queue[i]._inactive = true;
      activateChildComponent$1(queue[i], true /* true */);
    }
  }

  /**
   * Push a watcher into the watcher queue.
   * Jobs with duplicate IDs will be skipped unless it's
   * pushed when the queue is being flushed.
   */
  function queueWatcher$1 (watcher) {
    var id = watcher.id;
    if (has$1[id] == null) {
      has$1[id] = true;
      if (!flushing$1) {
        queue$2.push(watcher);
      } else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue$2.length - 1;
        while (i > index$2 && queue$2[i].id > watcher.id) {
          i--;
        }
        queue$2.splice(i + 1, 0, watcher);
      }
      // queue the flush
      if (!waiting$1) {
        waiting$1 = true;

        if (!config$2.async) {
          flushSchedulerQueue$1();
          return
        }
        nextTick$2(flushSchedulerQueue$1);
      }
    }
  }

  /*  */



  var uid$2$1 = 0;

  /**
   * A watcher parses an expression, collects dependencies,
   * and fires callback when the expression value changes.
   * This is used for both the $watch() api and directives.
   */
  var Watcher$1 = function Watcher (
    vm,
    expOrFn,
    cb,
    options,
    isRenderWatcher
  ) {
    this.vm = vm;
    if (isRenderWatcher) {
      vm._watcher = this;
    }
    vm._watchers.push(this);
    // options
    if (options) {
      this.deep = !!options.deep;
      this.user = !!options.user;
      this.lazy = !!options.lazy;
      this.sync = !!options.sync;
      this.before = options.before;
    } else {
      this.deep = this.user = this.lazy = this.sync = false;
    }
    this.cb = cb;
    this.id = ++uid$2$1; // uid for batching
    this.active = true;
    this.dirty = this.lazy; // for lazy watchers
    this.deps = [];
    this.newDeps = [];
    this.depIds = new _Set$1();
    this.newDepIds = new _Set$1();
    this.expression = expOrFn.toString()
      ;
    // parse expression for getter
    if (typeof expOrFn === 'function') {
      this.getter = expOrFn;
    } else {
      this.getter = parsePath$1(expOrFn);
      if (!this.getter) {
        this.getter = noop$2;
        warn$3(
          "Failed watching path: \"" + expOrFn + "\" " +
          'Watcher only accepts simple dot-delimited paths. ' +
          'For full control, use a function instead.',
          vm
        );
      }
    }
    this.value = this.lazy
      ? undefined
      : this.get();
  };

  /**
   * Evaluate the getter, and re-collect dependencies.
   */
  Watcher$1.prototype.get = function get () {
    pushTarget$1(this);
    var value;
    var vm = this.vm;
    try {
      value = this.getter.call(vm, vm);
    } catch (e) {
      if (this.user) {
        handleError$1(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
      } else {
        throw e
      }
    } finally {
      // "touch" every property so they are all tracked as
      // dependencies for deep watching
      if (this.deep) {
        traverse$1(value);
      }
      popTarget$1();
      this.cleanupDeps();
    }
    return value
  };

  /**
   * Add a dependency to this directive.
   */
  Watcher$1.prototype.addDep = function addDep (dep) {
    var id = dep.id;
    if (!this.newDepIds.has(id)) {
      this.newDepIds.add(id);
      this.newDeps.push(dep);
      if (!this.depIds.has(id)) {
        dep.addSub(this);
      }
    }
  };

  /**
   * Clean up for dependency collection.
   */
  Watcher$1.prototype.cleanupDeps = function cleanupDeps () {
    var i = this.deps.length;
    while (i--) {
      var dep = this.deps[i];
      if (!this.newDepIds.has(dep.id)) {
        dep.removeSub(this);
      }
    }
    var tmp = this.depIds;
    this.depIds = this.newDepIds;
    this.newDepIds = tmp;
    this.newDepIds.clear();
    tmp = this.deps;
    this.deps = this.newDeps;
    this.newDeps = tmp;
    this.newDeps.length = 0;
  };

  /**
   * Subscriber interface.
   * Will be called when a dependency changes.
   */
  Watcher$1.prototype.update = function update () {
    /* istanbul ignore else */
    if (this.lazy) {
      this.dirty = true;
    } else if (this.sync) {
      this.run();
    } else {
      queueWatcher$1(this);
    }
  };

  /**
   * Scheduler job interface.
   * Will be called by the scheduler.
   */
  Watcher$1.prototype.run = function run () {
    if (this.active) {
      var value = this.get();
      if (
        value !== this.value ||
        // Deep watchers and watchers on Object/Arrays should fire even
        // when the value is the same, because the value may
        // have mutated.
        isObject$6(value) ||
        this.deep
      ) {
        // set new value
        var oldValue = this.value;
        this.value = value;
        if (this.user) {
          try {
            this.cb.call(this.vm, value, oldValue);
          } catch (e) {
            handleError$1(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
          }
        } else {
          this.cb.call(this.vm, value, oldValue);
        }
      }
    }
  };

  /**
   * Evaluate the value of the watcher.
   * This only gets called for lazy watchers.
   */
  Watcher$1.prototype.evaluate = function evaluate () {
    this.value = this.get();
    this.dirty = false;
  };

  /**
   * Depend on all deps collected by this watcher.
   */
  Watcher$1.prototype.depend = function depend () {
    var i = this.deps.length;
    while (i--) {
      this.deps[i].depend();
    }
  };

  /**
   * Remove self from all dependencies' subscriber list.
   */
  Watcher$1.prototype.teardown = function teardown () {
    if (this.active) {
      // remove self from vm's watcher list
      // this is a somewhat expensive operation so we skip it
      // if the vm is being destroyed.
      if (!this.vm._isBeingDestroyed) {
        remove$3(this.vm._watchers, this);
      }
      var i = this.deps.length;
      while (i--) {
        this.deps[i].removeSub(this);
      }
      this.active = false;
    }
  };

  /*  */

  var sharedPropertyDefinition$1 = {
    enumerable: true,
    configurable: true,
    get: noop$2,
    set: noop$2
  };

  function proxy$1 (target, sourceKey, key) {
    sharedPropertyDefinition$1.get = function proxyGetter () {
      return this[sourceKey][key]
    };
    sharedPropertyDefinition$1.set = function proxySetter (val) {
      this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition$1);
  }

  function initState$1 (vm) {
    vm._watchers = [];
    var opts = vm.$options;
    if (opts.props) { initProps$2(vm, opts.props); }
    if (opts.methods) { initMethods$1(vm, opts.methods); }
    if (opts.data) {
      initData$1(vm);
    } else {
      observe$1(vm._data = {}, true /* asRootData */);
    }
    if (opts.computed) { initComputed$2(vm, opts.computed); }
    if (opts.watch && opts.watch !== nativeWatch$1) {
      initWatch$1(vm, opts.watch);
    }
  }

  function initProps$2 (vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = vm._props = {};
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = vm.$options._propKeys = [];
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
      toggleObserving$1(false);
    }
    var loop = function ( key ) {
      keys.push(key);
      var value = validateProp$1(key, propsOptions, propsData, vm);
      /* istanbul ignore else */
      {
        var hyphenatedKey = hyphenate$1(key);
        if (isReservedAttribute$1(hyphenatedKey) ||
            config$2.isReservedAttr(hyphenatedKey)) {
          warn$3(
            ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
            vm
          );
        }
        defineReactive$$1$1(props, key, value, function () {
          if (!isRoot && !isUpdatingChildComponent$1) {
            warn$3(
              "Avoid mutating a prop directly since the value will be " +
              "overwritten whenever the parent component re-renders. " +
              "Instead, use a data or computed property based on the prop's " +
              "value. Prop being mutated: \"" + key + "\"",
              vm
            );
          }
        });
      }
      // static props are already proxied on the component's prototype
      // during Vue.extend(). We only need to proxy props defined at
      // instantiation here.
      if (!(key in vm)) {
        proxy$1(vm, "_props", key);
      }
    };

    for (var key in propsOptions) loop( key );
    toggleObserving$1(true);
  }

  function initData$1 (vm) {
    var data = vm.$options.data;
    data = vm._data = typeof data === 'function'
      ? getData$1(data, vm)
      : data || {};
    if (!isPlainObject$2(data)) {
      data = {};
      warn$3(
        'data functions should return an object:\n' +
        'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
        vm
      );
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
      var key = keys[i];
      {
        if (methods && hasOwn$1(methods, key)) {
          warn$3(
            ("Method \"" + key + "\" has already been defined as a data property."),
            vm
          );
        }
      }
      if (props && hasOwn$1(props, key)) {
        warn$3(
          "The data property \"" + key + "\" is already declared as a prop. " +
          "Use prop default value instead.",
          vm
        );
      } else if (!isReserved$1(key)) {
        proxy$1(vm, "_data", key);
      }
    }
    // observe data
    observe$1(data, true /* asRootData */);
  }

  function getData$1 (data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget$1();
    try {
      return data.call(vm, vm)
    } catch (e) {
      handleError$1(e, vm, "data()");
      return {}
    } finally {
      popTarget$1();
    }
  }

  var computedWatcherOptions$1 = { lazy: true };

  function initComputed$2 (vm, computed) {
    // $flow-disable-line
    var watchers = vm._computedWatchers = Object.create(null);
    // computed properties are just getters during SSR
    var isSSR = isServerRendering$1();

    for (var key in computed) {
      var userDef = computed[key];
      var getter = typeof userDef === 'function' ? userDef : userDef.get;
      if (getter == null) {
        warn$3(
          ("Getter is missing for computed property \"" + key + "\"."),
          vm
        );
      }

      if (!isSSR) {
        // create internal watcher for the computed property.
        watchers[key] = new Watcher$1(
          vm,
          getter || noop$2,
          noop$2,
          computedWatcherOptions$1
        );
      }

      // component-defined computed properties are already defined on the
      // component prototype. We only need to define computed properties defined
      // at instantiation here.
      if (!(key in vm)) {
        defineComputed$1(vm, key, userDef);
      } else {
        if (key in vm.$data) {
          warn$3(("The computed property \"" + key + "\" is already defined in data."), vm);
        } else if (vm.$options.props && key in vm.$options.props) {
          warn$3(("The computed property \"" + key + "\" is already defined as a prop."), vm);
        }
      }
    }
  }

  function defineComputed$1 (
    target,
    key,
    userDef
  ) {
    var shouldCache = !isServerRendering$1();
    if (typeof userDef === 'function') {
      sharedPropertyDefinition$1.get = shouldCache
        ? createComputedGetter$1(key)
        : createGetterInvoker$1(userDef);
      sharedPropertyDefinition$1.set = noop$2;
    } else {
      sharedPropertyDefinition$1.get = userDef.get
        ? shouldCache && userDef.cache !== false
          ? createComputedGetter$1(key)
          : createGetterInvoker$1(userDef.get)
        : noop$2;
      sharedPropertyDefinition$1.set = userDef.set || noop$2;
    }
    if (sharedPropertyDefinition$1.set === noop$2) {
      sharedPropertyDefinition$1.set = function () {
        warn$3(
          ("Computed property \"" + key + "\" was assigned to but it has no setter."),
          this
        );
      };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition$1);
  }

  function createComputedGetter$1 (key) {
    return function computedGetter () {
      var watcher = this._computedWatchers && this._computedWatchers[key];
      if (watcher) {
        if (watcher.dirty) {
          watcher.evaluate();
        }
        if (Dep$1.target) {
          watcher.depend();
        }
        return watcher.value
      }
    }
  }

  function createGetterInvoker$1(fn) {
    return function computedGetter () {
      return fn.call(this, this)
    }
  }

  function initMethods$1 (vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
      {
        if (typeof methods[key] !== 'function') {
          warn$3(
            "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
            "Did you reference the function correctly?",
            vm
          );
        }
        if (props && hasOwn$1(props, key)) {
          warn$3(
            ("Method \"" + key + "\" has already been defined as a prop."),
            vm
          );
        }
        if ((key in vm) && isReserved$1(key)) {
          warn$3(
            "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
            "Avoid defining component methods that start with _ or $."
          );
        }
      }
      vm[key] = typeof methods[key] !== 'function' ? noop$2 : bind$4(methods[key], vm);
    }
  }

  function initWatch$1 (vm, watch) {
    for (var key in watch) {
      var handler = watch[key];
      if (Array.isArray(handler)) {
        for (var i = 0; i < handler.length; i++) {
          createWatcher$1(vm, key, handler[i]);
        }
      } else {
        createWatcher$1(vm, key, handler);
      }
    }
  }

  function createWatcher$1 (
    vm,
    expOrFn,
    handler,
    options
  ) {
    if (isPlainObject$2(handler)) {
      options = handler;
      handler = handler.handler;
    }
    if (typeof handler === 'string') {
      handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options)
  }

  function stateMixin$1 (Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () { return this._data };
    var propsDef = {};
    propsDef.get = function () { return this._props };
    {
      dataDef.set = function () {
        warn$3(
          'Avoid replacing instance root $data. ' +
          'Use nested data properties instead.',
          this
        );
      };
      propsDef.set = function () {
        warn$3("$props is readonly.", this);
      };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);

    Vue.prototype.$set = set$1;
    Vue.prototype.$delete = del$1;

    Vue.prototype.$watch = function (
      expOrFn,
      cb,
      options
    ) {
      var vm = this;
      if (isPlainObject$2(cb)) {
        return createWatcher$1(vm, expOrFn, cb, options)
      }
      options = options || {};
      options.user = true;
      var watcher = new Watcher$1(vm, expOrFn, cb, options);
      if (options.immediate) {
        try {
          cb.call(vm, watcher.value);
        } catch (error) {
          handleError$1(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
        }
      }
      return function unwatchFn () {
        watcher.teardown();
      }
    };
  }

  /*  */

  var uid$3$1 = 0;

  function initMixin$2 (Vue) {
    Vue.prototype._init = function (options) {
      var vm = this;
      // a uid
      vm._uid = uid$3$1++;

      var startTag, endTag;
      /* istanbul ignore if */
      if (config$2.performance && mark$1) {
        startTag = "vue-perf-start:" + (vm._uid);
        endTag = "vue-perf-end:" + (vm._uid);
        mark$1(startTag);
      }

      // a flag to avoid this being observed
      vm._isVue = true;
      // merge options
      if (options && options._isComponent) {
        // optimize internal component instantiation
        // since dynamic options merging is pretty slow, and none of the
        // internal component options needs special treatment.
        initInternalComponent$1(vm, options);
      } else {
        vm.$options = mergeOptions$1(
          resolveConstructorOptions$1(vm.constructor),
          options || {},
          vm
        );
      }
      /* istanbul ignore else */
      {
        initProxy$1(vm);
      }
      // expose real self
      vm._self = vm;
      initLifecycle$1(vm);
      initEvents$1(vm);
      initRender$1(vm);
      callHook$2(vm, 'beforeCreate');
      initInjections$1(vm); // resolve injections before data/props
      initState$1(vm);
      initProvide$1(vm); // resolve provide after data/props
      callHook$2(vm, 'created');

      /* istanbul ignore if */
      if (config$2.performance && mark$1) {
        vm._name = formatComponentName$1(vm, false);
        mark$1(endTag);
        measure$1(("vue " + (vm._name) + " init"), startTag, endTag);
      }

      if (vm.$options.el) {
        vm.$mount(vm.$options.el);
      }
    };
  }

  function initInternalComponent$1 (vm, options) {
    var opts = vm.$options = Object.create(vm.constructor.options);
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;

    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;

    if (options.render) {
      opts.render = options.render;
      opts.staticRenderFns = options.staticRenderFns;
    }
  }

  function resolveConstructorOptions$1 (Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
      var superOptions = resolveConstructorOptions$1(Ctor.super);
      var cachedSuperOptions = Ctor.superOptions;
      if (superOptions !== cachedSuperOptions) {
        // super option changed,
        // need to resolve new options.
        Ctor.superOptions = superOptions;
        // check if there are any late-modified/attached options (#4976)
        var modifiedOptions = resolveModifiedOptions$1(Ctor);
        // update base extend options
        if (modifiedOptions) {
          extend$2(Ctor.extendOptions, modifiedOptions);
        }
        options = Ctor.options = mergeOptions$1(superOptions, Ctor.extendOptions);
        if (options.name) {
          options.components[options.name] = Ctor;
        }
      }
    }
    return options
  }

  function resolveModifiedOptions$1 (Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
      if (latest[key] !== sealed[key]) {
        if (!modified) { modified = {}; }
        modified[key] = latest[key];
      }
    }
    return modified
  }

  function Vue$3 (options) {
    if (!(this instanceof Vue$3)
    ) {
      warn$3('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
  }

  initMixin$2(Vue$3);
  stateMixin$1(Vue$3);
  eventsMixin$1(Vue$3);
  lifecycleMixin$1(Vue$3);
  renderMixin$1(Vue$3);

  /*  */

  function initUse$1 (Vue) {
    Vue.use = function (plugin) {
      var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
      if (installedPlugins.indexOf(plugin) > -1) {
        return this
      }

      // additional parameters
      var args = toArray$1(arguments, 1);
      args.unshift(this);
      if (typeof plugin.install === 'function') {
        plugin.install.apply(plugin, args);
      } else if (typeof plugin === 'function') {
        plugin.apply(null, args);
      }
      installedPlugins.push(plugin);
      return this
    };
  }

  /*  */

  function initMixin$1$1 (Vue) {
    Vue.mixin = function (mixin) {
      this.options = mergeOptions$1(this.options, mixin);
      return this
    };
  }

  /*  */

  function initExtend$1 (Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;

    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
      extendOptions = extendOptions || {};
      var Super = this;
      var SuperId = Super.cid;
      var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
      if (cachedCtors[SuperId]) {
        return cachedCtors[SuperId]
      }

      var name = extendOptions.name || Super.options.name;
      if (name) {
        validateComponentName$1(name);
      }

      var Sub = function VueComponent (options) {
        this._init(options);
      };
      Sub.prototype = Object.create(Super.prototype);
      Sub.prototype.constructor = Sub;
      Sub.cid = cid++;
      Sub.options = mergeOptions$1(
        Super.options,
        extendOptions
      );
      Sub['super'] = Super;

      // For props and computed properties, we define the proxy getters on
      // the Vue instances at extension time, on the extended prototype. This
      // avoids Object.defineProperty calls for each instance created.
      if (Sub.options.props) {
        initProps$1$1(Sub);
      }
      if (Sub.options.computed) {
        initComputed$1$1(Sub);
      }

      // allow further extension/mixin/plugin usage
      Sub.extend = Super.extend;
      Sub.mixin = Super.mixin;
      Sub.use = Super.use;

      // create asset registers, so extended classes
      // can have their private assets too.
      ASSET_TYPES$1.forEach(function (type) {
        Sub[type] = Super[type];
      });
      // enable recursive self-lookup
      if (name) {
        Sub.options.components[name] = Sub;
      }

      // keep a reference to the super options at extension time.
      // later at instantiation we can check if Super's options have
      // been updated.
      Sub.superOptions = Super.options;
      Sub.extendOptions = extendOptions;
      Sub.sealedOptions = extend$2({}, Sub.options);

      // cache constructor
      cachedCtors[SuperId] = Sub;
      return Sub
    };
  }

  function initProps$1$1 (Comp) {
    var props = Comp.options.props;
    for (var key in props) {
      proxy$1(Comp.prototype, "_props", key);
    }
  }

  function initComputed$1$1 (Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
      defineComputed$1(Comp.prototype, key, computed[key]);
    }
  }

  /*  */

  function initAssetRegisters$1 (Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES$1.forEach(function (type) {
      Vue[type] = function (
        id,
        definition
      ) {
        if (!definition) {
          return this.options[type + 's'][id]
        } else {
          /* istanbul ignore if */
          if (type === 'component') {
            validateComponentName$1(id);
          }
          if (type === 'component' && isPlainObject$2(definition)) {
            definition.name = definition.name || id;
            definition = this.options._base.extend(definition);
          }
          if (type === 'directive' && typeof definition === 'function') {
            definition = { bind: definition, update: definition };
          }
          this.options[type + 's'][id] = definition;
          return definition
        }
      };
    });
  }

  /*  */



  function getComponentName$1 (opts) {
    return opts && (opts.Ctor.options.name || opts.tag)
  }

  function matches$1 (pattern, name) {
    if (Array.isArray(pattern)) {
      return pattern.indexOf(name) > -1
    } else if (typeof pattern === 'string') {
      return pattern.split(',').indexOf(name) > -1
    } else if (isRegExp$1(pattern)) {
      return pattern.test(name)
    }
    /* istanbul ignore next */
    return false
  }

  function pruneCache$1 (keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache;
    var keys = keepAliveInstance.keys;
    var _vnode = keepAliveInstance._vnode;
    for (var key in cache) {
      var cachedNode = cache[key];
      if (cachedNode) {
        var name = getComponentName$1(cachedNode.componentOptions);
        if (name && !filter(name)) {
          pruneCacheEntry$1(cache, key, keys, _vnode);
        }
      }
    }
  }

  function pruneCacheEntry$1 (
    cache,
    key,
    keys,
    current
  ) {
    var cached$$1 = cache[key];
    if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
      cached$$1.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$3(keys, key);
  }

  var patternTypes$1 = [String, RegExp, Array];

  var KeepAlive$1 = {
    name: 'keep-alive',
    abstract: true,

    props: {
      include: patternTypes$1,
      exclude: patternTypes$1,
      max: [String, Number]
    },

    created: function created () {
      this.cache = Object.create(null);
      this.keys = [];
    },

    destroyed: function destroyed () {
      for (var key in this.cache) {
        pruneCacheEntry$1(this.cache, key, this.keys);
      }
    },

    mounted: function mounted () {
      var this$1$1 = this;

      this.$watch('include', function (val) {
        pruneCache$1(this$1$1, function (name) { return matches$1(val, name); });
      });
      this.$watch('exclude', function (val) {
        pruneCache$1(this$1$1, function (name) { return !matches$1(val, name); });
      });
    },

    render: function render () {
      var slot = this.$slots.default;
      var vnode = getFirstComponentChild$1(slot);
      var componentOptions = vnode && vnode.componentOptions;
      if (componentOptions) {
        // check pattern
        var name = getComponentName$1(componentOptions);
        var ref = this;
        var include = ref.include;
        var exclude = ref.exclude;
        if (
          // not included
          (include && (!name || !matches$1(include, name))) ||
          // excluded
          (exclude && name && matches$1(exclude, name))
        ) {
          return vnode
        }

        var ref$1 = this;
        var cache = ref$1.cache;
        var keys = ref$1.keys;
        var key = vnode.key == null
          // same constructor may get registered as different local components
          // so cid alone is not enough (#3269)
          ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
          : vnode.key;
        if (cache[key]) {
          vnode.componentInstance = cache[key].componentInstance;
          // make current key freshest
          remove$3(keys, key);
          keys.push(key);
        } else {
          cache[key] = vnode;
          keys.push(key);
          // prune oldest entry
          if (this.max && keys.length > parseInt(this.max)) {
            pruneCacheEntry$1(cache, keys[0], keys, this._vnode);
          }
        }

        vnode.data.keepAlive = true;
      }
      return vnode || (slot && slot[0])
    }
  };

  var builtInComponents$1 = {
    KeepAlive: KeepAlive$1
  };

  /*  */

  function initGlobalAPI$1 (Vue) {
    // config
    var configDef = {};
    configDef.get = function () { return config$2; };
    {
      configDef.set = function () {
        warn$3(
          'Do not replace the Vue.config object, set individual fields instead.'
        );
      };
    }
    Object.defineProperty(Vue, 'config', configDef);

    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
      warn: warn$3,
      extend: extend$2,
      mergeOptions: mergeOptions$1,
      defineReactive: defineReactive$$1$1
    };

    Vue.set = set$1;
    Vue.delete = del$1;
    Vue.nextTick = nextTick$2;

    // 2.6 explicit observable API
    Vue.observable = function (obj) {
      observe$1(obj);
      return obj
    };

    Vue.options = Object.create(null);
    ASSET_TYPES$1.forEach(function (type) {
      Vue.options[type + 's'] = Object.create(null);
    });

    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;

    extend$2(Vue.options.components, builtInComponents$1);

    initUse$1(Vue);
    initMixin$1$1(Vue);
    initExtend$1(Vue);
    initAssetRegisters$1(Vue);
  }

  initGlobalAPI$1(Vue$3);

  Object.defineProperty(Vue$3.prototype, '$isServer', {
    get: isServerRendering$1
  });

  Object.defineProperty(Vue$3.prototype, '$ssrContext', {
    get: function get () {
      /* istanbul ignore next */
      return this.$vnode && this.$vnode.ssrContext
    }
  });

  // expose FunctionalRenderContext for ssr runtime helper installation
  Object.defineProperty(Vue$3, 'FunctionalRenderContext', {
    value: FunctionalRenderContext$1
  });

  Vue$3.version = '2.6.12';

  /*  */

  // these are reserved for web because they are directly compiled away
  // during template compilation
  var isReservedAttr$1 = makeMap$1('style,class');

  // attributes that should be using props for binding
  var acceptValue$1 = makeMap$1('input,textarea,option,select,progress');
  var mustUseProp$1 = function (tag, type, attr) {
    return (
      (attr === 'value' && acceptValue$1(tag)) && type !== 'button' ||
      (attr === 'selected' && tag === 'option') ||
      (attr === 'checked' && tag === 'input') ||
      (attr === 'muted' && tag === 'video')
    )
  };

  var isEnumeratedAttr$1 = makeMap$1('contenteditable,draggable,spellcheck');

  var isValidContentEditableValue$1 = makeMap$1('events,caret,typing,plaintext-only');

  var convertEnumeratedValue$1 = function (key, value) {
    return isFalsyAttrValue$1(value) || value === 'false'
      ? 'false'
      // allow arbitrary string value for contenteditable
      : key === 'contenteditable' && isValidContentEditableValue$1(value)
        ? value
        : 'true'
  };

  var isBooleanAttr$1 = makeMap$1(
    'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
    'required,reversed,scoped,seamless,selected,sortable,translate,' +
    'truespeed,typemustmatch,visible'
  );

  var xlinkNS$1 = 'http://www.w3.org/1999/xlink';

  var isXlink$1 = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
  };

  var getXlinkProp$1 = function (name) {
    return isXlink$1(name) ? name.slice(6, name.length) : ''
  };

  var isFalsyAttrValue$1 = function (val) {
    return val == null || val === false
  };

  /*  */

  function genClassForVnode$1 (vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef$1(childNode.componentInstance)) {
      childNode = childNode.componentInstance._vnode;
      if (childNode && childNode.data) {
        data = mergeClassData$1(childNode.data, data);
      }
    }
    while (isDef$1(parentNode = parentNode.parent)) {
      if (parentNode && parentNode.data) {
        data = mergeClassData$1(data, parentNode.data);
      }
    }
    return renderClass$1(data.staticClass, data.class)
  }

  function mergeClassData$1 (child, parent) {
    return {
      staticClass: concat$1(child.staticClass, parent.staticClass),
      class: isDef$1(child.class)
        ? [child.class, parent.class]
        : parent.class
    }
  }

  function renderClass$1 (
    staticClass,
    dynamicClass
  ) {
    if (isDef$1(staticClass) || isDef$1(dynamicClass)) {
      return concat$1(staticClass, stringifyClass$1(dynamicClass))
    }
    /* istanbul ignore next */
    return ''
  }

  function concat$1 (a, b) {
    return a ? b ? (a + ' ' + b) : a : (b || '')
  }

  function stringifyClass$1 (value) {
    if (Array.isArray(value)) {
      return stringifyArray$1(value)
    }
    if (isObject$6(value)) {
      return stringifyObject$1(value)
    }
    if (typeof value === 'string') {
      return value
    }
    /* istanbul ignore next */
    return ''
  }

  function stringifyArray$1 (value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
      if (isDef$1(stringified = stringifyClass$1(value[i])) && stringified !== '') {
        if (res) { res += ' '; }
        res += stringified;
      }
    }
    return res
  }

  function stringifyObject$1 (value) {
    var res = '';
    for (var key in value) {
      if (value[key]) {
        if (res) { res += ' '; }
        res += key;
      }
    }
    return res
  }

  /*  */

  var namespaceMap$1 = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
  };

  var isHTMLTag$1 = makeMap$1(
    'html,body,base,head,link,meta,style,title,' +
    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
    'embed,object,param,source,canvas,script,noscript,del,ins,' +
    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
    'output,progress,select,textarea,' +
    'details,dialog,menu,menuitem,summary,' +
    'content,element,shadow,template,blockquote,iframe,tfoot'
  );

  // this map is intentionally selective, only covering SVG elements that may
  // contain child elements.
  var isSVG$1 = makeMap$1(
    'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
    'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
    true
  );

  var isReservedTag$1 = function (tag) {
    return isHTMLTag$1(tag) || isSVG$1(tag)
  };

  function getTagNamespace$1 (tag) {
    if (isSVG$1(tag)) {
      return 'svg'
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
      return 'math'
    }
  }

  var unknownElementCache$1 = Object.create(null);
  function isUnknownElement$1 (tag) {
    /* istanbul ignore if */
    if (!inBrowser$1) {
      return true
    }
    if (isReservedTag$1(tag)) {
      return false
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache$1[tag] != null) {
      return unknownElementCache$1[tag]
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
      // http://stackoverflow.com/a/28210364/1070244
      return (unknownElementCache$1[tag] = (
        el.constructor === window.HTMLUnknownElement ||
        el.constructor === window.HTMLElement
      ))
    } else {
      return (unknownElementCache$1[tag] = /HTMLUnknownElement/.test(el.toString()))
    }
  }

  var isTextInputType$1 = makeMap$1('text,number,password,search,email,tel,url');

  /*  */

  /**
   * Query an element selector if it's not an element already.
   */
  function query$1 (el) {
    if (typeof el === 'string') {
      var selected = document.querySelector(el);
      if (!selected) {
        warn$3(
          'Cannot find element: ' + el
        );
        return document.createElement('div')
      }
      return selected
    } else {
      return el
    }
  }

  /*  */

  function createElement$1$1 (tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
      return elm
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
      elm.setAttribute('multiple', 'multiple');
    }
    return elm
  }

  function createElementNS$1 (namespace, tagName) {
    return document.createElementNS(namespaceMap$1[namespace], tagName)
  }

  function createTextNode$1 (text) {
    return document.createTextNode(text)
  }

  function createComment$1 (text) {
    return document.createComment(text)
  }

  function insertBefore$1 (parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
  }

  function removeChild$1 (node, child) {
    node.removeChild(child);
  }

  function appendChild$1 (node, child) {
    node.appendChild(child);
  }

  function parentNode$1 (node) {
    return node.parentNode
  }

  function nextSibling$1 (node) {
    return node.nextSibling
  }

  function tagName$1 (node) {
    return node.tagName
  }

  function setTextContent$1 (node, text) {
    node.textContent = text;
  }

  function setStyleScope$1 (node, scopeId) {
    node.setAttribute(scopeId, '');
  }

  var nodeOps$1 = /*#__PURE__*/Object.freeze({
    createElement: createElement$1$1,
    createElementNS: createElementNS$1,
    createTextNode: createTextNode$1,
    createComment: createComment$1,
    insertBefore: insertBefore$1,
    removeChild: removeChild$1,
    appendChild: appendChild$1,
    parentNode: parentNode$1,
    nextSibling: nextSibling$1,
    tagName: tagName$1,
    setTextContent: setTextContent$1,
    setStyleScope: setStyleScope$1
  });

  /*  */

  var ref$2 = {
    create: function create (_, vnode) {
      registerRef$1(vnode);
    },
    update: function update (oldVnode, vnode) {
      if (oldVnode.data.ref !== vnode.data.ref) {
        registerRef$1(oldVnode, true);
        registerRef$1(vnode);
      }
    },
    destroy: function destroy (vnode) {
      registerRef$1(vnode, true);
    }
  };

  function registerRef$1 (vnode, isRemoval) {
    var key = vnode.data.ref;
    if (!isDef$1(key)) { return }

    var vm = vnode.context;
    var ref = vnode.componentInstance || vnode.elm;
    var refs = vm.$refs;
    if (isRemoval) {
      if (Array.isArray(refs[key])) {
        remove$3(refs[key], ref);
      } else if (refs[key] === ref) {
        refs[key] = undefined;
      }
    } else {
      if (vnode.data.refInFor) {
        if (!Array.isArray(refs[key])) {
          refs[key] = [ref];
        } else if (refs[key].indexOf(ref) < 0) {
          // $flow-disable-line
          refs[key].push(ref);
        }
      } else {
        refs[key] = ref;
      }
    }
  }

  /**
   * Virtual DOM patching algorithm based on Snabbdom by
   * Simon Friis Vindum (@paldepind)
   * Licensed under the MIT License
   * https://github.com/paldepind/snabbdom/blob/master/LICENSE
   *
   * modified by Evan You (@yyx990803)
   *
   * Not type-checking this because this file is perf-critical and the cost
   * of making flow understand it is not worth it.
   */

  var emptyNode$1 = new VNode$1('', {}, []);

  var hooks$1 = ['create', 'activate', 'update', 'remove', 'destroy'];

  function sameVnode$1 (a, b) {
    return (
      a.key === b.key && (
        (
          a.tag === b.tag &&
          a.isComment === b.isComment &&
          isDef$1(a.data) === isDef$1(b.data) &&
          sameInputType$1(a, b)
        ) || (
          isTrue$1(a.isAsyncPlaceholder) &&
          a.asyncFactory === b.asyncFactory &&
          isUndef$1(b.asyncFactory.error)
        )
      )
    )
  }

  function sameInputType$1 (a, b) {
    if (a.tag !== 'input') { return true }
    var i;
    var typeA = isDef$1(i = a.data) && isDef$1(i = i.attrs) && i.type;
    var typeB = isDef$1(i = b.data) && isDef$1(i = i.attrs) && i.type;
    return typeA === typeB || isTextInputType$1(typeA) && isTextInputType$1(typeB)
  }

  function createKeyToOldIdx$1 (children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
      key = children[i].key;
      if (isDef$1(key)) { map[key] = i; }
    }
    return map
  }

  function createPatchFunction$1 (backend) {
    var i, j;
    var cbs = {};

    var modules = backend.modules;
    var nodeOps = backend.nodeOps;

    for (i = 0; i < hooks$1.length; ++i) {
      cbs[hooks$1[i]] = [];
      for (j = 0; j < modules.length; ++j) {
        if (isDef$1(modules[j][hooks$1[i]])) {
          cbs[hooks$1[i]].push(modules[j][hooks$1[i]]);
        }
      }
    }

    function emptyNodeAt (elm) {
      return new VNode$1(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
    }

    function createRmCb (childElm, listeners) {
      function remove$$1 () {
        if (--remove$$1.listeners === 0) {
          removeNode(childElm);
        }
      }
      remove$$1.listeners = listeners;
      return remove$$1
    }

    function removeNode (el) {
      var parent = nodeOps.parentNode(el);
      // element may have already been removed due to v-html / v-text
      if (isDef$1(parent)) {
        nodeOps.removeChild(parent, el);
      }
    }

    function isUnknownElement$$1 (vnode, inVPre) {
      return (
        !inVPre &&
        !vnode.ns &&
        !(
          config$2.ignoredElements.length &&
          config$2.ignoredElements.some(function (ignore) {
            return isRegExp$1(ignore)
              ? ignore.test(vnode.tag)
              : ignore === vnode.tag
          })
        ) &&
        config$2.isUnknownElement(vnode.tag)
      )
    }

    var creatingElmInVPre = 0;

    function createElm (
      vnode,
      insertedVnodeQueue,
      parentElm,
      refElm,
      nested,
      ownerArray,
      index
    ) {
      if (isDef$1(vnode.elm) && isDef$1(ownerArray)) {
        // This vnode was used in a previous render!
        // now it's used as a new node, overwriting its elm would cause
        // potential patch errors down the road when it's used as an insertion
        // reference node. Instead, we clone the node on-demand before creating
        // associated DOM element for it.
        vnode = ownerArray[index] = cloneVNode$1(vnode);
      }

      vnode.isRootInsert = !nested; // for transition enter check
      if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
        return
      }

      var data = vnode.data;
      var children = vnode.children;
      var tag = vnode.tag;
      if (isDef$1(tag)) {
        {
          if (data && data.pre) {
            creatingElmInVPre++;
          }
          if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
            warn$3(
              'Unknown custom element: <' + tag + '> - did you ' +
              'register the component correctly? For recursive components, ' +
              'make sure to provide the "name" option.',
              vnode.context
            );
          }
        }

        vnode.elm = vnode.ns
          ? nodeOps.createElementNS(vnode.ns, tag)
          : nodeOps.createElement(tag, vnode);
        setScope(vnode);

        /* istanbul ignore if */
        {
          createChildren(vnode, children, insertedVnodeQueue);
          if (isDef$1(data)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
          }
          insert(parentElm, vnode.elm, refElm);
        }

        if (data && data.pre) {
          creatingElmInVPre--;
        }
      } else if (isTrue$1(vnode.isComment)) {
        vnode.elm = nodeOps.createComment(vnode.text);
        insert(parentElm, vnode.elm, refElm);
      } else {
        vnode.elm = nodeOps.createTextNode(vnode.text);
        insert(parentElm, vnode.elm, refElm);
      }
    }

    function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
      var i = vnode.data;
      if (isDef$1(i)) {
        var isReactivated = isDef$1(vnode.componentInstance) && i.keepAlive;
        if (isDef$1(i = i.hook) && isDef$1(i = i.init)) {
          i(vnode, false /* hydrating */);
        }
        // after calling the init hook, if the vnode is a child component
        // it should've created a child instance and mounted it. the child
        // component also has set the placeholder vnode's elm.
        // in that case we can just return the element and be done.
        if (isDef$1(vnode.componentInstance)) {
          initComponent(vnode, insertedVnodeQueue);
          insert(parentElm, vnode.elm, refElm);
          if (isTrue$1(isReactivated)) {
            reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
          }
          return true
        }
      }
    }

    function initComponent (vnode, insertedVnodeQueue) {
      if (isDef$1(vnode.data.pendingInsert)) {
        insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
        vnode.data.pendingInsert = null;
      }
      vnode.elm = vnode.componentInstance.$el;
      if (isPatchable(vnode)) {
        invokeCreateHooks(vnode, insertedVnodeQueue);
        setScope(vnode);
      } else {
        // empty component root.
        // skip all element-related modules except for ref (#3455)
        registerRef$1(vnode);
        // make sure to invoke the insert hook
        insertedVnodeQueue.push(vnode);
      }
    }

    function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
      var i;
      // hack for #4339: a reactivated component with inner transition
      // does not trigger because the inner node's created hooks are not called
      // again. It's not ideal to involve module-specific logic in here but
      // there doesn't seem to be a better way to do it.
      var innerNode = vnode;
      while (innerNode.componentInstance) {
        innerNode = innerNode.componentInstance._vnode;
        if (isDef$1(i = innerNode.data) && isDef$1(i = i.transition)) {
          for (i = 0; i < cbs.activate.length; ++i) {
            cbs.activate[i](emptyNode$1, innerNode);
          }
          insertedVnodeQueue.push(innerNode);
          break
        }
      }
      // unlike a newly created component,
      // a reactivated keep-alive component doesn't insert itself
      insert(parentElm, vnode.elm, refElm);
    }

    function insert (parent, elm, ref$$1) {
      if (isDef$1(parent)) {
        if (isDef$1(ref$$1)) {
          if (nodeOps.parentNode(ref$$1) === parent) {
            nodeOps.insertBefore(parent, elm, ref$$1);
          }
        } else {
          nodeOps.appendChild(parent, elm);
        }
      }
    }

    function createChildren (vnode, children, insertedVnodeQueue) {
      if (Array.isArray(children)) {
        {
          checkDuplicateKeys(children);
        }
        for (var i = 0; i < children.length; ++i) {
          createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
        }
      } else if (isPrimitive$1(vnode.text)) {
        nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
      }
    }

    function isPatchable (vnode) {
      while (vnode.componentInstance) {
        vnode = vnode.componentInstance._vnode;
      }
      return isDef$1(vnode.tag)
    }

    function invokeCreateHooks (vnode, insertedVnodeQueue) {
      for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
        cbs.create[i$1](emptyNode$1, vnode);
      }
      i = vnode.data.hook; // Reuse variable
      if (isDef$1(i)) {
        if (isDef$1(i.create)) { i.create(emptyNode$1, vnode); }
        if (isDef$1(i.insert)) { insertedVnodeQueue.push(vnode); }
      }
    }

    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope (vnode) {
      var i;
      if (isDef$1(i = vnode.fnScopeId)) {
        nodeOps.setStyleScope(vnode.elm, i);
      } else {
        var ancestor = vnode;
        while (ancestor) {
          if (isDef$1(i = ancestor.context) && isDef$1(i = i.$options._scopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
          }
          ancestor = ancestor.parent;
        }
      }
      // for slot content they should also get the scopeId from the host instance.
      if (isDef$1(i = activeInstance$1) &&
        i !== vnode.context &&
        i !== vnode.fnContext &&
        isDef$1(i = i.$options._scopeId)
      ) {
        nodeOps.setStyleScope(vnode.elm, i);
      }
    }

    function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
      for (; startIdx <= endIdx; ++startIdx) {
        createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
      }
    }

    function invokeDestroyHook (vnode) {
      var i, j;
      var data = vnode.data;
      if (isDef$1(data)) {
        if (isDef$1(i = data.hook) && isDef$1(i = i.destroy)) { i(vnode); }
        for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
      }
      if (isDef$1(i = vnode.children)) {
        for (j = 0; j < vnode.children.length; ++j) {
          invokeDestroyHook(vnode.children[j]);
        }
      }
    }

    function removeVnodes (vnodes, startIdx, endIdx) {
      for (; startIdx <= endIdx; ++startIdx) {
        var ch = vnodes[startIdx];
        if (isDef$1(ch)) {
          if (isDef$1(ch.tag)) {
            removeAndInvokeRemoveHook(ch);
            invokeDestroyHook(ch);
          } else { // Text node
            removeNode(ch.elm);
          }
        }
      }
    }

    function removeAndInvokeRemoveHook (vnode, rm) {
      if (isDef$1(rm) || isDef$1(vnode.data)) {
        var i;
        var listeners = cbs.remove.length + 1;
        if (isDef$1(rm)) {
          // we have a recursively passed down rm callback
          // increase the listeners count
          rm.listeners += listeners;
        } else {
          // directly removing
          rm = createRmCb(vnode.elm, listeners);
        }
        // recursively invoke hooks on child component root node
        if (isDef$1(i = vnode.componentInstance) && isDef$1(i = i._vnode) && isDef$1(i.data)) {
          removeAndInvokeRemoveHook(i, rm);
        }
        for (i = 0; i < cbs.remove.length; ++i) {
          cbs.remove[i](vnode, rm);
        }
        if (isDef$1(i = vnode.data.hook) && isDef$1(i = i.remove)) {
          i(vnode, rm);
        } else {
          rm();
        }
      } else {
        removeNode(vnode.elm);
      }
    }

    function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
      var oldStartIdx = 0;
      var newStartIdx = 0;
      var oldEndIdx = oldCh.length - 1;
      var oldStartVnode = oldCh[0];
      var oldEndVnode = oldCh[oldEndIdx];
      var newEndIdx = newCh.length - 1;
      var newStartVnode = newCh[0];
      var newEndVnode = newCh[newEndIdx];
      var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

      // removeOnly is a special flag used only by <transition-group>
      // to ensure removed elements stay in correct relative positions
      // during leaving transitions
      var canMove = !removeOnly;

      {
        checkDuplicateKeys(newCh);
      }

      while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
        if (isUndef$1(oldStartVnode)) {
          oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
        } else if (isUndef$1(oldEndVnode)) {
          oldEndVnode = oldCh[--oldEndIdx];
        } else if (sameVnode$1(oldStartVnode, newStartVnode)) {
          patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
          oldStartVnode = oldCh[++oldStartIdx];
          newStartVnode = newCh[++newStartIdx];
        } else if (sameVnode$1(oldEndVnode, newEndVnode)) {
          patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
          oldEndVnode = oldCh[--oldEndIdx];
          newEndVnode = newCh[--newEndIdx];
        } else if (sameVnode$1(oldStartVnode, newEndVnode)) { // Vnode moved right
          patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
          canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
          oldStartVnode = oldCh[++oldStartIdx];
          newEndVnode = newCh[--newEndIdx];
        } else if (sameVnode$1(oldEndVnode, newStartVnode)) { // Vnode moved left
          patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
          canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
          oldEndVnode = oldCh[--oldEndIdx];
          newStartVnode = newCh[++newStartIdx];
        } else {
          if (isUndef$1(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx$1(oldCh, oldStartIdx, oldEndIdx); }
          idxInOld = isDef$1(newStartVnode.key)
            ? oldKeyToIdx[newStartVnode.key]
            : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
          if (isUndef$1(idxInOld)) { // New element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          } else {
            vnodeToMove = oldCh[idxInOld];
            if (sameVnode$1(vnodeToMove, newStartVnode)) {
              patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
              oldCh[idxInOld] = undefined;
              canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
            } else {
              // same key but different element. treat as new element
              createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
            }
          }
          newStartVnode = newCh[++newStartIdx];
        }
      }
      if (oldStartIdx > oldEndIdx) {
        refElm = isUndef$1(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
        addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
      } else if (newStartIdx > newEndIdx) {
        removeVnodes(oldCh, oldStartIdx, oldEndIdx);
      }
    }

    function checkDuplicateKeys (children) {
      var seenKeys = {};
      for (var i = 0; i < children.length; i++) {
        var vnode = children[i];
        var key = vnode.key;
        if (isDef$1(key)) {
          if (seenKeys[key]) {
            warn$3(
              ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
              vnode.context
            );
          } else {
            seenKeys[key] = true;
          }
        }
      }
    }

    function findIdxInOld (node, oldCh, start, end) {
      for (var i = start; i < end; i++) {
        var c = oldCh[i];
        if (isDef$1(c) && sameVnode$1(node, c)) { return i }
      }
    }

    function patchVnode (
      oldVnode,
      vnode,
      insertedVnodeQueue,
      ownerArray,
      index,
      removeOnly
    ) {
      if (oldVnode === vnode) {
        return
      }

      if (isDef$1(vnode.elm) && isDef$1(ownerArray)) {
        // clone reused vnode
        vnode = ownerArray[index] = cloneVNode$1(vnode);
      }

      var elm = vnode.elm = oldVnode.elm;

      if (isTrue$1(oldVnode.isAsyncPlaceholder)) {
        if (isDef$1(vnode.asyncFactory.resolved)) {
          hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
        } else {
          vnode.isAsyncPlaceholder = true;
        }
        return
      }

      // reuse element for static trees.
      // note we only do this if the vnode is cloned -
      // if the new node is not cloned it means the render functions have been
      // reset by the hot-reload-api and we need to do a proper re-render.
      if (isTrue$1(vnode.isStatic) &&
        isTrue$1(oldVnode.isStatic) &&
        vnode.key === oldVnode.key &&
        (isTrue$1(vnode.isCloned) || isTrue$1(vnode.isOnce))
      ) {
        vnode.componentInstance = oldVnode.componentInstance;
        return
      }

      var i;
      var data = vnode.data;
      if (isDef$1(data) && isDef$1(i = data.hook) && isDef$1(i = i.prepatch)) {
        i(oldVnode, vnode);
      }

      var oldCh = oldVnode.children;
      var ch = vnode.children;
      if (isDef$1(data) && isPatchable(vnode)) {
        for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
        if (isDef$1(i = data.hook) && isDef$1(i = i.update)) { i(oldVnode, vnode); }
      }
      if (isUndef$1(vnode.text)) {
        if (isDef$1(oldCh) && isDef$1(ch)) {
          if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
        } else if (isDef$1(ch)) {
          {
            checkDuplicateKeys(ch);
          }
          if (isDef$1(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
          addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
        } else if (isDef$1(oldCh)) {
          removeVnodes(oldCh, 0, oldCh.length - 1);
        } else if (isDef$1(oldVnode.text)) {
          nodeOps.setTextContent(elm, '');
        }
      } else if (oldVnode.text !== vnode.text) {
        nodeOps.setTextContent(elm, vnode.text);
      }
      if (isDef$1(data)) {
        if (isDef$1(i = data.hook) && isDef$1(i = i.postpatch)) { i(oldVnode, vnode); }
      }
    }

    function invokeInsertHook (vnode, queue, initial) {
      // delay insert hooks for component root nodes, invoke them after the
      // element is really inserted
      if (isTrue$1(initial) && isDef$1(vnode.parent)) {
        vnode.parent.data.pendingInsert = queue;
      } else {
        for (var i = 0; i < queue.length; ++i) {
          queue[i].data.hook.insert(queue[i]);
        }
      }
    }

    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap$1('attrs,class,staticClass,staticStyle,key');

    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
      var i;
      var tag = vnode.tag;
      var data = vnode.data;
      var children = vnode.children;
      inVPre = inVPre || (data && data.pre);
      vnode.elm = elm;

      if (isTrue$1(vnode.isComment) && isDef$1(vnode.asyncFactory)) {
        vnode.isAsyncPlaceholder = true;
        return true
      }
      // assert node match
      {
        if (!assertNodeMatch(elm, vnode, inVPre)) {
          return false
        }
      }
      if (isDef$1(data)) {
        if (isDef$1(i = data.hook) && isDef$1(i = i.init)) { i(vnode, true /* hydrating */); }
        if (isDef$1(i = vnode.componentInstance)) {
          // child component. it should have hydrated its own tree.
          initComponent(vnode, insertedVnodeQueue);
          return true
        }
      }
      if (isDef$1(tag)) {
        if (isDef$1(children)) {
          // empty element, allow client to pick up and populate children
          if (!elm.hasChildNodes()) {
            createChildren(vnode, children, insertedVnodeQueue);
          } else {
            // v-html and domProps: innerHTML
            if (isDef$1(i = data) && isDef$1(i = i.domProps) && isDef$1(i = i.innerHTML)) {
              if (i !== elm.innerHTML) {
                /* istanbul ignore if */
                if (typeof console !== 'undefined' &&
                  !hydrationBailed
                ) {
                  hydrationBailed = true;
                  console.warn('Parent: ', elm);
                  console.warn('server innerHTML: ', i);
                  console.warn('client innerHTML: ', elm.innerHTML);
                }
                return false
              }
            } else {
              // iterate and compare children lists
              var childrenMatch = true;
              var childNode = elm.firstChild;
              for (var i$1 = 0; i$1 < children.length; i$1++) {
                if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                  childrenMatch = false;
                  break
                }
                childNode = childNode.nextSibling;
              }
              // if childNode is not null, it means the actual childNodes list is
              // longer than the virtual children list.
              if (!childrenMatch || childNode) {
                /* istanbul ignore if */
                if (typeof console !== 'undefined' &&
                  !hydrationBailed
                ) {
                  hydrationBailed = true;
                  console.warn('Parent: ', elm);
                  console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                }
                return false
              }
            }
          }
        }
        if (isDef$1(data)) {
          var fullInvoke = false;
          for (var key in data) {
            if (!isRenderedModule(key)) {
              fullInvoke = true;
              invokeCreateHooks(vnode, insertedVnodeQueue);
              break
            }
          }
          if (!fullInvoke && data['class']) {
            // ensure collecting deps for deep class bindings for future updates
            traverse$1(data['class']);
          }
        }
      } else if (elm.data !== vnode.text) {
        elm.data = vnode.text;
      }
      return true
    }

    function assertNodeMatch (node, vnode, inVPre) {
      if (isDef$1(vnode.tag)) {
        return vnode.tag.indexOf('vue-component') === 0 || (
          !isUnknownElement$$1(vnode, inVPre) &&
          vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
        )
      } else {
        return node.nodeType === (vnode.isComment ? 8 : 3)
      }
    }

    return function patch (oldVnode, vnode, hydrating, removeOnly) {
      if (isUndef$1(vnode)) {
        if (isDef$1(oldVnode)) { invokeDestroyHook(oldVnode); }
        return
      }

      var isInitialPatch = false;
      var insertedVnodeQueue = [];

      if (isUndef$1(oldVnode)) {
        // empty mount (likely as component), create new root element
        isInitialPatch = true;
        createElm(vnode, insertedVnodeQueue);
      } else {
        var isRealElement = isDef$1(oldVnode.nodeType);
        if (!isRealElement && sameVnode$1(oldVnode, vnode)) {
          // patch existing root node
          patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
        } else {
          if (isRealElement) {
            // mounting to a real element
            // check if this is server-rendered content and if we can perform
            // a successful hydration.
            if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR$1)) {
              oldVnode.removeAttribute(SSR_ATTR$1);
              hydrating = true;
            }
            if (isTrue$1(hydrating)) {
              if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                invokeInsertHook(vnode, insertedVnodeQueue, true);
                return oldVnode
              } else {
                warn$3(
                  'The client-side rendered virtual DOM tree is not matching ' +
                  'server-rendered content. This is likely caused by incorrect ' +
                  'HTML markup, for example nesting block-level elements inside ' +
                  '<p>, or missing <tbody>. Bailing hydration and performing ' +
                  'full client-side render.'
                );
              }
            }
            // either not server-rendered, or hydration failed.
            // create an empty node and replace it
            oldVnode = emptyNodeAt(oldVnode);
          }

          // replacing existing element
          var oldElm = oldVnode.elm;
          var parentElm = nodeOps.parentNode(oldElm);

          // create new node
          createElm(
            vnode,
            insertedVnodeQueue,
            // extremely rare edge case: do not insert if old element is in a
            // leaving transition. Only happens when combining transition +
            // keep-alive + HOCs. (#4590)
            oldElm._leaveCb ? null : parentElm,
            nodeOps.nextSibling(oldElm)
          );

          // update parent placeholder node element, recursively
          if (isDef$1(vnode.parent)) {
            var ancestor = vnode.parent;
            var patchable = isPatchable(vnode);
            while (ancestor) {
              for (var i = 0; i < cbs.destroy.length; ++i) {
                cbs.destroy[i](ancestor);
              }
              ancestor.elm = vnode.elm;
              if (patchable) {
                for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                  cbs.create[i$1](emptyNode$1, ancestor);
                }
                // #6513
                // invoke insert hooks that may have been merged by create hooks.
                // e.g. for directives that uses the "inserted" hook.
                var insert = ancestor.data.hook.insert;
                if (insert.merged) {
                  // start at index 1 to avoid re-invoking component mounted hook
                  for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                    insert.fns[i$2]();
                  }
                }
              } else {
                registerRef$1(ancestor);
              }
              ancestor = ancestor.parent;
            }
          }

          // destroy old node
          if (isDef$1(parentElm)) {
            removeVnodes([oldVnode], 0, 0);
          } else if (isDef$1(oldVnode.tag)) {
            invokeDestroyHook(oldVnode);
          }
        }
      }

      invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
      return vnode.elm
    }
  }

  /*  */

  var directives$2 = {
    create: updateDirectives$1,
    update: updateDirectives$1,
    destroy: function unbindDirectives (vnode) {
      updateDirectives$1(vnode, emptyNode$1);
    }
  };

  function updateDirectives$1 (oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
      _update$1(oldVnode, vnode);
    }
  }

  function _update$1 (oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode$1;
    var isDestroy = vnode === emptyNode$1;
    var oldDirs = normalizeDirectives$1$1(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives$1$1(vnode.data.directives, vnode.context);

    var dirsWithInsert = [];
    var dirsWithPostpatch = [];

    var key, oldDir, dir;
    for (key in newDirs) {
      oldDir = oldDirs[key];
      dir = newDirs[key];
      if (!oldDir) {
        // new directive, bind
        callHook$1$1(dir, 'bind', vnode, oldVnode);
        if (dir.def && dir.def.inserted) {
          dirsWithInsert.push(dir);
        }
      } else {
        // existing directive, update
        dir.oldValue = oldDir.value;
        dir.oldArg = oldDir.arg;
        callHook$1$1(dir, 'update', vnode, oldVnode);
        if (dir.def && dir.def.componentUpdated) {
          dirsWithPostpatch.push(dir);
        }
      }
    }

    if (dirsWithInsert.length) {
      var callInsert = function () {
        for (var i = 0; i < dirsWithInsert.length; i++) {
          callHook$1$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
        }
      };
      if (isCreate) {
        mergeVNodeHook$1(vnode, 'insert', callInsert);
      } else {
        callInsert();
      }
    }

    if (dirsWithPostpatch.length) {
      mergeVNodeHook$1(vnode, 'postpatch', function () {
        for (var i = 0; i < dirsWithPostpatch.length; i++) {
          callHook$1$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
        }
      });
    }

    if (!isCreate) {
      for (key in oldDirs) {
        if (!newDirs[key]) {
          // no longer present, unbind
          callHook$1$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
        }
      }
    }
  }

  var emptyModifiers$1 = Object.create(null);

  function normalizeDirectives$1$1 (
    dirs,
    vm
  ) {
    var res = Object.create(null);
    if (!dirs) {
      // $flow-disable-line
      return res
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
      dir = dirs[i];
      if (!dir.modifiers) {
        // $flow-disable-line
        dir.modifiers = emptyModifiers$1;
      }
      res[getRawDirName$1(dir)] = dir;
      dir.def = resolveAsset$1(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res
  }

  function getRawDirName$1 (dir) {
    return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
  }

  function callHook$1$1 (dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
      try {
        fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
      } catch (e) {
        handleError$1(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
      }
    }
  }

  var baseModules$1 = [
    ref$2,
    directives$2
  ];

  /*  */

  function updateAttrs$1 (oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef$1(opts) && opts.Ctor.options.inheritAttrs === false) {
      return
    }
    if (isUndef$1(oldVnode.data.attrs) && isUndef$1(vnode.data.attrs)) {
      return
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef$1(attrs.__ob__)) {
      attrs = vnode.data.attrs = extend$2({}, attrs);
    }

    for (key in attrs) {
      cur = attrs[key];
      old = oldAttrs[key];
      if (old !== cur) {
        setAttr$1(elm, key, cur);
      }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE$1 || isEdge$1) && attrs.value !== oldAttrs.value) {
      setAttr$1(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
      if (isUndef$1(attrs[key])) {
        if (isXlink$1(key)) {
          elm.removeAttributeNS(xlinkNS$1, getXlinkProp$1(key));
        } else if (!isEnumeratedAttr$1(key)) {
          elm.removeAttribute(key);
        }
      }
    }
  }

  function setAttr$1 (el, key, value) {
    if (el.tagName.indexOf('-') > -1) {
      baseSetAttr$1(el, key, value);
    } else if (isBooleanAttr$1(key)) {
      // set attribute for blank value
      // e.g. <option disabled>Select one</option>
      if (isFalsyAttrValue$1(value)) {
        el.removeAttribute(key);
      } else {
        // technically allowfullscreen is a boolean attribute for <iframe>,
        // but Flash expects a value of "true" when used on <embed> tag
        value = key === 'allowfullscreen' && el.tagName === 'EMBED'
          ? 'true'
          : key;
        el.setAttribute(key, value);
      }
    } else if (isEnumeratedAttr$1(key)) {
      el.setAttribute(key, convertEnumeratedValue$1(key, value));
    } else if (isXlink$1(key)) {
      if (isFalsyAttrValue$1(value)) {
        el.removeAttributeNS(xlinkNS$1, getXlinkProp$1(key));
      } else {
        el.setAttributeNS(xlinkNS$1, key, value);
      }
    } else {
      baseSetAttr$1(el, key, value);
    }
  }

  function baseSetAttr$1 (el, key, value) {
    if (isFalsyAttrValue$1(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.
      /* istanbul ignore if */
      if (
        isIE$1 && !isIE9$1 &&
        el.tagName === 'TEXTAREA' &&
        key === 'placeholder' && value !== '' && !el.__ieph
      ) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };
        el.addEventListener('input', blocker);
        // $flow-disable-line
        el.__ieph = true; /* IE placeholder patched */
      }
      el.setAttribute(key, value);
    }
  }

  var attrs$1 = {
    create: updateAttrs$1,
    update: updateAttrs$1
  };

  /*  */

  function updateClass$1 (oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (
      isUndef$1(data.staticClass) &&
      isUndef$1(data.class) && (
        isUndef$1(oldData) || (
          isUndef$1(oldData.staticClass) &&
          isUndef$1(oldData.class)
        )
      )
    ) {
      return
    }

    var cls = genClassForVnode$1(vnode);

    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef$1(transitionClass)) {
      cls = concat$1(cls, stringifyClass$1(transitionClass));
    }

    // set the class
    if (cls !== el._prevClass) {
      el.setAttribute('class', cls);
      el._prevClass = cls;
    }
  }

  var klass$2 = {
    create: updateClass$1,
    update: updateClass$1
  };

  /*  */

  /*  */

  /*  */

  /*  */

  // in some cases, the event used has to be determined at runtime
  // so we used some reserved tokens during compile.
  var RANGE_TOKEN$1 = '__r';
  var CHECKBOX_RADIO_TOKEN$1 = '__c';

  /*  */

  // normalize v-model event tokens that can only be determined at runtime.
  // it's important to place the event as the first in the array because
  // the whole point is ensuring the v-model callback gets called before
  // user-attached handlers.
  function normalizeEvents$1 (on) {
    /* istanbul ignore if */
    if (isDef$1(on[RANGE_TOKEN$1])) {
      // IE input[type=range] only supports `change` event
      var event = isIE$1 ? 'change' : 'input';
      on[event] = [].concat(on[RANGE_TOKEN$1], on[event] || []);
      delete on[RANGE_TOKEN$1];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef$1(on[CHECKBOX_RADIO_TOKEN$1])) {
      on.change = [].concat(on[CHECKBOX_RADIO_TOKEN$1], on.change || []);
      delete on[CHECKBOX_RADIO_TOKEN$1];
    }
  }

  var target$1$2;

  function createOnceHandler$1$1 (event, handler, capture) {
    var _target = target$1$2; // save current target element in closure
    return function onceHandler () {
      var res = handler.apply(null, arguments);
      if (res !== null) {
        remove$2$1(event, onceHandler, capture, _target);
      }
    }
  }

  // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
  // implementation and does not fire microtasks in between event propagation, so
  // safe to exclude.
  var useMicrotaskFix$1 = isUsingMicroTask$1 && !(isFF$1 && Number(isFF$1[1]) <= 53);

  function add$1$1 (
    name,
    handler,
    capture,
    passive
  ) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix$1) {
      var attachedTimestamp = currentFlushTimestamp$1;
      var original = handler;
      handler = original._wrapper = function (e) {
        if (
          // no bubbling, should always fire.
          // this is just a safety net in case event.timeStamp is unreliable in
          // certain weird environments...
          e.target === e.currentTarget ||
          // event is fired after handler attachment
          e.timeStamp >= attachedTimestamp ||
          // bail for environments that have buggy event.timeStamp implementations
          // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
          // #9681 QtWebEngine event.timeStamp is negative value
          e.timeStamp <= 0 ||
          // #9448 bail if event is fired in another document in a multi-page
          // electron/nw.js app, since event.timeStamp will be using a different
          // starting reference
          e.target.ownerDocument !== document
        ) {
          return original.apply(this, arguments)
        }
      };
    }
    target$1$2.addEventListener(
      name,
      handler,
      supportsPassive$1
        ? { capture: capture, passive: passive }
        : capture
    );
  }

  function remove$2$1 (
    name,
    handler,
    capture,
    _target
  ) {
    (_target || target$1$2).removeEventListener(
      name,
      handler._wrapper || handler,
      capture
    );
  }

  function updateDOMListeners$1 (oldVnode, vnode) {
    if (isUndef$1(oldVnode.data.on) && isUndef$1(vnode.data.on)) {
      return
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    target$1$2 = vnode.elm;
    normalizeEvents$1(on);
    updateListeners$1(on, oldOn, add$1$1, remove$2$1, createOnceHandler$1$1, vnode.context);
    target$1$2 = undefined;
  }

  var events$1 = {
    create: updateDOMListeners$1,
    update: updateDOMListeners$1
  };

  /*  */

  var svgContainer$1;

  function updateDOMProps$1 (oldVnode, vnode) {
    if (isUndef$1(oldVnode.data.domProps) && isUndef$1(vnode.data.domProps)) {
      return
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef$1(props.__ob__)) {
      props = vnode.data.domProps = extend$2({}, props);
    }

    for (key in oldProps) {
      if (!(key in props)) {
        elm[key] = '';
      }
    }

    for (key in props) {
      cur = props[key];
      // ignore children if the node has textContent or innerHTML,
      // as these will throw away existing DOM nodes and cause removal errors
      // on subsequent patches (#3360)
      if (key === 'textContent' || key === 'innerHTML') {
        if (vnode.children) { vnode.children.length = 0; }
        if (cur === oldProps[key]) { continue }
        // #6601 work around Chrome version <= 55 bug where single textNode
        // replaced by innerHTML/textContent retains its parentNode property
        if (elm.childNodes.length === 1) {
          elm.removeChild(elm.childNodes[0]);
        }
      }

      if (key === 'value' && elm.tagName !== 'PROGRESS') {
        // store value as _value as well since
        // non-string values will be stringified
        elm._value = cur;
        // avoid resetting cursor position when value is the same
        var strCur = isUndef$1(cur) ? '' : String(cur);
        if (shouldUpdateValue$1(elm, strCur)) {
          elm.value = strCur;
        }
      } else if (key === 'innerHTML' && isSVG$1(elm.tagName) && isUndef$1(elm.innerHTML)) {
        // IE doesn't support innerHTML for SVG elements
        svgContainer$1 = svgContainer$1 || document.createElement('div');
        svgContainer$1.innerHTML = "<svg>" + cur + "</svg>";
        var svg = svgContainer$1.firstChild;
        while (elm.firstChild) {
          elm.removeChild(elm.firstChild);
        }
        while (svg.firstChild) {
          elm.appendChild(svg.firstChild);
        }
      } else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]
      ) {
        // some property updates can throw
        // e.g. `value` on <progress> w/ non-finite value
        try {
          elm[key] = cur;
        } catch (e) {}
      }
    }
  }

  // check platforms/web/util/attrs.js acceptValue


  function shouldUpdateValue$1 (elm, checkVal) {
    return (!elm.composing && (
      elm.tagName === 'OPTION' ||
      isNotInFocusAndDirty$1(elm, checkVal) ||
      isDirtyWithModifiers$1(elm, checkVal)
    ))
  }

  function isNotInFocusAndDirty$1 (elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try { notInFocus = document.activeElement !== elm; } catch (e) {}
    return notInFocus && elm.value !== checkVal
  }

  function isDirtyWithModifiers$1 (elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef$1(modifiers)) {
      if (modifiers.number) {
        return toNumber$3(value) !== toNumber$3(newVal)
      }
      if (modifiers.trim) {
        return value.trim() !== newVal.trim()
      }
    }
    return value !== newVal
  }

  var domProps$1 = {
    create: updateDOMProps$1,
    update: updateDOMProps$1
  };

  /*  */

  var parseStyleText$1 = cached$1(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
      if (item) {
        var tmp = item.split(propertyDelimiter);
        tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
      }
    });
    return res
  });

  // merge static and dynamic style data on the same vnode
  function normalizeStyleData$1 (data) {
    var style = normalizeStyleBinding$1(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle
      ? extend$2(data.staticStyle, style)
      : style
  }

  // normalize possible array / string values into Object
  function normalizeStyleBinding$1 (bindingStyle) {
    if (Array.isArray(bindingStyle)) {
      return toObject$1(bindingStyle)
    }
    if (typeof bindingStyle === 'string') {
      return parseStyleText$1(bindingStyle)
    }
    return bindingStyle
  }

  /**
   * parent component style should be after child's
   * so that parent component's style could override it
   */
  function getStyle$1 (vnode, checkChild) {
    var res = {};
    var styleData;

    if (checkChild) {
      var childNode = vnode;
      while (childNode.componentInstance) {
        childNode = childNode.componentInstance._vnode;
        if (
          childNode && childNode.data &&
          (styleData = normalizeStyleData$1(childNode.data))
        ) {
          extend$2(res, styleData);
        }
      }
    }

    if ((styleData = normalizeStyleData$1(vnode.data))) {
      extend$2(res, styleData);
    }

    var parentNode = vnode;
    while ((parentNode = parentNode.parent)) {
      if (parentNode.data && (styleData = normalizeStyleData$1(parentNode.data))) {
        extend$2(res, styleData);
      }
    }
    return res
  }

  /*  */

  var cssVarRE$1 = /^--/;
  var importantRE$1 = /\s*!important$/;
  var setProp$1 = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE$1.test(name)) {
      el.style.setProperty(name, val);
    } else if (importantRE$1.test(val)) {
      el.style.setProperty(hyphenate$1(name), val.replace(importantRE$1, ''), 'important');
    } else {
      var normalizedName = normalize$1(name);
      if (Array.isArray(val)) {
        // Support values array created by autoprefixer, e.g.
        // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
        // Set them one by one, and the browser will only set those it can recognize
        for (var i = 0, len = val.length; i < len; i++) {
          el.style[normalizedName] = val[i];
        }
      } else {
        el.style[normalizedName] = val;
      }
    }
  };

  var vendorNames$1 = ['Webkit', 'Moz', 'ms'];

  var emptyStyle$1;
  var normalize$1 = cached$1(function (prop) {
    emptyStyle$1 = emptyStyle$1 || document.createElement('div').style;
    prop = camelize$1(prop);
    if (prop !== 'filter' && (prop in emptyStyle$1)) {
      return prop
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames$1.length; i++) {
      var name = vendorNames$1[i] + capName;
      if (name in emptyStyle$1) {
        return name
      }
    }
  });

  function updateStyle$1 (oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;

    if (isUndef$1(data.staticStyle) && isUndef$1(data.style) &&
      isUndef$1(oldData.staticStyle) && isUndef$1(oldData.style)
    ) {
      return
    }

    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;

    var style = normalizeStyleBinding$1(vnode.data.style) || {};

    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef$1(style.__ob__)
      ? extend$2({}, style)
      : style;

    var newStyle = getStyle$1(vnode, true);

    for (name in oldStyle) {
      if (isUndef$1(newStyle[name])) {
        setProp$1(el, name, '');
      }
    }
    for (name in newStyle) {
      cur = newStyle[name];
      if (cur !== oldStyle[name]) {
        // ie9 setting to null has no effect, must use empty string
        setProp$1(el, name, cur == null ? '' : cur);
      }
    }
  }

  var style$2 = {
    create: updateStyle$1,
    update: updateStyle$1
  };

  /*  */

  var whitespaceRE$2 = /\s+/;

  /**
   * Add class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */
  function addClass$1 (el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
      return
    }

    /* istanbul ignore else */
    if (el.classList) {
      if (cls.indexOf(' ') > -1) {
        cls.split(whitespaceRE$2).forEach(function (c) { return el.classList.add(c); });
      } else {
        el.classList.add(cls);
      }
    } else {
      var cur = " " + (el.getAttribute('class') || '') + " ";
      if (cur.indexOf(' ' + cls + ' ') < 0) {
        el.setAttribute('class', (cur + cls).trim());
      }
    }
  }

  /**
   * Remove class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */
  function removeClass$1 (el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
      return
    }

    /* istanbul ignore else */
    if (el.classList) {
      if (cls.indexOf(' ') > -1) {
        cls.split(whitespaceRE$2).forEach(function (c) { return el.classList.remove(c); });
      } else {
        el.classList.remove(cls);
      }
      if (!el.classList.length) {
        el.removeAttribute('class');
      }
    } else {
      var cur = " " + (el.getAttribute('class') || '') + " ";
      var tar = ' ' + cls + ' ';
      while (cur.indexOf(tar) >= 0) {
        cur = cur.replace(tar, ' ');
      }
      cur = cur.trim();
      if (cur) {
        el.setAttribute('class', cur);
      } else {
        el.removeAttribute('class');
      }
    }
  }

  /*  */

  function resolveTransition$1 (def$$1) {
    if (!def$$1) {
      return
    }
    /* istanbul ignore else */
    if (typeof def$$1 === 'object') {
      var res = {};
      if (def$$1.css !== false) {
        extend$2(res, autoCssTransition$1(def$$1.name || 'v'));
      }
      extend$2(res, def$$1);
      return res
    } else if (typeof def$$1 === 'string') {
      return autoCssTransition$1(def$$1)
    }
  }

  var autoCssTransition$1 = cached$1(function (name) {
    return {
      enterClass: (name + "-enter"),
      enterToClass: (name + "-enter-to"),
      enterActiveClass: (name + "-enter-active"),
      leaveClass: (name + "-leave"),
      leaveToClass: (name + "-leave-to"),
      leaveActiveClass: (name + "-leave-active")
    }
  });

  var hasTransition$1 = inBrowser$1 && !isIE9$1;
  var TRANSITION$1 = 'transition';
  var ANIMATION$1 = 'animation';

  // Transition property/event sniffing
  var transitionProp$1 = 'transition';
  var transitionEndEvent$1 = 'transitionend';
  var animationProp$1 = 'animation';
  var animationEndEvent$1 = 'animationend';
  if (hasTransition$1) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined &&
      window.onwebkittransitionend !== undefined
    ) {
      transitionProp$1 = 'WebkitTransition';
      transitionEndEvent$1 = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined &&
      window.onwebkitanimationend !== undefined
    ) {
      animationProp$1 = 'WebkitAnimation';
      animationEndEvent$1 = 'webkitAnimationEnd';
    }
  }

  // binding to window is necessary to make hot reload work in IE in strict mode
  var raf$1 = inBrowser$1
    ? window.requestAnimationFrame
      ? window.requestAnimationFrame.bind(window)
      : setTimeout
    : /* istanbul ignore next */ function (fn) { return fn(); };

  function nextFrame$1 (fn) {
    raf$1(function () {
      raf$1(fn);
    });
  }

  function addTransitionClass$1 (el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
      transitionClasses.push(cls);
      addClass$1(el, cls);
    }
  }

  function removeTransitionClass$1 (el, cls) {
    if (el._transitionClasses) {
      remove$3(el._transitionClasses, cls);
    }
    removeClass$1(el, cls);
  }

  function whenTransitionEnds$1 (
    el,
    expectedType,
    cb
  ) {
    var ref = getTransitionInfo$1(el, expectedType);
    var type = ref.type;
    var timeout = ref.timeout;
    var propCount = ref.propCount;
    if (!type) { return cb() }
    var event = type === TRANSITION$1 ? transitionEndEvent$1 : animationEndEvent$1;
    var ended = 0;
    var end = function () {
      el.removeEventListener(event, onEnd);
      cb();
    };
    var onEnd = function (e) {
      if (e.target === el) {
        if (++ended >= propCount) {
          end();
        }
      }
    };
    setTimeout(function () {
      if (ended < propCount) {
        end();
      }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
  }

  var transformRE$1 = /\b(transform|all)(,|$)/;

  function getTransitionInfo$1 (el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp$1 + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp$1 + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout$1(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp$1 + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp$1 + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout$1(animationDelays, animationDurations);

    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION$1) {
      if (transitionTimeout > 0) {
        type = TRANSITION$1;
        timeout = transitionTimeout;
        propCount = transitionDurations.length;
      }
    } else if (expectedType === ANIMATION$1) {
      if (animationTimeout > 0) {
        type = ANIMATION$1;
        timeout = animationTimeout;
        propCount = animationDurations.length;
      }
    } else {
      timeout = Math.max(transitionTimeout, animationTimeout);
      type = timeout > 0
        ? transitionTimeout > animationTimeout
          ? TRANSITION$1
          : ANIMATION$1
        : null;
      propCount = type
        ? type === TRANSITION$1
          ? transitionDurations.length
          : animationDurations.length
        : 0;
    }
    var hasTransform =
      type === TRANSITION$1 &&
      transformRE$1.test(styles[transitionProp$1 + 'Property']);
    return {
      type: type,
      timeout: timeout,
      propCount: propCount,
      hasTransform: hasTransform
    }
  }

  function getTimeout$1 (delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
      delays = delays.concat(delays);
    }

    return Math.max.apply(null, durations.map(function (d, i) {
      return toMs$1(d) + toMs$1(delays[i])
    }))
  }

  // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
  // in a locale-dependent way, using a comma instead of a dot.
  // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
  // as a floor function) causing unexpected behaviors
  function toMs$1 (s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000
  }

  /*  */

  function enter$1 (vnode, toggleDisplay) {
    var el = vnode.elm;

    // call leave callback now
    if (isDef$1(el._leaveCb)) {
      el._leaveCb.cancelled = true;
      el._leaveCb();
    }

    var data = resolveTransition$1(vnode.data.transition);
    if (isUndef$1(data)) {
      return
    }

    /* istanbul ignore if */
    if (isDef$1(el._enterCb) || el.nodeType !== 1) {
      return
    }

    var css = data.css;
    var type = data.type;
    var enterClass = data.enterClass;
    var enterToClass = data.enterToClass;
    var enterActiveClass = data.enterActiveClass;
    var appearClass = data.appearClass;
    var appearToClass = data.appearToClass;
    var appearActiveClass = data.appearActiveClass;
    var beforeEnter = data.beforeEnter;
    var enter = data.enter;
    var afterEnter = data.afterEnter;
    var enterCancelled = data.enterCancelled;
    var beforeAppear = data.beforeAppear;
    var appear = data.appear;
    var afterAppear = data.afterAppear;
    var appearCancelled = data.appearCancelled;
    var duration = data.duration;

    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance$1;
    var transitionNode = activeInstance$1.$vnode;
    while (transitionNode && transitionNode.parent) {
      context = transitionNode.context;
      transitionNode = transitionNode.parent;
    }

    var isAppear = !context._isMounted || !vnode.isRootInsert;

    if (isAppear && !appear && appear !== '') {
      return
    }

    var startClass = isAppear && appearClass
      ? appearClass
      : enterClass;
    var activeClass = isAppear && appearActiveClass
      ? appearActiveClass
      : enterActiveClass;
    var toClass = isAppear && appearToClass
      ? appearToClass
      : enterToClass;

    var beforeEnterHook = isAppear
      ? (beforeAppear || beforeEnter)
      : beforeEnter;
    var enterHook = isAppear
      ? (typeof appear === 'function' ? appear : enter)
      : enter;
    var afterEnterHook = isAppear
      ? (afterAppear || afterEnter)
      : afterEnter;
    var enterCancelledHook = isAppear
      ? (appearCancelled || enterCancelled)
      : enterCancelled;

    var explicitEnterDuration = toNumber$3(
      isObject$6(duration)
        ? duration.enter
        : duration
    );

    if (explicitEnterDuration != null) {
      checkDuration$1(explicitEnterDuration, 'enter', vnode);
    }

    var expectsCSS = css !== false && !isIE9$1;
    var userWantsControl = getHookArgumentsLength$1(enterHook);

    var cb = el._enterCb = once$2(function () {
      if (expectsCSS) {
        removeTransitionClass$1(el, toClass);
        removeTransitionClass$1(el, activeClass);
      }
      if (cb.cancelled) {
        if (expectsCSS) {
          removeTransitionClass$1(el, startClass);
        }
        enterCancelledHook && enterCancelledHook(el);
      } else {
        afterEnterHook && afterEnterHook(el);
      }
      el._enterCb = null;
    });

    if (!vnode.data.show) {
      // remove pending leave element on enter by injecting an insert hook
      mergeVNodeHook$1(vnode, 'insert', function () {
        var parent = el.parentNode;
        var pendingNode = parent && parent._pending && parent._pending[vnode.key];
        if (pendingNode &&
          pendingNode.tag === vnode.tag &&
          pendingNode.elm._leaveCb
        ) {
          pendingNode.elm._leaveCb();
        }
        enterHook && enterHook(el, cb);
      });
    }

    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
      addTransitionClass$1(el, startClass);
      addTransitionClass$1(el, activeClass);
      nextFrame$1(function () {
        removeTransitionClass$1(el, startClass);
        if (!cb.cancelled) {
          addTransitionClass$1(el, toClass);
          if (!userWantsControl) {
            if (isValidDuration$1(explicitEnterDuration)) {
              setTimeout(cb, explicitEnterDuration);
            } else {
              whenTransitionEnds$1(el, type, cb);
            }
          }
        }
      });
    }

    if (vnode.data.show) {
      toggleDisplay && toggleDisplay();
      enterHook && enterHook(el, cb);
    }

    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }

  function leave$1 (vnode, rm) {
    var el = vnode.elm;

    // call enter callback now
    if (isDef$1(el._enterCb)) {
      el._enterCb.cancelled = true;
      el._enterCb();
    }

    var data = resolveTransition$1(vnode.data.transition);
    if (isUndef$1(data) || el.nodeType !== 1) {
      return rm()
    }

    /* istanbul ignore if */
    if (isDef$1(el._leaveCb)) {
      return
    }

    var css = data.css;
    var type = data.type;
    var leaveClass = data.leaveClass;
    var leaveToClass = data.leaveToClass;
    var leaveActiveClass = data.leaveActiveClass;
    var beforeLeave = data.beforeLeave;
    var leave = data.leave;
    var afterLeave = data.afterLeave;
    var leaveCancelled = data.leaveCancelled;
    var delayLeave = data.delayLeave;
    var duration = data.duration;

    var expectsCSS = css !== false && !isIE9$1;
    var userWantsControl = getHookArgumentsLength$1(leave);

    var explicitLeaveDuration = toNumber$3(
      isObject$6(duration)
        ? duration.leave
        : duration
    );

    if (isDef$1(explicitLeaveDuration)) {
      checkDuration$1(explicitLeaveDuration, 'leave', vnode);
    }

    var cb = el._leaveCb = once$2(function () {
      if (el.parentNode && el.parentNode._pending) {
        el.parentNode._pending[vnode.key] = null;
      }
      if (expectsCSS) {
        removeTransitionClass$1(el, leaveToClass);
        removeTransitionClass$1(el, leaveActiveClass);
      }
      if (cb.cancelled) {
        if (expectsCSS) {
          removeTransitionClass$1(el, leaveClass);
        }
        leaveCancelled && leaveCancelled(el);
      } else {
        rm();
        afterLeave && afterLeave(el);
      }
      el._leaveCb = null;
    });

    if (delayLeave) {
      delayLeave(performLeave);
    } else {
      performLeave();
    }

    function performLeave () {
      // the delayed leave may have already been cancelled
      if (cb.cancelled) {
        return
      }
      // record leaving element
      if (!vnode.data.show && el.parentNode) {
        (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
      }
      beforeLeave && beforeLeave(el);
      if (expectsCSS) {
        addTransitionClass$1(el, leaveClass);
        addTransitionClass$1(el, leaveActiveClass);
        nextFrame$1(function () {
          removeTransitionClass$1(el, leaveClass);
          if (!cb.cancelled) {
            addTransitionClass$1(el, leaveToClass);
            if (!userWantsControl) {
              if (isValidDuration$1(explicitLeaveDuration)) {
                setTimeout(cb, explicitLeaveDuration);
              } else {
                whenTransitionEnds$1(el, type, cb);
              }
            }
          }
        });
      }
      leave && leave(el, cb);
      if (!expectsCSS && !userWantsControl) {
        cb();
      }
    }
  }

  // only used in dev mode
  function checkDuration$1 (val, name, vnode) {
    if (typeof val !== 'number') {
      warn$3(
        "<transition> explicit " + name + " duration is not a valid number - " +
        "got " + (JSON.stringify(val)) + ".",
        vnode.context
      );
    } else if (isNaN(val)) {
      warn$3(
        "<transition> explicit " + name + " duration is NaN - " +
        'the duration expression might be incorrect.',
        vnode.context
      );
    }
  }

  function isValidDuration$1 (val) {
    return typeof val === 'number' && !isNaN(val)
  }

  /**
   * Normalize a transition hook's argument length. The hook may be:
   * - a merged hook (invoker) with the original in .fns
   * - a wrapped component method (check ._length)
   * - a plain function (.length)
   */
  function getHookArgumentsLength$1 (fn) {
    if (isUndef$1(fn)) {
      return false
    }
    var invokerFns = fn.fns;
    if (isDef$1(invokerFns)) {
      // invoker
      return getHookArgumentsLength$1(
        Array.isArray(invokerFns)
          ? invokerFns[0]
          : invokerFns
      )
    } else {
      return (fn._length || fn.length) > 1
    }
  }

  function _enter$1 (_, vnode) {
    if (vnode.data.show !== true) {
      enter$1(vnode);
    }
  }

  var transition$1 = inBrowser$1 ? {
    create: _enter$1,
    activate: _enter$1,
    remove: function remove$$1 (vnode, rm) {
      /* istanbul ignore else */
      if (vnode.data.show !== true) {
        leave$1(vnode, rm);
      } else {
        rm();
      }
    }
  } : {};

  var platformModules$1 = [
    attrs$1,
    klass$2,
    events$1,
    domProps$1,
    style$2,
    transition$1
  ];

  /*  */

  // the directive module should be applied last, after all
  // built-in modules have been applied.
  var modules$2 = platformModules$1.concat(baseModules$1);

  var patch$1 = createPatchFunction$1({ nodeOps: nodeOps$1, modules: modules$2 });

  /**
   * Not type checking this file because flow doesn't like attaching
   * properties to Elements.
   */

  /* istanbul ignore if */
  if (isIE9$1) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
      var el = document.activeElement;
      if (el && el.vmodel) {
        trigger$1(el, 'input');
      }
    });
  }

  var directive$1 = {
    inserted: function inserted (el, binding, vnode, oldVnode) {
      if (vnode.tag === 'select') {
        // #6903
        if (oldVnode.elm && !oldVnode.elm._vOptions) {
          mergeVNodeHook$1(vnode, 'postpatch', function () {
            directive$1.componentUpdated(el, binding, vnode);
          });
        } else {
          setSelected$1(el, binding, vnode.context);
        }
        el._vOptions = [].map.call(el.options, getValue$1);
      } else if (vnode.tag === 'textarea' || isTextInputType$1(el.type)) {
        el._vModifiers = binding.modifiers;
        if (!binding.modifiers.lazy) {
          el.addEventListener('compositionstart', onCompositionStart$1);
          el.addEventListener('compositionend', onCompositionEnd$1);
          // Safari < 10.2 & UIWebView doesn't fire compositionend when
          // switching focus before confirming composition choice
          // this also fixes the issue where some browsers e.g. iOS Chrome
          // fires "change" instead of "input" on autocomplete.
          el.addEventListener('change', onCompositionEnd$1);
          /* istanbul ignore if */
          if (isIE9$1) {
            el.vmodel = true;
          }
        }
      }
    },

    componentUpdated: function componentUpdated (el, binding, vnode) {
      if (vnode.tag === 'select') {
        setSelected$1(el, binding, vnode.context);
        // in case the options rendered by v-for have changed,
        // it's possible that the value is out-of-sync with the rendered options.
        // detect such cases and filter out values that no longer has a matching
        // option in the DOM.
        var prevOptions = el._vOptions;
        var curOptions = el._vOptions = [].map.call(el.options, getValue$1);
        if (curOptions.some(function (o, i) { return !looseEqual$1(o, prevOptions[i]); })) {
          // trigger change event if
          // no matching option found for at least one value
          var needReset = el.multiple
            ? binding.value.some(function (v) { return hasNoMatchingOption$1(v, curOptions); })
            : binding.value !== binding.oldValue && hasNoMatchingOption$1(binding.value, curOptions);
          if (needReset) {
            trigger$1(el, 'change');
          }
        }
      }
    }
  };

  function setSelected$1 (el, binding, vm) {
    actuallySetSelected$1(el, binding, vm);
    /* istanbul ignore if */
    if (isIE$1 || isEdge$1) {
      setTimeout(function () {
        actuallySetSelected$1(el, binding, vm);
      }, 0);
    }
  }

  function actuallySetSelected$1 (el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
      warn$3(
        "<select multiple v-model=\"" + (binding.expression) + "\"> " +
        "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
        vm
      );
      return
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
      option = el.options[i];
      if (isMultiple) {
        selected = looseIndexOf$1(value, getValue$1(option)) > -1;
        if (option.selected !== selected) {
          option.selected = selected;
        }
      } else {
        if (looseEqual$1(getValue$1(option), value)) {
          if (el.selectedIndex !== i) {
            el.selectedIndex = i;
          }
          return
        }
      }
    }
    if (!isMultiple) {
      el.selectedIndex = -1;
    }
  }

  function hasNoMatchingOption$1 (value, options) {
    return options.every(function (o) { return !looseEqual$1(o, value); })
  }

  function getValue$1 (option) {
    return '_value' in option
      ? option._value
      : option.value
  }

  function onCompositionStart$1 (e) {
    e.target.composing = true;
  }

  function onCompositionEnd$1 (e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing) { return }
    e.target.composing = false;
    trigger$1(e.target, 'input');
  }

  function trigger$1 (el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
  }

  /*  */

  // recursively search for possible transition defined inside the component root
  function locateNode$1 (vnode) {
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
      ? locateNode$1(vnode.componentInstance._vnode)
      : vnode
  }

  var show$1 = {
    bind: function bind (el, ref, vnode) {
      var value = ref.value;

      vnode = locateNode$1(vnode);
      var transition$$1 = vnode.data && vnode.data.transition;
      var originalDisplay = el.__vOriginalDisplay =
        el.style.display === 'none' ? '' : el.style.display;
      if (value && transition$$1) {
        vnode.data.show = true;
        enter$1(vnode, function () {
          el.style.display = originalDisplay;
        });
      } else {
        el.style.display = value ? originalDisplay : 'none';
      }
    },

    update: function update (el, ref, vnode) {
      var value = ref.value;
      var oldValue = ref.oldValue;

      /* istanbul ignore if */
      if (!value === !oldValue) { return }
      vnode = locateNode$1(vnode);
      var transition$$1 = vnode.data && vnode.data.transition;
      if (transition$$1) {
        vnode.data.show = true;
        if (value) {
          enter$1(vnode, function () {
            el.style.display = el.__vOriginalDisplay;
          });
        } else {
          leave$1(vnode, function () {
            el.style.display = 'none';
          });
        }
      } else {
        el.style.display = value ? el.__vOriginalDisplay : 'none';
      }
    },

    unbind: function unbind (
      el,
      binding,
      vnode,
      oldVnode,
      isDestroy
    ) {
      if (!isDestroy) {
        el.style.display = el.__vOriginalDisplay;
      }
    }
  };

  var platformDirectives$1 = {
    model: directive$1,
    show: show$1
  };

  /*  */

  var transitionProps$1 = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
  };

  // in case the child is also an abstract component, e.g. <keep-alive>
  // we want to recursively retrieve the real component to be rendered
  function getRealChild$1 (vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
      return getRealChild$1(getFirstComponentChild$1(compOptions.children))
    } else {
      return vnode
    }
  }

  function extractTransitionData$1 (comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
      data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key$1 in listeners) {
      data[camelize$1(key$1)] = listeners[key$1];
    }
    return data
  }

  function placeholder$1 (h, rawChild) {
    if (/\d-keep-alive$/.test(rawChild.tag)) {
      return h('keep-alive', {
        props: rawChild.componentOptions.propsData
      })
    }
  }

  function hasParentTransition$1 (vnode) {
    while ((vnode = vnode.parent)) {
      if (vnode.data.transition) {
        return true
      }
    }
  }

  function isSameChild$1 (child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag
  }

  var isNotTextNode$1 = function (c) { return c.tag || isAsyncPlaceholder$1(c); };

  var isVShowDirective$1 = function (d) { return d.name === 'show'; };

  var Transition$1 = {
    name: 'transition',
    props: transitionProps$1,
    abstract: true,

    render: function render (h) {
      var this$1$1 = this;

      var children = this.$slots.default;
      if (!children) {
        return
      }

      // filter out text nodes (possible whitespaces)
      children = children.filter(isNotTextNode$1);
      /* istanbul ignore if */
      if (!children.length) {
        return
      }

      // warn multiple elements
      if (children.length > 1) {
        warn$3(
          '<transition> can only be used on a single element. Use ' +
          '<transition-group> for lists.',
          this.$parent
        );
      }

      var mode = this.mode;

      // warn invalid mode
      if (mode && mode !== 'in-out' && mode !== 'out-in'
      ) {
        warn$3(
          'invalid <transition> mode: ' + mode,
          this.$parent
        );
      }

      var rawChild = children[0];

      // if this is a component root node and the component's
      // parent container node also has transition, skip.
      if (hasParentTransition$1(this.$vnode)) {
        return rawChild
      }

      // apply transition data to child
      // use getRealChild() to ignore abstract components e.g. keep-alive
      var child = getRealChild$1(rawChild);
      /* istanbul ignore if */
      if (!child) {
        return rawChild
      }

      if (this._leaving) {
        return placeholder$1(h, rawChild)
      }

      // ensure a key that is unique to the vnode type and to this transition
      // component instance. This key will be used to remove pending leaving nodes
      // during entering.
      var id = "__transition-" + (this._uid) + "-";
      child.key = child.key == null
        ? child.isComment
          ? id + 'comment'
          : id + child.tag
        : isPrimitive$1(child.key)
          ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
          : child.key;

      var data = (child.data || (child.data = {})).transition = extractTransitionData$1(this);
      var oldRawChild = this._vnode;
      var oldChild = getRealChild$1(oldRawChild);

      // mark v-show
      // so that the transition module can hand over the control to the directive
      if (child.data.directives && child.data.directives.some(isVShowDirective$1)) {
        child.data.show = true;
      }

      if (
        oldChild &&
        oldChild.data &&
        !isSameChild$1(child, oldChild) &&
        !isAsyncPlaceholder$1(oldChild) &&
        // #6687 component root is a comment node
        !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
      ) {
        // replace old child transition data with fresh one
        // important for dynamic transitions!
        var oldData = oldChild.data.transition = extend$2({}, data);
        // handle transition mode
        if (mode === 'out-in') {
          // return placeholder node and queue update when leave finishes
          this._leaving = true;
          mergeVNodeHook$1(oldData, 'afterLeave', function () {
            this$1$1._leaving = false;
            this$1$1.$forceUpdate();
          });
          return placeholder$1(h, rawChild)
        } else if (mode === 'in-out') {
          if (isAsyncPlaceholder$1(child)) {
            return oldRawChild
          }
          var delayedLeave;
          var performLeave = function () { delayedLeave(); };
          mergeVNodeHook$1(data, 'afterEnter', performLeave);
          mergeVNodeHook$1(data, 'enterCancelled', performLeave);
          mergeVNodeHook$1(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
        }
      }

      return rawChild
    }
  };

  /*  */

  var props$1 = extend$2({
    tag: String,
    moveClass: String
  }, transitionProps$1);

  delete props$1.mode;

  var TransitionGroup$1 = {
    props: props$1,

    beforeMount: function beforeMount () {
      var this$1$1 = this;

      var update = this._update;
      this._update = function (vnode, hydrating) {
        var restoreActiveInstance = setActiveInstance$1(this$1$1);
        // force removing pass
        this$1$1.__patch__(
          this$1$1._vnode,
          this$1$1.kept,
          false, // hydrating
          true // removeOnly (!important, avoids unnecessary moves)
        );
        this$1$1._vnode = this$1$1.kept;
        restoreActiveInstance();
        update.call(this$1$1, vnode, hydrating);
      };
    },

    render: function render (h) {
      var tag = this.tag || this.$vnode.data.tag || 'span';
      var map = Object.create(null);
      var prevChildren = this.prevChildren = this.children;
      var rawChildren = this.$slots.default || [];
      var children = this.children = [];
      var transitionData = extractTransitionData$1(this);

      for (var i = 0; i < rawChildren.length; i++) {
        var c = rawChildren[i];
        if (c.tag) {
          if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
            children.push(c);
            map[c.key] = c
            ;(c.data || (c.data = {})).transition = transitionData;
          } else {
            var opts = c.componentOptions;
            var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
            warn$3(("<transition-group> children must be keyed: <" + name + ">"));
          }
        }
      }

      if (prevChildren) {
        var kept = [];
        var removed = [];
        for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
          var c$1 = prevChildren[i$1];
          c$1.data.transition = transitionData;
          c$1.data.pos = c$1.elm.getBoundingClientRect();
          if (map[c$1.key]) {
            kept.push(c$1);
          } else {
            removed.push(c$1);
          }
        }
        this.kept = h(tag, null, kept);
        this.removed = removed;
      }

      return h(tag, null, children)
    },

    updated: function updated () {
      var children = this.prevChildren;
      var moveClass = this.moveClass || ((this.name || 'v') + '-move');
      if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
        return
      }

      // we divide the work into three loops to avoid mixing DOM reads and writes
      // in each iteration - which helps prevent layout thrashing.
      children.forEach(callPendingCbs$1);
      children.forEach(recordPosition$1);
      children.forEach(applyTranslation$1);

      // force reflow to put everything in position
      // assign to this to avoid being removed in tree-shaking
      // $flow-disable-line
      this._reflow = document.body.offsetHeight;

      children.forEach(function (c) {
        if (c.data.moved) {
          var el = c.elm;
          var s = el.style;
          addTransitionClass$1(el, moveClass);
          s.transform = s.WebkitTransform = s.transitionDuration = '';
          el.addEventListener(transitionEndEvent$1, el._moveCb = function cb (e) {
            if (e && e.target !== el) {
              return
            }
            if (!e || /transform$/.test(e.propertyName)) {
              el.removeEventListener(transitionEndEvent$1, cb);
              el._moveCb = null;
              removeTransitionClass$1(el, moveClass);
            }
          });
        }
      });
    },

    methods: {
      hasMove: function hasMove (el, moveClass) {
        /* istanbul ignore if */
        if (!hasTransition$1) {
          return false
        }
        /* istanbul ignore if */
        if (this._hasMove) {
          return this._hasMove
        }
        // Detect whether an element with the move class applied has
        // CSS transitions. Since the element may be inside an entering
        // transition at this very moment, we make a clone of it and remove
        // all other transition classes applied to ensure only the move class
        // is applied.
        var clone = el.cloneNode();
        if (el._transitionClasses) {
          el._transitionClasses.forEach(function (cls) { removeClass$1(clone, cls); });
        }
        addClass$1(clone, moveClass);
        clone.style.display = 'none';
        this.$el.appendChild(clone);
        var info = getTransitionInfo$1(clone);
        this.$el.removeChild(clone);
        return (this._hasMove = info.hasTransform)
      }
    }
  };

  function callPendingCbs$1 (c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
      c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
      c.elm._enterCb();
    }
  }

  function recordPosition$1 (c) {
    c.data.newPos = c.elm.getBoundingClientRect();
  }

  function applyTranslation$1 (c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
      c.data.moved = true;
      var s = c.elm.style;
      s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
      s.transitionDuration = '0s';
    }
  }

  var platformComponents$1 = {
    Transition: Transition$1,
    TransitionGroup: TransitionGroup$1
  };

  /*  */

  // install platform specific utils
  Vue$3.config.mustUseProp = mustUseProp$1;
  Vue$3.config.isReservedTag = isReservedTag$1;
  Vue$3.config.isReservedAttr = isReservedAttr$1;
  Vue$3.config.getTagNamespace = getTagNamespace$1;
  Vue$3.config.isUnknownElement = isUnknownElement$1;

  // install platform runtime directives & components
  extend$2(Vue$3.options.directives, platformDirectives$1);
  extend$2(Vue$3.options.components, platformComponents$1);

  // install platform patch function
  Vue$3.prototype.__patch__ = inBrowser$1 ? patch$1 : noop$2;

  // public mount method
  Vue$3.prototype.$mount = function (
    el,
    hydrating
  ) {
    el = el && inBrowser$1 ? query$1(el) : undefined;
    return mountComponent$1(this, el, hydrating)
  };

  // devtools global hook
  /* istanbul ignore next */
  if (inBrowser$1) {
    setTimeout(function () {
      if (config$2.devtools) {
        if (devtools$1) {
          devtools$1.emit('init', Vue$3);
        } else {
          console[console.info ? 'info' : 'log'](
            'Download the Vue Devtools extension for a better development experience:\n' +
            'https://github.com/vuejs/vue-devtools'
          );
        }
      }
      if (config$2.productionTip !== false &&
        typeof console !== 'undefined'
      ) {
        console[console.info ? 'info' : 'log'](
          "You are running Vue in development mode.\n" +
          "Make sure to turn on production mode when deploying for production.\n" +
          "See more tips at https://vuejs.org/guide/deployment.html"
        );
      }
    }, 0);
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var defineProperty = _defineProperty;

  var _defineProperty$1 = /*@__PURE__*/getDefaultExportFromCjs(defineProperty);

  var vue_common = {exports: {}};

  /*!
   * Vue.js v2.6.12
   * (c) 2014-2020 Evan You
   * Released under the MIT License.
   */

  /*  */

  var emptyObject = Object.freeze({});

  // These helpers produce better VM code in JS engines due to their
  // explicitness and function inlining.
  function isUndef (v) {
    return v === undefined || v === null
  }

  function isDef (v) {
    return v !== undefined && v !== null
  }

  function isTrue (v) {
    return v === true
  }

  function isFalse (v) {
    return v === false
  }

  /**
   * Check if value is primitive.
   */
  function isPrimitive (value) {
    return (
      typeof value === 'string' ||
      typeof value === 'number' ||
      // $flow-disable-line
      typeof value === 'symbol' ||
      typeof value === 'boolean'
    )
  }

  /**
   * Quick object check - this is primarily used to tell
   * Objects from primitive values when we know the value
   * is a JSON-compliant type.
   */
  function isObject$5 (obj) {
    return obj !== null && typeof obj === 'object'
  }

  /**
   * Get the raw type string of a value, e.g., [object Object].
   */
  var _toString = Object.prototype.toString;

  function toRawType (value) {
    return _toString.call(value).slice(8, -1)
  }

  /**
   * Strict object type check. Only returns true
   * for plain JavaScript objects.
   */
  function isPlainObject$1 (obj) {
    return _toString.call(obj) === '[object Object]'
  }

  function isRegExp (v) {
    return _toString.call(v) === '[object RegExp]'
  }

  /**
   * Check if val is a valid array index.
   */
  function isValidArrayIndex (val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val)
  }

  function isPromise$1 (val) {
    return (
      isDef(val) &&
      typeof val.then === 'function' &&
      typeof val.catch === 'function'
    )
  }

  /**
   * Convert a value to a string that is actually rendered.
   */
  function toString$1 (val) {
    return val == null
      ? ''
      : Array.isArray(val) || (isPlainObject$1(val) && val.toString === _toString)
        ? JSON.stringify(val, null, 2)
        : String(val)
  }

  /**
   * Convert an input value to a number for persistence.
   * If the conversion fails, return original string.
   */
  function toNumber$2 (val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n
  }

  /**
   * Make a map and return a function for checking if a key
   * is in that map.
   */
  function makeMap (
    str,
    expectsLowerCase
  ) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
      map[list[i]] = true;
    }
    return expectsLowerCase
      ? function (val) { return map[val.toLowerCase()]; }
      : function (val) { return map[val]; }
  }

  /**
   * Check if a tag is a built-in tag.
   */
  var isBuiltInTag = makeMap('slot,component', true);

  /**
   * Check if an attribute is a reserved attribute.
   */
  var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

  /**
   * Remove an item from an array.
   */
  function remove (arr, item) {
    if (arr.length) {
      var index = arr.indexOf(item);
      if (index > -1) {
        return arr.splice(index, 1)
      }
    }
  }

  /**
   * Check whether an object has the property.
   */
  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
  function hasOwn (obj, key) {
    return hasOwnProperty$1.call(obj, key)
  }

  /**
   * Create a cached version of a pure function.
   */
  function cached (fn) {
    var cache = Object.create(null);
    return (function cachedFn (str) {
      var hit = cache[str];
      return hit || (cache[str] = fn(str))
    })
  }

  /**
   * Camelize a hyphen-delimited string.
   */
  var camelizeRE = /-(\w)/g;
  var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
  });

  /**
   * Capitalize a string.
   */
  var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  });

  /**
   * Hyphenate a camelCase string.
   */
  var hyphenateRE = /\B([A-Z])/g;
  var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase()
  });

  /**
   * Simple bind polyfill for environments that do not support it,
   * e.g., PhantomJS 1.x. Technically, we don't need this anymore
   * since native bind is now performant enough in most browsers.
   * But removing it would mean breaking code that was able to run in
   * PhantomJS 1.x, so this must be kept for backward compatibility.
   */

  /* istanbul ignore next */
  function polyfillBind (fn, ctx) {
    function boundFn (a) {
      var l = arguments.length;
      return l
        ? l > 1
          ? fn.apply(ctx, arguments)
          : fn.call(ctx, a)
        : fn.call(ctx)
    }

    boundFn._length = fn.length;
    return boundFn
  }

  function nativeBind (fn, ctx) {
    return fn.bind(ctx)
  }

  var bind$3 = Function.prototype.bind
    ? nativeBind
    : polyfillBind;

  /**
   * Convert an Array-like object to a real Array.
   */
  function toArray (list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
      ret[i] = list[i + start];
    }
    return ret
  }

  /**
   * Mix properties into target object.
   */
  function extend$1 (to, _from) {
    for (var key in _from) {
      to[key] = _from[key];
    }
    return to
  }

  /**
   * Merge an Array of Objects into a single Object.
   */
  function toObject (arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
      if (arr[i]) {
        extend$1(res, arr[i]);
      }
    }
    return res
  }

  /* eslint-disable no-unused-vars */

  /**
   * Perform no operation.
   * Stubbing args to make Flow happy without leaving useless transpiled code
   * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
   */
  function noop$1 (a, b, c) {}

  /**
   * Always return false.
   */
  var no = function (a, b, c) { return false; };

  /* eslint-enable no-unused-vars */

  /**
   * Return the same value.
   */
  var identity = function (_) { return _; };

  /**
   * Generate a string containing static keys from compiler modules.
   */
  function genStaticKeys (modules) {
    return modules.reduce(function (keys, m) {
      return keys.concat(m.staticKeys || [])
    }, []).join(',')
  }

  /**
   * Check if two values are loosely equal - that is,
   * if they are plain objects, do they have the same shape?
   */
  function looseEqual (a, b) {
    if (a === b) { return true }
    var isObjectA = isObject$5(a);
    var isObjectB = isObject$5(b);
    if (isObjectA && isObjectB) {
      try {
        var isArrayA = Array.isArray(a);
        var isArrayB = Array.isArray(b);
        if (isArrayA && isArrayB) {
          return a.length === b.length && a.every(function (e, i) {
            return looseEqual(e, b[i])
          })
        } else if (a instanceof Date && b instanceof Date) {
          return a.getTime() === b.getTime()
        } else if (!isArrayA && !isArrayB) {
          var keysA = Object.keys(a);
          var keysB = Object.keys(b);
          return keysA.length === keysB.length && keysA.every(function (key) {
            return looseEqual(a[key], b[key])
          })
        } else {
          /* istanbul ignore next */
          return false
        }
      } catch (e) {
        /* istanbul ignore next */
        return false
      }
    } else if (!isObjectA && !isObjectB) {
      return String(a) === String(b)
    } else {
      return false
    }
  }

  /**
   * Return the first index at which a loosely equal value can be
   * found in the array (if value is a plain object, the array must
   * contain an object of the same shape), or -1 if it is not present.
   */
  function looseIndexOf (arr, val) {
    for (var i = 0; i < arr.length; i++) {
      if (looseEqual(arr[i], val)) { return i }
    }
    return -1
  }

  /**
   * Ensure a function is called only once.
   */
  function once$1 (fn) {
    var called = false;
    return function () {
      if (!called) {
        called = true;
        fn.apply(this, arguments);
      }
    }
  }

  var SSR_ATTR = 'data-server-rendered';

  var ASSET_TYPES = [
    'component',
    'directive',
    'filter'
  ];

  var LIFECYCLE_HOOKS = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch'
  ];

  /*  */



  var config$1 = ({
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),

    /**
     * Whether to suppress warnings.
     */
    silent: false,

    /**
     * Show production mode tip message on boot?
     */
    productionTip: "development" !== 'production',

    /**
     * Whether to enable devtools
     */
    devtools: "development" !== 'production',

    /**
     * Whether to record perf
     */
    performance: false,

    /**
     * Error handler for watcher errors
     */
    errorHandler: null,

    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,

    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],

    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),

    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,

    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,

    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,

    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop$1,

    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,

    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,

    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,

    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
  });

  /*  */

  /**
   * unicode letters used for parsing html tags, component names and property paths.
   * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
   * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
   */
  var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

  /**
   * Check if a string starts with $ or _
   */
  function isReserved (str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5F
  }

  /**
   * Define a property.
   */
  function def (obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
      value: val,
      enumerable: !!enumerable,
      writable: true,
      configurable: true
    });
  }

  /**
   * Parse simple path.
   */
  var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
  function parsePath (path) {
    if (bailRE.test(path)) {
      return
    }
    var segments = path.split('.');
    return function (obj) {
      for (var i = 0; i < segments.length; i++) {
        if (!obj) { return }
        obj = obj[segments[i]];
      }
      return obj
    }
  }

  /*  */

  // can we use __proto__?
  var hasProto = '__proto__' in {};

  // Browser environment sniffing
  var inBrowser = typeof window !== 'undefined';
  var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
  var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
  var UA = inBrowser && window.navigator.userAgent.toLowerCase();
  var isIE = UA && /msie|trident/.test(UA);
  var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
  var isEdge = UA && UA.indexOf('edge/') > 0;
  (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
  var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
  var isFF = UA && UA.match(/firefox\/(\d+)/);

  // Firefox has a "watch" function on Object.prototype...
  var nativeWatch = ({}).watch;

  var supportsPassive = false;
  if (inBrowser) {
    try {
      var opts = {};
      Object.defineProperty(opts, 'passive', ({
        get: function get () {
          /* istanbul ignore next */
          supportsPassive = true;
        }
      })); // https://github.com/facebook/flow/issues/285
      window.addEventListener('test-passive', null, opts);
    } catch (e) {}
  }

  // this needs to be lazy-evaled because vue may be required before
  // vue-server-renderer can set VUE_ENV
  var _isServer;
  var isServerRendering = function () {
    if (_isServer === undefined) {
      /* istanbul ignore if */
      if (!inBrowser && !inWeex && typeof commonjsGlobal !== 'undefined') {
        // detect presence of vue-server-renderer and avoid
        // Webpack shimming the process
        _isServer = commonjsGlobal['process'] && commonjsGlobal['process'].env.VUE_ENV === 'server';
      } else {
        _isServer = false;
      }
    }
    return _isServer
  };

  // detect devtools
  var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

  /* istanbul ignore next */
  function isNative (Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
  }

  var hasSymbol =
    typeof Symbol !== 'undefined' && isNative(Symbol) &&
    typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

  var _Set;
  /* istanbul ignore if */ // $flow-disable-line
  if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
  } else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /*@__PURE__*/(function () {
      function Set () {
        this.set = Object.create(null);
      }
      Set.prototype.has = function has (key) {
        return this.set[key] === true
      };
      Set.prototype.add = function add (key) {
        this.set[key] = true;
      };
      Set.prototype.clear = function clear () {
        this.set = Object.create(null);
      };

      return Set;
    }());
  }

  /*  */

  var warn = noop$1;
  var tip = noop$1;
  var generateComponentTrace = (noop$1); // work around flow check
  var formatComponentName = (noop$1);

  {
    var hasConsole = typeof console !== 'undefined';
    var classifyRE = /(?:^|[-_])(\w)/g;
    var classify = function (str) { return str
      .replace(classifyRE, function (c) { return c.toUpperCase(); })
      .replace(/[-_]/g, ''); };

    warn = function (msg, vm) {
      var trace = vm ? generateComponentTrace(vm) : '';

      if (config$1.warnHandler) {
        config$1.warnHandler.call(null, msg, vm, trace);
      } else if (hasConsole && (!config$1.silent)) {
        console.error(("[Vue warn]: " + msg + trace));
      }
    };

    tip = function (msg, vm) {
      if (hasConsole && (!config$1.silent)) {
        console.warn("[Vue tip]: " + msg + (
          vm ? generateComponentTrace(vm) : ''
        ));
      }
    };

    formatComponentName = function (vm, includeFile) {
      if (vm.$root === vm) {
        return '<Root>'
      }
      var options = typeof vm === 'function' && vm.cid != null
        ? vm.options
        : vm._isVue
          ? vm.$options || vm.constructor.options
          : vm;
      var name = options.name || options._componentTag;
      var file = options.__file;
      if (!name && file) {
        var match = file.match(/([^/\\]+)\.vue$/);
        name = match && match[1];
      }

      return (
        (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
        (file && includeFile !== false ? (" at " + file) : '')
      )
    };

    var repeat$1 = function (str, n) {
      var res = '';
      while (n) {
        if (n % 2 === 1) { res += str; }
        if (n > 1) { str += str; }
        n >>= 1;
      }
      return res
    };

    generateComponentTrace = function (vm) {
      if (vm._isVue && vm.$parent) {
        var tree = [];
        var currentRecursiveSequence = 0;
        while (vm) {
          if (tree.length > 0) {
            var last = tree[tree.length - 1];
            if (last.constructor === vm.constructor) {
              currentRecursiveSequence++;
              vm = vm.$parent;
              continue
            } else if (currentRecursiveSequence > 0) {
              tree[tree.length - 1] = [last, currentRecursiveSequence];
              currentRecursiveSequence = 0;
            }
          }
          tree.push(vm);
          vm = vm.$parent;
        }
        return '\n\nfound in\n\n' + tree
          .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat$1(' ', 5 + i * 2)) + (Array.isArray(vm)
              ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
              : formatComponentName(vm))); })
          .join('\n')
      } else {
        return ("\n\n(found in " + (formatComponentName(vm)) + ")")
      }
    };
  }

  /*  */

  var uid = 0;

  /**
   * A dep is an observable that can have multiple
   * directives subscribing to it.
   */
  var Dep = function Dep () {
    this.id = uid++;
    this.subs = [];
  };

  Dep.prototype.addSub = function addSub (sub) {
    this.subs.push(sub);
  };

  Dep.prototype.removeSub = function removeSub (sub) {
    remove(this.subs, sub);
  };

  Dep.prototype.depend = function depend () {
    if (Dep.target) {
      Dep.target.addDep(this);
    }
  };

  Dep.prototype.notify = function notify () {
    // stabilize the subscriber list first
    var subs = this.subs.slice();
    if (!config$1.async) {
      // subs aren't sorted in scheduler if not running async
      // we need to sort them now to make sure they fire in correct
      // order
      subs.sort(function (a, b) { return a.id - b.id; });
    }
    for (var i = 0, l = subs.length; i < l; i++) {
      subs[i].update();
    }
  };

  // The current target watcher being evaluated.
  // This is globally unique because only one watcher
  // can be evaluated at a time.
  Dep.target = null;
  var targetStack = [];

  function pushTarget (target) {
    targetStack.push(target);
    Dep.target = target;
  }

  function popTarget () {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
  }

  /*  */

  var VNode = function VNode (
    tag,
    data,
    children,
    text,
    elm,
    context,
    componentOptions,
    asyncFactory
  ) {
    this.tag = tag;
    this.data = data;
    this.children = children;
    this.text = text;
    this.elm = elm;
    this.ns = undefined;
    this.context = context;
    this.fnContext = undefined;
    this.fnOptions = undefined;
    this.fnScopeId = undefined;
    this.key = data && data.key;
    this.componentOptions = componentOptions;
    this.componentInstance = undefined;
    this.parent = undefined;
    this.raw = false;
    this.isStatic = false;
    this.isRootInsert = true;
    this.isComment = false;
    this.isCloned = false;
    this.isOnce = false;
    this.asyncFactory = asyncFactory;
    this.asyncMeta = undefined;
    this.isAsyncPlaceholder = false;
  };

  var prototypeAccessors$2 = { child: { configurable: true } };

  // DEPRECATED: alias for componentInstance for backwards compat.
  /* istanbul ignore next */
  prototypeAccessors$2.child.get = function () {
    return this.componentInstance
  };

  Object.defineProperties( VNode.prototype, prototypeAccessors$2 );

  var createEmptyVNode = function (text) {
    if ( text === void 0 ) text = '';

    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node
  };

  function createTextVNode (val) {
    return new VNode(undefined, undefined, undefined, String(val))
  }

  // optimized shallow clone
  // used for static nodes and slot nodes because they may be reused across
  // multiple renders, cloning them avoids errors when DOM manipulations rely
  // on their elm reference.
  function cloneVNode (vnode) {
    var cloned = new VNode(
      vnode.tag,
      vnode.data,
      // #7975
      // clone children array to avoid mutating original in case of cloning
      // a child.
      vnode.children && vnode.children.slice(),
      vnode.text,
      vnode.elm,
      vnode.context,
      vnode.componentOptions,
      vnode.asyncFactory
    );
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned
  }

  /*
   * not type checking this file because flow doesn't play well with
   * dynamically accessing methods on Array prototype
   */

  var arrayProto = Array.prototype;
  var arrayMethods = Object.create(arrayProto);

  var methodsToPatch = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
  ];

  /**
   * Intercept mutating methods and emit events
   */
  methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var result = original.apply(this, args);
      var ob = this.__ob__;
      var inserted;
      switch (method) {
        case 'push':
        case 'unshift':
          inserted = args;
          break
        case 'splice':
          inserted = args.slice(2);
          break
      }
      if (inserted) { ob.observeArray(inserted); }
      // notify change
      ob.dep.notify();
      return result
    });
  });

  /*  */

  var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

  /**
   * In some cases we may want to disable observation inside a component's
   * update computation.
   */
  var shouldObserve = true;

  function toggleObserving (value) {
    shouldObserve = value;
  }

  /**
   * Observer class that is attached to each observed
   * object. Once attached, the observer converts the target
   * object's property keys into getter/setters that
   * collect dependencies and dispatch updates.
   */
  var Observer = function Observer (value) {
    this.value = value;
    this.dep = new Dep();
    this.vmCount = 0;
    def(value, '__ob__', this);
    if (Array.isArray(value)) {
      if (hasProto) {
        protoAugment(value, arrayMethods);
      } else {
        copyAugment(value, arrayMethods, arrayKeys);
      }
      this.observeArray(value);
    } else {
      this.walk(value);
    }
  };

  /**
   * Walk through all properties and convert them into
   * getter/setters. This method should only be called when
   * value type is Object.
   */
  Observer.prototype.walk = function walk (obj) {
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      defineReactive$$1(obj, keys[i]);
    }
  };

  /**
   * Observe a list of Array items.
   */
  Observer.prototype.observeArray = function observeArray (items) {
    for (var i = 0, l = items.length; i < l; i++) {
      observe(items[i]);
    }
  };

  // helpers

  /**
   * Augment a target Object or Array by intercepting
   * the prototype chain using __proto__
   */
  function protoAugment (target, src) {
    /* eslint-disable no-proto */
    target.__proto__ = src;
    /* eslint-enable no-proto */
  }

  /**
   * Augment a target Object or Array by defining
   * hidden properties.
   */
  /* istanbul ignore next */
  function copyAugment (target, src, keys) {
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      def(target, key, src[key]);
    }
  }

  /**
   * Attempt to create an observer instance for a value,
   * returns the new observer if successfully observed,
   * or the existing observer if the value already has one.
   */
  function observe (value, asRootData) {
    if (!isObject$5(value) || value instanceof VNode) {
      return
    }
    var ob;
    if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
      ob = value.__ob__;
    } else if (
      shouldObserve &&
      !isServerRendering() &&
      (Array.isArray(value) || isPlainObject$1(value)) &&
      Object.isExtensible(value) &&
      !value._isVue
    ) {
      ob = new Observer(value);
    }
    if (asRootData && ob) {
      ob.vmCount++;
    }
    return ob
  }

  /**
   * Define a reactive property on an Object.
   */
  function defineReactive$$1 (
    obj,
    key,
    val,
    customSetter,
    shallow
  ) {
    var dep = new Dep();

    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
      return
    }

    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) && arguments.length === 2) {
      val = obj[key];
    }

    var childOb = !shallow && observe(val);
    Object.defineProperty(obj, key, {
      enumerable: true,
      configurable: true,
      get: function reactiveGetter () {
        var value = getter ? getter.call(obj) : val;
        if (Dep.target) {
          dep.depend();
          if (childOb) {
            childOb.dep.depend();
            if (Array.isArray(value)) {
              dependArray(value);
            }
          }
        }
        return value
      },
      set: function reactiveSetter (newVal) {
        var value = getter ? getter.call(obj) : val;
        /* eslint-disable no-self-compare */
        if (newVal === value || (newVal !== newVal && value !== value)) {
          return
        }
        /* eslint-enable no-self-compare */
        if (customSetter) {
          customSetter();
        }
        // #7981: for accessor properties without setter
        if (getter && !setter) { return }
        if (setter) {
          setter.call(obj, newVal);
        } else {
          val = newVal;
        }
        childOb = !shallow && observe(newVal);
        dep.notify();
      }
    });
  }

  /**
   * Set a property on an object. Adds the new property and
   * triggers change notification if the property doesn't
   * already exist.
   */
  function set (target, key, val) {
    if (isUndef(target) || isPrimitive(target)
    ) {
      warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
    }
    if (Array.isArray(target) && isValidArrayIndex(key)) {
      target.length = Math.max(target.length, key);
      target.splice(key, 1, val);
      return val
    }
    if (key in target && !(key in Object.prototype)) {
      target[key] = val;
      return val
    }
    var ob = (target).__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
      warn(
        'Avoid adding reactive properties to a Vue instance or its root $data ' +
        'at runtime - declare it upfront in the data option.'
      );
      return val
    }
    if (!ob) {
      target[key] = val;
      return val
    }
    defineReactive$$1(ob.value, key, val);
    ob.dep.notify();
    return val
  }

  /**
   * Delete a property and trigger change if necessary.
   */
  function del (target, key) {
    if (isUndef(target) || isPrimitive(target)
    ) {
      warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
    }
    if (Array.isArray(target) && isValidArrayIndex(key)) {
      target.splice(key, 1);
      return
    }
    var ob = (target).__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
      warn(
        'Avoid deleting properties on a Vue instance or its root $data ' +
        '- just set it to null.'
      );
      return
    }
    if (!hasOwn(target, key)) {
      return
    }
    delete target[key];
    if (!ob) {
      return
    }
    ob.dep.notify();
  }

  /**
   * Collect dependencies on array elements when the array is touched, since
   * we cannot intercept array element access like property getters.
   */
  function dependArray (value) {
    for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
      e = value[i];
      e && e.__ob__ && e.__ob__.dep.depend();
      if (Array.isArray(e)) {
        dependArray(e);
      }
    }
  }

  /*  */

  /**
   * Option overwriting strategies are functions that handle
   * how to merge a parent option value and a child option
   * value into the final value.
   */
  var strats = config$1.optionMergeStrategies;

  /**
   * Options with restrictions
   */
  {
    strats.el = strats.propsData = function (parent, child, vm, key) {
      if (!vm) {
        warn(
          "option \"" + key + "\" can only be used during instance " +
          'creation with the `new` keyword.'
        );
      }
      return defaultStrat(parent, child)
    };
  }

  /**
   * Helper that recursively merges two data objects together.
   */
  function mergeData (to, from) {
    if (!from) { return to }
    var key, toVal, fromVal;

    var keys = hasSymbol
      ? Reflect.ownKeys(from)
      : Object.keys(from);

    for (var i = 0; i < keys.length; i++) {
      key = keys[i];
      // in case the object is already observed...
      if (key === '__ob__') { continue }
      toVal = to[key];
      fromVal = from[key];
      if (!hasOwn(to, key)) {
        set(to, key, fromVal);
      } else if (
        toVal !== fromVal &&
        isPlainObject$1(toVal) &&
        isPlainObject$1(fromVal)
      ) {
        mergeData(toVal, fromVal);
      }
    }
    return to
  }

  /**
   * Data
   */
  function mergeDataOrFn (
    parentVal,
    childVal,
    vm
  ) {
    if (!vm) {
      // in a Vue.extend merge, both should be functions
      if (!childVal) {
        return parentVal
      }
      if (!parentVal) {
        return childVal
      }
      // when parentVal & childVal are both present,
      // we need to return a function that returns the
      // merged result of both functions... no need to
      // check if parentVal is a function here because
      // it has to be a function to pass previous merges.
      return function mergedDataFn () {
        return mergeData(
          typeof childVal === 'function' ? childVal.call(this, this) : childVal,
          typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
        )
      }
    } else {
      return function mergedInstanceDataFn () {
        // instance merge
        var instanceData = typeof childVal === 'function'
          ? childVal.call(vm, vm)
          : childVal;
        var defaultData = typeof parentVal === 'function'
          ? parentVal.call(vm, vm)
          : parentVal;
        if (instanceData) {
          return mergeData(instanceData, defaultData)
        } else {
          return defaultData
        }
      }
    }
  }

  strats.data = function (
    parentVal,
    childVal,
    vm
  ) {
    if (!vm) {
      if (childVal && typeof childVal !== 'function') {
        warn(
          'The "data" option should be a function ' +
          'that returns a per-instance value in component ' +
          'definitions.',
          vm
        );

        return parentVal
      }
      return mergeDataOrFn(parentVal, childVal)
    }

    return mergeDataOrFn(parentVal, childVal, vm)
  };

  /**
   * Hooks and props are merged as arrays.
   */
  function mergeHook (
    parentVal,
    childVal
  ) {
    var res = childVal
      ? parentVal
        ? parentVal.concat(childVal)
        : Array.isArray(childVal)
          ? childVal
          : [childVal]
      : parentVal;
    return res
      ? dedupeHooks(res)
      : res
  }

  function dedupeHooks (hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
      if (res.indexOf(hooks[i]) === -1) {
        res.push(hooks[i]);
      }
    }
    return res
  }

  LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeHook;
  });

  /**
   * Assets
   *
   * When a vm is present (instance creation), we need to do
   * a three-way merge between constructor options, instance
   * options and parent options.
   */
  function mergeAssets (
    parentVal,
    childVal,
    vm,
    key
  ) {
    var res = Object.create(parentVal || null);
    if (childVal) {
      assertObjectType(key, childVal, vm);
      return extend$1(res, childVal)
    } else {
      return res
    }
  }

  ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
  });

  /**
   * Watchers.
   *
   * Watchers hashes should not overwrite one
   * another, so we merge them as arrays.
   */
  strats.watch = function (
    parentVal,
    childVal,
    vm,
    key
  ) {
    // work around Firefox's Object.prototype.watch...
    if (parentVal === nativeWatch) { parentVal = undefined; }
    if (childVal === nativeWatch) { childVal = undefined; }
    /* istanbul ignore if */
    if (!childVal) { return Object.create(parentVal || null) }
    {
      assertObjectType(key, childVal, vm);
    }
    if (!parentVal) { return childVal }
    var ret = {};
    extend$1(ret, parentVal);
    for (var key$1 in childVal) {
      var parent = ret[key$1];
      var child = childVal[key$1];
      if (parent && !Array.isArray(parent)) {
        parent = [parent];
      }
      ret[key$1] = parent
        ? parent.concat(child)
        : Array.isArray(child) ? child : [child];
    }
    return ret
  };

  /**
   * Other object hashes.
   */
  strats.props =
  strats.methods =
  strats.inject =
  strats.computed = function (
    parentVal,
    childVal,
    vm,
    key
  ) {
    if (childVal && "development" !== 'production') {
      assertObjectType(key, childVal, vm);
    }
    if (!parentVal) { return childVal }
    var ret = Object.create(null);
    extend$1(ret, parentVal);
    if (childVal) { extend$1(ret, childVal); }
    return ret
  };
  strats.provide = mergeDataOrFn;

  /**
   * Default strategy.
   */
  var defaultStrat = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };

  /**
   * Validate component names
   */
  function checkComponents (options) {
    for (var key in options.components) {
      validateComponentName(key);
    }
  }

  function validateComponentName (name) {
    if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
      warn(
        'Invalid component name: "' + name + '". Component names ' +
        'should conform to valid custom element name in html5 specification.'
      );
    }
    if (isBuiltInTag(name) || config$1.isReservedTag(name)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + name
      );
    }
  }

  /**
   * Ensure all props option syntax are normalized into the
   * Object-based format.
   */
  function normalizeProps (options, vm) {
    var props = options.props;
    if (!props) { return }
    var res = {};
    var i, val, name;
    if (Array.isArray(props)) {
      i = props.length;
      while (i--) {
        val = props[i];
        if (typeof val === 'string') {
          name = camelize(val);
          res[name] = { type: null };
        } else {
          warn('props must be strings when using array syntax.');
        }
      }
    } else if (isPlainObject$1(props)) {
      for (var key in props) {
        val = props[key];
        name = camelize(key);
        res[name] = isPlainObject$1(val)
          ? val
          : { type: val };
      }
    } else {
      warn(
        "Invalid value for option \"props\": expected an Array or an Object, " +
        "but got " + (toRawType(props)) + ".",
        vm
      );
    }
    options.props = res;
  }

  /**
   * Normalize all injections into Object-based format
   */
  function normalizeInject (options, vm) {
    var inject = options.inject;
    if (!inject) { return }
    var normalized = options.inject = {};
    if (Array.isArray(inject)) {
      for (var i = 0; i < inject.length; i++) {
        normalized[inject[i]] = { from: inject[i] };
      }
    } else if (isPlainObject$1(inject)) {
      for (var key in inject) {
        var val = inject[key];
        normalized[key] = isPlainObject$1(val)
          ? extend$1({ from: key }, val)
          : { from: val };
      }
    } else {
      warn(
        "Invalid value for option \"inject\": expected an Array or an Object, " +
        "but got " + (toRawType(inject)) + ".",
        vm
      );
    }
  }

  /**
   * Normalize raw function directives into object format.
   */
  function normalizeDirectives (options) {
    var dirs = options.directives;
    if (dirs) {
      for (var key in dirs) {
        var def$$1 = dirs[key];
        if (typeof def$$1 === 'function') {
          dirs[key] = { bind: def$$1, update: def$$1 };
        }
      }
    }
  }

  function assertObjectType (name, value, vm) {
    if (!isPlainObject$1(value)) {
      warn(
        "Invalid value for option \"" + name + "\": expected an Object, " +
        "but got " + (toRawType(value)) + ".",
        vm
      );
    }
  }

  /**
   * Merge two option objects into a new one.
   * Core utility used in both instantiation and inheritance.
   */
  function mergeOptions (
    parent,
    child,
    vm
  ) {
    {
      checkComponents(child);
    }

    if (typeof child === 'function') {
      child = child.options;
    }

    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives(child);

    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
      if (child.extends) {
        parent = mergeOptions(parent, child.extends, vm);
      }
      if (child.mixins) {
        for (var i = 0, l = child.mixins.length; i < l; i++) {
          parent = mergeOptions(parent, child.mixins[i], vm);
        }
      }
    }

    var options = {};
    var key;
    for (key in parent) {
      mergeField(key);
    }
    for (key in child) {
      if (!hasOwn(parent, key)) {
        mergeField(key);
      }
    }
    function mergeField (key) {
      var strat = strats[key] || defaultStrat;
      options[key] = strat(parent[key], child[key], vm, key);
    }
    return options
  }

  /**
   * Resolve an asset.
   * This function is used because child instances need access
   * to assets defined in its ancestor chain.
   */
  function resolveAsset (
    options,
    type,
    id,
    warnMissing
  ) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
      return
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id)) { return assets[id] }
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (warnMissing && !res) {
      warn(
        'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
        options
      );
    }
    return res
  }

  /*  */



  function validateProp (
    key,
    propOptions,
    propsData,
    vm
  ) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
      if (absent && !hasOwn(prop, 'default')) {
        value = false;
      } else if (value === '' || value === hyphenate(key)) {
        // only cast empty string / same name to boolean if
        // boolean has higher priority
        var stringIndex = getTypeIndex(String, prop.type);
        if (stringIndex < 0 || booleanIndex < stringIndex) {
          value = true;
        }
      }
    }
    // check default value
    if (value === undefined) {
      value = getPropDefaultValue(vm, prop, key);
      // since the default value is a fresh copy,
      // make sure to observe it.
      var prevShouldObserve = shouldObserve;
      toggleObserving(true);
      observe(value);
      toggleObserving(prevShouldObserve);
    }
    {
      assertProp(prop, key, value, vm, absent);
    }
    return value
  }

  /**
   * Get the default value of a prop.
   */
  function getPropDefaultValue (vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
      return undefined
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (isObject$5(def)) {
      warn(
        'Invalid default value for prop "' + key + '": ' +
        'Props with type Object/Array must use a factory function ' +
        'to return the default value.',
        vm
      );
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm && vm.$options.propsData &&
      vm.$options.propsData[key] === undefined &&
      vm._props[key] !== undefined
    ) {
      return vm._props[key]
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return typeof def === 'function' && getType(prop.type) !== 'Function'
      ? def.call(vm)
      : def
  }

  /**
   * Assert whether a prop is valid.
   */
  function assertProp (
    prop,
    name,
    value,
    vm,
    absent
  ) {
    if (prop.required && absent) {
      warn(
        'Missing required prop: "' + name + '"',
        vm
      );
      return
    }
    if (value == null && !prop.required) {
      return
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
      if (!Array.isArray(type)) {
        type = [type];
      }
      for (var i = 0; i < type.length && !valid; i++) {
        var assertedType = assertType(value, type[i]);
        expectedTypes.push(assertedType.expectedType || '');
        valid = assertedType.valid;
      }
    }

    if (!valid) {
      warn(
        getInvalidTypeMessage(name, value, expectedTypes),
        vm
      );
      return
    }
    var validator = prop.validator;
    if (validator) {
      if (!validator(value)) {
        warn(
          'Invalid prop: custom validator check failed for prop "' + name + '".',
          vm
        );
      }
    }
  }

  var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

  function assertType (value, type) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
      var t = typeof value;
      valid = t === expectedType.toLowerCase();
      // for primitive wrapper objects
      if (!valid && t === 'object') {
        valid = value instanceof type;
      }
    } else if (expectedType === 'Object') {
      valid = isPlainObject$1(value);
    } else if (expectedType === 'Array') {
      valid = Array.isArray(value);
    } else {
      valid = value instanceof type;
    }
    return {
      valid: valid,
      expectedType: expectedType
    }
  }

  /**
   * Use function string name to check built-in types,
   * because a simple equality check will fail when running
   * across different vms / iframes.
   */
  function getType (fn) {
    var match = fn && fn.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ''
  }

  function isSameType (a, b) {
    return getType(a) === getType(b)
  }

  function getTypeIndex (type, expectedTypes) {
    if (!Array.isArray(expectedTypes)) {
      return isSameType(expectedTypes, type) ? 0 : -1
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
      if (isSameType(expectedTypes[i], type)) {
        return i
      }
    }
    return -1
  }

  function getInvalidTypeMessage (name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    var expectedValue = styleValue(value, expectedType);
    var receivedValue = styleValue(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        !isBoolean(expectedType, receivedType)) {
      message += " with value " + expectedValue;
    }
    message += ", got " + receivedType + " ";
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
      message += "with value " + receivedValue + ".";
    }
    return message
  }

  function styleValue (value, type) {
    if (type === 'String') {
      return ("\"" + value + "\"")
    } else if (type === 'Number') {
      return ("" + (Number(value)))
    } else {
      return ("" + value)
    }
  }

  function isExplicable (value) {
    var explicitTypes = ['string', 'number', 'boolean'];
    return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
  }

  function isBoolean () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
  }

  /*  */

  function handleError (err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
      if (vm) {
        var cur = vm;
        while ((cur = cur.$parent)) {
          var hooks = cur.$options.errorCaptured;
          if (hooks) {
            for (var i = 0; i < hooks.length; i++) {
              try {
                var capture = hooks[i].call(cur, err, vm, info) === false;
                if (capture) { return }
              } catch (e) {
                globalHandleError(e, cur, 'errorCaptured hook');
              }
            }
          }
        }
      }
      globalHandleError(err, vm, info);
    } finally {
      popTarget();
    }
  }

  function invokeWithErrorHandling (
    handler,
    context,
    args,
    vm,
    info
  ) {
    var res;
    try {
      res = args ? handler.apply(context, args) : handler.call(context);
      if (res && !res._isVue && isPromise$1(res) && !res._handled) {
        res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
        // issue #9511
        // avoid catch triggering multiple times when nested calls
        res._handled = true;
      }
    } catch (e) {
      handleError(e, vm, info);
    }
    return res
  }

  function globalHandleError (err, vm, info) {
    if (config$1.errorHandler) {
      try {
        return config$1.errorHandler.call(null, err, vm, info)
      } catch (e) {
        // if the user intentionally throws the original error in the handler,
        // do not log it twice
        if (e !== err) {
          logError(e, null, 'config.errorHandler');
        }
      }
    }
    logError(err, vm, info);
  }

  function logError (err, vm, info) {
    {
      warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
    }
    /* istanbul ignore else */
    if ((inBrowser || inWeex) && typeof console !== 'undefined') {
      console.error(err);
    } else {
      throw err
    }
  }

  /*  */

  var isUsingMicroTask = false;

  var callbacks = [];
  var pending = false;

  function flushCallbacks () {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // Here we have async deferring wrappers using microtasks.
  // In 2.5 we used (macro) tasks (in combination with microtasks).
  // However, it has subtle problems when state is changed right before repaint
  // (e.g. #6813, out-in transitions).
  // Also, using (macro) tasks in event handler would cause some weird behaviors
  // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
  // So we now use microtasks everywhere, again.
  // A major drawback of this tradeoff is that there are some scenarios
  // where microtasks have too high a priority and fire in between supposedly
  // sequential events (e.g. #4521, #6690, which have workarounds)
  // or even between bubbling of the same event (#6566).
  var timerFunc;

  // The nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore next, $flow-disable-line */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    timerFunc = function () {
      p.then(flushCallbacks);
      // In problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) { setTimeout(noop$1); }
    };
    isUsingMicroTask = true;
  } else if (!isIE && typeof MutationObserver !== 'undefined' && (
    isNative(MutationObserver) ||
    // PhantomJS and iOS 7.x
    MutationObserver.toString() === '[object MutationObserverConstructor]'
  )) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
    isUsingMicroTask = true;
  } else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function () {
      setImmediate(flushCallbacks);
    };
  } else {
    // Fallback to setTimeout.
    timerFunc = function () {
      setTimeout(flushCallbacks, 0);
    };
  }

  function nextTick$1 (cb, ctx) {
    var _resolve;
    callbacks.push(function () {
      if (cb) {
        try {
          cb.call(ctx);
        } catch (e) {
          handleError(e, ctx, 'nextTick');
        }
      } else if (_resolve) {
        _resolve(ctx);
      }
    });
    if (!pending) {
      pending = true;
      timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
      return new Promise(function (resolve) {
        _resolve = resolve;
      })
    }
  }

  /*  */

  var mark;
  var measure;

  {
    var perf = inBrowser && window.performance;
    /* istanbul ignore if */
    if (
      perf &&
      perf.mark &&
      perf.measure &&
      perf.clearMarks &&
      perf.clearMeasures
    ) {
      mark = function (tag) { return perf.mark(tag); };
      measure = function (name, startTag, endTag) {
        perf.measure(name, startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag);
        // perf.clearMeasures(name)
      };
    }
  }

  /* not type checking this file because flow doesn't play well with Proxy */

  var initProxy;

  {
    var allowedGlobals = makeMap(
      'Infinity,undefined,NaN,isFinite,isNaN,' +
      'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
      'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
      'require' // for Webpack/Browserify
    );

    var warnNonPresent = function (target, key) {
      warn(
        "Property or method \"" + key + "\" is not defined on the instance but " +
        'referenced during render. Make sure that this property is reactive, ' +
        'either in the data option, or for class-based components, by ' +
        'initializing the property. ' +
        'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
        target
      );
    };

    var warnReservedPrefix = function (target, key) {
      warn(
        "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
        'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
        'prevent conflicts with Vue internals. ' +
        'See: https://vuejs.org/v2/api/#data',
        target
      );
    };

    var hasProxy =
      typeof Proxy !== 'undefined' && isNative(Proxy);

    if (hasProxy) {
      var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
      config$1.keyCodes = new Proxy(config$1.keyCodes, {
        set: function set (target, key, value) {
          if (isBuiltInModifier(key)) {
            warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
            return false
          } else {
            target[key] = value;
            return true
          }
        }
      });
    }

    var hasHandler = {
      has: function has (target, key) {
        var has = key in target;
        var isAllowed = allowedGlobals(key) ||
          (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
        if (!has && !isAllowed) {
          if (key in target.$data) { warnReservedPrefix(target, key); }
          else { warnNonPresent(target, key); }
        }
        return has || !isAllowed
      }
    };

    var getHandler = {
      get: function get (target, key) {
        if (typeof key === 'string' && !(key in target)) {
          if (key in target.$data) { warnReservedPrefix(target, key); }
          else { warnNonPresent(target, key); }
        }
        return target[key]
      }
    };

    initProxy = function initProxy (vm) {
      if (hasProxy) {
        // determine which proxy handler to use
        var options = vm.$options;
        var handlers = options.render && options.render._withStripped
          ? getHandler
          : hasHandler;
        vm._renderProxy = new Proxy(vm, handlers);
      } else {
        vm._renderProxy = vm;
      }
    };
  }

  /*  */

  var seenObjects = new _Set();

  /**
   * Recursively traverse an object to evoke all converted
   * getters, so that every nested property inside the object
   * is collected as a "deep" dependency.
   */
  function traverse (val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
  }

  function _traverse (val, seen) {
    var i, keys;
    var isA = Array.isArray(val);
    if ((!isA && !isObject$5(val)) || Object.isFrozen(val) || val instanceof VNode) {
      return
    }
    if (val.__ob__) {
      var depId = val.__ob__.dep.id;
      if (seen.has(depId)) {
        return
      }
      seen.add(depId);
    }
    if (isA) {
      i = val.length;
      while (i--) { _traverse(val[i], seen); }
    } else {
      keys = Object.keys(val);
      i = keys.length;
      while (i--) { _traverse(val[keys[i]], seen); }
    }
  }

  /*  */

  var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once$$1 ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
      name: name,
      once: once$$1,
      capture: capture,
      passive: passive
    }
  });

  function createFnInvoker (fns, vm) {
    function invoker () {
      var arguments$1 = arguments;

      var fns = invoker.fns;
      if (Array.isArray(fns)) {
        var cloned = fns.slice();
        for (var i = 0; i < cloned.length; i++) {
          invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
        }
      } else {
        // return handler return value for single handlers
        return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
      }
    }
    invoker.fns = fns;
    return invoker
  }

  function updateListeners (
    on,
    oldOn,
    add,
    remove$$1,
    createOnceHandler,
    vm
  ) {
    var name, cur, old, event;
    for (name in on) {
      cur = on[name];
      old = oldOn[name];
      event = normalizeEvent(name);
      if (isUndef(cur)) {
        warn(
          "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
          vm
        );
      } else if (isUndef(old)) {
        if (isUndef(cur.fns)) {
          cur = on[name] = createFnInvoker(cur, vm);
        }
        if (isTrue(event.once)) {
          cur = on[name] = createOnceHandler(event.name, cur, event.capture);
        }
        add(event.name, cur, event.capture, event.passive, event.params);
      } else if (cur !== old) {
        old.fns = cur;
        on[name] = old;
      }
    }
    for (name in oldOn) {
      if (isUndef(on[name])) {
        event = normalizeEvent(name);
        remove$$1(event.name, oldOn[name], event.capture);
      }
    }
  }

  /*  */

  function mergeVNodeHook (def, hookKey, hook) {
    if (def instanceof VNode) {
      def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];

    function wrappedHook () {
      hook.apply(this, arguments);
      // important: remove merged hook to ensure it's called only once
      // and prevent memory leak
      remove(invoker.fns, wrappedHook);
    }

    if (isUndef(oldHook)) {
      // no existing hook
      invoker = createFnInvoker([wrappedHook]);
    } else {
      /* istanbul ignore if */
      if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
        // already a merged invoker
        invoker = oldHook;
        invoker.fns.push(wrappedHook);
      } else {
        // existing plain hook
        invoker = createFnInvoker([oldHook, wrappedHook]);
      }
    }

    invoker.merged = true;
    def[hookKey] = invoker;
  }

  /*  */

  function extractPropsFromVNodeData (
    data,
    Ctor,
    tag
  ) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
      return
    }
    var res = {};
    var attrs = data.attrs;
    var props = data.props;
    if (isDef(attrs) || isDef(props)) {
      for (var key in propOptions) {
        var altKey = hyphenate(key);
        {
          var keyInLowerCase = key.toLowerCase();
          if (
            key !== keyInLowerCase &&
            attrs && hasOwn(attrs, keyInLowerCase)
          ) {
            tip(
              "Prop \"" + keyInLowerCase + "\" is passed to component " +
              (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
              " \"" + key + "\". " +
              "Note that HTML attributes are case-insensitive and camelCased " +
              "props need to use their kebab-case equivalents when using in-DOM " +
              "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
            );
          }
        }
        checkProp(res, props, key, altKey, true) ||
        checkProp(res, attrs, key, altKey, false);
      }
    }
    return res
  }

  function checkProp (
    res,
    hash,
    key,
    altKey,
    preserve
  ) {
    if (isDef(hash)) {
      if (hasOwn(hash, key)) {
        res[key] = hash[key];
        if (!preserve) {
          delete hash[key];
        }
        return true
      } else if (hasOwn(hash, altKey)) {
        res[key] = hash[altKey];
        if (!preserve) {
          delete hash[altKey];
        }
        return true
      }
    }
    return false
  }

  /*  */

  // The template compiler attempts to minimize the need for normalization by
  // statically analyzing the template at compile time.
  //
  // For plain HTML markup, normalization can be completely skipped because the
  // generated render function is guaranteed to return Array<VNode>. There are
  // two cases where extra normalization is needed:

  // 1. When the children contains components - because a functional component
  // may return an Array instead of a single root. In this case, just a simple
  // normalization is needed - if any child is an Array, we flatten the whole
  // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
  // because functional components already normalize their own children.
  function simpleNormalizeChildren (children) {
    for (var i = 0; i < children.length; i++) {
      if (Array.isArray(children[i])) {
        return Array.prototype.concat.apply([], children)
      }
    }
    return children
  }

  // 2. When the children contains constructs that always generated nested Arrays,
  // e.g. <template>, <slot>, v-for, or when the children is provided by user
  // with hand-written render functions / JSX. In such cases a full normalization
  // is needed to cater to all possible types of children values.
  function normalizeChildren (children) {
    return isPrimitive(children)
      ? [createTextVNode(children)]
      : Array.isArray(children)
        ? normalizeArrayChildren(children)
        : undefined
  }

  function isTextNode (node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment)
  }

  function normalizeArrayChildren (children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
      c = children[i];
      if (isUndef(c) || typeof c === 'boolean') { continue }
      lastIndex = res.length - 1;
      last = res[lastIndex];
      //  nested
      if (Array.isArray(c)) {
        if (c.length > 0) {
          c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
          // merge adjacent text nodes
          if (isTextNode(c[0]) && isTextNode(last)) {
            res[lastIndex] = createTextVNode(last.text + (c[0]).text);
            c.shift();
          }
          res.push.apply(res, c);
        }
      } else if (isPrimitive(c)) {
        if (isTextNode(last)) {
          // merge adjacent text nodes
          // this is necessary for SSR hydration because text nodes are
          // essentially merged when rendered to HTML strings
          res[lastIndex] = createTextVNode(last.text + c);
        } else if (c !== '') {
          // convert primitive to vnode
          res.push(createTextVNode(c));
        }
      } else {
        if (isTextNode(c) && isTextNode(last)) {
          // merge adjacent text nodes
          res[lastIndex] = createTextVNode(last.text + c.text);
        } else {
          // default key for nested array children (likely generated by v-for)
          if (isTrue(children._isVList) &&
            isDef(c.tag) &&
            isUndef(c.key) &&
            isDef(nestedIndex)) {
            c.key = "__vlist" + nestedIndex + "_" + i + "__";
          }
          res.push(c);
        }
      }
    }
    return res
  }

  /*  */

  function initProvide (vm) {
    var provide = vm.$options.provide;
    if (provide) {
      vm._provided = typeof provide === 'function'
        ? provide.call(vm)
        : provide;
    }
  }

  function initInjections (vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
      toggleObserving(false);
      Object.keys(result).forEach(function (key) {
        /* istanbul ignore else */
        {
          defineReactive$$1(vm, key, result[key], function () {
            warn(
              "Avoid mutating an injected value directly since the changes will be " +
              "overwritten whenever the provided component re-renders. " +
              "injection being mutated: \"" + key + "\"",
              vm
            );
          });
        }
      });
      toggleObserving(true);
    }
  }

  function resolveInject (inject, vm) {
    if (inject) {
      // inject is :any because flow is not smart enough to figure out cached
      var result = Object.create(null);
      var keys = hasSymbol
        ? Reflect.ownKeys(inject)
        : Object.keys(inject);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        // #6574 in case the inject object is observed...
        if (key === '__ob__') { continue }
        var provideKey = inject[key].from;
        var source = vm;
        while (source) {
          if (source._provided && hasOwn(source._provided, provideKey)) {
            result[key] = source._provided[provideKey];
            break
          }
          source = source.$parent;
        }
        if (!source) {
          if ('default' in inject[key]) {
            var provideDefault = inject[key].default;
            result[key] = typeof provideDefault === 'function'
              ? provideDefault.call(vm)
              : provideDefault;
          } else {
            warn(("Injection \"" + key + "\" not found"), vm);
          }
        }
      }
      return result
    }
  }

  /*  */



  /**
   * Runtime helper for resolving raw children VNodes into a slot object.
   */
  function resolveSlots (
    children,
    context
  ) {
    if (!children || !children.length) {
      return {}
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
      var child = children[i];
      var data = child.data;
      // remove slot attribute if the node is resolved as a Vue slot node
      if (data && data.attrs && data.attrs.slot) {
        delete data.attrs.slot;
      }
      // named slots should only be respected if the vnode was rendered in the
      // same context.
      if ((child.context === context || child.fnContext === context) &&
        data && data.slot != null
      ) {
        var name = data.slot;
        var slot = (slots[name] || (slots[name] = []));
        if (child.tag === 'template') {
          slot.push.apply(slot, child.children || []);
        } else {
          slot.push(child);
        }
      } else {
        (slots.default || (slots.default = [])).push(child);
      }
    }
    // ignore slots that contains only whitespace
    for (var name$1 in slots) {
      if (slots[name$1].every(isWhitespace)) {
        delete slots[name$1];
      }
    }
    return slots
  }

  function isWhitespace (node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' '
  }

  /*  */

  function normalizeScopedSlots (
    slots,
    normalSlots,
    prevSlots
  ) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = slots ? !!slots.$stable : !hasNormalSlots;
    var key = slots && slots.$key;
    if (!slots) {
      res = {};
    } else if (slots._normalized) {
      // fast path 1: child component re-render only, parent did not change
      return slots._normalized
    } else if (
      isStable &&
      prevSlots &&
      prevSlots !== emptyObject &&
      key === prevSlots.$key &&
      !hasNormalSlots &&
      !prevSlots.$hasNormal
    ) {
      // fast path 2: stable scoped slots w/ no normal slots to proxy,
      // only need to normalize once
      return prevSlots
    } else {
      res = {};
      for (var key$1 in slots) {
        if (slots[key$1] && key$1[0] !== '$') {
          res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
        }
      }
    }
    // expose normal slots on scopedSlots
    for (var key$2 in normalSlots) {
      if (!(key$2 in res)) {
        res[key$2] = proxyNormalSlot(normalSlots, key$2);
      }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (slots && Object.isExtensible(slots)) {
      (slots)._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res
  }

  function normalizeScopedSlot(normalSlots, key, fn) {
    var normalized = function () {
      var res = arguments.length ? fn.apply(null, arguments) : fn({});
      res = res && typeof res === 'object' && !Array.isArray(res)
        ? [res] // single vnode
        : normalizeChildren(res);
      return res && (
        res.length === 0 ||
        (res.length === 1 && res[0].isComment) // #9658
      ) ? undefined
        : res
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
      Object.defineProperty(normalSlots, key, {
        get: normalized,
        enumerable: true,
        configurable: true
      });
    }
    return normalized
  }

  function proxyNormalSlot(slots, key) {
    return function () { return slots[key]; }
  }

  /*  */

  /**
   * Runtime helper for rendering v-for lists.
   */
  function renderList (
    val,
    render
  ) {
    var ret, i, l, keys, key;
    if (Array.isArray(val) || typeof val === 'string') {
      ret = new Array(val.length);
      for (i = 0, l = val.length; i < l; i++) {
        ret[i] = render(val[i], i);
      }
    } else if (typeof val === 'number') {
      ret = new Array(val);
      for (i = 0; i < val; i++) {
        ret[i] = render(i + 1, i);
      }
    } else if (isObject$5(val)) {
      if (hasSymbol && val[Symbol.iterator]) {
        ret = [];
        var iterator = val[Symbol.iterator]();
        var result = iterator.next();
        while (!result.done) {
          ret.push(render(result.value, ret.length));
          result = iterator.next();
        }
      } else {
        keys = Object.keys(val);
        ret = new Array(keys.length);
        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          ret[i] = render(val[key], key, i);
        }
      }
    }
    if (!isDef(ret)) {
      ret = [];
    }
    (ret)._isVList = true;
    return ret
  }

  /*  */

  /**
   * Runtime helper for rendering <slot>
   */
  function renderSlot (
    name,
    fallback,
    props,
    bindObject
  ) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) { // scoped slot
      props = props || {};
      if (bindObject) {
        if (!isObject$5(bindObject)) {
          warn(
            'slot v-bind without argument expects an Object',
            this
          );
        }
        props = extend$1(extend$1({}, bindObject), props);
      }
      nodes = scopedSlotFn(props) || fallback;
    } else {
      nodes = this.$slots[name] || fallback;
    }

    var target = props && props.slot;
    if (target) {
      return this.$createElement('template', { slot: target }, nodes)
    } else {
      return nodes
    }
  }

  /*  */

  /**
   * Runtime helper for resolving filters
   */
  function resolveFilter (id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity
  }

  /*  */

  function isKeyNotMatch (expect, actual) {
    if (Array.isArray(expect)) {
      return expect.indexOf(actual) === -1
    } else {
      return expect !== actual
    }
  }

  /**
   * Runtime helper for checking keyCodes from config.
   * exposed as Vue.prototype._k
   * passing in eventKeyName as last argument separately for backwards compat
   */
  function checkKeyCodes (
    eventKeyCode,
    key,
    builtInKeyCode,
    eventKeyName,
    builtInKeyName
  ) {
    var mappedKeyCode = config$1.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config$1.keyCodes[key]) {
      return isKeyNotMatch(builtInKeyName, eventKeyName)
    } else if (mappedKeyCode) {
      return isKeyNotMatch(mappedKeyCode, eventKeyCode)
    } else if (eventKeyName) {
      return hyphenate(eventKeyName) !== key
    }
  }

  /*  */

  /**
   * Runtime helper for merging v-bind="object" into a VNode's data.
   */
  function bindObjectProps (
    data,
    tag,
    value,
    asProp,
    isSync
  ) {
    if (value) {
      if (!isObject$5(value)) {
        warn(
          'v-bind without argument expects an Object or Array value',
          this
        );
      } else {
        if (Array.isArray(value)) {
          value = toObject(value);
        }
        var hash;
        var loop = function ( key ) {
          if (
            key === 'class' ||
            key === 'style' ||
            isReservedAttribute(key)
          ) {
            hash = data;
          } else {
            var type = data.attrs && data.attrs.type;
            hash = asProp || config$1.mustUseProp(tag, type, key)
              ? data.domProps || (data.domProps = {})
              : data.attrs || (data.attrs = {});
          }
          var camelizedKey = camelize(key);
          var hyphenatedKey = hyphenate(key);
          if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
            hash[key] = value[key];

            if (isSync) {
              var on = data.on || (data.on = {});
              on[("update:" + key)] = function ($event) {
                value[key] = $event;
              };
            }
          }
        };

        for (var key in value) loop( key );
      }
    }
    return data
  }

  /*  */

  /**
   * Runtime helper for rendering static trees.
   */
  function renderStatic (
    index,
    isInFor
  ) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
      return tree
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(
      this._renderProxy,
      null,
      this // for render fns generated for functional component templates
    );
    markStatic(tree, ("__static__" + index), false);
    return tree
  }

  /**
   * Runtime helper for v-once.
   * Effectively it means marking the node as static with a unique key.
   */
  function markOnce (
    tree,
    index,
    key
  ) {
    markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
    return tree
  }

  function markStatic (
    tree,
    key,
    isOnce
  ) {
    if (Array.isArray(tree)) {
      for (var i = 0; i < tree.length; i++) {
        if (tree[i] && typeof tree[i] !== 'string') {
          markStaticNode(tree[i], (key + "_" + i), isOnce);
        }
      }
    } else {
      markStaticNode(tree, key, isOnce);
    }
  }

  function markStaticNode (node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
  }

  /*  */

  function bindObjectListeners (data, value) {
    if (value) {
      if (!isPlainObject$1(value)) {
        warn(
          'v-on without argument expects an Object value',
          this
        );
      } else {
        var on = data.on = data.on ? extend$1({}, data.on) : {};
        for (var key in value) {
          var existing = on[key];
          var ours = value[key];
          on[key] = existing ? [].concat(existing, ours) : ours;
        }
      }
    }
    return data
  }

  /*  */

  function resolveScopedSlots (
    fns, // see flow/vnode
    res,
    // the following are added in 2.6
    hasDynamicKeys,
    contentHashKey
  ) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
      var slot = fns[i];
      if (Array.isArray(slot)) {
        resolveScopedSlots(slot, res, hasDynamicKeys);
      } else if (slot) {
        // marker for reverse proxying v-slot without scope on this.$slots
        if (slot.proxy) {
          slot.fn.proxy = true;
        }
        res[slot.key] = slot.fn;
      }
    }
    if (contentHashKey) {
      (res).$key = contentHashKey;
    }
    return res
  }

  /*  */

  function bindDynamicKeys (baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
      var key = values[i];
      if (typeof key === 'string' && key) {
        baseObj[values[i]] = values[i + 1];
      } else if (key !== '' && key !== null) {
        // null is a special value for explicitly removing a binding
        warn(
          ("Invalid value for dynamic directive argument (expected string or null): " + key),
          this
        );
      }
    }
    return baseObj
  }

  // helper to dynamically append modifier runtime markers to event names.
  // ensure only append when value is already string, otherwise it will be cast
  // to string and cause the type check to miss.
  function prependModifier (value, symbol) {
    return typeof value === 'string' ? symbol + value : value
  }

  /*  */

  function installRenderHelpers (target) {
    target._o = markOnce;
    target._n = toNumber$2;
    target._s = toString$1;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
  }

  /*  */

  function FunctionalRenderContext (
    data,
    props,
    children,
    parent,
    Ctor
  ) {
    var this$1$1 = this;

    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
      contextVm = Object.create(parent);
      // $flow-disable-line
      contextVm._original = parent;
    } else {
      // the context vm passed in is a functional context as well.
      // in this case we want to make sure we are able to get a hold to the
      // real context instance.
      contextVm = parent;
      // $flow-disable-line
      parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;

    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
      if (!this$1$1.$slots) {
        normalizeScopedSlots(
          data.scopedSlots,
          this$1$1.$slots = resolveSlots(children, parent)
        );
      }
      return this$1$1.$slots
    };

    Object.defineProperty(this, 'scopedSlots', ({
      enumerable: true,
      get: function get () {
        return normalizeScopedSlots(data.scopedSlots, this.slots())
      }
    }));

    // support for compiled functional template
    if (isCompiled) {
      // exposing $options for renderStatic()
      this.$options = options;
      // pre-resolve slots for renderSlot()
      this.$slots = this.slots();
      this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
    }

    if (options._scopeId) {
      this._c = function (a, b, c, d) {
        var vnode = createElement(contextVm, a, b, c, d, needNormalization);
        if (vnode && !Array.isArray(vnode)) {
          vnode.fnScopeId = options._scopeId;
          vnode.fnContext = parent;
        }
        return vnode
      };
    } else {
      this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
    }
  }

  installRenderHelpers(FunctionalRenderContext.prototype);

  function createFunctionalComponent (
    Ctor,
    propsData,
    data,
    contextVm,
    children
  ) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
      for (var key in propOptions) {
        props[key] = validateProp(key, propOptions, propsData || emptyObject);
      }
    } else {
      if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
      if (isDef(data.props)) { mergeProps(props, data.props); }
    }

    var renderContext = new FunctionalRenderContext(
      data,
      props,
      children,
      contextVm,
      Ctor
    );

    var vnode = options.render.call(null, renderContext._c, renderContext);

    if (vnode instanceof VNode) {
      return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
    } else if (Array.isArray(vnode)) {
      var vnodes = normalizeChildren(vnode) || [];
      var res = new Array(vnodes.length);
      for (var i = 0; i < vnodes.length; i++) {
        res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
      }
      return res
    }
  }

  function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    {
      (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
    }
    if (data.slot) {
      (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone
  }

  function mergeProps (to, from) {
    for (var key in from) {
      to[camelize(key)] = from[key];
    }
  }

  /*  */

  /*  */

  /*  */

  /*  */

  // inline hooks to be invoked on component VNodes during patch
  var componentVNodeHooks = {
    init: function init (vnode, hydrating) {
      if (
        vnode.componentInstance &&
        !vnode.componentInstance._isDestroyed &&
        vnode.data.keepAlive
      ) {
        // kept-alive components, treat as a patch
        var mountedNode = vnode; // work around flow
        componentVNodeHooks.prepatch(mountedNode, mountedNode);
      } else {
        var child = vnode.componentInstance = createComponentInstanceForVnode(
          vnode,
          activeInstance
        );
        child.$mount(hydrating ? vnode.elm : undefined, hydrating);
      }
    },

    prepatch: function prepatch (oldVnode, vnode) {
      var options = vnode.componentOptions;
      var child = vnode.componentInstance = oldVnode.componentInstance;
      updateChildComponent(
        child,
        options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
      );
    },

    insert: function insert (vnode) {
      var context = vnode.context;
      var componentInstance = vnode.componentInstance;
      if (!componentInstance._isMounted) {
        componentInstance._isMounted = true;
        callHook(componentInstance, 'mounted');
      }
      if (vnode.data.keepAlive) {
        if (context._isMounted) {
          // vue-router#1212
          // During updates, a kept-alive component's child components may
          // change, so directly walking the tree here may call activated hooks
          // on incorrect children. Instead we push them into a queue which will
          // be processed after the whole patch process ended.
          queueActivatedComponent(componentInstance);
        } else {
          activateChildComponent(componentInstance, true /* direct */);
        }
      }
    },

    destroy: function destroy (vnode) {
      var componentInstance = vnode.componentInstance;
      if (!componentInstance._isDestroyed) {
        if (!vnode.data.keepAlive) {
          componentInstance.$destroy();
        } else {
          deactivateChildComponent(componentInstance, true /* direct */);
        }
      }
    }
  };

  var hooksToMerge = Object.keys(componentVNodeHooks);

  function createComponent (
    Ctor,
    data,
    context,
    children,
    tag
  ) {
    if (isUndef(Ctor)) {
      return
    }

    var baseCtor = context.$options._base;

    // plain options object: turn it into a constructor
    if (isObject$5(Ctor)) {
      Ctor = baseCtor.extend(Ctor);
    }

    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
      {
        warn(("Invalid Component definition: " + (String(Ctor))), context);
      }
      return
    }

    // async component
    var asyncFactory;
    if (isUndef(Ctor.cid)) {
      asyncFactory = Ctor;
      Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
      if (Ctor === undefined) {
        // return a placeholder node for async component, which is rendered
        // as a comment node but preserves all the raw information for the node.
        // the information will be used for async server-rendering and hydration.
        return createAsyncPlaceholder(
          asyncFactory,
          data,
          context,
          children,
          tag
        )
      }
    }

    data = data || {};

    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);

    // transform component v-model data into props & events
    if (isDef(data.model)) {
      transformModel(Ctor.options, data);
    }

    // extract props
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);

    // functional component
    if (isTrue(Ctor.options.functional)) {
      return createFunctionalComponent(Ctor, propsData, data, context, children)
    }

    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;

    if (isTrue(Ctor.options.abstract)) {
      // abstract components do not keep anything
      // other than props & listeners & slot

      // work around flow
      var slot = data.slot;
      data = {};
      if (slot) {
        data.slot = slot;
      }
    }

    // install component management hooks onto the placeholder node
    installComponentHooks(data);

    // return a placeholder vnode
    var name = Ctor.options.name || tag;
    var vnode = new VNode(
      ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
      data, undefined, undefined, undefined, context,
      { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
      asyncFactory
    );

    return vnode
  }

  function createComponentInstanceForVnode (
    vnode, // we know it's MountedComponentVNode but flow doesn't
    parent // activeInstance in lifecycle state
  ) {
    var options = {
      _isComponent: true,
      _parentVnode: vnode,
      parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
      options.render = inlineTemplate.render;
      options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options)
  }

  function installComponentHooks (data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
      var key = hooksToMerge[i];
      var existing = hooks[key];
      var toMerge = componentVNodeHooks[key];
      if (existing !== toMerge && !(existing && existing._merged)) {
        hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
      }
    }
  }

  function mergeHook$1 (f1, f2) {
    var merged = function (a, b) {
      // flow complains about extra args which is why we use any
      f1(a, b);
      f2(a, b);
    };
    merged._merged = true;
    return merged
  }

  // transform component v-model info (value and callback) into
  // prop and event handler respectively.
  function transformModel (options, data) {
    var prop = (options.model && options.model.prop) || 'value';
    var event = (options.model && options.model.event) || 'input'
    ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
      if (
        Array.isArray(existing)
          ? existing.indexOf(callback) === -1
          : existing !== callback
      ) {
        on[event] = [callback].concat(existing);
      }
    } else {
      on[event] = callback;
    }
  }

  /*  */

  var SIMPLE_NORMALIZE = 1;
  var ALWAYS_NORMALIZE = 2;

  // wrapper function for providing a more flexible interface
  // without getting yelled at by flow
  function createElement (
    context,
    tag,
    data,
    children,
    normalizationType,
    alwaysNormalize
  ) {
    if (Array.isArray(data) || isPrimitive(data)) {
      normalizationType = children;
      children = data;
      data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
      normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType)
  }

  function _createElement (
    context,
    tag,
    data,
    children,
    normalizationType
  ) {
    if (isDef(data) && isDef((data).__ob__)) {
      warn(
        "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
        'Always create fresh vnode data objects in each render!',
        context
      );
      return createEmptyVNode()
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
      tag = data.is;
    }
    if (!tag) {
      // in case of component :is set to falsy value
      return createEmptyVNode()
    }
    // warn against non-primitive key
    if (isDef(data) && isDef(data.key) && !isPrimitive(data.key)
    ) {
      {
        warn(
          'Avoid using non-primitive value as key, ' +
          'use string/number value instead.',
          context
        );
      }
    }
    // support single function children as default scoped slot
    if (Array.isArray(children) &&
      typeof children[0] === 'function'
    ) {
      data = data || {};
      data.scopedSlots = { default: children[0] };
      children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
      children = normalizeChildren(children);
    } else if (normalizationType === SIMPLE_NORMALIZE) {
      children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
      var Ctor;
      ns = (context.$vnode && context.$vnode.ns) || config$1.getTagNamespace(tag);
      if (config$1.isReservedTag(tag)) {
        // platform built-in elements
        if (isDef(data) && isDef(data.nativeOn)) {
          warn(
            ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
            context
          );
        }
        vnode = new VNode(
          config$1.parsePlatformTagName(tag), data, children,
          undefined, undefined, context
        );
      } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
        // component
        vnode = createComponent(Ctor, data, context, children, tag);
      } else {
        // unknown or unlisted namespaced elements
        // check at runtime because it may get assigned a namespace when its
        // parent normalizes children
        vnode = new VNode(
          tag, data, children,
          undefined, undefined, context
        );
      }
    } else {
      // direct component options / constructor
      vnode = createComponent(tag, data, context, children);
    }
    if (Array.isArray(vnode)) {
      return vnode
    } else if (isDef(vnode)) {
      if (isDef(ns)) { applyNS(vnode, ns); }
      if (isDef(data)) { registerDeepBindings(data); }
      return vnode
    } else {
      return createEmptyVNode()
    }
  }

  function applyNS (vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
      // use default namespace inside foreignObject
      ns = undefined;
      force = true;
    }
    if (isDef(vnode.children)) {
      for (var i = 0, l = vnode.children.length; i < l; i++) {
        var child = vnode.children[i];
        if (isDef(child.tag) && (
          isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
          applyNS(child, ns, force);
        }
      }
    }
  }

  // ref #5318
  // necessary to ensure parent re-render when deep bindings like :style and
  // :class are used on slot nodes
  function registerDeepBindings (data) {
    if (isObject$5(data.style)) {
      traverse(data.style);
    }
    if (isObject$5(data.class)) {
      traverse(data.class);
    }
  }

  /*  */

  function initRender (vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;

    /* istanbul ignore else */
    {
      defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
        !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
      }, true);
      defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
        !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
      }, true);
    }
  }

  var currentRenderingInstance = null;

  function renderMixin (Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);

    Vue.prototype.$nextTick = function (fn) {
      return nextTick$1(fn, this)
    };

    Vue.prototype._render = function () {
      var vm = this;
      var ref = vm.$options;
      var render = ref.render;
      var _parentVnode = ref._parentVnode;

      if (_parentVnode) {
        vm.$scopedSlots = normalizeScopedSlots(
          _parentVnode.data.scopedSlots,
          vm.$slots,
          vm.$scopedSlots
        );
      }

      // set parent vnode. this allows render functions to have access
      // to the data on the placeholder node.
      vm.$vnode = _parentVnode;
      // render self
      var vnode;
      try {
        // There's no need to maintain a stack because all render fns are called
        // separately from one another. Nested component's render fns are called
        // when parent component is patched.
        currentRenderingInstance = vm;
        vnode = render.call(vm._renderProxy, vm.$createElement);
      } catch (e) {
        handleError(e, vm, "render");
        // return error render result,
        // or previous vnode to prevent render error causing blank component
        /* istanbul ignore else */
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } finally {
        currentRenderingInstance = null;
      }
      // if the returned array contains only a single node, allow it
      if (Array.isArray(vnode) && vnode.length === 1) {
        vnode = vnode[0];
      }
      // return empty vnode in case the render function errored out
      if (!(vnode instanceof VNode)) {
        if (Array.isArray(vnode)) {
          warn(
            'Multiple root nodes returned from render function. Render function ' +
            'should return a single root node.',
            vm
          );
        }
        vnode = createEmptyVNode();
      }
      // set parent
      vnode.parent = _parentVnode;
      return vnode
    };
  }

  /*  */

  function ensureCtor (comp, base) {
    if (
      comp.__esModule ||
      (hasSymbol && comp[Symbol.toStringTag] === 'Module')
    ) {
      comp = comp.default;
    }
    return isObject$5(comp)
      ? base.extend(comp)
      : comp
  }

  function createAsyncPlaceholder (
    factory,
    data,
    context,
    children,
    tag
  ) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node
  }

  function resolveAsyncComponent (
    factory,
    baseCtor
  ) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
      return factory.errorComp
    }

    if (isDef(factory.resolved)) {
      return factory.resolved
    }

    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
      // already pending
      factory.owners.push(owner);
    }

    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
      return factory.loadingComp
    }

    if (owner && !isDef(factory.owners)) {
      var owners = factory.owners = [owner];
      var sync = true;
      var timerLoading = null;
      var timerTimeout = null

      ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

      var forceRender = function (renderCompleted) {
        for (var i = 0, l = owners.length; i < l; i++) {
          (owners[i]).$forceUpdate();
        }

        if (renderCompleted) {
          owners.length = 0;
          if (timerLoading !== null) {
            clearTimeout(timerLoading);
            timerLoading = null;
          }
          if (timerTimeout !== null) {
            clearTimeout(timerTimeout);
            timerTimeout = null;
          }
        }
      };

      var resolve = once$1(function (res) {
        // cache resolved
        factory.resolved = ensureCtor(res, baseCtor);
        // invoke callbacks only if this is not a synchronous resolve
        // (async resolves are shimmed as synchronous during SSR)
        if (!sync) {
          forceRender(true);
        } else {
          owners.length = 0;
        }
      });

      var reject = once$1(function (reason) {
        warn(
          "Failed to resolve async component: " + (String(factory)) +
          (reason ? ("\nReason: " + reason) : '')
        );
        if (isDef(factory.errorComp)) {
          factory.error = true;
          forceRender(true);
        }
      });

      var res = factory(resolve, reject);

      if (isObject$5(res)) {
        if (isPromise$1(res)) {
          // () => Promise
          if (isUndef(factory.resolved)) {
            res.then(resolve, reject);
          }
        } else if (isPromise$1(res.component)) {
          res.component.then(resolve, reject);

          if (isDef(res.error)) {
            factory.errorComp = ensureCtor(res.error, baseCtor);
          }

          if (isDef(res.loading)) {
            factory.loadingComp = ensureCtor(res.loading, baseCtor);
            if (res.delay === 0) {
              factory.loading = true;
            } else {
              timerLoading = setTimeout(function () {
                timerLoading = null;
                if (isUndef(factory.resolved) && isUndef(factory.error)) {
                  factory.loading = true;
                  forceRender(false);
                }
              }, res.delay || 200);
            }
          }

          if (isDef(res.timeout)) {
            timerTimeout = setTimeout(function () {
              timerTimeout = null;
              if (isUndef(factory.resolved)) {
                reject(
                  "timeout (" + (res.timeout) + "ms)"
                );
              }
            }, res.timeout);
          }
        }
      }

      sync = false;
      // return in case resolved synchronously
      return factory.loading
        ? factory.loadingComp
        : factory.resolved
    }
  }

  /*  */

  function isAsyncPlaceholder (node) {
    return node.isComment && node.asyncFactory
  }

  /*  */

  function getFirstComponentChild (children) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; i++) {
        var c = children[i];
        if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
          return c
        }
      }
    }
  }

  /*  */

  /*  */

  function initEvents (vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
      updateComponentListeners(vm, listeners);
    }
  }

  var target$1;

  function add (event, fn) {
    target$1.$on(event, fn);
  }

  function remove$1 (event, fn) {
    target$1.$off(event, fn);
  }

  function createOnceHandler (event, fn) {
    var _target = target$1;
    return function onceHandler () {
      var res = fn.apply(null, arguments);
      if (res !== null) {
        _target.$off(event, onceHandler);
      }
    }
  }

  function updateComponentListeners (
    vm,
    listeners,
    oldListeners
  ) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
    target$1 = undefined;
  }

  function eventsMixin (Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
      var vm = this;
      if (Array.isArray(event)) {
        for (var i = 0, l = event.length; i < l; i++) {
          vm.$on(event[i], fn);
        }
      } else {
        (vm._events[event] || (vm._events[event] = [])).push(fn);
        // optimize hook:event cost by using a boolean flag marked at registration
        // instead of a hash lookup
        if (hookRE.test(event)) {
          vm._hasHookEvent = true;
        }
      }
      return vm
    };

    Vue.prototype.$once = function (event, fn) {
      var vm = this;
      function on () {
        vm.$off(event, on);
        fn.apply(vm, arguments);
      }
      on.fn = fn;
      vm.$on(event, on);
      return vm
    };

    Vue.prototype.$off = function (event, fn) {
      var vm = this;
      // all
      if (!arguments.length) {
        vm._events = Object.create(null);
        return vm
      }
      // array of events
      if (Array.isArray(event)) {
        for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
          vm.$off(event[i$1], fn);
        }
        return vm
      }
      // specific event
      var cbs = vm._events[event];
      if (!cbs) {
        return vm
      }
      if (!fn) {
        vm._events[event] = null;
        return vm
      }
      // specific handler
      var cb;
      var i = cbs.length;
      while (i--) {
        cb = cbs[i];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i, 1);
          break
        }
      }
      return vm
    };

    Vue.prototype.$emit = function (event) {
      var vm = this;
      {
        var lowerCaseEvent = event.toLowerCase();
        if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
          tip(
            "Event \"" + lowerCaseEvent + "\" is emitted in component " +
            (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
            "Note that HTML attributes are case-insensitive and you cannot use " +
            "v-on to listen to camelCase events when using in-DOM templates. " +
            "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
          );
        }
      }
      var cbs = vm._events[event];
      if (cbs) {
        cbs = cbs.length > 1 ? toArray(cbs) : cbs;
        var args = toArray(arguments, 1);
        var info = "event handler for \"" + event + "\"";
        for (var i = 0, l = cbs.length; i < l; i++) {
          invokeWithErrorHandling(cbs[i], vm, args, vm, info);
        }
      }
      return vm
    };
  }

  /*  */

  var activeInstance = null;
  var isUpdatingChildComponent = false;

  function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
      activeInstance = prevActiveInstance;
    }
  }

  function initLifecycle (vm) {
    var options = vm.$options;

    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
      while (parent.$options.abstract && parent.$parent) {
        parent = parent.$parent;
      }
      parent.$children.push(vm);
    }

    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;

    vm.$children = [];
    vm.$refs = {};

    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
  }

  function lifecycleMixin (Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
      var vm = this;
      var prevEl = vm.$el;
      var prevVnode = vm._vnode;
      var restoreActiveInstance = setActiveInstance(vm);
      vm._vnode = vnode;
      // Vue.prototype.__patch__ is injected in entry points
      // based on the rendering backend used.
      if (!prevVnode) {
        // initial render
        vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
      } else {
        // updates
        vm.$el = vm.__patch__(prevVnode, vnode);
      }
      restoreActiveInstance();
      // update __vue__ reference
      if (prevEl) {
        prevEl.__vue__ = null;
      }
      if (vm.$el) {
        vm.$el.__vue__ = vm;
      }
      // if parent is an HOC, update its $el as well
      if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
        vm.$parent.$el = vm.$el;
      }
      // updated hook is called by the scheduler to ensure that children are
      // updated in a parent's updated hook.
    };

    Vue.prototype.$forceUpdate = function () {
      var vm = this;
      if (vm._watcher) {
        vm._watcher.update();
      }
    };

    Vue.prototype.$destroy = function () {
      var vm = this;
      if (vm._isBeingDestroyed) {
        return
      }
      callHook(vm, 'beforeDestroy');
      vm._isBeingDestroyed = true;
      // remove self from parent
      var parent = vm.$parent;
      if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
        remove(parent.$children, vm);
      }
      // teardown watchers
      if (vm._watcher) {
        vm._watcher.teardown();
      }
      var i = vm._watchers.length;
      while (i--) {
        vm._watchers[i].teardown();
      }
      // remove reference from data ob
      // frozen object may not have observer.
      if (vm._data.__ob__) {
        vm._data.__ob__.vmCount--;
      }
      // call the last hook...
      vm._isDestroyed = true;
      // invoke destroy hooks on current rendered tree
      vm.__patch__(vm._vnode, null);
      // fire destroyed hook
      callHook(vm, 'destroyed');
      // turn off all instance listeners.
      vm.$off();
      // remove __vue__ reference
      if (vm.$el) {
        vm.$el.__vue__ = null;
      }
      // release circular reference (#6759)
      if (vm.$vnode) {
        vm.$vnode.parent = null;
      }
    };
  }

  function mountComponent (
    vm,
    el,
    hydrating
  ) {
    vm.$el = el;
    if (!vm.$options.render) {
      vm.$options.render = createEmptyVNode;
      {
        /* istanbul ignore if */
        if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
          vm.$options.el || el) {
          warn(
            'You are using the runtime-only build of Vue where the template ' +
            'compiler is not available. Either pre-compile the templates into ' +
            'render functions, or use the compiler-included build.',
            vm
          );
        } else {
          warn(
            'Failed to mount component: template or render function not defined.',
            vm
          );
        }
      }
    }
    callHook(vm, 'beforeMount');

    var updateComponent;
    /* istanbul ignore if */
    if (config$1.performance && mark) {
      updateComponent = function () {
        var name = vm._name;
        var id = vm._uid;
        var startTag = "vue-perf-start:" + id;
        var endTag = "vue-perf-end:" + id;

        mark(startTag);
        var vnode = vm._render();
        mark(endTag);
        measure(("vue " + name + " render"), startTag, endTag);

        mark(startTag);
        vm._update(vnode, hydrating);
        mark(endTag);
        measure(("vue " + name + " patch"), startTag, endTag);
      };
    } else {
      updateComponent = function () {
        vm._update(vm._render(), hydrating);
      };
    }

    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop$1, {
      before: function before () {
        if (vm._isMounted && !vm._isDestroyed) {
          callHook(vm, 'beforeUpdate');
        }
      }
    }, true /* isRenderWatcher */);
    hydrating = false;

    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
      vm._isMounted = true;
      callHook(vm, 'mounted');
    }
    return vm
  }

  function updateChildComponent (
    vm,
    propsData,
    listeners,
    parentVnode,
    renderChildren
  ) {
    {
      isUpdatingChildComponent = true;
    }

    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.

    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!(
      (newScopedSlots && !newScopedSlots.$stable) ||
      (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
      (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
    );

    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(
      renderChildren ||               // has new static slots
      vm.$options._renderChildren ||  // has old static slots
      hasDynamicScopedSlot
    );

    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render

    if (vm._vnode) { // update child tree's parent
      vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;

    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    vm.$attrs = parentVnode.data.attrs || emptyObject;
    vm.$listeners = listeners || emptyObject;

    // update props
    if (propsData && vm.$options.props) {
      toggleObserving(false);
      var props = vm._props;
      var propKeys = vm.$options._propKeys || [];
      for (var i = 0; i < propKeys.length; i++) {
        var key = propKeys[i];
        var propOptions = vm.$options.props; // wtf flow?
        props[key] = validateProp(key, propOptions, propsData, vm);
      }
      toggleObserving(true);
      // keep a copy of raw propsData
      vm.$options.propsData = propsData;
    }

    // update listeners
    listeners = listeners || emptyObject;
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);

    // resolve slots + force update if has children
    if (needsForceUpdate) {
      vm.$slots = resolveSlots(renderChildren, parentVnode.context);
      vm.$forceUpdate();
    }

    {
      isUpdatingChildComponent = false;
    }
  }

  function isInInactiveTree (vm) {
    while (vm && (vm = vm.$parent)) {
      if (vm._inactive) { return true }
    }
    return false
  }

  function activateChildComponent (vm, direct) {
    if (direct) {
      vm._directInactive = false;
      if (isInInactiveTree(vm)) {
        return
      }
    } else if (vm._directInactive) {
      return
    }
    if (vm._inactive || vm._inactive === null) {
      vm._inactive = false;
      for (var i = 0; i < vm.$children.length; i++) {
        activateChildComponent(vm.$children[i]);
      }
      callHook(vm, 'activated');
    }
  }

  function deactivateChildComponent (vm, direct) {
    if (direct) {
      vm._directInactive = true;
      if (isInInactiveTree(vm)) {
        return
      }
    }
    if (!vm._inactive) {
      vm._inactive = true;
      for (var i = 0; i < vm.$children.length; i++) {
        deactivateChildComponent(vm.$children[i]);
      }
      callHook(vm, 'deactivated');
    }
  }

  function callHook (vm, hook) {
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var handlers = vm.$options[hook];
    var info = hook + " hook";
    if (handlers) {
      for (var i = 0, j = handlers.length; i < j; i++) {
        invokeWithErrorHandling(handlers[i], vm, null, vm, info);
      }
    }
    if (vm._hasHookEvent) {
      vm.$emit('hook:' + hook);
    }
    popTarget();
  }

  /*  */

  var MAX_UPDATE_COUNT = 100;

  var queue$1 = [];
  var activatedChildren = [];
  var has = {};
  var circular = {};
  var waiting = false;
  var flushing = false;
  var index$1 = 0;

  /**
   * Reset the scheduler's state.
   */
  function resetSchedulerState () {
    index$1 = queue$1.length = activatedChildren.length = 0;
    has = {};
    {
      circular = {};
    }
    waiting = flushing = false;
  }

  // Async edge case #6566 requires saving the timestamp when event listeners are
  // attached. However, calling performance.now() has a perf overhead especially
  // if the page has thousands of event listeners. Instead, we take a timestamp
  // every time the scheduler flushes and use that for all event listeners
  // attached during that flush.
  var currentFlushTimestamp = 0;

  // Async edge case fix requires storing an event listener's attach timestamp.
  var getNow = Date.now;

  // Determine what event timestamp the browser is using. Annoyingly, the
  // timestamp can either be hi-res (relative to page load) or low-res
  // (relative to UNIX epoch), so in order to compare time we have to use the
  // same timestamp type when saving the flush timestamp.
  // All IE versions use low-res event timestamps, and have problematic clock
  // implementations (#9632)
  if (inBrowser && !isIE) {
    var performance$1 = window.performance;
    if (
      performance$1 &&
      typeof performance$1.now === 'function' &&
      getNow() > document.createEvent('Event').timeStamp
    ) {
      // if the event timestamp, although evaluated AFTER the Date.now(), is
      // smaller than it, it means the event is using a hi-res timestamp,
      // and we need to use the hi-res version for event listener timestamps as
      // well.
      getNow = function () { return performance$1.now(); };
    }
  }

  /**
   * Flush both queues and run the watchers.
   */
  function flushSchedulerQueue () {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;

    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue$1.sort(function (a, b) { return a.id - b.id; });

    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index$1 = 0; index$1 < queue$1.length; index$1++) {
      watcher = queue$1[index$1];
      if (watcher.before) {
        watcher.before();
      }
      id = watcher.id;
      has[id] = null;
      watcher.run();
      // in dev build, check and stop circular updates.
      if (has[id] != null) {
        circular[id] = (circular[id] || 0) + 1;
        if (circular[id] > MAX_UPDATE_COUNT) {
          warn(
            'You may have an infinite update loop ' + (
              watcher.user
                ? ("in watcher with expression \"" + (watcher.expression) + "\"")
                : "in a component render function."
            ),
            watcher.vm
          );
          break
        }
      }
    }

    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue$1.slice();

    resetSchedulerState();

    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);

    // devtool hook
    /* istanbul ignore if */
    if (devtools && config$1.devtools) {
      devtools.emit('flush');
    }
  }

  function callUpdatedHooks (queue) {
    var i = queue.length;
    while (i--) {
      var watcher = queue[i];
      var vm = watcher.vm;
      if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'updated');
      }
    }
  }

  /**
   * Queue a kept-alive component that was activated during patch.
   * The queue will be processed after the entire tree has been patched.
   */
  function queueActivatedComponent (vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
  }

  function callActivatedHooks (queue) {
    for (var i = 0; i < queue.length; i++) {
      queue[i]._inactive = true;
      activateChildComponent(queue[i], true /* true */);
    }
  }

  /**
   * Push a watcher into the watcher queue.
   * Jobs with duplicate IDs will be skipped unless it's
   * pushed when the queue is being flushed.
   */
  function queueWatcher (watcher) {
    var id = watcher.id;
    if (has[id] == null) {
      has[id] = true;
      if (!flushing) {
        queue$1.push(watcher);
      } else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue$1.length - 1;
        while (i > index$1 && queue$1[i].id > watcher.id) {
          i--;
        }
        queue$1.splice(i + 1, 0, watcher);
      }
      // queue the flush
      if (!waiting) {
        waiting = true;

        if (!config$1.async) {
          flushSchedulerQueue();
          return
        }
        nextTick$1(flushSchedulerQueue);
      }
    }
  }

  /*  */



  var uid$2 = 0;

  /**
   * A watcher parses an expression, collects dependencies,
   * and fires callback when the expression value changes.
   * This is used for both the $watch() api and directives.
   */
  var Watcher = function Watcher (
    vm,
    expOrFn,
    cb,
    options,
    isRenderWatcher
  ) {
    this.vm = vm;
    if (isRenderWatcher) {
      vm._watcher = this;
    }
    vm._watchers.push(this);
    // options
    if (options) {
      this.deep = !!options.deep;
      this.user = !!options.user;
      this.lazy = !!options.lazy;
      this.sync = !!options.sync;
      this.before = options.before;
    } else {
      this.deep = this.user = this.lazy = this.sync = false;
    }
    this.cb = cb;
    this.id = ++uid$2; // uid for batching
    this.active = true;
    this.dirty = this.lazy; // for lazy watchers
    this.deps = [];
    this.newDeps = [];
    this.depIds = new _Set();
    this.newDepIds = new _Set();
    this.expression = expOrFn.toString();
    // parse expression for getter
    if (typeof expOrFn === 'function') {
      this.getter = expOrFn;
    } else {
      this.getter = parsePath(expOrFn);
      if (!this.getter) {
        this.getter = noop$1;
        warn(
          "Failed watching path: \"" + expOrFn + "\" " +
          'Watcher only accepts simple dot-delimited paths. ' +
          'For full control, use a function instead.',
          vm
        );
      }
    }
    this.value = this.lazy
      ? undefined
      : this.get();
  };

  /**
   * Evaluate the getter, and re-collect dependencies.
   */
  Watcher.prototype.get = function get () {
    pushTarget(this);
    var value;
    var vm = this.vm;
    try {
      value = this.getter.call(vm, vm);
    } catch (e) {
      if (this.user) {
        handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
      } else {
        throw e
      }
    } finally {
      // "touch" every property so they are all tracked as
      // dependencies for deep watching
      if (this.deep) {
        traverse(value);
      }
      popTarget();
      this.cleanupDeps();
    }
    return value
  };

  /**
   * Add a dependency to this directive.
   */
  Watcher.prototype.addDep = function addDep (dep) {
    var id = dep.id;
    if (!this.newDepIds.has(id)) {
      this.newDepIds.add(id);
      this.newDeps.push(dep);
      if (!this.depIds.has(id)) {
        dep.addSub(this);
      }
    }
  };

  /**
   * Clean up for dependency collection.
   */
  Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var i = this.deps.length;
    while (i--) {
      var dep = this.deps[i];
      if (!this.newDepIds.has(dep.id)) {
        dep.removeSub(this);
      }
    }
    var tmp = this.depIds;
    this.depIds = this.newDepIds;
    this.newDepIds = tmp;
    this.newDepIds.clear();
    tmp = this.deps;
    this.deps = this.newDeps;
    this.newDeps = tmp;
    this.newDeps.length = 0;
  };

  /**
   * Subscriber interface.
   * Will be called when a dependency changes.
   */
  Watcher.prototype.update = function update () {
    /* istanbul ignore else */
    if (this.lazy) {
      this.dirty = true;
    } else if (this.sync) {
      this.run();
    } else {
      queueWatcher(this);
    }
  };

  /**
   * Scheduler job interface.
   * Will be called by the scheduler.
   */
  Watcher.prototype.run = function run () {
    if (this.active) {
      var value = this.get();
      if (
        value !== this.value ||
        // Deep watchers and watchers on Object/Arrays should fire even
        // when the value is the same, because the value may
        // have mutated.
        isObject$5(value) ||
        this.deep
      ) {
        // set new value
        var oldValue = this.value;
        this.value = value;
        if (this.user) {
          try {
            this.cb.call(this.vm, value, oldValue);
          } catch (e) {
            handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
          }
        } else {
          this.cb.call(this.vm, value, oldValue);
        }
      }
    }
  };

  /**
   * Evaluate the value of the watcher.
   * This only gets called for lazy watchers.
   */
  Watcher.prototype.evaluate = function evaluate () {
    this.value = this.get();
    this.dirty = false;
  };

  /**
   * Depend on all deps collected by this watcher.
   */
  Watcher.prototype.depend = function depend () {
    var i = this.deps.length;
    while (i--) {
      this.deps[i].depend();
    }
  };

  /**
   * Remove self from all dependencies' subscriber list.
   */
  Watcher.prototype.teardown = function teardown () {
    if (this.active) {
      // remove self from vm's watcher list
      // this is a somewhat expensive operation so we skip it
      // if the vm is being destroyed.
      if (!this.vm._isBeingDestroyed) {
        remove(this.vm._watchers, this);
      }
      var i = this.deps.length;
      while (i--) {
        this.deps[i].removeSub(this);
      }
      this.active = false;
    }
  };

  /*  */

  var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop$1,
    set: noop$1
  };

  function proxy (target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter () {
      return this[sourceKey][key]
    };
    sharedPropertyDefinition.set = function proxySetter (val) {
      this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
  }

  function initState (vm) {
    vm._watchers = [];
    var opts = vm.$options;
    if (opts.props) { initProps(vm, opts.props); }
    if (opts.methods) { initMethods(vm, opts.methods); }
    if (opts.data) {
      initData(vm);
    } else {
      observe(vm._data = {}, true /* asRootData */);
    }
    if (opts.computed) { initComputed(vm, opts.computed); }
    if (opts.watch && opts.watch !== nativeWatch) {
      initWatch(vm, opts.watch);
    }
  }

  function initProps (vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = vm._props = {};
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = vm.$options._propKeys = [];
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
      toggleObserving(false);
    }
    var loop = function ( key ) {
      keys.push(key);
      var value = validateProp(key, propsOptions, propsData, vm);
      /* istanbul ignore else */
      {
        var hyphenatedKey = hyphenate(key);
        if (isReservedAttribute(hyphenatedKey) ||
            config$1.isReservedAttr(hyphenatedKey)) {
          warn(
            ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
            vm
          );
        }
        defineReactive$$1(props, key, value, function () {
          if (!isRoot && !isUpdatingChildComponent) {
            warn(
              "Avoid mutating a prop directly since the value will be " +
              "overwritten whenever the parent component re-renders. " +
              "Instead, use a data or computed property based on the prop's " +
              "value. Prop being mutated: \"" + key + "\"",
              vm
            );
          }
        });
      }
      // static props are already proxied on the component's prototype
      // during Vue.extend(). We only need to proxy props defined at
      // instantiation here.
      if (!(key in vm)) {
        proxy(vm, "_props", key);
      }
    };

    for (var key in propsOptions) loop( key );
    toggleObserving(true);
  }

  function initData (vm) {
    var data = vm.$options.data;
    data = vm._data = typeof data === 'function'
      ? getData(data, vm)
      : data || {};
    if (!isPlainObject$1(data)) {
      data = {};
      warn(
        'data functions should return an object:\n' +
        'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
        vm
      );
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
      var key = keys[i];
      {
        if (methods && hasOwn(methods, key)) {
          warn(
            ("Method \"" + key + "\" has already been defined as a data property."),
            vm
          );
        }
      }
      if (props && hasOwn(props, key)) {
        warn(
          "The data property \"" + key + "\" is already declared as a prop. " +
          "Use prop default value instead.",
          vm
        );
      } else if (!isReserved(key)) {
        proxy(vm, "_data", key);
      }
    }
    // observe data
    observe(data, true /* asRootData */);
  }

  function getData (data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
      return data.call(vm, vm)
    } catch (e) {
      handleError(e, vm, "data()");
      return {}
    } finally {
      popTarget();
    }
  }

  var computedWatcherOptions = { lazy: true };

  function initComputed (vm, computed) {
    // $flow-disable-line
    var watchers = vm._computedWatchers = Object.create(null);
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();

    for (var key in computed) {
      var userDef = computed[key];
      var getter = typeof userDef === 'function' ? userDef : userDef.get;
      if (getter == null) {
        warn(
          ("Getter is missing for computed property \"" + key + "\"."),
          vm
        );
      }

      if (!isSSR) {
        // create internal watcher for the computed property.
        watchers[key] = new Watcher(
          vm,
          getter || noop$1,
          noop$1,
          computedWatcherOptions
        );
      }

      // component-defined computed properties are already defined on the
      // component prototype. We only need to define computed properties defined
      // at instantiation here.
      if (!(key in vm)) {
        defineComputed(vm, key, userDef);
      } else {
        if (key in vm.$data) {
          warn(("The computed property \"" + key + "\" is already defined in data."), vm);
        } else if (vm.$options.props && key in vm.$options.props) {
          warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
        }
      }
    }
  }

  function defineComputed (
    target,
    key,
    userDef
  ) {
    var shouldCache = !isServerRendering();
    if (typeof userDef === 'function') {
      sharedPropertyDefinition.get = shouldCache
        ? createComputedGetter(key)
        : createGetterInvoker(userDef);
      sharedPropertyDefinition.set = noop$1;
    } else {
      sharedPropertyDefinition.get = userDef.get
        ? shouldCache && userDef.cache !== false
          ? createComputedGetter(key)
          : createGetterInvoker(userDef.get)
        : noop$1;
      sharedPropertyDefinition.set = userDef.set || noop$1;
    }
    if (sharedPropertyDefinition.set === noop$1) {
      sharedPropertyDefinition.set = function () {
        warn(
          ("Computed property \"" + key + "\" was assigned to but it has no setter."),
          this
        );
      };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition);
  }

  function createComputedGetter (key) {
    return function computedGetter () {
      var watcher = this._computedWatchers && this._computedWatchers[key];
      if (watcher) {
        if (watcher.dirty) {
          watcher.evaluate();
        }
        if (Dep.target) {
          watcher.depend();
        }
        return watcher.value
      }
    }
  }

  function createGetterInvoker(fn) {
    return function computedGetter () {
      return fn.call(this, this)
    }
  }

  function initMethods (vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
      {
        if (typeof methods[key] !== 'function') {
          warn(
            "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
            "Did you reference the function correctly?",
            vm
          );
        }
        if (props && hasOwn(props, key)) {
          warn(
            ("Method \"" + key + "\" has already been defined as a prop."),
            vm
          );
        }
        if ((key in vm) && isReserved(key)) {
          warn(
            "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
            "Avoid defining component methods that start with _ or $."
          );
        }
      }
      vm[key] = typeof methods[key] !== 'function' ? noop$1 : bind$3(methods[key], vm);
    }
  }

  function initWatch (vm, watch) {
    for (var key in watch) {
      var handler = watch[key];
      if (Array.isArray(handler)) {
        for (var i = 0; i < handler.length; i++) {
          createWatcher(vm, key, handler[i]);
        }
      } else {
        createWatcher(vm, key, handler);
      }
    }
  }

  function createWatcher (
    vm,
    expOrFn,
    handler,
    options
  ) {
    if (isPlainObject$1(handler)) {
      options = handler;
      handler = handler.handler;
    }
    if (typeof handler === 'string') {
      handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options)
  }

  function stateMixin (Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () { return this._data };
    var propsDef = {};
    propsDef.get = function () { return this._props };
    {
      dataDef.set = function () {
        warn(
          'Avoid replacing instance root $data. ' +
          'Use nested data properties instead.',
          this
        );
      };
      propsDef.set = function () {
        warn("$props is readonly.", this);
      };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);

    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;

    Vue.prototype.$watch = function (
      expOrFn,
      cb,
      options
    ) {
      var vm = this;
      if (isPlainObject$1(cb)) {
        return createWatcher(vm, expOrFn, cb, options)
      }
      options = options || {};
      options.user = true;
      var watcher = new Watcher(vm, expOrFn, cb, options);
      if (options.immediate) {
        try {
          cb.call(vm, watcher.value);
        } catch (error) {
          handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
        }
      }
      return function unwatchFn () {
        watcher.teardown();
      }
    };
  }

  /*  */

  var uid$3 = 0;

  function initMixin (Vue) {
    Vue.prototype._init = function (options) {
      var vm = this;
      // a uid
      vm._uid = uid$3++;

      var startTag, endTag;
      /* istanbul ignore if */
      if (config$1.performance && mark) {
        startTag = "vue-perf-start:" + (vm._uid);
        endTag = "vue-perf-end:" + (vm._uid);
        mark(startTag);
      }

      // a flag to avoid this being observed
      vm._isVue = true;
      // merge options
      if (options && options._isComponent) {
        // optimize internal component instantiation
        // since dynamic options merging is pretty slow, and none of the
        // internal component options needs special treatment.
        initInternalComponent(vm, options);
      } else {
        vm.$options = mergeOptions(
          resolveConstructorOptions(vm.constructor),
          options || {},
          vm
        );
      }
      /* istanbul ignore else */
      {
        initProxy(vm);
      }
      // expose real self
      vm._self = vm;
      initLifecycle(vm);
      initEvents(vm);
      initRender(vm);
      callHook(vm, 'beforeCreate');
      initInjections(vm); // resolve injections before data/props
      initState(vm);
      initProvide(vm); // resolve provide after data/props
      callHook(vm, 'created');

      /* istanbul ignore if */
      if (config$1.performance && mark) {
        vm._name = formatComponentName(vm, false);
        mark(endTag);
        measure(("vue " + (vm._name) + " init"), startTag, endTag);
      }

      if (vm.$options.el) {
        vm.$mount(vm.$options.el);
      }
    };
  }

  function initInternalComponent (vm, options) {
    var opts = vm.$options = Object.create(vm.constructor.options);
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;

    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;

    if (options.render) {
      opts.render = options.render;
      opts.staticRenderFns = options.staticRenderFns;
    }
  }

  function resolveConstructorOptions (Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
      var superOptions = resolveConstructorOptions(Ctor.super);
      var cachedSuperOptions = Ctor.superOptions;
      if (superOptions !== cachedSuperOptions) {
        // super option changed,
        // need to resolve new options.
        Ctor.superOptions = superOptions;
        // check if there are any late-modified/attached options (#4976)
        var modifiedOptions = resolveModifiedOptions(Ctor);
        // update base extend options
        if (modifiedOptions) {
          extend$1(Ctor.extendOptions, modifiedOptions);
        }
        options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
        if (options.name) {
          options.components[options.name] = Ctor;
        }
      }
    }
    return options
  }

  function resolveModifiedOptions (Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
      if (latest[key] !== sealed[key]) {
        if (!modified) { modified = {}; }
        modified[key] = latest[key];
      }
    }
    return modified
  }

  function Vue$2 (options) {
    if (!(this instanceof Vue$2)
    ) {
      warn('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
  }

  initMixin(Vue$2);
  stateMixin(Vue$2);
  eventsMixin(Vue$2);
  lifecycleMixin(Vue$2);
  renderMixin(Vue$2);

  /*  */

  function initUse (Vue) {
    Vue.use = function (plugin) {
      var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
      if (installedPlugins.indexOf(plugin) > -1) {
        return this
      }

      // additional parameters
      var args = toArray(arguments, 1);
      args.unshift(this);
      if (typeof plugin.install === 'function') {
        plugin.install.apply(plugin, args);
      } else if (typeof plugin === 'function') {
        plugin.apply(null, args);
      }
      installedPlugins.push(plugin);
      return this
    };
  }

  /*  */

  function initMixin$1 (Vue) {
    Vue.mixin = function (mixin) {
      this.options = mergeOptions(this.options, mixin);
      return this
    };
  }

  /*  */

  function initExtend (Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;

    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
      extendOptions = extendOptions || {};
      var Super = this;
      var SuperId = Super.cid;
      var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
      if (cachedCtors[SuperId]) {
        return cachedCtors[SuperId]
      }

      var name = extendOptions.name || Super.options.name;
      if (name) {
        validateComponentName(name);
      }

      var Sub = function VueComponent (options) {
        this._init(options);
      };
      Sub.prototype = Object.create(Super.prototype);
      Sub.prototype.constructor = Sub;
      Sub.cid = cid++;
      Sub.options = mergeOptions(
        Super.options,
        extendOptions
      );
      Sub['super'] = Super;

      // For props and computed properties, we define the proxy getters on
      // the Vue instances at extension time, on the extended prototype. This
      // avoids Object.defineProperty calls for each instance created.
      if (Sub.options.props) {
        initProps$1(Sub);
      }
      if (Sub.options.computed) {
        initComputed$1(Sub);
      }

      // allow further extension/mixin/plugin usage
      Sub.extend = Super.extend;
      Sub.mixin = Super.mixin;
      Sub.use = Super.use;

      // create asset registers, so extended classes
      // can have their private assets too.
      ASSET_TYPES.forEach(function (type) {
        Sub[type] = Super[type];
      });
      // enable recursive self-lookup
      if (name) {
        Sub.options.components[name] = Sub;
      }

      // keep a reference to the super options at extension time.
      // later at instantiation we can check if Super's options have
      // been updated.
      Sub.superOptions = Super.options;
      Sub.extendOptions = extendOptions;
      Sub.sealedOptions = extend$1({}, Sub.options);

      // cache constructor
      cachedCtors[SuperId] = Sub;
      return Sub
    };
  }

  function initProps$1 (Comp) {
    var props = Comp.options.props;
    for (var key in props) {
      proxy(Comp.prototype, "_props", key);
    }
  }

  function initComputed$1 (Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
      defineComputed(Comp.prototype, key, computed[key]);
    }
  }

  /*  */

  function initAssetRegisters (Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
      Vue[type] = function (
        id,
        definition
      ) {
        if (!definition) {
          return this.options[type + 's'][id]
        } else {
          /* istanbul ignore if */
          if (type === 'component') {
            validateComponentName(id);
          }
          if (type === 'component' && isPlainObject$1(definition)) {
            definition.name = definition.name || id;
            definition = this.options._base.extend(definition);
          }
          if (type === 'directive' && typeof definition === 'function') {
            definition = { bind: definition, update: definition };
          }
          this.options[type + 's'][id] = definition;
          return definition
        }
      };
    });
  }

  /*  */



  function getComponentName (opts) {
    return opts && (opts.Ctor.options.name || opts.tag)
  }

  function matches (pattern, name) {
    if (Array.isArray(pattern)) {
      return pattern.indexOf(name) > -1
    } else if (typeof pattern === 'string') {
      return pattern.split(',').indexOf(name) > -1
    } else if (isRegExp(pattern)) {
      return pattern.test(name)
    }
    /* istanbul ignore next */
    return false
  }

  function pruneCache (keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache;
    var keys = keepAliveInstance.keys;
    var _vnode = keepAliveInstance._vnode;
    for (var key in cache) {
      var cachedNode = cache[key];
      if (cachedNode) {
        var name = getComponentName(cachedNode.componentOptions);
        if (name && !filter(name)) {
          pruneCacheEntry(cache, key, keys, _vnode);
        }
      }
    }
  }

  function pruneCacheEntry (
    cache,
    key,
    keys,
    current
  ) {
    var cached$$1 = cache[key];
    if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
      cached$$1.componentInstance.$destroy();
    }
    cache[key] = null;
    remove(keys, key);
  }

  var patternTypes = [String, RegExp, Array];

  var KeepAlive = {
    name: 'keep-alive',
    abstract: true,

    props: {
      include: patternTypes,
      exclude: patternTypes,
      max: [String, Number]
    },

    created: function created () {
      this.cache = Object.create(null);
      this.keys = [];
    },

    destroyed: function destroyed () {
      for (var key in this.cache) {
        pruneCacheEntry(this.cache, key, this.keys);
      }
    },

    mounted: function mounted () {
      var this$1$1 = this;

      this.$watch('include', function (val) {
        pruneCache(this$1$1, function (name) { return matches(val, name); });
      });
      this.$watch('exclude', function (val) {
        pruneCache(this$1$1, function (name) { return !matches(val, name); });
      });
    },

    render: function render () {
      var slot = this.$slots.default;
      var vnode = getFirstComponentChild(slot);
      var componentOptions = vnode && vnode.componentOptions;
      if (componentOptions) {
        // check pattern
        var name = getComponentName(componentOptions);
        var ref = this;
        var include = ref.include;
        var exclude = ref.exclude;
        if (
          // not included
          (include && (!name || !matches(include, name))) ||
          // excluded
          (exclude && name && matches(exclude, name))
        ) {
          return vnode
        }

        var ref$1 = this;
        var cache = ref$1.cache;
        var keys = ref$1.keys;
        var key = vnode.key == null
          // same constructor may get registered as different local components
          // so cid alone is not enough (#3269)
          ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
          : vnode.key;
        if (cache[key]) {
          vnode.componentInstance = cache[key].componentInstance;
          // make current key freshest
          remove(keys, key);
          keys.push(key);
        } else {
          cache[key] = vnode;
          keys.push(key);
          // prune oldest entry
          if (this.max && keys.length > parseInt(this.max)) {
            pruneCacheEntry(cache, keys[0], keys, this._vnode);
          }
        }

        vnode.data.keepAlive = true;
      }
      return vnode || (slot && slot[0])
    }
  };

  var builtInComponents = {
    KeepAlive: KeepAlive
  };

  /*  */

  function initGlobalAPI (Vue) {
    // config
    var configDef = {};
    configDef.get = function () { return config$1; };
    {
      configDef.set = function () {
        warn(
          'Do not replace the Vue.config object, set individual fields instead.'
        );
      };
    }
    Object.defineProperty(Vue, 'config', configDef);

    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
      warn: warn,
      extend: extend$1,
      mergeOptions: mergeOptions,
      defineReactive: defineReactive$$1
    };

    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick$1;

    // 2.6 explicit observable API
    Vue.observable = function (obj) {
      observe(obj);
      return obj
    };

    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
      Vue.options[type + 's'] = Object.create(null);
    });

    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;

    extend$1(Vue.options.components, builtInComponents);

    initUse(Vue);
    initMixin$1(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
  }

  initGlobalAPI(Vue$2);

  Object.defineProperty(Vue$2.prototype, '$isServer', {
    get: isServerRendering
  });

  Object.defineProperty(Vue$2.prototype, '$ssrContext', {
    get: function get () {
      /* istanbul ignore next */
      return this.$vnode && this.$vnode.ssrContext
    }
  });

  // expose FunctionalRenderContext for ssr runtime helper installation
  Object.defineProperty(Vue$2, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
  });

  Vue$2.version = '2.6.12';

  /*  */

  // these are reserved for web because they are directly compiled away
  // during template compilation
  var isReservedAttr = makeMap('style,class');

  // attributes that should be using props for binding
  var acceptValue = makeMap('input,textarea,option,select,progress');
  var mustUseProp = function (tag, type, attr) {
    return (
      (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
      (attr === 'selected' && tag === 'option') ||
      (attr === 'checked' && tag === 'input') ||
      (attr === 'muted' && tag === 'video')
    )
  };

  var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

  var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

  var convertEnumeratedValue = function (key, value) {
    return isFalsyAttrValue(value) || value === 'false'
      ? 'false'
      // allow arbitrary string value for contenteditable
      : key === 'contenteditable' && isValidContentEditableValue(value)
        ? value
        : 'true'
  };

  var isBooleanAttr = makeMap(
    'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
    'required,reversed,scoped,seamless,selected,sortable,translate,' +
    'truespeed,typemustmatch,visible'
  );

  var xlinkNS = 'http://www.w3.org/1999/xlink';

  var isXlink = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
  };

  var getXlinkProp = function (name) {
    return isXlink(name) ? name.slice(6, name.length) : ''
  };

  var isFalsyAttrValue = function (val) {
    return val == null || val === false
  };

  /*  */

  function genClassForVnode (vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
      childNode = childNode.componentInstance._vnode;
      if (childNode && childNode.data) {
        data = mergeClassData(childNode.data, data);
      }
    }
    while (isDef(parentNode = parentNode.parent)) {
      if (parentNode && parentNode.data) {
        data = mergeClassData(data, parentNode.data);
      }
    }
    return renderClass(data.staticClass, data.class)
  }

  function mergeClassData (child, parent) {
    return {
      staticClass: concat(child.staticClass, parent.staticClass),
      class: isDef(child.class)
        ? [child.class, parent.class]
        : parent.class
    }
  }

  function renderClass (
    staticClass,
    dynamicClass
  ) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
      return concat(staticClass, stringifyClass(dynamicClass))
    }
    /* istanbul ignore next */
    return ''
  }

  function concat (a, b) {
    return a ? b ? (a + ' ' + b) : a : (b || '')
  }

  function stringifyClass (value) {
    if (Array.isArray(value)) {
      return stringifyArray(value)
    }
    if (isObject$5(value)) {
      return stringifyObject(value)
    }
    if (typeof value === 'string') {
      return value
    }
    /* istanbul ignore next */
    return ''
  }

  function stringifyArray (value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
      if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
        if (res) { res += ' '; }
        res += stringified;
      }
    }
    return res
  }

  function stringifyObject (value) {
    var res = '';
    for (var key in value) {
      if (value[key]) {
        if (res) { res += ' '; }
        res += key;
      }
    }
    return res
  }

  /*  */

  var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
  };

  var isHTMLTag = makeMap(
    'html,body,base,head,link,meta,style,title,' +
    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
    'embed,object,param,source,canvas,script,noscript,del,ins,' +
    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
    'output,progress,select,textarea,' +
    'details,dialog,menu,menuitem,summary,' +
    'content,element,shadow,template,blockquote,iframe,tfoot'
  );

  // this map is intentionally selective, only covering SVG elements that may
  // contain child elements.
  var isSVG = makeMap(
    'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
    'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
    true
  );

  var isPreTag = function (tag) { return tag === 'pre'; };

  var isReservedTag = function (tag) {
    return isHTMLTag(tag) || isSVG(tag)
  };

  function getTagNamespace (tag) {
    if (isSVG(tag)) {
      return 'svg'
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
      return 'math'
    }
  }

  var unknownElementCache = Object.create(null);
  function isUnknownElement (tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
      return true
    }
    if (isReservedTag(tag)) {
      return false
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
      return unknownElementCache[tag]
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
      // http://stackoverflow.com/a/28210364/1070244
      return (unknownElementCache[tag] = (
        el.constructor === window.HTMLUnknownElement ||
        el.constructor === window.HTMLElement
      ))
    } else {
      return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
    }
  }

  var isTextInputType = makeMap('text,number,password,search,email,tel,url');

  /*  */

  /**
   * Query an element selector if it's not an element already.
   */
  function query (el) {
    if (typeof el === 'string') {
      var selected = document.querySelector(el);
      if (!selected) {
        warn(
          'Cannot find element: ' + el
        );
        return document.createElement('div')
      }
      return selected
    } else {
      return el
    }
  }

  /*  */

  function createElement$1 (tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
      return elm
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
      elm.setAttribute('multiple', 'multiple');
    }
    return elm
  }

  function createElementNS (namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName)
  }

  function createTextNode (text) {
    return document.createTextNode(text)
  }

  function createComment (text) {
    return document.createComment(text)
  }

  function insertBefore (parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
  }

  function removeChild (node, child) {
    node.removeChild(child);
  }

  function appendChild (node, child) {
    node.appendChild(child);
  }

  function parentNode (node) {
    return node.parentNode
  }

  function nextSibling (node) {
    return node.nextSibling
  }

  function tagName (node) {
    return node.tagName
  }

  function setTextContent (node, text) {
    node.textContent = text;
  }

  function setStyleScope (node, scopeId) {
    node.setAttribute(scopeId, '');
  }

  var nodeOps = /*#__PURE__*/Object.freeze({
    createElement: createElement$1,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    setStyleScope: setStyleScope
  });

  /*  */

  var ref = {
    create: function create (_, vnode) {
      registerRef(vnode);
    },
    update: function update (oldVnode, vnode) {
      if (oldVnode.data.ref !== vnode.data.ref) {
        registerRef(oldVnode, true);
        registerRef(vnode);
      }
    },
    destroy: function destroy (vnode) {
      registerRef(vnode, true);
    }
  };

  function registerRef (vnode, isRemoval) {
    var key = vnode.data.ref;
    if (!isDef(key)) { return }

    var vm = vnode.context;
    var ref = vnode.componentInstance || vnode.elm;
    var refs = vm.$refs;
    if (isRemoval) {
      if (Array.isArray(refs[key])) {
        remove(refs[key], ref);
      } else if (refs[key] === ref) {
        refs[key] = undefined;
      }
    } else {
      if (vnode.data.refInFor) {
        if (!Array.isArray(refs[key])) {
          refs[key] = [ref];
        } else if (refs[key].indexOf(ref) < 0) {
          // $flow-disable-line
          refs[key].push(ref);
        }
      } else {
        refs[key] = ref;
      }
    }
  }

  /**
   * Virtual DOM patching algorithm based on Snabbdom by
   * Simon Friis Vindum (@paldepind)
   * Licensed under the MIT License
   * https://github.com/paldepind/snabbdom/blob/master/LICENSE
   *
   * modified by Evan You (@yyx990803)
   *
   * Not type-checking this because this file is perf-critical and the cost
   * of making flow understand it is not worth it.
   */

  var emptyNode = new VNode('', {}, []);

  var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

  function sameVnode (a, b) {
    return (
      a.key === b.key && (
        (
          a.tag === b.tag &&
          a.isComment === b.isComment &&
          isDef(a.data) === isDef(b.data) &&
          sameInputType(a, b)
        ) || (
          isTrue(a.isAsyncPlaceholder) &&
          a.asyncFactory === b.asyncFactory &&
          isUndef(b.asyncFactory.error)
        )
      )
    )
  }

  function sameInputType (a, b) {
    if (a.tag !== 'input') { return true }
    var i;
    var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
    var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
    return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
  }

  function createKeyToOldIdx (children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
      key = children[i].key;
      if (isDef(key)) { map[key] = i; }
    }
    return map
  }

  function createPatchFunction (backend) {
    var i, j;
    var cbs = {};

    var modules = backend.modules;
    var nodeOps = backend.nodeOps;

    for (i = 0; i < hooks.length; ++i) {
      cbs[hooks[i]] = [];
      for (j = 0; j < modules.length; ++j) {
        if (isDef(modules[j][hooks[i]])) {
          cbs[hooks[i]].push(modules[j][hooks[i]]);
        }
      }
    }

    function emptyNodeAt (elm) {
      return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
    }

    function createRmCb (childElm, listeners) {
      function remove$$1 () {
        if (--remove$$1.listeners === 0) {
          removeNode(childElm);
        }
      }
      remove$$1.listeners = listeners;
      return remove$$1
    }

    function removeNode (el) {
      var parent = nodeOps.parentNode(el);
      // element may have already been removed due to v-html / v-text
      if (isDef(parent)) {
        nodeOps.removeChild(parent, el);
      }
    }

    function isUnknownElement$$1 (vnode, inVPre) {
      return (
        !inVPre &&
        !vnode.ns &&
        !(
          config$1.ignoredElements.length &&
          config$1.ignoredElements.some(function (ignore) {
            return isRegExp(ignore)
              ? ignore.test(vnode.tag)
              : ignore === vnode.tag
          })
        ) &&
        config$1.isUnknownElement(vnode.tag)
      )
    }

    var creatingElmInVPre = 0;

    function createElm (
      vnode,
      insertedVnodeQueue,
      parentElm,
      refElm,
      nested,
      ownerArray,
      index
    ) {
      if (isDef(vnode.elm) && isDef(ownerArray)) {
        // This vnode was used in a previous render!
        // now it's used as a new node, overwriting its elm would cause
        // potential patch errors down the road when it's used as an insertion
        // reference node. Instead, we clone the node on-demand before creating
        // associated DOM element for it.
        vnode = ownerArray[index] = cloneVNode(vnode);
      }

      vnode.isRootInsert = !nested; // for transition enter check
      if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
        return
      }

      var data = vnode.data;
      var children = vnode.children;
      var tag = vnode.tag;
      if (isDef(tag)) {
        {
          if (data && data.pre) {
            creatingElmInVPre++;
          }
          if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
            warn(
              'Unknown custom element: <' + tag + '> - did you ' +
              'register the component correctly? For recursive components, ' +
              'make sure to provide the "name" option.',
              vnode.context
            );
          }
        }

        vnode.elm = vnode.ns
          ? nodeOps.createElementNS(vnode.ns, tag)
          : nodeOps.createElement(tag, vnode);
        setScope(vnode);

        /* istanbul ignore if */
        {
          createChildren(vnode, children, insertedVnodeQueue);
          if (isDef(data)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
          }
          insert(parentElm, vnode.elm, refElm);
        }

        if (data && data.pre) {
          creatingElmInVPre--;
        }
      } else if (isTrue(vnode.isComment)) {
        vnode.elm = nodeOps.createComment(vnode.text);
        insert(parentElm, vnode.elm, refElm);
      } else {
        vnode.elm = nodeOps.createTextNode(vnode.text);
        insert(parentElm, vnode.elm, refElm);
      }
    }

    function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
      var i = vnode.data;
      if (isDef(i)) {
        var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
        if (isDef(i = i.hook) && isDef(i = i.init)) {
          i(vnode, false /* hydrating */);
        }
        // after calling the init hook, if the vnode is a child component
        // it should've created a child instance and mounted it. the child
        // component also has set the placeholder vnode's elm.
        // in that case we can just return the element and be done.
        if (isDef(vnode.componentInstance)) {
          initComponent(vnode, insertedVnodeQueue);
          insert(parentElm, vnode.elm, refElm);
          if (isTrue(isReactivated)) {
            reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
          }
          return true
        }
      }
    }

    function initComponent (vnode, insertedVnodeQueue) {
      if (isDef(vnode.data.pendingInsert)) {
        insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
        vnode.data.pendingInsert = null;
      }
      vnode.elm = vnode.componentInstance.$el;
      if (isPatchable(vnode)) {
        invokeCreateHooks(vnode, insertedVnodeQueue);
        setScope(vnode);
      } else {
        // empty component root.
        // skip all element-related modules except for ref (#3455)
        registerRef(vnode);
        // make sure to invoke the insert hook
        insertedVnodeQueue.push(vnode);
      }
    }

    function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
      var i;
      // hack for #4339: a reactivated component with inner transition
      // does not trigger because the inner node's created hooks are not called
      // again. It's not ideal to involve module-specific logic in here but
      // there doesn't seem to be a better way to do it.
      var innerNode = vnode;
      while (innerNode.componentInstance) {
        innerNode = innerNode.componentInstance._vnode;
        if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
          for (i = 0; i < cbs.activate.length; ++i) {
            cbs.activate[i](emptyNode, innerNode);
          }
          insertedVnodeQueue.push(innerNode);
          break
        }
      }
      // unlike a newly created component,
      // a reactivated keep-alive component doesn't insert itself
      insert(parentElm, vnode.elm, refElm);
    }

    function insert (parent, elm, ref$$1) {
      if (isDef(parent)) {
        if (isDef(ref$$1)) {
          if (nodeOps.parentNode(ref$$1) === parent) {
            nodeOps.insertBefore(parent, elm, ref$$1);
          }
        } else {
          nodeOps.appendChild(parent, elm);
        }
      }
    }

    function createChildren (vnode, children, insertedVnodeQueue) {
      if (Array.isArray(children)) {
        {
          checkDuplicateKeys(children);
        }
        for (var i = 0; i < children.length; ++i) {
          createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
        }
      } else if (isPrimitive(vnode.text)) {
        nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
      }
    }

    function isPatchable (vnode) {
      while (vnode.componentInstance) {
        vnode = vnode.componentInstance._vnode;
      }
      return isDef(vnode.tag)
    }

    function invokeCreateHooks (vnode, insertedVnodeQueue) {
      for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
        cbs.create[i$1](emptyNode, vnode);
      }
      i = vnode.data.hook; // Reuse variable
      if (isDef(i)) {
        if (isDef(i.create)) { i.create(emptyNode, vnode); }
        if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
      }
    }

    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope (vnode) {
      var i;
      if (isDef(i = vnode.fnScopeId)) {
        nodeOps.setStyleScope(vnode.elm, i);
      } else {
        var ancestor = vnode;
        while (ancestor) {
          if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
          }
          ancestor = ancestor.parent;
        }
      }
      // for slot content they should also get the scopeId from the host instance.
      if (isDef(i = activeInstance) &&
        i !== vnode.context &&
        i !== vnode.fnContext &&
        isDef(i = i.$options._scopeId)
      ) {
        nodeOps.setStyleScope(vnode.elm, i);
      }
    }

    function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
      for (; startIdx <= endIdx; ++startIdx) {
        createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
      }
    }

    function invokeDestroyHook (vnode) {
      var i, j;
      var data = vnode.data;
      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
        for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
      }
      if (isDef(i = vnode.children)) {
        for (j = 0; j < vnode.children.length; ++j) {
          invokeDestroyHook(vnode.children[j]);
        }
      }
    }

    function removeVnodes (vnodes, startIdx, endIdx) {
      for (; startIdx <= endIdx; ++startIdx) {
        var ch = vnodes[startIdx];
        if (isDef(ch)) {
          if (isDef(ch.tag)) {
            removeAndInvokeRemoveHook(ch);
            invokeDestroyHook(ch);
          } else { // Text node
            removeNode(ch.elm);
          }
        }
      }
    }

    function removeAndInvokeRemoveHook (vnode, rm) {
      if (isDef(rm) || isDef(vnode.data)) {
        var i;
        var listeners = cbs.remove.length + 1;
        if (isDef(rm)) {
          // we have a recursively passed down rm callback
          // increase the listeners count
          rm.listeners += listeners;
        } else {
          // directly removing
          rm = createRmCb(vnode.elm, listeners);
        }
        // recursively invoke hooks on child component root node
        if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
          removeAndInvokeRemoveHook(i, rm);
        }
        for (i = 0; i < cbs.remove.length; ++i) {
          cbs.remove[i](vnode, rm);
        }
        if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
          i(vnode, rm);
        } else {
          rm();
        }
      } else {
        removeNode(vnode.elm);
      }
    }

    function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
      var oldStartIdx = 0;
      var newStartIdx = 0;
      var oldEndIdx = oldCh.length - 1;
      var oldStartVnode = oldCh[0];
      var oldEndVnode = oldCh[oldEndIdx];
      var newEndIdx = newCh.length - 1;
      var newStartVnode = newCh[0];
      var newEndVnode = newCh[newEndIdx];
      var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

      // removeOnly is a special flag used only by <transition-group>
      // to ensure removed elements stay in correct relative positions
      // during leaving transitions
      var canMove = !removeOnly;

      {
        checkDuplicateKeys(newCh);
      }

      while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
        if (isUndef(oldStartVnode)) {
          oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
        } else if (isUndef(oldEndVnode)) {
          oldEndVnode = oldCh[--oldEndIdx];
        } else if (sameVnode(oldStartVnode, newStartVnode)) {
          patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
          oldStartVnode = oldCh[++oldStartIdx];
          newStartVnode = newCh[++newStartIdx];
        } else if (sameVnode(oldEndVnode, newEndVnode)) {
          patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
          oldEndVnode = oldCh[--oldEndIdx];
          newEndVnode = newCh[--newEndIdx];
        } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
          patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
          canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
          oldStartVnode = oldCh[++oldStartIdx];
          newEndVnode = newCh[--newEndIdx];
        } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
          patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
          canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
          oldEndVnode = oldCh[--oldEndIdx];
          newStartVnode = newCh[++newStartIdx];
        } else {
          if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
          idxInOld = isDef(newStartVnode.key)
            ? oldKeyToIdx[newStartVnode.key]
            : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
          if (isUndef(idxInOld)) { // New element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          } else {
            vnodeToMove = oldCh[idxInOld];
            if (sameVnode(vnodeToMove, newStartVnode)) {
              patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
              oldCh[idxInOld] = undefined;
              canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
            } else {
              // same key but different element. treat as new element
              createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
            }
          }
          newStartVnode = newCh[++newStartIdx];
        }
      }
      if (oldStartIdx > oldEndIdx) {
        refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
        addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
      } else if (newStartIdx > newEndIdx) {
        removeVnodes(oldCh, oldStartIdx, oldEndIdx);
      }
    }

    function checkDuplicateKeys (children) {
      var seenKeys = {};
      for (var i = 0; i < children.length; i++) {
        var vnode = children[i];
        var key = vnode.key;
        if (isDef(key)) {
          if (seenKeys[key]) {
            warn(
              ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
              vnode.context
            );
          } else {
            seenKeys[key] = true;
          }
        }
      }
    }

    function findIdxInOld (node, oldCh, start, end) {
      for (var i = start; i < end; i++) {
        var c = oldCh[i];
        if (isDef(c) && sameVnode(node, c)) { return i }
      }
    }

    function patchVnode (
      oldVnode,
      vnode,
      insertedVnodeQueue,
      ownerArray,
      index,
      removeOnly
    ) {
      if (oldVnode === vnode) {
        return
      }

      if (isDef(vnode.elm) && isDef(ownerArray)) {
        // clone reused vnode
        vnode = ownerArray[index] = cloneVNode(vnode);
      }

      var elm = vnode.elm = oldVnode.elm;

      if (isTrue(oldVnode.isAsyncPlaceholder)) {
        if (isDef(vnode.asyncFactory.resolved)) {
          hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
        } else {
          vnode.isAsyncPlaceholder = true;
        }
        return
      }

      // reuse element for static trees.
      // note we only do this if the vnode is cloned -
      // if the new node is not cloned it means the render functions have been
      // reset by the hot-reload-api and we need to do a proper re-render.
      if (isTrue(vnode.isStatic) &&
        isTrue(oldVnode.isStatic) &&
        vnode.key === oldVnode.key &&
        (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
      ) {
        vnode.componentInstance = oldVnode.componentInstance;
        return
      }

      var i;
      var data = vnode.data;
      if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
        i(oldVnode, vnode);
      }

      var oldCh = oldVnode.children;
      var ch = vnode.children;
      if (isDef(data) && isPatchable(vnode)) {
        for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
        if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
      }
      if (isUndef(vnode.text)) {
        if (isDef(oldCh) && isDef(ch)) {
          if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
        } else if (isDef(ch)) {
          {
            checkDuplicateKeys(ch);
          }
          if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
          addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
        } else if (isDef(oldCh)) {
          removeVnodes(oldCh, 0, oldCh.length - 1);
        } else if (isDef(oldVnode.text)) {
          nodeOps.setTextContent(elm, '');
        }
      } else if (oldVnode.text !== vnode.text) {
        nodeOps.setTextContent(elm, vnode.text);
      }
      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
      }
    }

    function invokeInsertHook (vnode, queue, initial) {
      // delay insert hooks for component root nodes, invoke them after the
      // element is really inserted
      if (isTrue(initial) && isDef(vnode.parent)) {
        vnode.parent.data.pendingInsert = queue;
      } else {
        for (var i = 0; i < queue.length; ++i) {
          queue[i].data.hook.insert(queue[i]);
        }
      }
    }

    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
      var i;
      var tag = vnode.tag;
      var data = vnode.data;
      var children = vnode.children;
      inVPre = inVPre || (data && data.pre);
      vnode.elm = elm;

      if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
        vnode.isAsyncPlaceholder = true;
        return true
      }
      // assert node match
      {
        if (!assertNodeMatch(elm, vnode, inVPre)) {
          return false
        }
      }
      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
        if (isDef(i = vnode.componentInstance)) {
          // child component. it should have hydrated its own tree.
          initComponent(vnode, insertedVnodeQueue);
          return true
        }
      }
      if (isDef(tag)) {
        if (isDef(children)) {
          // empty element, allow client to pick up and populate children
          if (!elm.hasChildNodes()) {
            createChildren(vnode, children, insertedVnodeQueue);
          } else {
            // v-html and domProps: innerHTML
            if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
              if (i !== elm.innerHTML) {
                /* istanbul ignore if */
                if (typeof console !== 'undefined' &&
                  !hydrationBailed
                ) {
                  hydrationBailed = true;
                  console.warn('Parent: ', elm);
                  console.warn('server innerHTML: ', i);
                  console.warn('client innerHTML: ', elm.innerHTML);
                }
                return false
              }
            } else {
              // iterate and compare children lists
              var childrenMatch = true;
              var childNode = elm.firstChild;
              for (var i$1 = 0; i$1 < children.length; i$1++) {
                if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                  childrenMatch = false;
                  break
                }
                childNode = childNode.nextSibling;
              }
              // if childNode is not null, it means the actual childNodes list is
              // longer than the virtual children list.
              if (!childrenMatch || childNode) {
                /* istanbul ignore if */
                if (typeof console !== 'undefined' &&
                  !hydrationBailed
                ) {
                  hydrationBailed = true;
                  console.warn('Parent: ', elm);
                  console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                }
                return false
              }
            }
          }
        }
        if (isDef(data)) {
          var fullInvoke = false;
          for (var key in data) {
            if (!isRenderedModule(key)) {
              fullInvoke = true;
              invokeCreateHooks(vnode, insertedVnodeQueue);
              break
            }
          }
          if (!fullInvoke && data['class']) {
            // ensure collecting deps for deep class bindings for future updates
            traverse(data['class']);
          }
        }
      } else if (elm.data !== vnode.text) {
        elm.data = vnode.text;
      }
      return true
    }

    function assertNodeMatch (node, vnode, inVPre) {
      if (isDef(vnode.tag)) {
        return vnode.tag.indexOf('vue-component') === 0 || (
          !isUnknownElement$$1(vnode, inVPre) &&
          vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
        )
      } else {
        return node.nodeType === (vnode.isComment ? 8 : 3)
      }
    }

    return function patch (oldVnode, vnode, hydrating, removeOnly) {
      if (isUndef(vnode)) {
        if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
        return
      }

      var isInitialPatch = false;
      var insertedVnodeQueue = [];

      if (isUndef(oldVnode)) {
        // empty mount (likely as component), create new root element
        isInitialPatch = true;
        createElm(vnode, insertedVnodeQueue);
      } else {
        var isRealElement = isDef(oldVnode.nodeType);
        if (!isRealElement && sameVnode(oldVnode, vnode)) {
          // patch existing root node
          patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
        } else {
          if (isRealElement) {
            // mounting to a real element
            // check if this is server-rendered content and if we can perform
            // a successful hydration.
            if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
              oldVnode.removeAttribute(SSR_ATTR);
              hydrating = true;
            }
            if (isTrue(hydrating)) {
              if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                invokeInsertHook(vnode, insertedVnodeQueue, true);
                return oldVnode
              } else {
                warn(
                  'The client-side rendered virtual DOM tree is not matching ' +
                  'server-rendered content. This is likely caused by incorrect ' +
                  'HTML markup, for example nesting block-level elements inside ' +
                  '<p>, or missing <tbody>. Bailing hydration and performing ' +
                  'full client-side render.'
                );
              }
            }
            // either not server-rendered, or hydration failed.
            // create an empty node and replace it
            oldVnode = emptyNodeAt(oldVnode);
          }

          // replacing existing element
          var oldElm = oldVnode.elm;
          var parentElm = nodeOps.parentNode(oldElm);

          // create new node
          createElm(
            vnode,
            insertedVnodeQueue,
            // extremely rare edge case: do not insert if old element is in a
            // leaving transition. Only happens when combining transition +
            // keep-alive + HOCs. (#4590)
            oldElm._leaveCb ? null : parentElm,
            nodeOps.nextSibling(oldElm)
          );

          // update parent placeholder node element, recursively
          if (isDef(vnode.parent)) {
            var ancestor = vnode.parent;
            var patchable = isPatchable(vnode);
            while (ancestor) {
              for (var i = 0; i < cbs.destroy.length; ++i) {
                cbs.destroy[i](ancestor);
              }
              ancestor.elm = vnode.elm;
              if (patchable) {
                for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                  cbs.create[i$1](emptyNode, ancestor);
                }
                // #6513
                // invoke insert hooks that may have been merged by create hooks.
                // e.g. for directives that uses the "inserted" hook.
                var insert = ancestor.data.hook.insert;
                if (insert.merged) {
                  // start at index 1 to avoid re-invoking component mounted hook
                  for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                    insert.fns[i$2]();
                  }
                }
              } else {
                registerRef(ancestor);
              }
              ancestor = ancestor.parent;
            }
          }

          // destroy old node
          if (isDef(parentElm)) {
            removeVnodes([oldVnode], 0, 0);
          } else if (isDef(oldVnode.tag)) {
            invokeDestroyHook(oldVnode);
          }
        }
      }

      invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
      return vnode.elm
    }
  }

  /*  */

  var directives = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives (vnode) {
      updateDirectives(vnode, emptyNode);
    }
  };

  function updateDirectives (oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
      _update(oldVnode, vnode);
    }
  }

  function _update (oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

    var dirsWithInsert = [];
    var dirsWithPostpatch = [];

    var key, oldDir, dir;
    for (key in newDirs) {
      oldDir = oldDirs[key];
      dir = newDirs[key];
      if (!oldDir) {
        // new directive, bind
        callHook$1(dir, 'bind', vnode, oldVnode);
        if (dir.def && dir.def.inserted) {
          dirsWithInsert.push(dir);
        }
      } else {
        // existing directive, update
        dir.oldValue = oldDir.value;
        dir.oldArg = oldDir.arg;
        callHook$1(dir, 'update', vnode, oldVnode);
        if (dir.def && dir.def.componentUpdated) {
          dirsWithPostpatch.push(dir);
        }
      }
    }

    if (dirsWithInsert.length) {
      var callInsert = function () {
        for (var i = 0; i < dirsWithInsert.length; i++) {
          callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
        }
      };
      if (isCreate) {
        mergeVNodeHook(vnode, 'insert', callInsert);
      } else {
        callInsert();
      }
    }

    if (dirsWithPostpatch.length) {
      mergeVNodeHook(vnode, 'postpatch', function () {
        for (var i = 0; i < dirsWithPostpatch.length; i++) {
          callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
        }
      });
    }

    if (!isCreate) {
      for (key in oldDirs) {
        if (!newDirs[key]) {
          // no longer present, unbind
          callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
        }
      }
    }
  }

  var emptyModifiers = Object.create(null);

  function normalizeDirectives$1 (
    dirs,
    vm
  ) {
    var res = Object.create(null);
    if (!dirs) {
      // $flow-disable-line
      return res
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
      dir = dirs[i];
      if (!dir.modifiers) {
        // $flow-disable-line
        dir.modifiers = emptyModifiers;
      }
      res[getRawDirName(dir)] = dir;
      dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res
  }

  function getRawDirName (dir) {
    return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
  }

  function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
      try {
        fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
      } catch (e) {
        handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
      }
    }
  }

  var baseModules = [
    ref,
    directives
  ];

  /*  */

  function updateAttrs (oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
      return
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
      return
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__)) {
      attrs = vnode.data.attrs = extend$1({}, attrs);
    }

    for (key in attrs) {
      cur = attrs[key];
      old = oldAttrs[key];
      if (old !== cur) {
        setAttr(elm, key, cur);
      }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
      setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
      if (isUndef(attrs[key])) {
        if (isXlink(key)) {
          elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
        } else if (!isEnumeratedAttr(key)) {
          elm.removeAttribute(key);
        }
      }
    }
  }

  function setAttr (el, key, value) {
    if (el.tagName.indexOf('-') > -1) {
      baseSetAttr(el, key, value);
    } else if (isBooleanAttr(key)) {
      // set attribute for blank value
      // e.g. <option disabled>Select one</option>
      if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
      } else {
        // technically allowfullscreen is a boolean attribute for <iframe>,
        // but Flash expects a value of "true" when used on <embed> tag
        value = key === 'allowfullscreen' && el.tagName === 'EMBED'
          ? 'true'
          : key;
        el.setAttribute(key, value);
      }
    } else if (isEnumeratedAttr(key)) {
      el.setAttribute(key, convertEnumeratedValue(key, value));
    } else if (isXlink(key)) {
      if (isFalsyAttrValue(value)) {
        el.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else {
        el.setAttributeNS(xlinkNS, key, value);
      }
    } else {
      baseSetAttr(el, key, value);
    }
  }

  function baseSetAttr (el, key, value) {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.
      /* istanbul ignore if */
      if (
        isIE && !isIE9 &&
        el.tagName === 'TEXTAREA' &&
        key === 'placeholder' && value !== '' && !el.__ieph
      ) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };
        el.addEventListener('input', blocker);
        // $flow-disable-line
        el.__ieph = true; /* IE placeholder patched */
      }
      el.setAttribute(key, value);
    }
  }

  var attrs = {
    create: updateAttrs,
    update: updateAttrs
  };

  /*  */

  function updateClass (oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (
      isUndef(data.staticClass) &&
      isUndef(data.class) && (
        isUndef(oldData) || (
          isUndef(oldData.staticClass) &&
          isUndef(oldData.class)
        )
      )
    ) {
      return
    }

    var cls = genClassForVnode(vnode);

    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
      cls = concat(cls, stringifyClass(transitionClass));
    }

    // set the class
    if (cls !== el._prevClass) {
      el.setAttribute('class', cls);
      el._prevClass = cls;
    }
  }

  var klass = {
    create: updateClass,
    update: updateClass
  };

  /*  */

  var validDivisionCharRE = /[\w).+\-_$\]]/;

  function parseFilters (exp) {
    var inSingle = false;
    var inDouble = false;
    var inTemplateString = false;
    var inRegex = false;
    var curly = 0;
    var square = 0;
    var paren = 0;
    var lastFilterIndex = 0;
    var c, prev, i, expression, filters;

    for (i = 0; i < exp.length; i++) {
      prev = c;
      c = exp.charCodeAt(i);
      if (inSingle) {
        if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
      } else if (inDouble) {
        if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
      } else if (inTemplateString) {
        if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
      } else if (inRegex) {
        if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
      } else if (
        c === 0x7C && // pipe
        exp.charCodeAt(i + 1) !== 0x7C &&
        exp.charCodeAt(i - 1) !== 0x7C &&
        !curly && !square && !paren
      ) {
        if (expression === undefined) {
          // first filter, end of expression
          lastFilterIndex = i + 1;
          expression = exp.slice(0, i).trim();
        } else {
          pushFilter();
        }
      } else {
        switch (c) {
          case 0x22: inDouble = true; break         // "
          case 0x27: inSingle = true; break         // '
          case 0x60: inTemplateString = true; break // `
          case 0x28: paren++; break                 // (
          case 0x29: paren--; break                 // )
          case 0x5B: square++; break                // [
          case 0x5D: square--; break                // ]
          case 0x7B: curly++; break                 // {
          case 0x7D: curly--; break                 // }
        }
        if (c === 0x2f) { // /
          var j = i - 1;
          var p = (void 0);
          // find first non-whitespace prev char
          for (; j >= 0; j--) {
            p = exp.charAt(j);
            if (p !== ' ') { break }
          }
          if (!p || !validDivisionCharRE.test(p)) {
            inRegex = true;
          }
        }
      }
    }

    if (expression === undefined) {
      expression = exp.slice(0, i).trim();
    } else if (lastFilterIndex !== 0) {
      pushFilter();
    }

    function pushFilter () {
      (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
      lastFilterIndex = i + 1;
    }

    if (filters) {
      for (i = 0; i < filters.length; i++) {
        expression = wrapFilter(expression, filters[i]);
      }
    }

    return expression
  }

  function wrapFilter (exp, filter) {
    var i = filter.indexOf('(');
    if (i < 0) {
      // _f: resolveFilter
      return ("_f(\"" + filter + "\")(" + exp + ")")
    } else {
      var name = filter.slice(0, i);
      var args = filter.slice(i + 1);
      return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
    }
  }

  /*  */



  /* eslint-disable no-unused-vars */
  function baseWarn (msg, range) {
    console.error(("[Vue compiler]: " + msg));
  }
  /* eslint-enable no-unused-vars */

  function pluckModuleFunction (
    modules,
    key
  ) {
    return modules
      ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
      : []
  }

  function addProp (el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
  }

  function addAttr (el, name, value, range, dynamic) {
    var attrs = dynamic
      ? (el.dynamicAttrs || (el.dynamicAttrs = []))
      : (el.attrs || (el.attrs = []));
    attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
  }

  // add a raw attr (use this in preTransforms)
  function addRawAttr (el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
  }

  function addDirective (
    el,
    name,
    rawName,
    value,
    arg,
    isDynamicArg,
    modifiers,
    range
  ) {
    (el.directives || (el.directives = [])).push(rangeSetItem({
      name: name,
      rawName: rawName,
      value: value,
      arg: arg,
      isDynamicArg: isDynamicArg,
      modifiers: modifiers
    }, range));
    el.plain = false;
  }

  function prependModifierMarker (symbol, name, dynamic) {
    return dynamic
      ? ("_p(" + name + ",\"" + symbol + "\")")
      : symbol + name // mark the event as captured
  }

  function addHandler (
    el,
    name,
    value,
    modifiers,
    important,
    warn,
    range,
    dynamic
  ) {
    modifiers = modifiers || emptyObject;
    // warn prevent and passive modifier
    /* istanbul ignore if */
    if (
      warn &&
      modifiers.prevent && modifiers.passive
    ) {
      warn(
        'passive and prevent can\'t be used together. ' +
        'Passive handler can\'t prevent default event.',
        range
      );
    }

    // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.
    if (modifiers.right) {
      if (dynamic) {
        name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
      } else if (name === 'click') {
        name = 'contextmenu';
        delete modifiers.right;
      }
    } else if (modifiers.middle) {
      if (dynamic) {
        name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
      } else if (name === 'click') {
        name = 'mouseup';
      }
    }

    // check capture modifier
    if (modifiers.capture) {
      delete modifiers.capture;
      name = prependModifierMarker('!', name, dynamic);
    }
    if (modifiers.once) {
      delete modifiers.once;
      name = prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */
    if (modifiers.passive) {
      delete modifiers.passive;
      name = prependModifierMarker('&', name, dynamic);
    }

    var events;
    if (modifiers.native) {
      delete modifiers.native;
      events = el.nativeEvents || (el.nativeEvents = {});
    } else {
      events = el.events || (el.events = {});
    }

    var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
    if (modifiers !== emptyObject) {
      newHandler.modifiers = modifiers;
    }

    var handlers = events[name];
    /* istanbul ignore if */
    if (Array.isArray(handlers)) {
      important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    } else if (handlers) {
      events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
    } else {
      events[name] = newHandler;
    }

    el.plain = false;
  }

  function getRawBindingAttr (
    el,
    name
  ) {
    return el.rawAttrsMap[':' + name] ||
      el.rawAttrsMap['v-bind:' + name] ||
      el.rawAttrsMap[name]
  }

  function getBindingAttr (
    el,
    name,
    getStatic
  ) {
    var dynamicValue =
      getAndRemoveAttr(el, ':' + name) ||
      getAndRemoveAttr(el, 'v-bind:' + name);
    if (dynamicValue != null) {
      return parseFilters(dynamicValue)
    } else if (getStatic !== false) {
      var staticValue = getAndRemoveAttr(el, name);
      if (staticValue != null) {
        return JSON.stringify(staticValue)
      }
    }
  }

  // note: this only removes the attr from the Array (attrsList) so that it
  // doesn't get processed by processAttrs.
  // By default it does NOT remove it from the map (attrsMap) because the map is
  // needed during codegen.
  function getAndRemoveAttr (
    el,
    name,
    removeFromMap
  ) {
    var val;
    if ((val = el.attrsMap[name]) != null) {
      var list = el.attrsList;
      for (var i = 0, l = list.length; i < l; i++) {
        if (list[i].name === name) {
          list.splice(i, 1);
          break
        }
      }
    }
    if (removeFromMap) {
      delete el.attrsMap[name];
    }
    return val
  }

  function getAndRemoveAttrByRegex (
    el,
    name
  ) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      var attr = list[i];
      if (name.test(attr.name)) {
        list.splice(i, 1);
        return attr
      }
    }
  }

  function rangeSetItem (
    item,
    range
  ) {
    if (range) {
      if (range.start != null) {
        item.start = range.start;
      }
      if (range.end != null) {
        item.end = range.end;
      }
    }
    return item
  }

  /*  */

  /**
   * Cross-platform code generation for component v-model
   */
  function genComponentModel (
    el,
    value,
    modifiers
  ) {
    var ref = modifiers || {};
    var number = ref.number;
    var trim = ref.trim;

    var baseValueExpression = '$$v';
    var valueExpression = baseValueExpression;
    if (trim) {
      valueExpression =
        "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
    }
    if (number) {
      valueExpression = "_n(" + valueExpression + ")";
    }
    var assignment = genAssignmentCode(value, valueExpression);

    el.model = {
      value: ("(" + value + ")"),
      expression: JSON.stringify(value),
      callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
    };
  }

  /**
   * Cross-platform codegen helper for generating v-model value assignment code.
   */
  function genAssignmentCode (
    value,
    assignment
  ) {
    var res = parseModel(value);
    if (res.key === null) {
      return (value + "=" + assignment)
    } else {
      return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
    }
  }

  /**
   * Parse a v-model expression into a base path and a final key segment.
   * Handles both dot-path and possible square brackets.
   *
   * Possible cases:
   *
   * - test
   * - test[key]
   * - test[test1[key]]
   * - test["a"][key]
   * - xxx.test[a[a].test1[key]]
   * - test.xxx.a["asa"][test1[key]]
   *
   */

  var len, str, chr, index$1$1, expressionPos, expressionEndPos;



  function parseModel (val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    len = val.length;

    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
      index$1$1 = val.lastIndexOf('.');
      if (index$1$1 > -1) {
        return {
          exp: val.slice(0, index$1$1),
          key: '"' + val.slice(index$1$1 + 1) + '"'
        }
      } else {
        return {
          exp: val,
          key: null
        }
      }
    }

    str = val;
    index$1$1 = expressionPos = expressionEndPos = 0;

    while (!eof()) {
      chr = next();
      /* istanbul ignore if */
      if (isStringStart(chr)) {
        parseString(chr);
      } else if (chr === 0x5B) {
        parseBracket(chr);
      }
    }

    return {
      exp: val.slice(0, expressionPos),
      key: val.slice(expressionPos + 1, expressionEndPos)
    }
  }

  function next () {
    return str.charCodeAt(++index$1$1)
  }

  function eof () {
    return index$1$1 >= len
  }

  function isStringStart (chr) {
    return chr === 0x22 || chr === 0x27
  }

  function parseBracket (chr) {
    var inBracket = 1;
    expressionPos = index$1$1;
    while (!eof()) {
      chr = next();
      if (isStringStart(chr)) {
        parseString(chr);
        continue
      }
      if (chr === 0x5B) { inBracket++; }
      if (chr === 0x5D) { inBracket--; }
      if (inBracket === 0) {
        expressionEndPos = index$1$1;
        break
      }
    }
  }

  function parseString (chr) {
    var stringQuote = chr;
    while (!eof()) {
      chr = next();
      if (chr === stringQuote) {
        break
      }
    }
  }

  /*  */

  var warn$1;

  // in some cases, the event used has to be determined at runtime
  // so we used some reserved tokens during compile.
  var RANGE_TOKEN = '__r';
  var CHECKBOX_RADIO_TOKEN = '__c';

  function model (
    el,
    dir,
    _warn
  ) {
    warn$1 = _warn;
    var value = dir.value;
    var modifiers = dir.modifiers;
    var tag = el.tag;
    var type = el.attrsMap.type;

    {
      // inputs with type="file" are read only and setting the input's
      // value will throw an error.
      if (tag === 'input' && type === 'file') {
        warn$1(
          "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
          "File inputs are read only. Use a v-on:change listener instead.",
          el.rawAttrsMap['v-model']
        );
      }
    }

    if (el.component) {
      genComponentModel(el, value, modifiers);
      // component v-model doesn't need extra runtime
      return false
    } else if (tag === 'select') {
      genSelect(el, value, modifiers);
    } else if (tag === 'input' && type === 'checkbox') {
      genCheckboxModel(el, value, modifiers);
    } else if (tag === 'input' && type === 'radio') {
      genRadioModel(el, value, modifiers);
    } else if (tag === 'input' || tag === 'textarea') {
      genDefaultModel(el, value, modifiers);
    } else if (!config$1.isReservedTag(tag)) {
      genComponentModel(el, value, modifiers);
      // component v-model doesn't need extra runtime
      return false
    } else {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "v-model is not supported on this element type. " +
        'If you are working with contenteditable, it\'s recommended to ' +
        'wrap a library dedicated for that purpose inside a custom component.',
        el.rawAttrsMap['v-model']
      );
    }

    // ensure runtime directive metadata
    return true
  }

  function genCheckboxModel (
    el,
    value,
    modifiers
  ) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
    var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
    addProp(el, 'checked',
      "Array.isArray(" + value + ")" +
      "?_i(" + value + "," + valueBinding + ")>-1" + (
        trueValueBinding === 'true'
          ? (":(" + value + ")")
          : (":_q(" + value + "," + trueValueBinding + ")")
      )
    );
    addHandler(el, 'change',
      "var $$a=" + value + "," +
          '$$el=$event.target,' +
          "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
      'if(Array.isArray($$a)){' +
        "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
            '$$i=_i($$a,$$v);' +
        "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
        "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
      "}else{" + (genAssignmentCode(value, '$$c')) + "}",
      null, true
    );
  }

  function genRadioModel (
    el,
    value,
    modifiers
  ) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
    addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
    addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
  }

  function genSelect (
    el,
    value,
    modifiers
  ) {
    var number = modifiers && modifiers.number;
    var selectedVal = "Array.prototype.filter" +
      ".call($event.target.options,function(o){return o.selected})" +
      ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
      "return " + (number ? '_n(val)' : 'val') + "})";

    var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    var code = "var $$selectedVal = " + selectedVal + ";";
    code = code + " " + (genAssignmentCode(value, assignment));
    addHandler(el, 'change', code, null, true);
  }

  function genDefaultModel (
    el,
    value,
    modifiers
  ) {
    var type = el.attrsMap.type;

    // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type
    {
      var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
      var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
      if (value$1 && !typeBinding) {
        var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
        warn$1(
          binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
          'because the latter already expands to a value binding internally',
          el.rawAttrsMap[binding]
        );
      }
    }

    var ref = modifiers || {};
    var lazy = ref.lazy;
    var number = ref.number;
    var trim = ref.trim;
    var needCompositionGuard = !lazy && type !== 'range';
    var event = lazy
      ? 'change'
      : type === 'range'
        ? RANGE_TOKEN
        : 'input';

    var valueExpression = '$event.target.value';
    if (trim) {
      valueExpression = "$event.target.value.trim()";
    }
    if (number) {
      valueExpression = "_n(" + valueExpression + ")";
    }

    var code = genAssignmentCode(value, valueExpression);
    if (needCompositionGuard) {
      code = "if($event.target.composing)return;" + code;
    }

    addProp(el, 'value', ("(" + value + ")"));
    addHandler(el, event, code, null, true);
    if (trim || number) {
      addHandler(el, 'blur', '$forceUpdate()');
    }
  }

  /*  */

  // normalize v-model event tokens that can only be determined at runtime.
  // it's important to place the event as the first in the array because
  // the whole point is ensuring the v-model callback gets called before
  // user-attached handlers.
  function normalizeEvents (on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
      // IE input[type=range] only supports `change` event
      var event = isIE ? 'change' : 'input';
      on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
      delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
      on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
      delete on[CHECKBOX_RADIO_TOKEN];
    }
  }

  var target$1$1;

  function createOnceHandler$1 (event, handler, capture) {
    var _target = target$1$1; // save current target element in closure
    return function onceHandler () {
      var res = handler.apply(null, arguments);
      if (res !== null) {
        remove$2(event, onceHandler, capture, _target);
      }
    }
  }

  // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
  // implementation and does not fire microtasks in between event propagation, so
  // safe to exclude.
  var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

  function add$1 (
    name,
    handler,
    capture,
    passive
  ) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
      var attachedTimestamp = currentFlushTimestamp;
      var original = handler;
      handler = original._wrapper = function (e) {
        if (
          // no bubbling, should always fire.
          // this is just a safety net in case event.timeStamp is unreliable in
          // certain weird environments...
          e.target === e.currentTarget ||
          // event is fired after handler attachment
          e.timeStamp >= attachedTimestamp ||
          // bail for environments that have buggy event.timeStamp implementations
          // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
          // #9681 QtWebEngine event.timeStamp is negative value
          e.timeStamp <= 0 ||
          // #9448 bail if event is fired in another document in a multi-page
          // electron/nw.js app, since event.timeStamp will be using a different
          // starting reference
          e.target.ownerDocument !== document
        ) {
          return original.apply(this, arguments)
        }
      };
    }
    target$1$1.addEventListener(
      name,
      handler,
      supportsPassive
        ? { capture: capture, passive: passive }
        : capture
    );
  }

  function remove$2 (
    name,
    handler,
    capture,
    _target
  ) {
    (_target || target$1$1).removeEventListener(
      name,
      handler._wrapper || handler,
      capture
    );
  }

  function updateDOMListeners (oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
      return
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    target$1$1 = vnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
    target$1$1 = undefined;
  }

  var events = {
    create: updateDOMListeners,
    update: updateDOMListeners
  };

  /*  */

  var svgContainer;

  function updateDOMProps (oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
      return
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__)) {
      props = vnode.data.domProps = extend$1({}, props);
    }

    for (key in oldProps) {
      if (!(key in props)) {
        elm[key] = '';
      }
    }

    for (key in props) {
      cur = props[key];
      // ignore children if the node has textContent or innerHTML,
      // as these will throw away existing DOM nodes and cause removal errors
      // on subsequent patches (#3360)
      if (key === 'textContent' || key === 'innerHTML') {
        if (vnode.children) { vnode.children.length = 0; }
        if (cur === oldProps[key]) { continue }
        // #6601 work around Chrome version <= 55 bug where single textNode
        // replaced by innerHTML/textContent retains its parentNode property
        if (elm.childNodes.length === 1) {
          elm.removeChild(elm.childNodes[0]);
        }
      }

      if (key === 'value' && elm.tagName !== 'PROGRESS') {
        // store value as _value as well since
        // non-string values will be stringified
        elm._value = cur;
        // avoid resetting cursor position when value is the same
        var strCur = isUndef(cur) ? '' : String(cur);
        if (shouldUpdateValue(elm, strCur)) {
          elm.value = strCur;
        }
      } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
        // IE doesn't support innerHTML for SVG elements
        svgContainer = svgContainer || document.createElement('div');
        svgContainer.innerHTML = "<svg>" + cur + "</svg>";
        var svg = svgContainer.firstChild;
        while (elm.firstChild) {
          elm.removeChild(elm.firstChild);
        }
        while (svg.firstChild) {
          elm.appendChild(svg.firstChild);
        }
      } else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]
      ) {
        // some property updates can throw
        // e.g. `value` on <progress> w/ non-finite value
        try {
          elm[key] = cur;
        } catch (e) {}
      }
    }
  }

  // check platforms/web/util/attrs.js acceptValue


  function shouldUpdateValue (elm, checkVal) {
    return (!elm.composing && (
      elm.tagName === 'OPTION' ||
      isNotInFocusAndDirty(elm, checkVal) ||
      isDirtyWithModifiers(elm, checkVal)
    ))
  }

  function isNotInFocusAndDirty (elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try { notInFocus = document.activeElement !== elm; } catch (e) {}
    return notInFocus && elm.value !== checkVal
  }

  function isDirtyWithModifiers (elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
      if (modifiers.number) {
        return toNumber$2(value) !== toNumber$2(newVal)
      }
      if (modifiers.trim) {
        return value.trim() !== newVal.trim()
      }
    }
    return value !== newVal
  }

  var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
  };

  /*  */

  var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
      if (item) {
        var tmp = item.split(propertyDelimiter);
        tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
      }
    });
    return res
  });

  // merge static and dynamic style data on the same vnode
  function normalizeStyleData (data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle
      ? extend$1(data.staticStyle, style)
      : style
  }

  // normalize possible array / string values into Object
  function normalizeStyleBinding (bindingStyle) {
    if (Array.isArray(bindingStyle)) {
      return toObject(bindingStyle)
    }
    if (typeof bindingStyle === 'string') {
      return parseStyleText(bindingStyle)
    }
    return bindingStyle
  }

  /**
   * parent component style should be after child's
   * so that parent component's style could override it
   */
  function getStyle (vnode, checkChild) {
    var res = {};
    var styleData;

    if (checkChild) {
      var childNode = vnode;
      while (childNode.componentInstance) {
        childNode = childNode.componentInstance._vnode;
        if (
          childNode && childNode.data &&
          (styleData = normalizeStyleData(childNode.data))
        ) {
          extend$1(res, styleData);
        }
      }
    }

    if ((styleData = normalizeStyleData(vnode.data))) {
      extend$1(res, styleData);
    }

    var parentNode = vnode;
    while ((parentNode = parentNode.parent)) {
      if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
        extend$1(res, styleData);
      }
    }
    return res
  }

  /*  */

  var cssVarRE = /^--/;
  var importantRE = /\s*!important$/;
  var setProp = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
      el.style.setProperty(name, val);
    } else if (importantRE.test(val)) {
      el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    } else {
      var normalizedName = normalize(name);
      if (Array.isArray(val)) {
        // Support values array created by autoprefixer, e.g.
        // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
        // Set them one by one, and the browser will only set those it can recognize
        for (var i = 0, len = val.length; i < len; i++) {
          el.style[normalizedName] = val[i];
        }
      } else {
        el.style[normalizedName] = val;
      }
    }
  };

  var vendorNames = ['Webkit', 'Moz', 'ms'];

  var emptyStyle;
  var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && (prop in emptyStyle)) {
      return prop
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
      var name = vendorNames[i] + capName;
      if (name in emptyStyle) {
        return name
      }
    }
  });

  function updateStyle (oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;

    if (isUndef(data.staticStyle) && isUndef(data.style) &&
      isUndef(oldData.staticStyle) && isUndef(oldData.style)
    ) {
      return
    }

    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;

    var style = normalizeStyleBinding(vnode.data.style) || {};

    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__)
      ? extend$1({}, style)
      : style;

    var newStyle = getStyle(vnode, true);

    for (name in oldStyle) {
      if (isUndef(newStyle[name])) {
        setProp(el, name, '');
      }
    }
    for (name in newStyle) {
      cur = newStyle[name];
      if (cur !== oldStyle[name]) {
        // ie9 setting to null has no effect, must use empty string
        setProp(el, name, cur == null ? '' : cur);
      }
    }
  }

  var style = {
    create: updateStyle,
    update: updateStyle
  };

  /*  */

  var whitespaceRE = /\s+/;

  /**
   * Add class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */
  function addClass (el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
      return
    }

    /* istanbul ignore else */
    if (el.classList) {
      if (cls.indexOf(' ') > -1) {
        cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
      } else {
        el.classList.add(cls);
      }
    } else {
      var cur = " " + (el.getAttribute('class') || '') + " ";
      if (cur.indexOf(' ' + cls + ' ') < 0) {
        el.setAttribute('class', (cur + cls).trim());
      }
    }
  }

  /**
   * Remove class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */
  function removeClass (el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
      return
    }

    /* istanbul ignore else */
    if (el.classList) {
      if (cls.indexOf(' ') > -1) {
        cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
      } else {
        el.classList.remove(cls);
      }
      if (!el.classList.length) {
        el.removeAttribute('class');
      }
    } else {
      var cur = " " + (el.getAttribute('class') || '') + " ";
      var tar = ' ' + cls + ' ';
      while (cur.indexOf(tar) >= 0) {
        cur = cur.replace(tar, ' ');
      }
      cur = cur.trim();
      if (cur) {
        el.setAttribute('class', cur);
      } else {
        el.removeAttribute('class');
      }
    }
  }

  /*  */

  function resolveTransition (def$$1) {
    if (!def$$1) {
      return
    }
    /* istanbul ignore else */
    if (typeof def$$1 === 'object') {
      var res = {};
      if (def$$1.css !== false) {
        extend$1(res, autoCssTransition(def$$1.name || 'v'));
      }
      extend$1(res, def$$1);
      return res
    } else if (typeof def$$1 === 'string') {
      return autoCssTransition(def$$1)
    }
  }

  var autoCssTransition = cached(function (name) {
    return {
      enterClass: (name + "-enter"),
      enterToClass: (name + "-enter-to"),
      enterActiveClass: (name + "-enter-active"),
      leaveClass: (name + "-leave"),
      leaveToClass: (name + "-leave-to"),
      leaveActiveClass: (name + "-leave-active")
    }
  });

  var hasTransition = inBrowser && !isIE9;
  var TRANSITION = 'transition';
  var ANIMATION = 'animation';

  // Transition property/event sniffing
  var transitionProp = 'transition';
  var transitionEndEvent = 'transitionend';
  var animationProp = 'animation';
  var animationEndEvent = 'animationend';
  if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined &&
      window.onwebkittransitionend !== undefined
    ) {
      transitionProp = 'WebkitTransition';
      transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined &&
      window.onwebkitanimationend !== undefined
    ) {
      animationProp = 'WebkitAnimation';
      animationEndEvent = 'webkitAnimationEnd';
    }
  }

  // binding to window is necessary to make hot reload work in IE in strict mode
  var raf = inBrowser
    ? window.requestAnimationFrame
      ? window.requestAnimationFrame.bind(window)
      : setTimeout
    : /* istanbul ignore next */ function (fn) { return fn(); };

  function nextFrame (fn) {
    raf(function () {
      raf(fn);
    });
  }

  function addTransitionClass (el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
      transitionClasses.push(cls);
      addClass(el, cls);
    }
  }

  function removeTransitionClass (el, cls) {
    if (el._transitionClasses) {
      remove(el._transitionClasses, cls);
    }
    removeClass(el, cls);
  }

  function whenTransitionEnds (
    el,
    expectedType,
    cb
  ) {
    var ref = getTransitionInfo(el, expectedType);
    var type = ref.type;
    var timeout = ref.timeout;
    var propCount = ref.propCount;
    if (!type) { return cb() }
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function () {
      el.removeEventListener(event, onEnd);
      cb();
    };
    var onEnd = function (e) {
      if (e.target === el) {
        if (++ended >= propCount) {
          end();
        }
      }
    };
    setTimeout(function () {
      if (ended < propCount) {
        end();
      }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
  }

  var transformRE = /\b(transform|all)(,|$)/;

  function getTransitionInfo (el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);

    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
      if (transitionTimeout > 0) {
        type = TRANSITION;
        timeout = transitionTimeout;
        propCount = transitionDurations.length;
      }
    } else if (expectedType === ANIMATION) {
      if (animationTimeout > 0) {
        type = ANIMATION;
        timeout = animationTimeout;
        propCount = animationDurations.length;
      }
    } else {
      timeout = Math.max(transitionTimeout, animationTimeout);
      type = timeout > 0
        ? transitionTimeout > animationTimeout
          ? TRANSITION
          : ANIMATION
        : null;
      propCount = type
        ? type === TRANSITION
          ? transitionDurations.length
          : animationDurations.length
        : 0;
    }
    var hasTransform =
      type === TRANSITION &&
      transformRE.test(styles[transitionProp + 'Property']);
    return {
      type: type,
      timeout: timeout,
      propCount: propCount,
      hasTransform: hasTransform
    }
  }

  function getTimeout (delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
      delays = delays.concat(delays);
    }

    return Math.max.apply(null, durations.map(function (d, i) {
      return toMs(d) + toMs(delays[i])
    }))
  }

  // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
  // in a locale-dependent way, using a comma instead of a dot.
  // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
  // as a floor function) causing unexpected behaviors
  function toMs (s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000
  }

  /*  */

  function enter (vnode, toggleDisplay) {
    var el = vnode.elm;

    // call leave callback now
    if (isDef(el._leaveCb)) {
      el._leaveCb.cancelled = true;
      el._leaveCb();
    }

    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
      return
    }

    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
      return
    }

    var css = data.css;
    var type = data.type;
    var enterClass = data.enterClass;
    var enterToClass = data.enterToClass;
    var enterActiveClass = data.enterActiveClass;
    var appearClass = data.appearClass;
    var appearToClass = data.appearToClass;
    var appearActiveClass = data.appearActiveClass;
    var beforeEnter = data.beforeEnter;
    var enter = data.enter;
    var afterEnter = data.afterEnter;
    var enterCancelled = data.enterCancelled;
    var beforeAppear = data.beforeAppear;
    var appear = data.appear;
    var afterAppear = data.afterAppear;
    var appearCancelled = data.appearCancelled;
    var duration = data.duration;

    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
      context = transitionNode.context;
      transitionNode = transitionNode.parent;
    }

    var isAppear = !context._isMounted || !vnode.isRootInsert;

    if (isAppear && !appear && appear !== '') {
      return
    }

    var startClass = isAppear && appearClass
      ? appearClass
      : enterClass;
    var activeClass = isAppear && appearActiveClass
      ? appearActiveClass
      : enterActiveClass;
    var toClass = isAppear && appearToClass
      ? appearToClass
      : enterToClass;

    var beforeEnterHook = isAppear
      ? (beforeAppear || beforeEnter)
      : beforeEnter;
    var enterHook = isAppear
      ? (typeof appear === 'function' ? appear : enter)
      : enter;
    var afterEnterHook = isAppear
      ? (afterAppear || afterEnter)
      : afterEnter;
    var enterCancelledHook = isAppear
      ? (appearCancelled || enterCancelled)
      : enterCancelled;

    var explicitEnterDuration = toNumber$2(
      isObject$5(duration)
        ? duration.enter
        : duration
    );

    if (explicitEnterDuration != null) {
      checkDuration(explicitEnterDuration, 'enter', vnode);
    }

    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);

    var cb = el._enterCb = once$1(function () {
      if (expectsCSS) {
        removeTransitionClass(el, toClass);
        removeTransitionClass(el, activeClass);
      }
      if (cb.cancelled) {
        if (expectsCSS) {
          removeTransitionClass(el, startClass);
        }
        enterCancelledHook && enterCancelledHook(el);
      } else {
        afterEnterHook && afterEnterHook(el);
      }
      el._enterCb = null;
    });

    if (!vnode.data.show) {
      // remove pending leave element on enter by injecting an insert hook
      mergeVNodeHook(vnode, 'insert', function () {
        var parent = el.parentNode;
        var pendingNode = parent && parent._pending && parent._pending[vnode.key];
        if (pendingNode &&
          pendingNode.tag === vnode.tag &&
          pendingNode.elm._leaveCb
        ) {
          pendingNode.elm._leaveCb();
        }
        enterHook && enterHook(el, cb);
      });
    }

    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
      addTransitionClass(el, startClass);
      addTransitionClass(el, activeClass);
      nextFrame(function () {
        removeTransitionClass(el, startClass);
        if (!cb.cancelled) {
          addTransitionClass(el, toClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitEnterDuration)) {
              setTimeout(cb, explicitEnterDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }

    if (vnode.data.show) {
      toggleDisplay && toggleDisplay();
      enterHook && enterHook(el, cb);
    }

    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }

  function leave (vnode, rm) {
    var el = vnode.elm;

    // call enter callback now
    if (isDef(el._enterCb)) {
      el._enterCb.cancelled = true;
      el._enterCb();
    }

    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
      return rm()
    }

    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
      return
    }

    var css = data.css;
    var type = data.type;
    var leaveClass = data.leaveClass;
    var leaveToClass = data.leaveToClass;
    var leaveActiveClass = data.leaveActiveClass;
    var beforeLeave = data.beforeLeave;
    var leave = data.leave;
    var afterLeave = data.afterLeave;
    var leaveCancelled = data.leaveCancelled;
    var delayLeave = data.delayLeave;
    var duration = data.duration;

    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);

    var explicitLeaveDuration = toNumber$2(
      isObject$5(duration)
        ? duration.leave
        : duration
    );

    if (isDef(explicitLeaveDuration)) {
      checkDuration(explicitLeaveDuration, 'leave', vnode);
    }

    var cb = el._leaveCb = once$1(function () {
      if (el.parentNode && el.parentNode._pending) {
        el.parentNode._pending[vnode.key] = null;
      }
      if (expectsCSS) {
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
      }
      if (cb.cancelled) {
        if (expectsCSS) {
          removeTransitionClass(el, leaveClass);
        }
        leaveCancelled && leaveCancelled(el);
      } else {
        rm();
        afterLeave && afterLeave(el);
      }
      el._leaveCb = null;
    });

    if (delayLeave) {
      delayLeave(performLeave);
    } else {
      performLeave();
    }

    function performLeave () {
      // the delayed leave may have already been cancelled
      if (cb.cancelled) {
        return
      }
      // record leaving element
      if (!vnode.data.show && el.parentNode) {
        (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
      }
      beforeLeave && beforeLeave(el);
      if (expectsCSS) {
        addTransitionClass(el, leaveClass);
        addTransitionClass(el, leaveActiveClass);
        nextFrame(function () {
          removeTransitionClass(el, leaveClass);
          if (!cb.cancelled) {
            addTransitionClass(el, leaveToClass);
            if (!userWantsControl) {
              if (isValidDuration(explicitLeaveDuration)) {
                setTimeout(cb, explicitLeaveDuration);
              } else {
                whenTransitionEnds(el, type, cb);
              }
            }
          }
        });
      }
      leave && leave(el, cb);
      if (!expectsCSS && !userWantsControl) {
        cb();
      }
    }
  }

  // only used in dev mode
  function checkDuration (val, name, vnode) {
    if (typeof val !== 'number') {
      warn(
        "<transition> explicit " + name + " duration is not a valid number - " +
        "got " + (JSON.stringify(val)) + ".",
        vnode.context
      );
    } else if (isNaN(val)) {
      warn(
        "<transition> explicit " + name + " duration is NaN - " +
        'the duration expression might be incorrect.',
        vnode.context
      );
    }
  }

  function isValidDuration (val) {
    return typeof val === 'number' && !isNaN(val)
  }

  /**
   * Normalize a transition hook's argument length. The hook may be:
   * - a merged hook (invoker) with the original in .fns
   * - a wrapped component method (check ._length)
   * - a plain function (.length)
   */
  function getHookArgumentsLength (fn) {
    if (isUndef(fn)) {
      return false
    }
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
      // invoker
      return getHookArgumentsLength(
        Array.isArray(invokerFns)
          ? invokerFns[0]
          : invokerFns
      )
    } else {
      return (fn._length || fn.length) > 1
    }
  }

  function _enter (_, vnode) {
    if (vnode.data.show !== true) {
      enter(vnode);
    }
  }

  var transition = inBrowser ? {
    create: _enter,
    activate: _enter,
    remove: function remove$$1 (vnode, rm) {
      /* istanbul ignore else */
      if (vnode.data.show !== true) {
        leave(vnode, rm);
      } else {
        rm();
      }
    }
  } : {};

  var platformModules = [
    attrs,
    klass,
    events,
    domProps,
    style,
    transition
  ];

  /*  */

  // the directive module should be applied last, after all
  // built-in modules have been applied.
  var modules = platformModules.concat(baseModules);

  var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

  /**
   * Not type checking this file because flow doesn't like attaching
   * properties to Elements.
   */

  /* istanbul ignore if */
  if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
      var el = document.activeElement;
      if (el && el.vmodel) {
        trigger(el, 'input');
      }
    });
  }

  var directive = {
    inserted: function inserted (el, binding, vnode, oldVnode) {
      if (vnode.tag === 'select') {
        // #6903
        if (oldVnode.elm && !oldVnode.elm._vOptions) {
          mergeVNodeHook(vnode, 'postpatch', function () {
            directive.componentUpdated(el, binding, vnode);
          });
        } else {
          setSelected(el, binding, vnode.context);
        }
        el._vOptions = [].map.call(el.options, getValue);
      } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
        el._vModifiers = binding.modifiers;
        if (!binding.modifiers.lazy) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
          // Safari < 10.2 & UIWebView doesn't fire compositionend when
          // switching focus before confirming composition choice
          // this also fixes the issue where some browsers e.g. iOS Chrome
          // fires "change" instead of "input" on autocomplete.
          el.addEventListener('change', onCompositionEnd);
          /* istanbul ignore if */
          if (isIE9) {
            el.vmodel = true;
          }
        }
      }
    },

    componentUpdated: function componentUpdated (el, binding, vnode) {
      if (vnode.tag === 'select') {
        setSelected(el, binding, vnode.context);
        // in case the options rendered by v-for have changed,
        // it's possible that the value is out-of-sync with the rendered options.
        // detect such cases and filter out values that no longer has a matching
        // option in the DOM.
        var prevOptions = el._vOptions;
        var curOptions = el._vOptions = [].map.call(el.options, getValue);
        if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
          // trigger change event if
          // no matching option found for at least one value
          var needReset = el.multiple
            ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
            : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
          if (needReset) {
            trigger(el, 'change');
          }
        }
      }
    }
  };

  function setSelected (el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE || isEdge) {
      setTimeout(function () {
        actuallySetSelected(el, binding, vm);
      }, 0);
    }
  }

  function actuallySetSelected (el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
      warn(
        "<select multiple v-model=\"" + (binding.expression) + "\"> " +
        "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
        vm
      );
      return
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
      option = el.options[i];
      if (isMultiple) {
        selected = looseIndexOf(value, getValue(option)) > -1;
        if (option.selected !== selected) {
          option.selected = selected;
        }
      } else {
        if (looseEqual(getValue(option), value)) {
          if (el.selectedIndex !== i) {
            el.selectedIndex = i;
          }
          return
        }
      }
    }
    if (!isMultiple) {
      el.selectedIndex = -1;
    }
  }

  function hasNoMatchingOption (value, options) {
    return options.every(function (o) { return !looseEqual(o, value); })
  }

  function getValue (option) {
    return '_value' in option
      ? option._value
      : option.value
  }

  function onCompositionStart (e) {
    e.target.composing = true;
  }

  function onCompositionEnd (e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing) { return }
    e.target.composing = false;
    trigger(e.target, 'input');
  }

  function trigger (el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
  }

  /*  */

  // recursively search for possible transition defined inside the component root
  function locateNode (vnode) {
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
      ? locateNode(vnode.componentInstance._vnode)
      : vnode
  }

  var show = {
    bind: function bind (el, ref, vnode) {
      var value = ref.value;

      vnode = locateNode(vnode);
      var transition$$1 = vnode.data && vnode.data.transition;
      var originalDisplay = el.__vOriginalDisplay =
        el.style.display === 'none' ? '' : el.style.display;
      if (value && transition$$1) {
        vnode.data.show = true;
        enter(vnode, function () {
          el.style.display = originalDisplay;
        });
      } else {
        el.style.display = value ? originalDisplay : 'none';
      }
    },

    update: function update (el, ref, vnode) {
      var value = ref.value;
      var oldValue = ref.oldValue;

      /* istanbul ignore if */
      if (!value === !oldValue) { return }
      vnode = locateNode(vnode);
      var transition$$1 = vnode.data && vnode.data.transition;
      if (transition$$1) {
        vnode.data.show = true;
        if (value) {
          enter(vnode, function () {
            el.style.display = el.__vOriginalDisplay;
          });
        } else {
          leave(vnode, function () {
            el.style.display = 'none';
          });
        }
      } else {
        el.style.display = value ? el.__vOriginalDisplay : 'none';
      }
    },

    unbind: function unbind (
      el,
      binding,
      vnode,
      oldVnode,
      isDestroy
    ) {
      if (!isDestroy) {
        el.style.display = el.__vOriginalDisplay;
      }
    }
  };

  var platformDirectives = {
    model: directive,
    show: show
  };

  /*  */

  var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
  };

  // in case the child is also an abstract component, e.g. <keep-alive>
  // we want to recursively retrieve the real component to be rendered
  function getRealChild (vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
      return getRealChild(getFirstComponentChild(compOptions.children))
    } else {
      return vnode
    }
  }

  function extractTransitionData (comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
      data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key$1 in listeners) {
      data[camelize(key$1)] = listeners[key$1];
    }
    return data
  }

  function placeholder (h, rawChild) {
    if (/\d-keep-alive$/.test(rawChild.tag)) {
      return h('keep-alive', {
        props: rawChild.componentOptions.propsData
      })
    }
  }

  function hasParentTransition (vnode) {
    while ((vnode = vnode.parent)) {
      if (vnode.data.transition) {
        return true
      }
    }
  }

  function isSameChild (child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag
  }

  var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

  var isVShowDirective = function (d) { return d.name === 'show'; };

  var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,

    render: function render (h) {
      var this$1$1 = this;

      var children = this.$slots.default;
      if (!children) {
        return
      }

      // filter out text nodes (possible whitespaces)
      children = children.filter(isNotTextNode);
      /* istanbul ignore if */
      if (!children.length) {
        return
      }

      // warn multiple elements
      if (children.length > 1) {
        warn(
          '<transition> can only be used on a single element. Use ' +
          '<transition-group> for lists.',
          this.$parent
        );
      }

      var mode = this.mode;

      // warn invalid mode
      if (mode && mode !== 'in-out' && mode !== 'out-in'
      ) {
        warn(
          'invalid <transition> mode: ' + mode,
          this.$parent
        );
      }

      var rawChild = children[0];

      // if this is a component root node and the component's
      // parent container node also has transition, skip.
      if (hasParentTransition(this.$vnode)) {
        return rawChild
      }

      // apply transition data to child
      // use getRealChild() to ignore abstract components e.g. keep-alive
      var child = getRealChild(rawChild);
      /* istanbul ignore if */
      if (!child) {
        return rawChild
      }

      if (this._leaving) {
        return placeholder(h, rawChild)
      }

      // ensure a key that is unique to the vnode type and to this transition
      // component instance. This key will be used to remove pending leaving nodes
      // during entering.
      var id = "__transition-" + (this._uid) + "-";
      child.key = child.key == null
        ? child.isComment
          ? id + 'comment'
          : id + child.tag
        : isPrimitive(child.key)
          ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
          : child.key;

      var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
      var oldRawChild = this._vnode;
      var oldChild = getRealChild(oldRawChild);

      // mark v-show
      // so that the transition module can hand over the control to the directive
      if (child.data.directives && child.data.directives.some(isVShowDirective)) {
        child.data.show = true;
      }

      if (
        oldChild &&
        oldChild.data &&
        !isSameChild(child, oldChild) &&
        !isAsyncPlaceholder(oldChild) &&
        // #6687 component root is a comment node
        !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
      ) {
        // replace old child transition data with fresh one
        // important for dynamic transitions!
        var oldData = oldChild.data.transition = extend$1({}, data);
        // handle transition mode
        if (mode === 'out-in') {
          // return placeholder node and queue update when leave finishes
          this._leaving = true;
          mergeVNodeHook(oldData, 'afterLeave', function () {
            this$1$1._leaving = false;
            this$1$1.$forceUpdate();
          });
          return placeholder(h, rawChild)
        } else if (mode === 'in-out') {
          if (isAsyncPlaceholder(child)) {
            return oldRawChild
          }
          var delayedLeave;
          var performLeave = function () { delayedLeave(); };
          mergeVNodeHook(data, 'afterEnter', performLeave);
          mergeVNodeHook(data, 'enterCancelled', performLeave);
          mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
        }
      }

      return rawChild
    }
  };

  /*  */

  var props = extend$1({
    tag: String,
    moveClass: String
  }, transitionProps);

  delete props.mode;

  var TransitionGroup = {
    props: props,

    beforeMount: function beforeMount () {
      var this$1$1 = this;

      var update = this._update;
      this._update = function (vnode, hydrating) {
        var restoreActiveInstance = setActiveInstance(this$1$1);
        // force removing pass
        this$1$1.__patch__(
          this$1$1._vnode,
          this$1$1.kept,
          false, // hydrating
          true // removeOnly (!important, avoids unnecessary moves)
        );
        this$1$1._vnode = this$1$1.kept;
        restoreActiveInstance();
        update.call(this$1$1, vnode, hydrating);
      };
    },

    render: function render (h) {
      var tag = this.tag || this.$vnode.data.tag || 'span';
      var map = Object.create(null);
      var prevChildren = this.prevChildren = this.children;
      var rawChildren = this.$slots.default || [];
      var children = this.children = [];
      var transitionData = extractTransitionData(this);

      for (var i = 0; i < rawChildren.length; i++) {
        var c = rawChildren[i];
        if (c.tag) {
          if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
            children.push(c);
            map[c.key] = c
            ;(c.data || (c.data = {})).transition = transitionData;
          } else {
            var opts = c.componentOptions;
            var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
            warn(("<transition-group> children must be keyed: <" + name + ">"));
          }
        }
      }

      if (prevChildren) {
        var kept = [];
        var removed = [];
        for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
          var c$1 = prevChildren[i$1];
          c$1.data.transition = transitionData;
          c$1.data.pos = c$1.elm.getBoundingClientRect();
          if (map[c$1.key]) {
            kept.push(c$1);
          } else {
            removed.push(c$1);
          }
        }
        this.kept = h(tag, null, kept);
        this.removed = removed;
      }

      return h(tag, null, children)
    },

    updated: function updated () {
      var children = this.prevChildren;
      var moveClass = this.moveClass || ((this.name || 'v') + '-move');
      if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
        return
      }

      // we divide the work into three loops to avoid mixing DOM reads and writes
      // in each iteration - which helps prevent layout thrashing.
      children.forEach(callPendingCbs);
      children.forEach(recordPosition);
      children.forEach(applyTranslation);

      // force reflow to put everything in position
      // assign to this to avoid being removed in tree-shaking
      // $flow-disable-line
      this._reflow = document.body.offsetHeight;

      children.forEach(function (c) {
        if (c.data.moved) {
          var el = c.elm;
          var s = el.style;
          addTransitionClass(el, moveClass);
          s.transform = s.WebkitTransform = s.transitionDuration = '';
          el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
            if (e && e.target !== el) {
              return
            }
            if (!e || /transform$/.test(e.propertyName)) {
              el.removeEventListener(transitionEndEvent, cb);
              el._moveCb = null;
              removeTransitionClass(el, moveClass);
            }
          });
        }
      });
    },

    methods: {
      hasMove: function hasMove (el, moveClass) {
        /* istanbul ignore if */
        if (!hasTransition) {
          return false
        }
        /* istanbul ignore if */
        if (this._hasMove) {
          return this._hasMove
        }
        // Detect whether an element with the move class applied has
        // CSS transitions. Since the element may be inside an entering
        // transition at this very moment, we make a clone of it and remove
        // all other transition classes applied to ensure only the move class
        // is applied.
        var clone = el.cloneNode();
        if (el._transitionClasses) {
          el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
        }
        addClass(clone, moveClass);
        clone.style.display = 'none';
        this.$el.appendChild(clone);
        var info = getTransitionInfo(clone);
        this.$el.removeChild(clone);
        return (this._hasMove = info.hasTransform)
      }
    }
  };

  function callPendingCbs (c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
      c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
      c.elm._enterCb();
    }
  }

  function recordPosition (c) {
    c.data.newPos = c.elm.getBoundingClientRect();
  }

  function applyTranslation (c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
      c.data.moved = true;
      var s = c.elm.style;
      s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
      s.transitionDuration = '0s';
    }
  }

  var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
  };

  /*  */

  // install platform specific utils
  Vue$2.config.mustUseProp = mustUseProp;
  Vue$2.config.isReservedTag = isReservedTag;
  Vue$2.config.isReservedAttr = isReservedAttr;
  Vue$2.config.getTagNamespace = getTagNamespace;
  Vue$2.config.isUnknownElement = isUnknownElement;

  // install platform runtime directives & components
  extend$1(Vue$2.options.directives, platformDirectives);
  extend$1(Vue$2.options.components, platformComponents);

  // install platform patch function
  Vue$2.prototype.__patch__ = inBrowser ? patch : noop$1;

  // public mount method
  Vue$2.prototype.$mount = function (
    el,
    hydrating
  ) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating)
  };

  // devtools global hook
  /* istanbul ignore next */
  if (inBrowser) {
    setTimeout(function () {
      if (config$1.devtools) {
        if (devtools) {
          devtools.emit('init', Vue$2);
        } else {
          console[console.info ? 'info' : 'log'](
            'Download the Vue Devtools extension for a better development experience:\n' +
            'https://github.com/vuejs/vue-devtools'
          );
        }
      }
      if (config$1.productionTip !== false &&
        typeof console !== 'undefined'
      ) {
        console[console.info ? 'info' : 'log'](
          "You are running Vue in development mode.\n" +
          "Make sure to turn on production mode when deploying for production.\n" +
          "See more tips at https://vuejs.org/guide/deployment.html"
        );
      }
    }, 0);
  }

  /*  */

  var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

  var buildRegex = cached(function (delimiters) {
    var open = delimiters[0].replace(regexEscapeRE, '\\$&');
    var close = delimiters[1].replace(regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
  });



  function parseText (
    text,
    delimiters
  ) {
    var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
    if (!tagRE.test(text)) {
      return
    }
    var tokens = [];
    var rawTokens = [];
    var lastIndex = tagRE.lastIndex = 0;
    var match, index, tokenValue;
    while ((match = tagRE.exec(text))) {
      index = match.index;
      // push text token
      if (index > lastIndex) {
        rawTokens.push(tokenValue = text.slice(lastIndex, index));
        tokens.push(JSON.stringify(tokenValue));
      }
      // tag token
      var exp = parseFilters(match[1].trim());
      tokens.push(("_s(" + exp + ")"));
      rawTokens.push({ '@binding': exp });
      lastIndex = index + match[0].length;
    }
    if (lastIndex < text.length) {
      rawTokens.push(tokenValue = text.slice(lastIndex));
      tokens.push(JSON.stringify(tokenValue));
    }
    return {
      expression: tokens.join('+'),
      tokens: rawTokens
    }
  }

  /*  */

  function transformNode (el, options) {
    var warn = options.warn || baseWarn;
    var staticClass = getAndRemoveAttr(el, 'class');
    if (staticClass) {
      var res = parseText(staticClass, options.delimiters);
      if (res) {
        warn(
          "class=\"" + staticClass + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div class="{{ val }}">, use <div :class="val">.',
          el.rawAttrsMap['class']
        );
      }
    }
    if (staticClass) {
      el.staticClass = JSON.stringify(staticClass);
    }
    var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
    if (classBinding) {
      el.classBinding = classBinding;
    }
  }

  function genData (el) {
    var data = '';
    if (el.staticClass) {
      data += "staticClass:" + (el.staticClass) + ",";
    }
    if (el.classBinding) {
      data += "class:" + (el.classBinding) + ",";
    }
    return data
  }

  var klass$1 = {
    staticKeys: ['staticClass'],
    transformNode: transformNode,
    genData: genData
  };

  /*  */

  function transformNode$1 (el, options) {
    var warn = options.warn || baseWarn;
    var staticStyle = getAndRemoveAttr(el, 'style');
    if (staticStyle) {
      /* istanbul ignore if */
      {
        var res = parseText(staticStyle, options.delimiters);
        if (res) {
          warn(
            "style=\"" + staticStyle + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div style="{{ val }}">, use <div :style="val">.',
            el.rawAttrsMap['style']
          );
        }
      }
      el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
    }

    var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
    if (styleBinding) {
      el.styleBinding = styleBinding;
    }
  }

  function genData$1 (el) {
    var data = '';
    if (el.staticStyle) {
      data += "staticStyle:" + (el.staticStyle) + ",";
    }
    if (el.styleBinding) {
      data += "style:(" + (el.styleBinding) + "),";
    }
    return data
  }

  var style$1 = {
    staticKeys: ['staticStyle'],
    transformNode: transformNode$1,
    genData: genData$1
  };

  /*  */

  var decoder;

  var he = {
    decode: function decode (html) {
      decoder = decoder || document.createElement('div');
      decoder.innerHTML = html;
      return decoder.textContent
    }
  };

  /*  */

  var isUnaryTag = makeMap(
    'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
    'link,meta,param,source,track,wbr'
  );

  // Elements that you can, intentionally, leave open
  // (and which close themselves)
  var canBeLeftOpenTag = makeMap(
    'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
  );

  // HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
  // Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
  var isNonPhrasingTag = makeMap(
    'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
    'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
    'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
    'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
    'title,tr,track'
  );

  /**
   * Not type-checking this file because it's mostly vendor code.
   */

  // Regular Expressions for parsing tags and attributes
  var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
  var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
  var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
  var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
  var startTagOpen = new RegExp(("^<" + qnameCapture));
  var startTagClose = /^\s*(\/?)>/;
  var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
  var doctype = /^<!DOCTYPE [^>]+>/i;
  // #7298: escape - to avoid being passed as HTML comment when inlined in page
  var comment = /^<!\--/;
  var conditionalComment = /^<!\[/;

  // Special Elements (can contain anything)
  var isPlainTextElement = makeMap('script,style,textarea', true);
  var reCache = {};

  var decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
  };
  var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
  var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

  // #5992
  var isIgnoreNewlineTag = makeMap('pre,textarea', true);
  var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

  function decodeAttr (value, shouldDecodeNewlines) {
    var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
    return value.replace(re, function (match) { return decodingMap[match]; })
  }

  function parseHTML (html, options) {
    var stack = [];
    var expectHTML = options.expectHTML;
    var isUnaryTag$$1 = options.isUnaryTag || no;
    var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
    var index = 0;
    var last, lastTag;
    while (html) {
      last = html;
      // Make sure we're not in a plaintext content element like script/style
      if (!lastTag || !isPlainTextElement(lastTag)) {
        var textEnd = html.indexOf('<');
        if (textEnd === 0) {
          // Comment:
          if (comment.test(html)) {
            var commentEnd = html.indexOf('-->');

            if (commentEnd >= 0) {
              if (options.shouldKeepComment) {
                options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
              }
              advance(commentEnd + 3);
              continue
            }
          }

          // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
          if (conditionalComment.test(html)) {
            var conditionalEnd = html.indexOf(']>');

            if (conditionalEnd >= 0) {
              advance(conditionalEnd + 2);
              continue
            }
          }

          // Doctype:
          var doctypeMatch = html.match(doctype);
          if (doctypeMatch) {
            advance(doctypeMatch[0].length);
            continue
          }

          // End tag:
          var endTagMatch = html.match(endTag);
          if (endTagMatch) {
            var curIndex = index;
            advance(endTagMatch[0].length);
            parseEndTag(endTagMatch[1], curIndex, index);
            continue
          }

          // Start tag:
          var startTagMatch = parseStartTag();
          if (startTagMatch) {
            handleStartTag(startTagMatch);
            if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
              advance(1);
            }
            continue
          }
        }

        var text = (void 0), rest = (void 0), next = (void 0);
        if (textEnd >= 0) {
          rest = html.slice(textEnd);
          while (
            !endTag.test(rest) &&
            !startTagOpen.test(rest) &&
            !comment.test(rest) &&
            !conditionalComment.test(rest)
          ) {
            // < in plain text, be forgiving and treat it as text
            next = rest.indexOf('<', 1);
            if (next < 0) { break }
            textEnd += next;
            rest = html.slice(textEnd);
          }
          text = html.substring(0, textEnd);
        }

        if (textEnd < 0) {
          text = html;
        }

        if (text) {
          advance(text.length);
        }

        if (options.chars && text) {
          options.chars(text, index - text.length, index);
        }
      } else {
        var endTagLength = 0;
        var stackedTag = lastTag.toLowerCase();
        var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
        var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
          endTagLength = endTag.length;
          if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
            text = text
              .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
              .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
          }
          if (shouldIgnoreFirstNewline(stackedTag, text)) {
            text = text.slice(1);
          }
          if (options.chars) {
            options.chars(text);
          }
          return ''
        });
        index += html.length - rest$1.length;
        html = rest$1;
        parseEndTag(stackedTag, index - endTagLength, index);
      }

      if (html === last) {
        options.chars && options.chars(html);
        if (!stack.length && options.warn) {
          options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
        }
        break
      }
    }

    // Clean up any remaining tags
    parseEndTag();

    function advance (n) {
      index += n;
      html = html.substring(n);
    }

    function parseStartTag () {
      var start = html.match(startTagOpen);
      if (start) {
        var match = {
          tagName: start[1],
          attrs: [],
          start: index
        };
        advance(start[0].length);
        var end, attr;
        while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
          attr.start = index;
          advance(attr[0].length);
          attr.end = index;
          match.attrs.push(attr);
        }
        if (end) {
          match.unarySlash = end[1];
          advance(end[0].length);
          match.end = index;
          return match
        }
      }
    }

    function handleStartTag (match) {
      var tagName = match.tagName;
      var unarySlash = match.unarySlash;

      if (expectHTML) {
        if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
          parseEndTag(lastTag);
        }
        if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
          parseEndTag(tagName);
        }
      }

      var unary = isUnaryTag$$1(tagName) || !!unarySlash;

      var l = match.attrs.length;
      var attrs = new Array(l);
      for (var i = 0; i < l; i++) {
        var args = match.attrs[i];
        var value = args[3] || args[4] || args[5] || '';
        var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
          ? options.shouldDecodeNewlinesForHref
          : options.shouldDecodeNewlines;
        attrs[i] = {
          name: args[1],
          value: decodeAttr(value, shouldDecodeNewlines)
        };
        if (options.outputSourceRange) {
          attrs[i].start = args.start + args[0].match(/^\s*/).length;
          attrs[i].end = args.end;
        }
      }

      if (!unary) {
        stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
        lastTag = tagName;
      }

      if (options.start) {
        options.start(tagName, attrs, unary, match.start, match.end);
      }
    }

    function parseEndTag (tagName, start, end) {
      var pos, lowerCasedTagName;
      if (start == null) { start = index; }
      if (end == null) { end = index; }

      // Find the closest opened tag of the same type
      if (tagName) {
        lowerCasedTagName = tagName.toLowerCase();
        for (pos = stack.length - 1; pos >= 0; pos--) {
          if (stack[pos].lowerCasedTag === lowerCasedTagName) {
            break
          }
        }
      } else {
        // If no tag name is provided, clean shop
        pos = 0;
      }

      if (pos >= 0) {
        // Close all the open elements, up the stack
        for (var i = stack.length - 1; i >= pos; i--) {
          if (i > pos || !tagName &&
            options.warn
          ) {
            options.warn(
              ("tag <" + (stack[i].tag) + "> has no matching end tag."),
              { start: stack[i].start, end: stack[i].end }
            );
          }
          if (options.end) {
            options.end(stack[i].tag, start, end);
          }
        }

        // Remove the open elements from the stack
        stack.length = pos;
        lastTag = pos && stack[pos - 1].tag;
      } else if (lowerCasedTagName === 'br') {
        if (options.start) {
          options.start(tagName, [], true, start, end);
        }
      } else if (lowerCasedTagName === 'p') {
        if (options.start) {
          options.start(tagName, [], false, start, end);
        }
        if (options.end) {
          options.end(tagName, start, end);
        }
      }
    }
  }

  /*  */

  var onRE = /^@|^v-on:/;
  var dirRE = /^v-|^@|^:|^#/;
  var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
  var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  var stripParensRE = /^\(|\)$/g;
  var dynamicArgRE = /^\[.*\]$/;

  var argRE = /:(.*)$/;
  var bindRE = /^:|^\.|^v-bind:/;
  var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

  var slotRE = /^v-slot(:|$)|^#/;

  var lineBreakRE = /[\r\n]/;
  var whitespaceRE$1 = /\s+/g;

  var invalidAttributeRE = /[\s"'<>\/=]/;

  var decodeHTMLCached = cached(he.decode);

  var emptySlotScopeToken = "_empty_";

  // configurable state
  var warn$2;
  var delimiters;
  var transforms;
  var preTransforms;
  var postTransforms;
  var platformIsPreTag;
  var platformMustUseProp;
  var platformGetTagNamespace;
  var maybeComponent;

  function createASTElement (
    tag,
    attrs,
    parent
  ) {
    return {
      type: 1,
      tag: tag,
      attrsList: attrs,
      attrsMap: makeAttrsMap(attrs),
      rawAttrsMap: {},
      parent: parent,
      children: []
    }
  }

  /**
   * Convert HTML string to AST.
   */
  function parse (
    template,
    options
  ) {
    warn$2 = options.warn || baseWarn;

    platformIsPreTag = options.isPreTag || no;
    platformMustUseProp = options.mustUseProp || no;
    platformGetTagNamespace = options.getTagNamespace || no;
    var isReservedTag = options.isReservedTag || no;
    maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

    transforms = pluckModuleFunction(options.modules, 'transformNode');
    preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
    postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

    delimiters = options.delimiters;

    var stack = [];
    var preserveWhitespace = options.preserveWhitespace !== false;
    var whitespaceOption = options.whitespace;
    var root;
    var currentParent;
    var inVPre = false;
    var inPre = false;
    var warned = false;

    function warnOnce (msg, range) {
      if (!warned) {
        warned = true;
        warn$2(msg, range);
      }
    }

    function closeElement (element) {
      trimEndingWhitespace(element);
      if (!inVPre && !element.processed) {
        element = processElement(element, options);
      }
      // tree management
      if (!stack.length && element !== root) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          {
            checkRootConstraints(element);
          }
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead.",
            { start: element.start }
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else {
          if (element.slotScope) {
            // scoped slot
            // keep it in the children list so that v-else(-if) conditions can
            // find it as the prev node.
            var name = element.slotTarget || '"default"'
            ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
          }
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }

      // final children cleanup
      // filter out scoped slots
      element.children = element.children.filter(function (c) { return !(c).slotScope; });
      // remove trailing whitespace node again
      trimEndingWhitespace(element);

      // check pre state
      if (element.pre) {
        inVPre = false;
      }
      if (platformIsPreTag(element.tag)) {
        inPre = false;
      }
      // apply post-transforms
      for (var i = 0; i < postTransforms.length; i++) {
        postTransforms[i](element, options);
      }
    }

    function trimEndingWhitespace (el) {
      // remove trailing whitespace node
      if (!inPre) {
        var lastNode;
        while (
          (lastNode = el.children[el.children.length - 1]) &&
          lastNode.type === 3 &&
          lastNode.text === ' '
        ) {
          el.children.pop();
        }
      }
    }

    function checkRootConstraints (el) {
      if (el.tag === 'slot' || el.tag === 'template') {
        warnOnce(
          "Cannot use <" + (el.tag) + "> as component root element because it may " +
          'contain multiple nodes.',
          { start: el.start }
        );
      }
      if (el.attrsMap.hasOwnProperty('v-for')) {
        warnOnce(
          'Cannot use v-for on stateful component root element because ' +
          'it renders multiple elements.',
          el.rawAttrsMap['v-for']
        );
      }
    }

    parseHTML(template, {
      warn: warn$2,
      expectHTML: options.expectHTML,
      isUnaryTag: options.isUnaryTag,
      canBeLeftOpenTag: options.canBeLeftOpenTag,
      shouldDecodeNewlines: options.shouldDecodeNewlines,
      shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
      shouldKeepComment: options.comments,
      outputSourceRange: options.outputSourceRange,
      start: function start (tag, attrs, unary, start$1, end) {
        // check namespace.
        // inherit parent ns if there is one
        var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

        // handle IE svg bug
        /* istanbul ignore if */
        if (isIE && ns === 'svg') {
          attrs = guardIESVGBug(attrs);
        }

        var element = createASTElement(tag, attrs, currentParent);
        if (ns) {
          element.ns = ns;
        }

        {
          if (options.outputSourceRange) {
            element.start = start$1;
            element.end = end;
            element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
              cumulated[attr.name] = attr;
              return cumulated
            }, {});
          }
          attrs.forEach(function (attr) {
            if (invalidAttributeRE.test(attr.name)) {
              warn$2(
                "Invalid dynamic argument expression: attribute names cannot contain " +
                "spaces, quotes, <, >, / or =.",
                {
                  start: attr.start + attr.name.indexOf("["),
                  end: attr.start + attr.name.length
                }
              );
            }
          });
        }

        if (isForbiddenTag(element) && !isServerRendering()) {
          element.forbidden = true;
          warn$2(
            'Templates should only be responsible for mapping the state to the ' +
            'UI. Avoid placing tags with side-effects in your templates, such as ' +
            "<" + tag + ">" + ', as they will not be parsed.',
            { start: element.start }
          );
        }

        // apply pre-transforms
        for (var i = 0; i < preTransforms.length; i++) {
          element = preTransforms[i](element, options) || element;
        }

        if (!inVPre) {
          processPre(element);
          if (element.pre) {
            inVPre = true;
          }
        }
        if (platformIsPreTag(element.tag)) {
          inPre = true;
        }
        if (inVPre) {
          processRawAttrs(element);
        } else if (!element.processed) {
          // structural directives
          processFor(element);
          processIf(element);
          processOnce(element);
        }

        if (!root) {
          root = element;
          {
            checkRootConstraints(root);
          }
        }

        if (!unary) {
          currentParent = element;
          stack.push(element);
        } else {
          closeElement(element);
        }
      },

      end: function end (tag, start, end$1) {
        var element = stack[stack.length - 1];
        // pop stack
        stack.length -= 1;
        currentParent = stack[stack.length - 1];
        if (options.outputSourceRange) {
          element.end = end$1;
        }
        closeElement(element);
      },

      chars: function chars (text, start, end) {
        if (!currentParent) {
          {
            if (text === template) {
              warnOnce(
                'Component template requires a root element, rather than just text.',
                { start: start }
              );
            } else if ((text = text.trim())) {
              warnOnce(
                ("text \"" + text + "\" outside root element will be ignored."),
                { start: start }
              );
            }
          }
          return
        }
        // IE textarea placeholder bug
        /* istanbul ignore if */
        if (isIE &&
          currentParent.tag === 'textarea' &&
          currentParent.attrsMap.placeholder === text
        ) {
          return
        }
        var children = currentParent.children;
        if (inPre || text.trim()) {
          text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
        } else if (!children.length) {
          // remove the whitespace-only node right after an opening tag
          text = '';
        } else if (whitespaceOption) {
          if (whitespaceOption === 'condense') {
            // in condense mode, remove the whitespace node if it contains
            // line break, otherwise condense to a single space
            text = lineBreakRE.test(text) ? '' : ' ';
          } else {
            text = ' ';
          }
        } else {
          text = preserveWhitespace ? ' ' : '';
        }
        if (text) {
          if (!inPre && whitespaceOption === 'condense') {
            // condense consecutive whitespaces into single space
            text = text.replace(whitespaceRE$1, ' ');
          }
          var res;
          var child;
          if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
            child = {
              type: 2,
              expression: res.expression,
              tokens: res.tokens,
              text: text
            };
          } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
            child = {
              type: 3,
              text: text
            };
          }
          if (child) {
            if (options.outputSourceRange) {
              child.start = start;
              child.end = end;
            }
            children.push(child);
          }
        }
      },
      comment: function comment (text, start, end) {
        // adding anything as a sibling to the root node is forbidden
        // comments should still be allowed, but ignored
        if (currentParent) {
          var child = {
            type: 3,
            text: text,
            isComment: true
          };
          if (options.outputSourceRange) {
            child.start = start;
            child.end = end;
          }
          currentParent.children.push(child);
        }
      }
    });
    return root
  }

  function processPre (el) {
    if (getAndRemoveAttr(el, 'v-pre') != null) {
      el.pre = true;
    }
  }

  function processRawAttrs (el) {
    var list = el.attrsList;
    var len = list.length;
    if (len) {
      var attrs = el.attrs = new Array(len);
      for (var i = 0; i < len; i++) {
        attrs[i] = {
          name: list[i].name,
          value: JSON.stringify(list[i].value)
        };
        if (list[i].start != null) {
          attrs[i].start = list[i].start;
          attrs[i].end = list[i].end;
        }
      }
    } else if (!el.pre) {
      // non root node in pre blocks with no attributes
      el.plain = true;
    }
  }

  function processElement (
    element,
    options
  ) {
    processKey(element);

    // determine whether this is a plain element after
    // removing structural attributes
    element.plain = (
      !element.key &&
      !element.scopedSlots &&
      !element.attrsList.length
    );

    processRef(element);
    processSlotContent(element);
    processSlotOutlet(element);
    processComponent(element);
    for (var i = 0; i < transforms.length; i++) {
      element = transforms[i](element, options) || element;
    }
    processAttrs(element);
    return element
  }

  function processKey (el) {
    var exp = getBindingAttr(el, 'key');
    if (exp) {
      {
        if (el.tag === 'template') {
          warn$2(
            "<template> cannot be keyed. Place the key on real elements instead.",
            getRawBindingAttr(el, 'key')
          );
        }
        if (el.for) {
          var iterator = el.iterator2 || el.iterator1;
          var parent = el.parent;
          if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
            warn$2(
              "Do not use v-for index as key on <transition-group> children, " +
              "this is the same as not using keys.",
              getRawBindingAttr(el, 'key'),
              true /* tip */
            );
          }
        }
      }
      el.key = exp;
    }
  }

  function processRef (el) {
    var ref = getBindingAttr(el, 'ref');
    if (ref) {
      el.ref = ref;
      el.refInFor = checkInFor(el);
    }
  }

  function processFor (el) {
    var exp;
    if ((exp = getAndRemoveAttr(el, 'v-for'))) {
      var res = parseFor(exp);
      if (res) {
        extend$1(el, res);
      } else {
        warn$2(
          ("Invalid v-for expression: " + exp),
          el.rawAttrsMap['v-for']
        );
      }
    }
  }



  function parseFor (exp) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch) { return }
    var res = {};
    res.for = inMatch[2].trim();
    var alias = inMatch[1].trim().replace(stripParensRE, '');
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
      res.alias = alias.replace(forIteratorRE, '').trim();
      res.iterator1 = iteratorMatch[1].trim();
      if (iteratorMatch[2]) {
        res.iterator2 = iteratorMatch[2].trim();
      }
    } else {
      res.alias = alias;
    }
    return res
  }

  function processIf (el) {
    var exp = getAndRemoveAttr(el, 'v-if');
    if (exp) {
      el.if = exp;
      addIfCondition(el, {
        exp: exp,
        block: el
      });
    } else {
      if (getAndRemoveAttr(el, 'v-else') != null) {
        el.else = true;
      }
      var elseif = getAndRemoveAttr(el, 'v-else-if');
      if (elseif) {
        el.elseif = elseif;
      }
    }
  }

  function processIfConditions (el, parent) {
    var prev = findPrevElement(parent.children);
    if (prev && prev.if) {
      addIfCondition(prev, {
        exp: el.elseif,
        block: el
      });
    } else {
      warn$2(
        "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
        "used on element <" + (el.tag) + "> without corresponding v-if.",
        el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
      );
    }
  }

  function findPrevElement (children) {
    var i = children.length;
    while (i--) {
      if (children[i].type === 1) {
        return children[i]
      } else {
        if (children[i].text !== ' ') {
          warn$2(
            "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
            "will be ignored.",
            children[i]
          );
        }
        children.pop();
      }
    }
  }

  function addIfCondition (el, condition) {
    if (!el.ifConditions) {
      el.ifConditions = [];
    }
    el.ifConditions.push(condition);
  }

  function processOnce (el) {
    var once$$1 = getAndRemoveAttr(el, 'v-once');
    if (once$$1 != null) {
      el.once = true;
    }
  }

  // handle content being passed to a component as slot,
  // e.g. <template slot="xxx">, <div slot-scope="xxx">
  function processSlotContent (el) {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (slotScope) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          el.rawAttrsMap['scope'],
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (el.attrsMap['v-for']) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          el.rawAttrsMap['slot-scope'],
          true
        );
      }
      el.slotScope = slotScope;
    }

    // slot="xxx"
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
      }
    }

    // 2.6 v-slot syntax
    {
      if (el.tag === 'template') {
        // v-slot on <template>
        var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
        if (slotBinding) {
          {
            if (el.slotTarget || el.slotScope) {
              warn$2(
                "Unexpected mixed usage of different slot syntaxes.",
                el
              );
            }
            if (el.parent && !maybeComponent(el.parent)) {
              warn$2(
                "<template v-slot> can only appear at the root level inside " +
                "the receiving component",
                el
              );
            }
          }
          var ref = getSlotName(slotBinding);
          var name = ref.name;
          var dynamic = ref.dynamic;
          el.slotTarget = name;
          el.slotTargetDynamic = dynamic;
          el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
        }
      } else {
        // v-slot on component, denotes default slot
        var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
        if (slotBinding$1) {
          {
            if (!maybeComponent(el)) {
              warn$2(
                "v-slot can only be used on components or <template>.",
                slotBinding$1
              );
            }
            if (el.slotScope || el.slotTarget) {
              warn$2(
                "Unexpected mixed usage of different slot syntaxes.",
                el
              );
            }
            if (el.scopedSlots) {
              warn$2(
                "To avoid scope ambiguity, the default slot should also use " +
                "<template> syntax when there are other named slots.",
                slotBinding$1
              );
            }
          }
          // add the component's children to its default slot
          var slots = el.scopedSlots || (el.scopedSlots = {});
          var ref$1 = getSlotName(slotBinding$1);
          var name$1 = ref$1.name;
          var dynamic$1 = ref$1.dynamic;
          var slotContainer = slots[name$1] = createASTElement('template', [], el);
          slotContainer.slotTarget = name$1;
          slotContainer.slotTargetDynamic = dynamic$1;
          slotContainer.children = el.children.filter(function (c) {
            if (!c.slotScope) {
              c.parent = slotContainer;
              return true
            }
          });
          slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
          // remove children as they are returned from scopedSlots now
          el.children = [];
          // mark el non-plain so data gets generated
          el.plain = false;
        }
      }
    }
  }

  function getSlotName (binding) {
    var name = binding.name.replace(slotRE, '');
    if (!name) {
      if (binding.name[0] !== '#') {
        name = 'default';
      } else {
        warn$2(
          "v-slot shorthand syntax requires a slot name.",
          binding
        );
      }
    }
    return dynamicArgRE.test(name)
      // dynamic [name]
      ? { name: name.slice(1, -1), dynamic: true }
      // static name
      : { name: ("\"" + name + "\""), dynamic: false }
  }

  // handle <slot/> outlets
  function processSlotOutlet (el) {
    if (el.tag === 'slot') {
      el.slotName = getBindingAttr(el, 'name');
      if (el.key) {
        warn$2(
          "`key` does not work on <slot> because slots are abstract outlets " +
          "and can possibly expand into multiple elements. " +
          "Use the key on a wrapping element instead.",
          getRawBindingAttr(el, 'key')
        );
      }
    }
  }

  function processComponent (el) {
    var binding;
    if ((binding = getBindingAttr(el, 'is'))) {
      el.component = binding;
    }
    if (getAndRemoveAttr(el, 'inline-template') != null) {
      el.inlineTemplate = true;
    }
  }

  function processAttrs (el) {
    var list = el.attrsList;
    var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
    for (i = 0, l = list.length; i < l; i++) {
      name = rawName = list[i].name;
      value = list[i].value;
      if (dirRE.test(name)) {
        // mark element as dynamic
        el.hasBindings = true;
        // modifiers
        modifiers = parseModifiers(name.replace(dirRE, ''));
        // support .foo shorthand syntax for the .prop modifier
        if (modifiers) {
          name = name.replace(modifierRE, '');
        }
        if (bindRE.test(name)) { // v-bind
          name = name.replace(bindRE, '');
          value = parseFilters(value);
          isDynamic = dynamicArgRE.test(name);
          if (isDynamic) {
            name = name.slice(1, -1);
          }
          if (
            value.trim().length === 0
          ) {
            warn$2(
              ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
            );
          }
          if (modifiers) {
            if (modifiers.prop && !isDynamic) {
              name = camelize(name);
              if (name === 'innerHtml') { name = 'innerHTML'; }
            }
            if (modifiers.camel && !isDynamic) {
              name = camelize(name);
            }
            if (modifiers.sync) {
              syncGen = genAssignmentCode(value, "$event");
              if (!isDynamic) {
                addHandler(
                  el,
                  ("update:" + (camelize(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
                if (hyphenate(name) !== camelize(name)) {
                  addHandler(
                    el,
                    ("update:" + (hyphenate(name))),
                    syncGen,
                    null,
                    false,
                    warn$2,
                    list[i]
                  );
                }
              } else {
                // handler w/ dynamic event name
                addHandler(
                  el,
                  ("\"update:\"+(" + name + ")"),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i],
                  true // dynamic
                );
              }
            }
          }
          if ((modifiers && modifiers.prop) || (
            !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
          )) {
            addProp(el, name, value, list[i], isDynamic);
          } else {
            addAttr(el, name, value, list[i], isDynamic);
          }
        } else if (onRE.test(name)) { // v-on
          name = name.replace(onRE, '');
          isDynamic = dynamicArgRE.test(name);
          if (isDynamic) {
            name = name.slice(1, -1);
          }
          addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
        } else { // normal directives
          name = name.replace(dirRE, '');
          // parse arg
          var argMatch = name.match(argRE);
          var arg = argMatch && argMatch[1];
          isDynamic = false;
          if (arg) {
            name = name.slice(0, -(arg.length + 1));
            if (dynamicArgRE.test(arg)) {
              arg = arg.slice(1, -1);
              isDynamic = true;
            }
          }
          addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
          if (name === 'model') {
            checkForAliasModel(el, value);
          }
        }
      } else {
        // literal attribute
        {
          var res = parseText(value, delimiters);
          if (res) {
            warn$2(
              name + "=\"" + value + "\": " +
              'Interpolation inside attributes has been removed. ' +
              'Use v-bind or the colon shorthand instead. For example, ' +
              'instead of <div id="{{ val }}">, use <div :id="val">.',
              list[i]
            );
          }
        }
        addAttr(el, name, JSON.stringify(value), list[i]);
        // #6887 firefox doesn't update muted state if set via attribute
        // even immediately after element creation
        if (!el.component &&
            name === 'muted' &&
            platformMustUseProp(el.tag, el.attrsMap.type, name)) {
          addProp(el, name, 'true', list[i]);
        }
      }
    }
  }

  function checkInFor (el) {
    var parent = el;
    while (parent) {
      if (parent.for !== undefined) {
        return true
      }
      parent = parent.parent;
    }
    return false
  }

  function parseModifiers (name) {
    var match = name.match(modifierRE);
    if (match) {
      var ret = {};
      match.forEach(function (m) { ret[m.slice(1)] = true; });
      return ret
    }
  }

  function makeAttrsMap (attrs) {
    var map = {};
    for (var i = 0, l = attrs.length; i < l; i++) {
      if (
        map[attrs[i].name] && !isIE && !isEdge
      ) {
        warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
      }
      map[attrs[i].name] = attrs[i].value;
    }
    return map
  }

  // for script (e.g. type="x/template") or style, do not decode content
  function isTextTag (el) {
    return el.tag === 'script' || el.tag === 'style'
  }

  function isForbiddenTag (el) {
    return (
      el.tag === 'style' ||
      (el.tag === 'script' && (
        !el.attrsMap.type ||
        el.attrsMap.type === 'text/javascript'
      ))
    )
  }

  var ieNSBug = /^xmlns:NS\d+/;
  var ieNSPrefix = /^NS\d+:/;

  /* istanbul ignore next */
  function guardIESVGBug (attrs) {
    var res = [];
    for (var i = 0; i < attrs.length; i++) {
      var attr = attrs[i];
      if (!ieNSBug.test(attr.name)) {
        attr.name = attr.name.replace(ieNSPrefix, '');
        res.push(attr);
      }
    }
    return res
  }

  function checkForAliasModel (el, value) {
    var _el = el;
    while (_el) {
      if (_el.for && _el.alias === value) {
        warn$2(
          "<" + (el.tag) + " v-model=\"" + value + "\">: " +
          "You are binding v-model directly to a v-for iteration alias. " +
          "This will not be able to modify the v-for source array because " +
          "writing to the alias is like modifying a function local variable. " +
          "Consider using an array of objects and use v-model on an object property instead.",
          el.rawAttrsMap['v-model']
        );
      }
      _el = _el.parent;
    }
  }

  /*  */

  function preTransformNode (el, options) {
    if (el.tag === 'input') {
      var map = el.attrsMap;
      if (!map['v-model']) {
        return
      }

      var typeBinding;
      if (map[':type'] || map['v-bind:type']) {
        typeBinding = getBindingAttr(el, 'type');
      }
      if (!map.type && !typeBinding && map['v-bind']) {
        typeBinding = "(" + (map['v-bind']) + ").type";
      }

      if (typeBinding) {
        var ifCondition = getAndRemoveAttr(el, 'v-if', true);
        var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
        var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
        var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
        // 1. checkbox
        var branch0 = cloneASTElement(el);
        // process for on the main node
        processFor(branch0);
        addRawAttr(branch0, 'type', 'checkbox');
        processElement(branch0, options);
        branch0.processed = true; // prevent it from double-processed
        branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
        addIfCondition(branch0, {
          exp: branch0.if,
          block: branch0
        });
        // 2. add radio else-if condition
        var branch1 = cloneASTElement(el);
        getAndRemoveAttr(branch1, 'v-for', true);
        addRawAttr(branch1, 'type', 'radio');
        processElement(branch1, options);
        addIfCondition(branch0, {
          exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
          block: branch1
        });
        // 3. other
        var branch2 = cloneASTElement(el);
        getAndRemoveAttr(branch2, 'v-for', true);
        addRawAttr(branch2, ':type', typeBinding);
        processElement(branch2, options);
        addIfCondition(branch0, {
          exp: ifCondition,
          block: branch2
        });

        if (hasElse) {
          branch0.else = true;
        } else if (elseIfCondition) {
          branch0.elseif = elseIfCondition;
        }

        return branch0
      }
    }
  }

  function cloneASTElement (el) {
    return createASTElement(el.tag, el.attrsList.slice(), el.parent)
  }

  var model$1 = {
    preTransformNode: preTransformNode
  };

  var modules$1 = [
    klass$1,
    style$1,
    model$1
  ];

  /*  */

  function text (el, dir) {
    if (dir.value) {
      addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
    }
  }

  /*  */

  function html (el, dir) {
    if (dir.value) {
      addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
    }
  }

  var directives$1 = {
    model: model,
    text: text,
    html: html
  };

  /*  */

  var baseOptions = {
    expectHTML: true,
    modules: modules$1,
    directives: directives$1,
    isPreTag: isPreTag,
    isUnaryTag: isUnaryTag,
    mustUseProp: mustUseProp,
    canBeLeftOpenTag: canBeLeftOpenTag,
    isReservedTag: isReservedTag,
    getTagNamespace: getTagNamespace,
    staticKeys: genStaticKeys(modules$1)
  };

  /*  */

  var isStaticKey;
  var isPlatformReservedTag;

  var genStaticKeysCached = cached(genStaticKeys$1);

  /**
   * Goal of the optimizer: walk the generated template AST tree
   * and detect sub-trees that are purely static, i.e. parts of
   * the DOM that never needs to change.
   *
   * Once we detect these sub-trees, we can:
   *
   * 1. Hoist them into constants, so that we no longer need to
   *    create fresh nodes for them on each re-render;
   * 2. Completely skip them in the patching process.
   */
  function optimize (root, options) {
    if (!root) { return }
    isStaticKey = genStaticKeysCached(options.staticKeys || '');
    isPlatformReservedTag = options.isReservedTag || no;
    // first pass: mark all non-static nodes.
    markStatic$1(root);
    // second pass: mark static roots.
    markStaticRoots(root, false);
  }

  function genStaticKeys$1 (keys) {
    return makeMap(
      'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
      (keys ? ',' + keys : '')
    )
  }

  function markStatic$1 (node) {
    node.static = isStatic(node);
    if (node.type === 1) {
      // do not make component slot content static. this avoids
      // 1. components not able to mutate slot nodes
      // 2. static slot content fails for hot-reloading
      if (
        !isPlatformReservedTag(node.tag) &&
        node.tag !== 'slot' &&
        node.attrsMap['inline-template'] == null
      ) {
        return
      }
      for (var i = 0, l = node.children.length; i < l; i++) {
        var child = node.children[i];
        markStatic$1(child);
        if (!child.static) {
          node.static = false;
        }
      }
      if (node.ifConditions) {
        for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
          var block = node.ifConditions[i$1].block;
          markStatic$1(block);
          if (!block.static) {
            node.static = false;
          }
        }
      }
    }
  }

  function markStaticRoots (node, isInFor) {
    if (node.type === 1) {
      if (node.static || node.once) {
        node.staticInFor = isInFor;
      }
      // For a node to qualify as a static root, it should have children that
      // are not just static text. Otherwise the cost of hoisting out will
      // outweigh the benefits and it's better off to just always render it fresh.
      if (node.static && node.children.length && !(
        node.children.length === 1 &&
        node.children[0].type === 3
      )) {
        node.staticRoot = true;
        return
      } else {
        node.staticRoot = false;
      }
      if (node.children) {
        for (var i = 0, l = node.children.length; i < l; i++) {
          markStaticRoots(node.children[i], isInFor || !!node.for);
        }
      }
      if (node.ifConditions) {
        for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
          markStaticRoots(node.ifConditions[i$1].block, isInFor);
        }
      }
    }
  }

  function isStatic (node) {
    if (node.type === 2) { // expression
      return false
    }
    if (node.type === 3) { // text
      return true
    }
    return !!(node.pre || (
      !node.hasBindings && // no dynamic bindings
      !node.if && !node.for && // not v-if or v-for or v-else
      !isBuiltInTag(node.tag) && // not a built-in
      isPlatformReservedTag(node.tag) && // not a component
      !isDirectChildOfTemplateFor(node) &&
      Object.keys(node).every(isStaticKey)
    ))
  }

  function isDirectChildOfTemplateFor (node) {
    while (node.parent) {
      node = node.parent;
      if (node.tag !== 'template') {
        return false
      }
      if (node.for) {
        return true
      }
    }
    return false
  }

  /*  */

  var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
  var fnInvokeRE = /\([^)]*?\);*$/;
  var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

  // KeyboardEvent.keyCode aliases
  var keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    'delete': [8, 46]
  };

  // KeyboardEvent.key aliases
  var keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: ['Esc', 'Escape'],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [' ', 'Spacebar'],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: ['Up', 'ArrowUp'],
    left: ['Left', 'ArrowLeft'],
    right: ['Right', 'ArrowRight'],
    down: ['Down', 'ArrowDown'],
    // #9112: IE11 uses `Del` for Delete key name.
    'delete': ['Backspace', 'Delete', 'Del']
  };

  // #4868: modifiers that prevent the execution of the listener
  // need to explicitly return null so that we can determine whether to remove
  // the listener for .once
  var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

  var modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: genGuard("$event.target !== $event.currentTarget"),
    ctrl: genGuard("!$event.ctrlKey"),
    shift: genGuard("!$event.shiftKey"),
    alt: genGuard("!$event.altKey"),
    meta: genGuard("!$event.metaKey"),
    left: genGuard("'button' in $event && $event.button !== 0"),
    middle: genGuard("'button' in $event && $event.button !== 1"),
    right: genGuard("'button' in $event && $event.button !== 2")
  };

  function genHandlers (
    events,
    isNative
  ) {
    var prefix = isNative ? 'nativeOn:' : 'on:';
    var staticHandlers = "";
    var dynamicHandlers = "";
    for (var name in events) {
      var handlerCode = genHandler(events[name]);
      if (events[name] && events[name].dynamic) {
        dynamicHandlers += name + "," + handlerCode + ",";
      } else {
        staticHandlers += "\"" + name + "\":" + handlerCode + ",";
      }
    }
    staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
    if (dynamicHandlers) {
      return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
    } else {
      return prefix + staticHandlers
    }
  }

  function genHandler (handler) {
    if (!handler) {
      return 'function(){}'
    }

    if (Array.isArray(handler)) {
      return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
    }

    var isMethodPath = simplePathRE.test(handler.value);
    var isFunctionExpression = fnExpRE.test(handler.value);
    var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

    if (!handler.modifiers) {
      if (isMethodPath || isFunctionExpression) {
        return handler.value
      }
      return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
    } else {
      var code = '';
      var genModifierCode = '';
      var keys = [];
      for (var key in handler.modifiers) {
        if (modifierCode[key]) {
          genModifierCode += modifierCode[key];
          // left/right
          if (keyCodes[key]) {
            keys.push(key);
          }
        } else if (key === 'exact') {
          var modifiers = (handler.modifiers);
          genModifierCode += genGuard(
            ['ctrl', 'shift', 'alt', 'meta']
              .filter(function (keyModifier) { return !modifiers[keyModifier]; })
              .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
              .join('||')
          );
        } else {
          keys.push(key);
        }
      }
      if (keys.length) {
        code += genKeyFilter(keys);
      }
      // Make sure modifiers like prevent and stop get executed after key filtering
      if (genModifierCode) {
        code += genModifierCode;
      }
      var handlerCode = isMethodPath
        ? ("return " + (handler.value) + "($event)")
        : isFunctionExpression
          ? ("return (" + (handler.value) + ")($event)")
          : isFunctionInvocation
            ? ("return " + (handler.value))
            : handler.value;
      return ("function($event){" + code + handlerCode + "}")
    }
  }

  function genKeyFilter (keys) {
    return (
      // make sure the key filters only apply to KeyboardEvents
      // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
      // key events that do not have keyCode property...
      "if(!$event.type.indexOf('key')&&" +
      (keys.map(genFilterCode).join('&&')) + ")return null;"
    )
  }

  function genFilterCode (key) {
    var keyVal = parseInt(key, 10);
    if (keyVal) {
      return ("$event.keyCode!==" + keyVal)
    }
    var keyCode = keyCodes[key];
    var keyName = keyNames[key];
    return (
      "_k($event.keyCode," +
      (JSON.stringify(key)) + "," +
      (JSON.stringify(keyCode)) + "," +
      "$event.key," +
      "" + (JSON.stringify(keyName)) +
      ")"
    )
  }

  /*  */

  function on$1 (el, dir) {
    if (dir.modifiers) {
      warn("v-on without argument does not support modifiers.");
    }
    el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
  }

  /*  */

  function bind$1$1 (el, dir) {
    el.wrapData = function (code) {
      return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
    };
  }

  /*  */

  var baseDirectives = {
    on: on$1,
    bind: bind$1$1,
    cloak: noop$1
  };

  /*  */





  var CodegenState = function CodegenState (options) {
    this.options = options;
    this.warn = options.warn || baseWarn;
    this.transforms = pluckModuleFunction(options.modules, 'transformCode');
    this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
    this.directives = extend$1(extend$1({}, baseDirectives), options.directives);
    var isReservedTag = options.isReservedTag || no;
    this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
    this.onceId = 0;
    this.staticRenderFns = [];
    this.pre = false;
  };



  function generate (
    ast,
    options
  ) {
    var state = new CodegenState(options);
    var code = ast ? genElement(ast, state) : '_c("div")';
    return {
      render: ("with(this){return " + code + "}"),
      staticRenderFns: state.staticRenderFns
    }
  }

  function genElement (el, state) {
    if (el.parent) {
      el.pre = el.pre || el.parent.pre;
    }

    if (el.staticRoot && !el.staticProcessed) {
      return genStatic(el, state)
    } else if (el.once && !el.onceProcessed) {
      return genOnce(el, state)
    } else if (el.for && !el.forProcessed) {
      return genFor(el, state)
    } else if (el.if && !el.ifProcessed) {
      return genIf(el, state)
    } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
      return genChildren(el, state) || 'void 0'
    } else if (el.tag === 'slot') {
      return genSlot(el, state)
    } else {
      // component or element
      var code;
      if (el.component) {
        code = genComponent(el.component, el, state);
      } else {
        var data;
        if (!el.plain || (el.pre && state.maybeComponent(el))) {
          data = genData$2(el, state);
        }

        var children = el.inlineTemplate ? null : genChildren(el, state, true);
        code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
      }
      // module transforms
      for (var i = 0; i < state.transforms.length; i++) {
        code = state.transforms[i](el, code);
      }
      return code
    }
  }

  // hoist static sub-trees out
  function genStatic (el, state) {
    el.staticProcessed = true;
    // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.
    var originalPreState = state.pre;
    if (el.pre) {
      state.pre = el.pre;
    }
    state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
    state.pre = originalPreState;
    return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
  }

  // v-once
  function genOnce (el, state) {
    el.onceProcessed = true;
    if (el.if && !el.ifProcessed) {
      return genIf(el, state)
    } else if (el.staticInFor) {
      var key = '';
      var parent = el.parent;
      while (parent) {
        if (parent.for) {
          key = parent.key;
          break
        }
        parent = parent.parent;
      }
      if (!key) {
        state.warn(
          "v-once can only be used inside v-for that is keyed. ",
          el.rawAttrsMap['v-once']
        );
        return genElement(el, state)
      }
      return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
    } else {
      return genStatic(el, state)
    }
  }

  function genIf (
    el,
    state,
    altGen,
    altEmpty
  ) {
    el.ifProcessed = true; // avoid recursion
    return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
  }

  function genIfConditions (
    conditions,
    state,
    altGen,
    altEmpty
  ) {
    if (!conditions.length) {
      return altEmpty || '_e()'
    }

    var condition = conditions.shift();
    if (condition.exp) {
      return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
    } else {
      return ("" + (genTernaryExp(condition.block)))
    }

    // v-if with v-once should generate code like (a)?_m(0):_m(1)
    function genTernaryExp (el) {
      return altGen
        ? altGen(el, state)
        : el.once
          ? genOnce(el, state)
          : genElement(el, state)
    }
  }

  function genFor (
    el,
    state,
    altGen,
    altHelper
  ) {
    var exp = el.for;
    var alias = el.alias;
    var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
    var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

    if (state.maybeComponent(el) &&
      el.tag !== 'slot' &&
      el.tag !== 'template' &&
      !el.key
    ) {
      state.warn(
        "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
        "v-for should have explicit keys. " +
        "See https://vuejs.org/guide/list.html#key for more info.",
        el.rawAttrsMap['v-for'],
        true /* tip */
      );
    }

    el.forProcessed = true; // avoid recursion
    return (altHelper || '_l') + "((" + exp + ")," +
      "function(" + alias + iterator1 + iterator2 + "){" +
        "return " + ((altGen || genElement)(el, state)) +
      '})'
  }

  function genData$2 (el, state) {
    var data = '{';

    // directives first.
    // directives may mutate the el's other properties before they are generated.
    var dirs = genDirectives(el, state);
    if (dirs) { data += dirs + ','; }

    // key
    if (el.key) {
      data += "key:" + (el.key) + ",";
    }
    // ref
    if (el.ref) {
      data += "ref:" + (el.ref) + ",";
    }
    if (el.refInFor) {
      data += "refInFor:true,";
    }
    // pre
    if (el.pre) {
      data += "pre:true,";
    }
    // record original tag name for components using "is" attribute
    if (el.component) {
      data += "tag:\"" + (el.tag) + "\",";
    }
    // module data generation functions
    for (var i = 0; i < state.dataGenFns.length; i++) {
      data += state.dataGenFns[i](el);
    }
    // attributes
    if (el.attrs) {
      data += "attrs:" + (genProps(el.attrs)) + ",";
    }
    // DOM props
    if (el.props) {
      data += "domProps:" + (genProps(el.props)) + ",";
    }
    // event handlers
    if (el.events) {
      data += (genHandlers(el.events, false)) + ",";
    }
    if (el.nativeEvents) {
      data += (genHandlers(el.nativeEvents, true)) + ",";
    }
    // slot target
    // only for non-scoped slots
    if (el.slotTarget && !el.slotScope) {
      data += "slot:" + (el.slotTarget) + ",";
    }
    // scoped slots
    if (el.scopedSlots) {
      data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
    }
    // component v-model
    if (el.model) {
      data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
    }
    // inline-template
    if (el.inlineTemplate) {
      var inlineTemplate = genInlineTemplate(el, state);
      if (inlineTemplate) {
        data += inlineTemplate + ",";
      }
    }
    data = data.replace(/,$/, '') + '}';
    // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.
    if (el.dynamicAttrs) {
      data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
    }
    // v-bind data wrap
    if (el.wrapData) {
      data = el.wrapData(data);
    }
    // v-on data wrap
    if (el.wrapListeners) {
      data = el.wrapListeners(data);
    }
    return data
  }

  function genDirectives (el, state) {
    var dirs = el.directives;
    if (!dirs) { return }
    var res = 'directives:[';
    var hasRuntime = false;
    var i, l, dir, needRuntime;
    for (i = 0, l = dirs.length; i < l; i++) {
      dir = dirs[i];
      needRuntime = true;
      var gen = state.directives[dir.name];
      if (gen) {
        // compile-time directive that manipulates AST.
        // returns true if it also needs a runtime counterpart.
        needRuntime = !!gen(el, dir, state.warn);
      }
      if (needRuntime) {
        hasRuntime = true;
        res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
      }
    }
    if (hasRuntime) {
      return res.slice(0, -1) + ']'
    }
  }

  function genInlineTemplate (el, state) {
    var ast = el.children[0];
    if (el.children.length !== 1 || ast.type !== 1) {
      state.warn(
        'Inline-template components must have exactly one child element.',
        { start: el.start }
      );
    }
    if (ast && ast.type === 1) {
      var inlineRenderFns = generate(ast, state.options);
      return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
    }
  }

  function genScopedSlots (
    el,
    slots,
    state
  ) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
      var slot = slots[key];
      return (
        slot.slotTargetDynamic ||
        slot.if ||
        slot.for ||
        containsSlotChild(slot) // is passing down slot from parent which may be dynamic
      )
    });

    // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.
    var needsKey = !!el.if;

    // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.
    if (!needsForceUpdate) {
      var parent = el.parent;
      while (parent) {
        if (
          (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
          parent.for
        ) {
          needsForceUpdate = true;
          break
        }
        if (parent.if) {
          needsKey = true;
        }
        parent = parent.parent;
      }
    }

    var generatedSlots = Object.keys(slots)
      .map(function (key) { return genScopedSlot(slots[key], state); })
      .join(',');

    return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
  }

  function hash(str) {
    var hash = 5381;
    var i = str.length;
    while(i) {
      hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    return hash >>> 0
  }

  function containsSlotChild (el) {
    if (el.type === 1) {
      if (el.tag === 'slot') {
        return true
      }
      return el.children.some(containsSlotChild)
    }
    return false
  }

  function genScopedSlot (
    el,
    state
  ) {
    var isLegacySyntax = el.attrsMap['slot-scope'];
    if (el.if && !el.ifProcessed && !isLegacySyntax) {
      return genIf(el, state, genScopedSlot, "null")
    }
    if (el.for && !el.forProcessed) {
      return genFor(el, state, genScopedSlot)
    }
    var slotScope = el.slotScope === emptySlotScopeToken
      ? ""
      : String(el.slotScope);
    var fn = "function(" + slotScope + "){" +
      "return " + (el.tag === 'template'
        ? el.if && isLegacySyntax
          ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
          : genChildren(el, state) || 'undefined'
        : genElement(el, state)) + "}";
    // reverse proxy v-slot without scope on this.$slots
    var reverseProxy = slotScope ? "" : ",proxy:true";
    return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
  }

  function genChildren (
    el,
    state,
    checkSkip,
    altGenElement,
    altGenNode
  ) {
    var children = el.children;
    if (children.length) {
      var el$1 = children[0];
      // optimize single v-for
      if (children.length === 1 &&
        el$1.for &&
        el$1.tag !== 'template' &&
        el$1.tag !== 'slot'
      ) {
        var normalizationType = checkSkip
          ? state.maybeComponent(el$1) ? ",1" : ",0"
          : "";
        return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
      }
      var normalizationType$1 = checkSkip
        ? getNormalizationType(children, state.maybeComponent)
        : 0;
      var gen = altGenNode || genNode;
      return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
    }
  }

  // determine the normalization needed for the children array.
  // 0: no normalization needed
  // 1: simple normalization needed (possible 1-level deep nested array)
  // 2: full normalization needed
  function getNormalizationType (
    children,
    maybeComponent
  ) {
    var res = 0;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el.type !== 1) {
        continue
      }
      if (needsNormalization(el) ||
          (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
        res = 2;
        break
      }
      if (maybeComponent(el) ||
          (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
        res = 1;
      }
    }
    return res
  }

  function needsNormalization (el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
  }

  function genNode (node, state) {
    if (node.type === 1) {
      return genElement(node, state)
    } else if (node.type === 3 && node.isComment) {
      return genComment(node)
    } else {
      return genText(node)
    }
  }

  function genText (text) {
    return ("_v(" + (text.type === 2
      ? text.expression // no need for () because already wrapped in _s()
      : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
  }

  function genComment (comment) {
    return ("_e(" + (JSON.stringify(comment.text)) + ")")
  }

  function genSlot (el, state) {
    var slotName = el.slotName || '"default"';
    var children = genChildren(el, state);
    var res = "_t(" + slotName + (children ? ("," + children) : '');
    var attrs = el.attrs || el.dynamicAttrs
      ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
          // slot props are camelized
          name: camelize(attr.name),
          value: attr.value,
          dynamic: attr.dynamic
        }); }))
      : null;
    var bind$$1 = el.attrsMap['v-bind'];
    if ((attrs || bind$$1) && !children) {
      res += ",null";
    }
    if (attrs) {
      res += "," + attrs;
    }
    if (bind$$1) {
      res += (attrs ? '' : ',null') + "," + bind$$1;
    }
    return res + ')'
  }

  // componentName is el.component, take it as argument to shun flow's pessimistic refinement
  function genComponent (
    componentName,
    el,
    state
  ) {
    var children = el.inlineTemplate ? null : genChildren(el, state, true);
    return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
  }

  function genProps (props) {
    var staticProps = "";
    var dynamicProps = "";
    for (var i = 0; i < props.length; i++) {
      var prop = props[i];
      var value = transformSpecialNewlines(prop.value);
      if (prop.dynamic) {
        dynamicProps += (prop.name) + "," + value + ",";
      } else {
        staticProps += "\"" + (prop.name) + "\":" + value + ",";
      }
    }
    staticProps = "{" + (staticProps.slice(0, -1)) + "}";
    if (dynamicProps) {
      return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
    } else {
      return staticProps
    }
  }

  // #3895, #4268
  function transformSpecialNewlines (text) {
    return text
      .replace(/\u2028/g, '\\u2028')
      .replace(/\u2029/g, '\\u2029')
  }

  /*  */



  // these keywords should not appear inside expressions, but operators like
  // typeof, instanceof and in are allowed
  var prohibitedKeywordRE = new RegExp('\\b' + (
    'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
    'super,throw,while,yield,delete,export,import,return,switch,default,' +
    'extends,finally,continue,debugger,function,arguments'
  ).split(',').join('\\b|\\b') + '\\b');

  // these unary operators should not be used as property/method names
  var unaryOperatorsRE = new RegExp('\\b' + (
    'delete,typeof,void'
  ).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

  // strip strings in expressions
  var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

  // detect problematic expressions in a template
  function detectErrors (ast, warn) {
    if (ast) {
      checkNode(ast, warn);
    }
  }

  function checkNode (node, warn) {
    if (node.type === 1) {
      for (var name in node.attrsMap) {
        if (dirRE.test(name)) {
          var value = node.attrsMap[name];
          if (value) {
            var range = node.rawAttrsMap[name];
            if (name === 'v-for') {
              checkFor(node, ("v-for=\"" + value + "\""), warn, range);
            } else if (name === 'v-slot' || name[0] === '#') {
              checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
            } else if (onRE.test(name)) {
              checkEvent(value, (name + "=\"" + value + "\""), warn, range);
            } else {
              checkExpression(value, (name + "=\"" + value + "\""), warn, range);
            }
          }
        }
      }
      if (node.children) {
        for (var i = 0; i < node.children.length; i++) {
          checkNode(node.children[i], warn);
        }
      }
    } else if (node.type === 2) {
      checkExpression(node.expression, node.text, warn, node);
    }
  }

  function checkEvent (exp, text, warn, range) {
    var stripped = exp.replace(stripStringRE, '');
    var keywordMatch = stripped.match(unaryOperatorsRE);
    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
      warn(
        "avoid using JavaScript unary operator as property name: " +
        "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
        range
      );
    }
    checkExpression(exp, text, warn, range);
  }

  function checkFor (node, text, warn, range) {
    checkExpression(node.for || '', text, warn, range);
    checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
  }

  function checkIdentifier (
    ident,
    type,
    text,
    warn,
    range
  ) {
    if (typeof ident === 'string') {
      try {
        new Function(("var " + ident + "=_"));
      } catch (e) {
        warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
      }
    }
  }

  function checkExpression (exp, text, warn, range) {
    try {
      new Function(("return " + exp));
    } catch (e) {
      var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
      if (keywordMatch) {
        warn(
          "avoid using JavaScript keyword as property name: " +
          "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
          range
        );
      } else {
        warn(
          "invalid expression: " + (e.message) + " in\n\n" +
          "    " + exp + "\n\n" +
          "  Raw expression: " + (text.trim()) + "\n",
          range
        );
      }
    }
  }

  function checkFunctionParameterExpression (exp, text, warn, range) {
    try {
      new Function(exp, '');
    } catch (e) {
      warn(
        "invalid function parameter expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }

  /*  */

  var range = 2;

  function generateCodeFrame (
    source,
    start,
    end
  ) {
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = source.length;

    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];
    for (var i = 0; i < lines.length; i++) {
      count += lines[i].length + 1;
      if (count >= start) {
        for (var j = i - range; j <= i + range || end > count; j++) {
          if (j < 0 || j >= lines.length) { continue }
          res.push(("" + (j + 1) + (repeat$1$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
          var lineLength = lines[j].length;
          if (j === i) {
            // push underline
            var pad = start - (count - lineLength) + 1;
            var length = end > count ? lineLength - pad : end - start;
            res.push("   |  " + repeat$1$1(" ", pad) + repeat$1$1("^", length));
          } else if (j > i) {
            if (end > count) {
              var length$1 = Math.min(end - count, lineLength);
              res.push("   |  " + repeat$1$1("^", length$1));
            }
            count += lineLength + 1;
          }
        }
        break
      }
    }
    return res.join('\n')
  }

  function repeat$1$1 (str, n) {
    var result = '';
    if (n > 0) {
      while (true) { // eslint-disable-line
        if (n & 1) { result += str; }
        n >>>= 1;
        if (n <= 0) { break }
        str += str;
      }
    }
    return result
  }

  /*  */



  function createFunction (code, errors) {
    try {
      return new Function(code)
    } catch (err) {
      errors.push({ err: err, code: code });
      return noop$1
    }
  }

  function createCompileToFunctionFn (compile) {
    var cache = Object.create(null);

    return function compileToFunctions (
      template,
      options,
      vm
    ) {
      options = extend$1({}, options);
      var warn$$1 = options.warn || warn;
      delete options.warn;

      /* istanbul ignore if */
      {
        // detect possible CSP restriction
        try {
          new Function('return 1');
        } catch (e) {
          if (e.toString().match(/unsafe-eval|CSP/)) {
            warn$$1(
              'It seems you are using the standalone build of Vue.js in an ' +
              'environment with Content Security Policy that prohibits unsafe-eval. ' +
              'The template compiler cannot work in this environment. Consider ' +
              'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
              'templates into render functions.'
            );
          }
        }
      }

      // check cache
      var key = options.delimiters
        ? String(options.delimiters) + template
        : template;
      if (cache[key]) {
        return cache[key]
      }

      // compile
      var compiled = compile(template, options);

      // check compilation errors/tips
      {
        if (compiled.errors && compiled.errors.length) {
          if (options.outputSourceRange) {
            compiled.errors.forEach(function (e) {
              warn$$1(
                "Error compiling template:\n\n" + (e.msg) + "\n\n" +
                generateCodeFrame(template, e.start, e.end),
                vm
              );
            });
          } else {
            warn$$1(
              "Error compiling template:\n\n" + template + "\n\n" +
              compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
              vm
            );
          }
        }
        if (compiled.tips && compiled.tips.length) {
          if (options.outputSourceRange) {
            compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
          } else {
            compiled.tips.forEach(function (msg) { return tip(msg, vm); });
          }
        }
      }

      // turn code into functions
      var res = {};
      var fnGenErrors = [];
      res.render = createFunction(compiled.render, fnGenErrors);
      res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
        return createFunction(code, fnGenErrors)
      });

      // check function generation errors.
      // this should only happen if there is a bug in the compiler itself.
      // mostly for codegen development use
      /* istanbul ignore if */
      {
        if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
          warn$$1(
            "Failed to generate render function:\n\n" +
            fnGenErrors.map(function (ref) {
              var err = ref.err;
              var code = ref.code;

              return ((err.toString()) + " in\n\n" + code + "\n");
          }).join('\n'),
            vm
          );
        }
      }

      return (cache[key] = res)
    }
  }

  /*  */

  function createCompilerCreator (baseCompile) {
    return function createCompiler (baseOptions) {
      function compile (
        template,
        options
      ) {
        var finalOptions = Object.create(baseOptions);
        var errors = [];
        var tips = [];

        var warn = function (msg, range, tip) {
          (tip ? tips : errors).push(msg);
        };

        if (options) {
          if (options.outputSourceRange) {
            // $flow-disable-line
            var leadingSpaceLength = template.match(/^\s*/)[0].length;

            warn = function (msg, range, tip) {
              var data = { msg: msg };
              if (range) {
                if (range.start != null) {
                  data.start = range.start + leadingSpaceLength;
                }
                if (range.end != null) {
                  data.end = range.end + leadingSpaceLength;
                }
              }
              (tip ? tips : errors).push(data);
            };
          }
          // merge custom modules
          if (options.modules) {
            finalOptions.modules =
              (baseOptions.modules || []).concat(options.modules);
          }
          // merge custom directives
          if (options.directives) {
            finalOptions.directives = extend$1(
              Object.create(baseOptions.directives || null),
              options.directives
            );
          }
          // copy other options
          for (var key in options) {
            if (key !== 'modules' && key !== 'directives') {
              finalOptions[key] = options[key];
            }
          }
        }

        finalOptions.warn = warn;

        var compiled = baseCompile(template.trim(), finalOptions);
        {
          detectErrors(compiled.ast, warn);
        }
        compiled.errors = errors;
        compiled.tips = tips;
        return compiled
      }

      return {
        compile: compile,
        compileToFunctions: createCompileToFunctionFn(compile)
      }
    }
  }

  /*  */

  // `createCompilerCreator` allows creating compilers that use alternative
  // parser/optimizer/codegen, e.g the SSR optimizing compiler.
  // Here we just export a default compiler using the default parts.
  var createCompiler = createCompilerCreator(function baseCompile (
    template,
    options
  ) {
    var ast = parse(template.trim(), options);
    if (options.optimize !== false) {
      optimize(ast, options);
    }
    var code = generate(ast, options);
    return {
      ast: ast,
      render: code.render,
      staticRenderFns: code.staticRenderFns
    }
  });

  /*  */

  var ref$1 = createCompiler(baseOptions);
  var compileToFunctions = ref$1.compileToFunctions;

  /*  */

  // check whether current browser encodes a char inside attribute values
  var div;
  function getShouldDecode (href) {
    div = div || document.createElement('div');
    div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
    return div.innerHTML.indexOf('&#10;') > 0
  }

  // #3663: IE encodes newlines inside attribute values while other browsers don't
  var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
  // #6828: chrome encodes content in a[href]
  var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

  /*  */

  var idToTemplate = cached(function (id) {
    var el = query(id);
    return el && el.innerHTML
  });

  var mount = Vue$2.prototype.$mount;
  Vue$2.prototype.$mount = function (
    el,
    hydrating
  ) {
    el = el && query(el);

    /* istanbul ignore if */
    if (el === document.body || el === document.documentElement) {
      warn(
        "Do not mount Vue to <html> or <body> - mount to normal elements instead."
      );
      return this
    }

    var options = this.$options;
    // resolve template/el and convert to render function
    if (!options.render) {
      var template = options.template;
      if (template) {
        if (typeof template === 'string') {
          if (template.charAt(0) === '#') {
            template = idToTemplate(template);
            /* istanbul ignore if */
            if (!template) {
              warn(
                ("Template element not found or is empty: " + (options.template)),
                this
              );
            }
          }
        } else if (template.nodeType) {
          template = template.innerHTML;
        } else {
          {
            warn('invalid template option:' + template, this);
          }
          return this
        }
      } else if (el) {
        template = getOuterHTML(el);
      }
      if (template) {
        /* istanbul ignore if */
        if (config$1.performance && mark) {
          mark('compile');
        }

        var ref = compileToFunctions(template, {
          outputSourceRange: "development" !== 'production',
          shouldDecodeNewlines: shouldDecodeNewlines,
          shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
          delimiters: options.delimiters,
          comments: options.comments
        }, this);
        var render = ref.render;
        var staticRenderFns = ref.staticRenderFns;
        options.render = render;
        options.staticRenderFns = staticRenderFns;

        /* istanbul ignore if */
        if (config$1.performance && mark) {
          mark('compile end');
          measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
        }
      }
    }
    return mount.call(this, el, hydrating)
  };

  /**
   * Get outerHTML of elements, taking care
   * of SVG elements in IE as well.
   */
  function getOuterHTML (el) {
    if (el.outerHTML) {
      return el.outerHTML
    } else {
      var container = document.createElement('div');
      container.appendChild(el.cloneNode(true));
      return container.innerHTML
    }
  }

  Vue$2.compile = compileToFunctions;

  var vue_common_dev = Vue$2;

  {
    vue_common.exports = vue_common_dev;
  }

  var vue_commonExports = vue_common.exports;
  var Vue$1 = /*@__PURE__*/getDefaultExportFromCjs(vue_commonExports);

  /*!
   * vuex v3.6.2
   * (c) 2021 Evan You
   * @license MIT
   */
  function applyMixin (Vue) {
    var version = Number(Vue.version.split('.')[0]);

    if (version >= 2) {
      Vue.mixin({ beforeCreate: vuexInit });
    } else {
      // override init and inject vuex init procedure
      // for 1.x backwards compatibility.
      var _init = Vue.prototype._init;
      Vue.prototype._init = function (options) {
        if ( options === void 0 ) options = {};

        options.init = options.init
          ? [vuexInit].concat(options.init)
          : vuexInit;
        _init.call(this, options);
      };
    }

    /**
     * Vuex init hook, injected into each instances init hooks list.
     */

    function vuexInit () {
      var options = this.$options;
      // store injection
      if (options.store) {
        this.$store = typeof options.store === 'function'
          ? options.store()
          : options.store;
      } else if (options.parent && options.parent.$store) {
        this.$store = options.parent.$store;
      }
    }
  }

  var target = typeof window !== 'undefined'
    ? window
    : typeof global$1 !== 'undefined'
      ? global$1
      : {};
  var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

  function devtoolPlugin (store) {
    if (!devtoolHook) { return }

    store._devtoolHook = devtoolHook;

    devtoolHook.emit('vuex:init', store);

    devtoolHook.on('vuex:travel-to-state', function (targetState) {
      store.replaceState(targetState);
    });

    store.subscribe(function (mutation, state) {
      devtoolHook.emit('vuex:mutation', mutation, state);
    }, { prepend: true });

    store.subscribeAction(function (action, state) {
      devtoolHook.emit('vuex:action', action, state);
    }, { prepend: true });
  }

  /**
   * Get the first item that pass the test
   * by second argument function
   *
   * @param {Array} list
   * @param {Function} f
   * @return {*}
   */
  function find (list, f) {
    return list.filter(f)[0]
  }

  /**
   * Deep copy the given object considering circular structure.
   * This function caches all nested objects and its copies.
   * If it detects circular structure, use cached copy to avoid infinite loop.
   *
   * @param {*} obj
   * @param {Array<Object>} cache
   * @return {*}
   */
  function deepCopy (obj, cache) {
    if ( cache === void 0 ) cache = [];

    // just return if obj is immutable value
    if (obj === null || typeof obj !== 'object') {
      return obj
    }

    // if obj is hit, it is in circular structure
    var hit = find(cache, function (c) { return c.original === obj; });
    if (hit) {
      return hit.copy
    }

    var copy = Array.isArray(obj) ? [] : {};
    // put the copy into cache at first
    // because we want to refer it in recursive deepCopy
    cache.push({
      original: obj,
      copy: copy
    });

    Object.keys(obj).forEach(function (key) {
      copy[key] = deepCopy(obj[key], cache);
    });

    return copy
  }

  /**
   * forEach for object
   */
  function forEachValue (obj, fn) {
    Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
  }

  function isObject$4 (obj) {
    return obj !== null && typeof obj === 'object'
  }

  function isPromise (val) {
    return val && typeof val.then === 'function'
  }

  function assert (condition, msg) {
    if (!condition) { throw new Error(("[vuex] " + msg)) }
  }

  function partial (fn, arg) {
    return function () {
      return fn(arg)
    }
  }

  // Base data struct for store's module, package with some attribute and method
  var Module = function Module (rawModule, runtime) {
    this.runtime = runtime;
    // Store some children item
    this._children = Object.create(null);
    // Store the origin module object which passed by programmer
    this._rawModule = rawModule;
    var rawState = rawModule.state;

    // Store the origin module's state
    this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
  };

  var prototypeAccessors = { namespaced: { configurable: true } };

  prototypeAccessors.namespaced.get = function () {
    return !!this._rawModule.namespaced
  };

  Module.prototype.addChild = function addChild (key, module) {
    this._children[key] = module;
  };

  Module.prototype.removeChild = function removeChild (key) {
    delete this._children[key];
  };

  Module.prototype.getChild = function getChild (key) {
    return this._children[key]
  };

  Module.prototype.hasChild = function hasChild (key) {
    return key in this._children
  };

  Module.prototype.update = function update (rawModule) {
    this._rawModule.namespaced = rawModule.namespaced;
    if (rawModule.actions) {
      this._rawModule.actions = rawModule.actions;
    }
    if (rawModule.mutations) {
      this._rawModule.mutations = rawModule.mutations;
    }
    if (rawModule.getters) {
      this._rawModule.getters = rawModule.getters;
    }
  };

  Module.prototype.forEachChild = function forEachChild (fn) {
    forEachValue(this._children, fn);
  };

  Module.prototype.forEachGetter = function forEachGetter (fn) {
    if (this._rawModule.getters) {
      forEachValue(this._rawModule.getters, fn);
    }
  };

  Module.prototype.forEachAction = function forEachAction (fn) {
    if (this._rawModule.actions) {
      forEachValue(this._rawModule.actions, fn);
    }
  };

  Module.prototype.forEachMutation = function forEachMutation (fn) {
    if (this._rawModule.mutations) {
      forEachValue(this._rawModule.mutations, fn);
    }
  };

  Object.defineProperties( Module.prototype, prototypeAccessors );

  var ModuleCollection = function ModuleCollection (rawRootModule) {
    // register root module (Vuex.Store options)
    this.register([], rawRootModule, false);
  };

  ModuleCollection.prototype.get = function get (path) {
    return path.reduce(function (module, key) {
      return module.getChild(key)
    }, this.root)
  };

  ModuleCollection.prototype.getNamespace = function getNamespace (path) {
    var module = this.root;
    return path.reduce(function (namespace, key) {
      module = module.getChild(key);
      return namespace + (module.namespaced ? key + '/' : '')
    }, '')
  };

  ModuleCollection.prototype.update = function update$1 (rawRootModule) {
    update([], this.root, rawRootModule);
  };

  ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
      var this$1$1 = this;
      if ( runtime === void 0 ) runtime = true;

    {
      assertRawModule(path, rawModule);
    }

    var newModule = new Module(rawModule, runtime);
    if (path.length === 0) {
      this.root = newModule;
    } else {
      var parent = this.get(path.slice(0, -1));
      parent.addChild(path[path.length - 1], newModule);
    }

    // register nested modules
    if (rawModule.modules) {
      forEachValue(rawModule.modules, function (rawChildModule, key) {
        this$1$1.register(path.concat(key), rawChildModule, runtime);
      });
    }
  };

  ModuleCollection.prototype.unregister = function unregister (path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    var child = parent.getChild(key);

    if (!child) {
      {
        console.warn(
          "[vuex] trying to unregister module '" + key + "', which is " +
          "not registered"
        );
      }
      return
    }

    if (!child.runtime) {
      return
    }

    parent.removeChild(key);
  };

  ModuleCollection.prototype.isRegistered = function isRegistered (path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];

    if (parent) {
      return parent.hasChild(key)
    }

    return false
  };

  function update (path, targetModule, newModule) {
    {
      assertRawModule(path, newModule);
    }

    // update target module
    targetModule.update(newModule);

    // update nested modules
    if (newModule.modules) {
      for (var key in newModule.modules) {
        if (!targetModule.getChild(key)) {
          {
            console.warn(
              "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
              'manual reload is needed'
            );
          }
          return
        }
        update(
          path.concat(key),
          targetModule.getChild(key),
          newModule.modules[key]
        );
      }
    }
  }

  var functionAssert = {
    assert: function (value) { return typeof value === 'function'; },
    expected: 'function'
  };

  var objectAssert = {
    assert: function (value) { return typeof value === 'function' ||
      (typeof value === 'object' && typeof value.handler === 'function'); },
    expected: 'function or object with "handler" function'
  };

  var assertTypes = {
    getters: functionAssert,
    mutations: functionAssert,
    actions: objectAssert
  };

  function assertRawModule (path, rawModule) {
    Object.keys(assertTypes).forEach(function (key) {
      if (!rawModule[key]) { return }

      var assertOptions = assertTypes[key];

      forEachValue(rawModule[key], function (value, type) {
        assert(
          assertOptions.assert(value),
          makeAssertionMessage(path, key, type, value, assertOptions.expected)
        );
      });
    });
  }

  function makeAssertionMessage (path, key, type, value, expected) {
    var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
    if (path.length > 0) {
      buf += " in module \"" + (path.join('.')) + "\"";
    }
    buf += " is " + (JSON.stringify(value)) + ".";
    return buf
  }

  var Vue; // bind on install

  var Store = function Store (options) {
    var this$1$1 = this;
    if ( options === void 0 ) options = {};

    // Auto install if it is not done yet and `window` has `Vue`.
    // To allow users to avoid auto-installation in some cases,
    // this code should be placed here. See #731
    if (!Vue && typeof window !== 'undefined' && window.Vue) {
      install(window.Vue);
    }

    {
      assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
      assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
      assert(this instanceof Store, "store must be called with the new operator.");
    }

    var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
    var strict = options.strict; if ( strict === void 0 ) strict = false;

    // store internal state
    this._committing = false;
    this._actions = Object.create(null);
    this._actionSubscribers = [];
    this._mutations = Object.create(null);
    this._wrappedGetters = Object.create(null);
    this._modules = new ModuleCollection(options);
    this._modulesNamespaceMap = Object.create(null);
    this._subscribers = [];
    this._watcherVM = new Vue();
    this._makeLocalGettersCache = Object.create(null);

    // bind commit and dispatch to self
    var store = this;
    var ref = this;
    var dispatch = ref.dispatch;
    var commit = ref.commit;
    this.dispatch = function boundDispatch (type, payload) {
      return dispatch.call(store, type, payload)
    };
    this.commit = function boundCommit (type, payload, options) {
      return commit.call(store, type, payload, options)
    };

    // strict mode
    this.strict = strict;

    var state = this._modules.root.state;

    // init root module.
    // this also recursively registers all sub-modules
    // and collects all module getters inside this._wrappedGetters
    installModule(this, state, [], this._modules.root);

    // initialize the store vm, which is responsible for the reactivity
    // (also registers _wrappedGetters as computed properties)
    resetStoreVM(this, state);

    // apply plugins
    plugins.forEach(function (plugin) { return plugin(this$1$1); });

    var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
    if (useDevtools) {
      devtoolPlugin(this);
    }
  };

  var prototypeAccessors$1 = { state: { configurable: true } };

  prototypeAccessors$1.state.get = function () {
    return this._vm._data.$$state
  };

  prototypeAccessors$1.state.set = function (v) {
    {
      assert(false, "use store.replaceState() to explicit replace store state.");
    }
  };

  Store.prototype.commit = function commit (_type, _payload, _options) {
      var this$1$1 = this;

    // check object-style commit
    var ref = unifyObjectStyle(_type, _payload, _options);
      var type = ref.type;
      var payload = ref.payload;
      var options = ref.options;

    var mutation = { type: type, payload: payload };
    var entry = this._mutations[type];
    if (!entry) {
      {
        console.error(("[vuex] unknown mutation type: " + type));
      }
      return
    }
    this._withCommit(function () {
      entry.forEach(function commitIterator (handler) {
        handler(payload);
      });
    });

    this._subscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .forEach(function (sub) { return sub(mutation, this$1$1.state); });

    if (
      options && options.silent
    ) {
      console.warn(
        "[vuex] mutation type: " + type + ". Silent option has been removed. " +
        'Use the filter functionality in the vue-devtools'
      );
    }
  };

  Store.prototype.dispatch = function dispatch (_type, _payload) {
      var this$1$1 = this;

    // check object-style dispatch
    var ref = unifyObjectStyle(_type, _payload);
      var type = ref.type;
      var payload = ref.payload;

    var action = { type: type, payload: payload };
    var entry = this._actions[type];
    if (!entry) {
      {
        console.error(("[vuex] unknown action type: " + type));
      }
      return
    }

    try {
      this._actionSubscribers
        .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
        .filter(function (sub) { return sub.before; })
        .forEach(function (sub) { return sub.before(action, this$1$1.state); });
    } catch (e) {
      {
        console.warn("[vuex] error in before action subscribers: ");
        console.error(e);
      }
    }

    var result = entry.length > 1
      ? Promise.all(entry.map(function (handler) { return handler(payload); }))
      : entry[0](payload);

    return new Promise(function (resolve, reject) {
      result.then(function (res) {
        try {
          this$1$1._actionSubscribers
            .filter(function (sub) { return sub.after; })
            .forEach(function (sub) { return sub.after(action, this$1$1.state); });
        } catch (e) {
          {
            console.warn("[vuex] error in after action subscribers: ");
            console.error(e);
          }
        }
        resolve(res);
      }, function (error) {
        try {
          this$1$1._actionSubscribers
            .filter(function (sub) { return sub.error; })
            .forEach(function (sub) { return sub.error(action, this$1$1.state, error); });
        } catch (e) {
          {
            console.warn("[vuex] error in error action subscribers: ");
            console.error(e);
          }
        }
        reject(error);
      });
    })
  };

  Store.prototype.subscribe = function subscribe (fn, options) {
    return genericSubscribe(fn, this._subscribers, options)
  };

  Store.prototype.subscribeAction = function subscribeAction (fn, options) {
    var subs = typeof fn === 'function' ? { before: fn } : fn;
    return genericSubscribe(subs, this._actionSubscribers, options)
  };

  Store.prototype.watch = function watch (getter, cb, options) {
      var this$1$1 = this;

    {
      assert(typeof getter === 'function', "store.watch only accepts a function.");
    }
    return this._watcherVM.$watch(function () { return getter(this$1$1.state, this$1$1.getters); }, cb, options)
  };

  Store.prototype.replaceState = function replaceState (state) {
      var this$1$1 = this;

    this._withCommit(function () {
      this$1$1._vm._data.$$state = state;
    });
  };

  Store.prototype.registerModule = function registerModule (path, rawModule, options) {
      if ( options === void 0 ) options = {};

    if (typeof path === 'string') { path = [path]; }

    {
      assert(Array.isArray(path), "module path must be a string or an Array.");
      assert(path.length > 0, 'cannot register the root module by using registerModule.');
    }

    this._modules.register(path, rawModule);
    installModule(this, this.state, path, this._modules.get(path), options.preserveState);
    // reset store to update getters...
    resetStoreVM(this, this.state);
  };

  Store.prototype.unregisterModule = function unregisterModule (path) {
      var this$1$1 = this;

    if (typeof path === 'string') { path = [path]; }

    {
      assert(Array.isArray(path), "module path must be a string or an Array.");
    }

    this._modules.unregister(path);
    this._withCommit(function () {
      var parentState = getNestedState(this$1$1.state, path.slice(0, -1));
      Vue.delete(parentState, path[path.length - 1]);
    });
    resetStore(this);
  };

  Store.prototype.hasModule = function hasModule (path) {
    if (typeof path === 'string') { path = [path]; }

    {
      assert(Array.isArray(path), "module path must be a string or an Array.");
    }

    return this._modules.isRegistered(path)
  };

  Store.prototype.hotUpdate = function hotUpdate (newOptions) {
    this._modules.update(newOptions);
    resetStore(this, true);
  };

  Store.prototype._withCommit = function _withCommit (fn) {
    var committing = this._committing;
    this._committing = true;
    fn();
    this._committing = committing;
  };

  Object.defineProperties( Store.prototype, prototypeAccessors$1 );

  function genericSubscribe (fn, subs, options) {
    if (subs.indexOf(fn) < 0) {
      options && options.prepend
        ? subs.unshift(fn)
        : subs.push(fn);
    }
    return function () {
      var i = subs.indexOf(fn);
      if (i > -1) {
        subs.splice(i, 1);
      }
    }
  }

  function resetStore (store, hot) {
    store._actions = Object.create(null);
    store._mutations = Object.create(null);
    store._wrappedGetters = Object.create(null);
    store._modulesNamespaceMap = Object.create(null);
    var state = store.state;
    // init all modules
    installModule(store, state, [], store._modules.root, true);
    // reset vm
    resetStoreVM(store, state, hot);
  }

  function resetStoreVM (store, state, hot) {
    var oldVm = store._vm;

    // bind store public getters
    store.getters = {};
    // reset local getters cache
    store._makeLocalGettersCache = Object.create(null);
    var wrappedGetters = store._wrappedGetters;
    var computed = {};
    forEachValue(wrappedGetters, function (fn, key) {
      // use computed to leverage its lazy-caching mechanism
      // direct inline function use will lead to closure preserving oldVm.
      // using partial to return function with only arguments preserved in closure environment.
      computed[key] = partial(fn, store);
      Object.defineProperty(store.getters, key, {
        get: function () { return store._vm[key]; },
        enumerable: true // for local getters
      });
    });

    // use a Vue instance to store the state tree
    // suppress warnings just in case the user has added
    // some funky global mixins
    var silent = Vue.config.silent;
    Vue.config.silent = true;
    store._vm = new Vue({
      data: {
        $$state: state
      },
      computed: computed
    });
    Vue.config.silent = silent;

    // enable strict mode for new vm
    if (store.strict) {
      enableStrictMode(store);
    }

    if (oldVm) {
      if (hot) {
        // dispatch changes in all subscribed watchers
        // to force getter re-evaluation for hot reloading.
        store._withCommit(function () {
          oldVm._data.$$state = null;
        });
      }
      Vue.nextTick(function () { return oldVm.$destroy(); });
    }
  }

  function installModule (store, rootState, path, module, hot) {
    var isRoot = !path.length;
    var namespace = store._modules.getNamespace(path);

    // register in namespace map
    if (module.namespaced) {
      if (store._modulesNamespaceMap[namespace] && ("development" !== 'production')) {
        console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
      }
      store._modulesNamespaceMap[namespace] = module;
    }

    // set state
    if (!isRoot && !hot) {
      var parentState = getNestedState(rootState, path.slice(0, -1));
      var moduleName = path[path.length - 1];
      store._withCommit(function () {
        {
          if (moduleName in parentState) {
            console.warn(
              ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
            );
          }
        }
        Vue.set(parentState, moduleName, module.state);
      });
    }

    var local = module.context = makeLocalContext(store, namespace, path);

    module.forEachMutation(function (mutation, key) {
      var namespacedType = namespace + key;
      registerMutation(store, namespacedType, mutation, local);
    });

    module.forEachAction(function (action, key) {
      var type = action.root ? key : namespace + key;
      var handler = action.handler || action;
      registerAction(store, type, handler, local);
    });

    module.forEachGetter(function (getter, key) {
      var namespacedType = namespace + key;
      registerGetter(store, namespacedType, getter, local);
    });

    module.forEachChild(function (child, key) {
      installModule(store, rootState, path.concat(key), child, hot);
    });
  }

  /**
   * make localized dispatch, commit, getters and state
   * if there is no namespace, just use root ones
   */
  function makeLocalContext (store, namespace, path) {
    var noNamespace = namespace === '';

    var local = {
      dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
        var args = unifyObjectStyle(_type, _payload, _options);
        var payload = args.payload;
        var options = args.options;
        var type = args.type;

        if (!options || !options.root) {
          type = namespace + type;
          if (!store._actions[type]) {
            console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
            return
          }
        }

        return store.dispatch(type, payload)
      },

      commit: noNamespace ? store.commit : function (_type, _payload, _options) {
        var args = unifyObjectStyle(_type, _payload, _options);
        var payload = args.payload;
        var options = args.options;
        var type = args.type;

        if (!options || !options.root) {
          type = namespace + type;
          if (!store._mutations[type]) {
            console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
            return
          }
        }

        store.commit(type, payload, options);
      }
    };

    // getters and state object must be gotten lazily
    // because they will be changed by vm update
    Object.defineProperties(local, {
      getters: {
        get: noNamespace
          ? function () { return store.getters; }
          : function () { return makeLocalGetters(store, namespace); }
      },
      state: {
        get: function () { return getNestedState(store.state, path); }
      }
    });

    return local
  }

  function makeLocalGetters (store, namespace) {
    if (!store._makeLocalGettersCache[namespace]) {
      var gettersProxy = {};
      var splitPos = namespace.length;
      Object.keys(store.getters).forEach(function (type) {
        // skip if the target getter is not match this namespace
        if (type.slice(0, splitPos) !== namespace) { return }

        // extract local getter type
        var localType = type.slice(splitPos);

        // Add a port to the getters proxy.
        // Define as getter property because
        // we do not want to evaluate the getters in this time.
        Object.defineProperty(gettersProxy, localType, {
          get: function () { return store.getters[type]; },
          enumerable: true
        });
      });
      store._makeLocalGettersCache[namespace] = gettersProxy;
    }

    return store._makeLocalGettersCache[namespace]
  }

  function registerMutation (store, type, handler, local) {
    var entry = store._mutations[type] || (store._mutations[type] = []);
    entry.push(function wrappedMutationHandler (payload) {
      handler.call(store, local.state, payload);
    });
  }

  function registerAction (store, type, handler, local) {
    var entry = store._actions[type] || (store._actions[type] = []);
    entry.push(function wrappedActionHandler (payload) {
      var res = handler.call(store, {
        dispatch: local.dispatch,
        commit: local.commit,
        getters: local.getters,
        state: local.state,
        rootGetters: store.getters,
        rootState: store.state
      }, payload);
      if (!isPromise(res)) {
        res = Promise.resolve(res);
      }
      if (store._devtoolHook) {
        return res.catch(function (err) {
          store._devtoolHook.emit('vuex:error', err);
          throw err
        })
      } else {
        return res
      }
    });
  }

  function registerGetter (store, type, rawGetter, local) {
    if (store._wrappedGetters[type]) {
      {
        console.error(("[vuex] duplicate getter key: " + type));
      }
      return
    }
    store._wrappedGetters[type] = function wrappedGetter (store) {
      return rawGetter(
        local.state, // local state
        local.getters, // local getters
        store.state, // root state
        store.getters // root getters
      )
    };
  }

  function enableStrictMode (store) {
    store._vm.$watch(function () { return this._data.$$state }, function () {
      {
        assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
      }
    }, { deep: true, sync: true });
  }

  function getNestedState (state, path) {
    return path.reduce(function (state, key) { return state[key]; }, state)
  }

  function unifyObjectStyle (type, payload, options) {
    if (isObject$4(type) && type.type) {
      options = payload;
      payload = type;
      type = type.type;
    }

    {
      assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
    }

    return { type: type, payload: payload, options: options }
  }

  function install (_Vue) {
    if (Vue && _Vue === Vue) {
      {
        console.error(
          '[vuex] already installed. Vue.use(Vuex) should be called only once.'
        );
      }
      return
    }
    Vue = _Vue;
    applyMixin(Vue);
  }

  /**
   * Reduce the code which written in Vue.js for getting the state.
   * @param {String} [namespace] - Module's namespace
   * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
   * @param {Object}
   */
  var mapState = normalizeNamespace(function (namespace, states) {
    var res = {};
    if (!isValidMap(states)) {
      console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
    }
    normalizeMap(states).forEach(function (ref) {
      var key = ref.key;
      var val = ref.val;

      res[key] = function mappedState () {
        var state = this.$store.state;
        var getters = this.$store.getters;
        if (namespace) {
          var module = getModuleByNamespace(this.$store, 'mapState', namespace);
          if (!module) {
            return
          }
          state = module.context.state;
          getters = module.context.getters;
        }
        return typeof val === 'function'
          ? val.call(this, state, getters)
          : state[val]
      };
      // mark vuex getter for devtools
      res[key].vuex = true;
    });
    return res
  });

  /**
   * Reduce the code which written in Vue.js for committing the mutation
   * @param {String} [namespace] - Module's namespace
   * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
   * @return {Object}
   */
  var mapMutations = normalizeNamespace(function (namespace, mutations) {
    var res = {};
    if (!isValidMap(mutations)) {
      console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
    }
    normalizeMap(mutations).forEach(function (ref) {
      var key = ref.key;
      var val = ref.val;

      res[key] = function mappedMutation () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        // Get the commit method from store
        var commit = this.$store.commit;
        if (namespace) {
          var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
          if (!module) {
            return
          }
          commit = module.context.commit;
        }
        return typeof val === 'function'
          ? val.apply(this, [commit].concat(args))
          : commit.apply(this.$store, [val].concat(args))
      };
    });
    return res
  });

  /**
   * Reduce the code which written in Vue.js for getting the getters
   * @param {String} [namespace] - Module's namespace
   * @param {Object|Array} getters
   * @return {Object}
   */
  var mapGetters = normalizeNamespace(function (namespace, getters) {
    var res = {};
    if (!isValidMap(getters)) {
      console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
    }
    normalizeMap(getters).forEach(function (ref) {
      var key = ref.key;
      var val = ref.val;

      // The namespace has been mutated by normalizeNamespace
      val = namespace + val;
      res[key] = function mappedGetter () {
        if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
          return
        }
        if (!(val in this.$store.getters)) {
          console.error(("[vuex] unknown getter: " + val));
          return
        }
        return this.$store.getters[val]
      };
      // mark vuex getter for devtools
      res[key].vuex = true;
    });
    return res
  });

  /**
   * Reduce the code which written in Vue.js for dispatch the action
   * @param {String} [namespace] - Module's namespace
   * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
   * @return {Object}
   */
  var mapActions = normalizeNamespace(function (namespace, actions) {
    var res = {};
    if (!isValidMap(actions)) {
      console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
    }
    normalizeMap(actions).forEach(function (ref) {
      var key = ref.key;
      var val = ref.val;

      res[key] = function mappedAction () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        // get dispatch function from store
        var dispatch = this.$store.dispatch;
        if (namespace) {
          var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
          if (!module) {
            return
          }
          dispatch = module.context.dispatch;
        }
        return typeof val === 'function'
          ? val.apply(this, [dispatch].concat(args))
          : dispatch.apply(this.$store, [val].concat(args))
      };
    });
    return res
  });

  /**
   * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
   * @param {String} namespace
   * @return {Object}
   */
  var createNamespacedHelpers = function (namespace) { return ({
    mapState: mapState.bind(null, namespace),
    mapGetters: mapGetters.bind(null, namespace),
    mapMutations: mapMutations.bind(null, namespace),
    mapActions: mapActions.bind(null, namespace)
  }); };

  /**
   * Normalize the map
   * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
   * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
   * @param {Array|Object} map
   * @return {Object}
   */
  function normalizeMap (map) {
    if (!isValidMap(map)) {
      return []
    }
    return Array.isArray(map)
      ? map.map(function (key) { return ({ key: key, val: key }); })
      : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
  }

  /**
   * Validate whether given map is valid or not
   * @param {*} map
   * @return {Boolean}
   */
  function isValidMap (map) {
    return Array.isArray(map) || isObject$4(map)
  }

  /**
   * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
   * @param {Function} fn
   * @return {Function}
   */
  function normalizeNamespace (fn) {
    return function (namespace, map) {
      if (typeof namespace !== 'string') {
        map = namespace;
        namespace = '';
      } else if (namespace.charAt(namespace.length - 1) !== '/') {
        namespace += '/';
      }
      return fn(namespace, map)
    }
  }

  /**
   * Search a special module from store by namespace. if module not exist, print error message.
   * @param {Object} store
   * @param {String} helper
   * @param {String} namespace
   * @return {Object}
   */
  function getModuleByNamespace (store, helper, namespace) {
    var module = store._modulesNamespaceMap[namespace];
    if (!module) {
      console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
    }
    return module
  }

  // Credits: borrowed code from fcomb/redux-logger

  function createLogger (ref) {
    if ( ref === void 0 ) ref = {};
    var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
    var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
    var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
    var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
    var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
    var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
    var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
    var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
    var logger = ref.logger; if ( logger === void 0 ) logger = console;

    return function (store) {
      var prevState = deepCopy(store.state);

      if (typeof logger === 'undefined') {
        return
      }

      if (logMutations) {
        store.subscribe(function (mutation, state) {
          var nextState = deepCopy(state);

          if (filter(mutation, prevState, nextState)) {
            var formattedTime = getFormattedTime();
            var formattedMutation = mutationTransformer(mutation);
            var message = "mutation " + (mutation.type) + formattedTime;

            startMessage(logger, message, collapsed);
            logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
            logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
            logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
            endMessage(logger);
          }

          prevState = nextState;
        });
      }

      if (logActions) {
        store.subscribeAction(function (action, state) {
          if (actionFilter(action, state)) {
            var formattedTime = getFormattedTime();
            var formattedAction = actionTransformer(action);
            var message = "action " + (action.type) + formattedTime;

            startMessage(logger, message, collapsed);
            logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
            endMessage(logger);
          }
        });
      }
    }
  }

  function startMessage (logger, message, collapsed) {
    var startMessage = collapsed
      ? logger.groupCollapsed
      : logger.group;

    // render
    try {
      startMessage.call(logger, message);
    } catch (e) {
      logger.log(message);
    }
  }

  function endMessage (logger) {
    try {
      logger.groupEnd();
    } catch (e) {
      logger.log('—— log end ——');
    }
  }

  function getFormattedTime () {
    var time = new Date();
    return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
  }

  function repeat (str, times) {
    return (new Array(times + 1)).join(str)
  }

  function pad (num, maxLength) {
    return repeat('0', maxLength - num.toString().length) + num
  }

  var index = {
    Store: Store,
    install: install,
    version: '3.6.2',
    mapState: mapState,
    mapMutations: mapMutations,
    mapGetters: mapGetters,
    mapActions: mapActions,
    createNamespacedHelpers: createNamespacedHelpers,
    createLogger: createLogger
  };

  var Vuex = index;

  /*! js-cookie v3.0.5 | MIT */
  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */

  function isObject$3(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  var isObject_1 = isObject$3;

  /** Detect free variable `global` from Node.js. */

  var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  var _freeGlobal = freeGlobal$1;

  var freeGlobal = _freeGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root$2 = freeGlobal || freeSelf || Function('return this')();

  var _root = root$2;

  var root$1 = _root;

  /**
   * Gets the timestamp of the number of milliseconds that have elapsed since
   * the Unix epoch (1 January 1970 00:00:00 UTC).
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Date
   * @returns {number} Returns the timestamp.
   * @example
   *
   * _.defer(function(stamp) {
   *   console.log(_.now() - stamp);
   * }, _.now());
   * // => Logs the number of milliseconds it took for the deferred invocation.
   */
  var now$1 = function() {
    return root$1.Date.now();
  };

  var now_1 = now$1;

  var root = _root;

  /** Built-in value references. */
  var Symbol$3 = root.Symbol;

  var _Symbol = Symbol$3;

  var Symbol$2 = _Symbol;

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto$1.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$1.toString;

  /** Built-in value references. */
  var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag$1(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag$1),
        tag = value[symToStringTag$1];

    try {
      value[symToStringTag$1] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString$1.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag$1] = tag;
      } else {
        delete value[symToStringTag$1];
      }
    }
    return result;
  }

  var _getRawTag = getRawTag$1;

  /** Used for built-in method references. */

  var objectProto = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString$1(value) {
    return nativeObjectToString.call(value);
  }

  var _objectToString = objectToString$1;

  var Symbol$1 = _Symbol,
      getRawTag = _getRawTag,
      objectToString = _objectToString;

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag$1(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag && symToStringTag in Object(value))
      ? getRawTag(value)
      : objectToString(value);
  }

  var _baseGetTag = baseGetTag$1;

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */

  function isObjectLike$1(value) {
    return value != null && typeof value == 'object';
  }

  var isObjectLike_1 = isObjectLike$1;

  var baseGetTag = _baseGetTag,
      isObjectLike = isObjectLike_1;

  /** `Object#toString` result references. */
  var symbolTag = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol$1(value) {
    return typeof value == 'symbol' ||
      (isObjectLike(value) && baseGetTag(value) == symbolTag);
  }

  var isSymbol_1 = isSymbol$1;

  var isObject$2 = isObject_1,
      isSymbol = isSymbol_1;

  /** Used as references for various `Number` constants. */
  var NAN = 0 / 0;

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Built-in method references without a dependency on `root`. */
  var freeParseInt = parseInt;

  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */
  function toNumber$1(value) {
    if (typeof value == 'number') {
      return value;
    }
    if (isSymbol(value)) {
      return NAN;
    }
    if (isObject$2(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject$2(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
      ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
      : (reIsBadHex.test(value) ? NAN : +value);
  }

  var toNumber_1 = toNumber$1;

  var isObject$1 = isObject_1,
      now = now_1,
      toNumber = toNumber_1;

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max,
      nativeMin = Math.min;

  /**
   * Creates a debounced function that delays invoking `func` until after `wait`
   * milliseconds have elapsed since the last time the debounced function was
   * invoked. The debounced function comes with a `cancel` method to cancel
   * delayed `func` invocations and a `flush` method to immediately invoke them.
   * Provide `options` to indicate whether `func` should be invoked on the
   * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
   * with the last arguments provided to the debounced function. Subsequent
   * calls to the debounced function return the result of the last `func`
   * invocation.
   *
   * **Note:** If `leading` and `trailing` options are `true`, `func` is
   * invoked on the trailing edge of the timeout only if the debounced function
   * is invoked more than once during the `wait` timeout.
   *
   * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
   * until to the next tick, similar to `setTimeout` with a timeout of `0`.
   *
   * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
   * for details over the differences between `_.debounce` and `_.throttle`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to debounce.
   * @param {number} [wait=0] The number of milliseconds to delay.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.leading=false]
   *  Specify invoking on the leading edge of the timeout.
   * @param {number} [options.maxWait]
   *  The maximum time `func` is allowed to be delayed before it's invoked.
   * @param {boolean} [options.trailing=true]
   *  Specify invoking on the trailing edge of the timeout.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // Avoid costly calculations while the window size is in flux.
   * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
   *
   * // Invoke `sendMail` when clicked, debouncing subsequent calls.
   * jQuery(element).on('click', _.debounce(sendMail, 300, {
   *   'leading': true,
   *   'trailing': false
   * }));
   *
   * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
   * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
   * var source = new EventSource('/stream');
   * jQuery(source).on('message', debounced);
   *
   * // Cancel the trailing debounced invocation.
   * jQuery(window).on('popstate', debounced.cancel);
   */
  function debounce(func, wait, options) {
    var lastArgs,
        lastThis,
        maxWait,
        result,
        timerId,
        lastCallTime,
        lastInvokeTime = 0,
        leading = false,
        maxing = false,
        trailing = true;

    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait = toNumber(wait) || 0;
    if (isObject$1(options)) {
      leading = !!options.leading;
      maxing = 'maxWait' in options;
      maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
      trailing = 'trailing' in options ? !!options.trailing : trailing;
    }

    function invokeFunc(time) {
      var args = lastArgs,
          thisArg = lastThis;

      lastArgs = lastThis = undefined;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }

    function leadingEdge(time) {
      // Reset any `maxWait` timer.
      lastInvokeTime = time;
      // Start the timer for the trailing edge.
      timerId = setTimeout(timerExpired, wait);
      // Invoke the leading edge.
      return leading ? invokeFunc(time) : result;
    }

    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime,
          timeWaiting = wait - timeSinceLastCall;

      return maxing
        ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
        : timeWaiting;
    }

    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime;

      // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.
      return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
        (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
    }

    function timerExpired() {
      var time = now();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      // Restart the timer.
      timerId = setTimeout(timerExpired, remainingWait(time));
    }

    function trailingEdge(time) {
      timerId = undefined;

      // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = undefined;
      return result;
    }

    function cancel() {
      if (timerId !== undefined) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = undefined;
    }

    function flush() {
      return timerId === undefined ? result : trailingEdge(now());
    }

    function debounced() {
      var time = now(),
          isInvoking = shouldInvoke(time);

      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;

      if (isInvoking) {
        if (timerId === undefined) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          // Handle invocations in a tight loop.
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === undefined) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }

  var debounce_1 = debounce;

  var debounce$1 = /*@__PURE__*/getDefaultExportFromCjs(debounce_1);

  var vueAwesomeSwiper = {exports: {}};

  var swiper = {exports: {}};

  /**
   * Swiper 4.5.1
   * Most modern mobile touch slider and framework with hardware accelerated transitions
   * http://www.idangero.us/swiper/
   *
   * Copyright 2014-2019 Vladimir Kharlampidi
   *
   * Released under the MIT License
   *
   * Released on: September 13, 2019
   */

  var hasRequiredSwiper;

  function requireSwiper () {
  	if (hasRequiredSwiper) return swiper.exports;
  	hasRequiredSwiper = 1;
  	(function (module, exports) {
  		(function (global, factory) {
  		  module.exports = factory() ;
  		}(commonjsGlobal, function () {
  		  /**
  		   * SSR Window 1.0.1
  		   * Better handling for window object in SSR environment
  		   * https://github.com/nolimits4web/ssr-window
  		   *
  		   * Copyright 2018, Vladimir Kharlampidi
  		   *
  		   * Licensed under MIT
  		   *
  		   * Released on: July 18, 2018
  		   */
  		  var doc = (typeof document === 'undefined') ? {
  		    body: {},
  		    addEventListener: function addEventListener() {},
  		    removeEventListener: function removeEventListener() {},
  		    activeElement: {
  		      blur: function blur() {},
  		      nodeName: '',
  		    },
  		    querySelector: function querySelector() {
  		      return null;
  		    },
  		    querySelectorAll: function querySelectorAll() {
  		      return [];
  		    },
  		    getElementById: function getElementById() {
  		      return null;
  		    },
  		    createEvent: function createEvent() {
  		      return {
  		        initEvent: function initEvent() {},
  		      };
  		    },
  		    createElement: function createElement() {
  		      return {
  		        children: [],
  		        childNodes: [],
  		        style: {},
  		        setAttribute: function setAttribute() {},
  		        getElementsByTagName: function getElementsByTagName() {
  		          return [];
  		        },
  		      };
  		    },
  		    location: { hash: '' },
  		  } : document; // eslint-disable-line

  		  var win = (typeof window === 'undefined') ? {
  		    document: doc,
  		    navigator: {
  		      userAgent: '',
  		    },
  		    location: {},
  		    history: {},
  		    CustomEvent: function CustomEvent() {
  		      return this;
  		    },
  		    addEventListener: function addEventListener() {},
  		    removeEventListener: function removeEventListener() {},
  		    getComputedStyle: function getComputedStyle() {
  		      return {
  		        getPropertyValue: function getPropertyValue() {
  		          return '';
  		        },
  		      };
  		    },
  		    Image: function Image() {},
  		    Date: function Date() {},
  		    screen: {},
  		    setTimeout: function setTimeout() {},
  		    clearTimeout: function clearTimeout() {},
  		  } : window; // eslint-disable-line

  		  /**
  		   * Dom7 2.1.3
  		   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
  		   * http://framework7.io/docs/dom.html
  		   *
  		   * Copyright 2019, Vladimir Kharlampidi
  		   * The iDangero.us
  		   * http://www.idangero.us/
  		   *
  		   * Licensed under MIT
  		   *
  		   * Released on: February 11, 2019
  		   */

  		  var Dom7 = function Dom7(arr) {
  		    var self = this;
  		    // Create array-like object
  		    for (var i = 0; i < arr.length; i += 1) {
  		      self[i] = arr[i];
  		    }
  		    self.length = arr.length;
  		    // Return collection with methods
  		    return this;
  		  };

  		  function $(selector, context) {
  		    var arr = [];
  		    var i = 0;
  		    if (selector && !context) {
  		      if (selector instanceof Dom7) {
  		        return selector;
  		      }
  		    }
  		    if (selector) {
  		        // String
  		      if (typeof selector === 'string') {
  		        var els;
  		        var tempParent;
  		        var html = selector.trim();
  		        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
  		          var toCreate = 'div';
  		          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
  		          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
  		          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
  		          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
  		          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
  		          tempParent = doc.createElement(toCreate);
  		          tempParent.innerHTML = html;
  		          for (i = 0; i < tempParent.childNodes.length; i += 1) {
  		            arr.push(tempParent.childNodes[i]);
  		          }
  		        } else {
  		          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
  		            // Pure ID selector
  		            els = [doc.getElementById(selector.trim().split('#')[1])];
  		          } else {
  		            // Other selectors
  		            els = (context || doc).querySelectorAll(selector.trim());
  		          }
  		          for (i = 0; i < els.length; i += 1) {
  		            if (els[i]) { arr.push(els[i]); }
  		          }
  		        }
  		      } else if (selector.nodeType || selector === win || selector === doc) {
  		        // Node/element
  		        arr.push(selector);
  		      } else if (selector.length > 0 && selector[0].nodeType) {
  		        // Array of elements or instance of Dom
  		        for (i = 0; i < selector.length; i += 1) {
  		          arr.push(selector[i]);
  		        }
  		      }
  		    }
  		    return new Dom7(arr);
  		  }

  		  $.fn = Dom7.prototype;
  		  $.Class = Dom7;
  		  $.Dom7 = Dom7;

  		  function unique(arr) {
  		    var uniqueArray = [];
  		    for (var i = 0; i < arr.length; i += 1) {
  		      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
  		    }
  		    return uniqueArray;
  		  }

  		  // Classes and attributes
  		  function addClass(className) {
  		    if (typeof className === 'undefined') {
  		      return this;
  		    }
  		    var classes = className.split(' ');
  		    for (var i = 0; i < classes.length; i += 1) {
  		      for (var j = 0; j < this.length; j += 1) {
  		        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
  		      }
  		    }
  		    return this;
  		  }
  		  function removeClass(className) {
  		    var classes = className.split(' ');
  		    for (var i = 0; i < classes.length; i += 1) {
  		      for (var j = 0; j < this.length; j += 1) {
  		        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
  		      }
  		    }
  		    return this;
  		  }
  		  function hasClass(className) {
  		    if (!this[0]) { return false; }
  		    return this[0].classList.contains(className);
  		  }
  		  function toggleClass(className) {
  		    var classes = className.split(' ');
  		    for (var i = 0; i < classes.length; i += 1) {
  		      for (var j = 0; j < this.length; j += 1) {
  		        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
  		      }
  		    }
  		    return this;
  		  }
  		  function attr(attrs, value) {
  		    var arguments$1 = arguments;

  		    if (arguments.length === 1 && typeof attrs === 'string') {
  		      // Get attr
  		      if (this[0]) { return this[0].getAttribute(attrs); }
  		      return undefined;
  		    }

  		    // Set attrs
  		    for (var i = 0; i < this.length; i += 1) {
  		      if (arguments$1.length === 2) {
  		        // String
  		        this[i].setAttribute(attrs, value);
  		      } else {
  		        // Object
  		        // eslint-disable-next-line
  		        for (var attrName in attrs) {
  		          this[i][attrName] = attrs[attrName];
  		          this[i].setAttribute(attrName, attrs[attrName]);
  		        }
  		      }
  		    }
  		    return this;
  		  }
  		  // eslint-disable-next-line
  		  function removeAttr(attr) {
  		    for (var i = 0; i < this.length; i += 1) {
  		      this[i].removeAttribute(attr);
  		    }
  		    return this;
  		  }
  		  function data(key, value) {
  		    var el;
  		    if (typeof value === 'undefined') {
  		      el = this[0];
  		      // Get value
  		      if (el) {
  		        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
  		          return el.dom7ElementDataStorage[key];
  		        }

  		        var dataKey = el.getAttribute(("data-" + key));
  		        if (dataKey) {
  		          return dataKey;
  		        }
  		        return undefined;
  		      }
  		      return undefined;
  		    }

  		    // Set value
  		    for (var i = 0; i < this.length; i += 1) {
  		      el = this[i];
  		      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
  		      el.dom7ElementDataStorage[key] = value;
  		    }
  		    return this;
  		  }
  		  // Transforms
  		  // eslint-disable-next-line
  		  function transform(transform) {
  		    for (var i = 0; i < this.length; i += 1) {
  		      var elStyle = this[i].style;
  		      elStyle.webkitTransform = transform;
  		      elStyle.transform = transform;
  		    }
  		    return this;
  		  }
  		  function transition(duration) {
  		    if (typeof duration !== 'string') {
  		      duration = duration + "ms"; // eslint-disable-line
  		    }
  		    for (var i = 0; i < this.length; i += 1) {
  		      var elStyle = this[i].style;
  		      elStyle.webkitTransitionDuration = duration;
  		      elStyle.transitionDuration = duration;
  		    }
  		    return this;
  		  }
  		  // Events
  		  function on() {
  		    var assign;

  		    var args = [], len = arguments.length;
  		    while ( len-- ) args[ len ] = arguments[ len ];
  		    var eventType = args[0];
  		    var targetSelector = args[1];
  		    var listener = args[2];
  		    var capture = args[3];
  		    if (typeof args[1] === 'function') {
  		      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
  		      targetSelector = undefined;
  		    }
  		    if (!capture) { capture = false; }

  		    function handleLiveEvent(e) {
  		      var target = e.target;
  		      if (!target) { return; }
  		      var eventData = e.target.dom7EventData || [];
  		      if (eventData.indexOf(e) < 0) {
  		        eventData.unshift(e);
  		      }
  		      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
  		      else {
  		        var parents = $(target).parents(); // eslint-disable-line
  		        for (var k = 0; k < parents.length; k += 1) {
  		          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
  		        }
  		      }
  		    }
  		    function handleEvent(e) {
  		      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
  		      if (eventData.indexOf(e) < 0) {
  		        eventData.unshift(e);
  		      }
  		      listener.apply(this, eventData);
  		    }
  		    var events = eventType.split(' ');
  		    var j;
  		    for (var i = 0; i < this.length; i += 1) {
  		      var el = this[i];
  		      if (!targetSelector) {
  		        for (j = 0; j < events.length; j += 1) {
  		          var event = events[j];
  		          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
  		          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
  		          el.dom7Listeners[event].push({
  		            listener: listener,
  		            proxyListener: handleEvent,
  		          });
  		          el.addEventListener(event, handleEvent, capture);
  		        }
  		      } else {
  		        // Live events
  		        for (j = 0; j < events.length; j += 1) {
  		          var event$1 = events[j];
  		          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
  		          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
  		          el.dom7LiveListeners[event$1].push({
  		            listener: listener,
  		            proxyListener: handleLiveEvent,
  		          });
  		          el.addEventListener(event$1, handleLiveEvent, capture);
  		        }
  		      }
  		    }
  		    return this;
  		  }
  		  function off() {
  		    var assign;

  		    var args = [], len = arguments.length;
  		    while ( len-- ) args[ len ] = arguments[ len ];
  		    var eventType = args[0];
  		    var targetSelector = args[1];
  		    var listener = args[2];
  		    var capture = args[3];
  		    if (typeof args[1] === 'function') {
  		      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
  		      targetSelector = undefined;
  		    }
  		    if (!capture) { capture = false; }

  		    var events = eventType.split(' ');
  		    for (var i = 0; i < events.length; i += 1) {
  		      var event = events[i];
  		      for (var j = 0; j < this.length; j += 1) {
  		        var el = this[j];
  		        var handlers = (void 0);
  		        if (!targetSelector && el.dom7Listeners) {
  		          handlers = el.dom7Listeners[event];
  		        } else if (targetSelector && el.dom7LiveListeners) {
  		          handlers = el.dom7LiveListeners[event];
  		        }
  		        if (handlers && handlers.length) {
  		          for (var k = handlers.length - 1; k >= 0; k -= 1) {
  		            var handler = handlers[k];
  		            if (listener && handler.listener === listener) {
  		              el.removeEventListener(event, handler.proxyListener, capture);
  		              handlers.splice(k, 1);
  		            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
  		              el.removeEventListener(event, handler.proxyListener, capture);
  		              handlers.splice(k, 1);
  		            } else if (!listener) {
  		              el.removeEventListener(event, handler.proxyListener, capture);
  		              handlers.splice(k, 1);
  		            }
  		          }
  		        }
  		      }
  		    }
  		    return this;
  		  }
  		  function trigger() {
  		    var args = [], len = arguments.length;
  		    while ( len-- ) args[ len ] = arguments[ len ];

  		    var events = args[0].split(' ');
  		    var eventData = args[1];
  		    for (var i = 0; i < events.length; i += 1) {
  		      var event = events[i];
  		      for (var j = 0; j < this.length; j += 1) {
  		        var el = this[j];
  		        var evt = (void 0);
  		        try {
  		          evt = new win.CustomEvent(event, {
  		            detail: eventData,
  		            bubbles: true,
  		            cancelable: true,
  		          });
  		        } catch (e) {
  		          evt = doc.createEvent('Event');
  		          evt.initEvent(event, true, true);
  		          evt.detail = eventData;
  		        }
  		        // eslint-disable-next-line
  		        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
  		        el.dispatchEvent(evt);
  		        el.dom7EventData = [];
  		        delete el.dom7EventData;
  		      }
  		    }
  		    return this;
  		  }
  		  function transitionEnd(callback) {
  		    var events = ['webkitTransitionEnd', 'transitionend'];
  		    var dom = this;
  		    var i;
  		    function fireCallBack(e) {
  		      /* jshint validthis:true */
  		      if (e.target !== this) { return; }
  		      callback.call(this, e);
  		      for (i = 0; i < events.length; i += 1) {
  		        dom.off(events[i], fireCallBack);
  		      }
  		    }
  		    if (callback) {
  		      for (i = 0; i < events.length; i += 1) {
  		        dom.on(events[i], fireCallBack);
  		      }
  		    }
  		    return this;
  		  }
  		  function outerWidth(includeMargins) {
  		    if (this.length > 0) {
  		      if (includeMargins) {
  		        // eslint-disable-next-line
  		        var styles = this.styles();
  		        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
  		      }
  		      return this[0].offsetWidth;
  		    }
  		    return null;
  		  }
  		  function outerHeight(includeMargins) {
  		    if (this.length > 0) {
  		      if (includeMargins) {
  		        // eslint-disable-next-line
  		        var styles = this.styles();
  		        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
  		      }
  		      return this[0].offsetHeight;
  		    }
  		    return null;
  		  }
  		  function offset() {
  		    if (this.length > 0) {
  		      var el = this[0];
  		      var box = el.getBoundingClientRect();
  		      var body = doc.body;
  		      var clientTop = el.clientTop || body.clientTop || 0;
  		      var clientLeft = el.clientLeft || body.clientLeft || 0;
  		      var scrollTop = el === win ? win.scrollY : el.scrollTop;
  		      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
  		      return {
  		        top: (box.top + scrollTop) - clientTop,
  		        left: (box.left + scrollLeft) - clientLeft,
  		      };
  		    }

  		    return null;
  		  }
  		  function styles() {
  		    if (this[0]) { return win.getComputedStyle(this[0], null); }
  		    return {};
  		  }
  		  function css(props, value) {
  		    var i;
  		    if (arguments.length === 1) {
  		      if (typeof props === 'string') {
  		        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
  		      } else {
  		        for (i = 0; i < this.length; i += 1) {
  		          // eslint-disable-next-line
  		          for (var prop in props) {
  		            this[i].style[prop] = props[prop];
  		          }
  		        }
  		        return this;
  		      }
  		    }
  		    if (arguments.length === 2 && typeof props === 'string') {
  		      for (i = 0; i < this.length; i += 1) {
  		        this[i].style[props] = value;
  		      }
  		      return this;
  		    }
  		    return this;
  		  }
  		  // Iterate over the collection passing elements to `callback`
  		  function each(callback) {
  		    // Don't bother continuing without a callback
  		    if (!callback) { return this; }
  		    // Iterate over the current collection
  		    for (var i = 0; i < this.length; i += 1) {
  		      // If the callback returns false
  		      if (callback.call(this[i], i, this[i]) === false) {
  		        // End the loop early
  		        return this;
  		      }
  		    }
  		    // Return `this` to allow chained DOM operations
  		    return this;
  		  }
  		  // eslint-disable-next-line
  		  function html(html) {
  		    if (typeof html === 'undefined') {
  		      return this[0] ? this[0].innerHTML : undefined;
  		    }

  		    for (var i = 0; i < this.length; i += 1) {
  		      this[i].innerHTML = html;
  		    }
  		    return this;
  		  }
  		  // eslint-disable-next-line
  		  function text(text) {
  		    if (typeof text === 'undefined') {
  		      if (this[0]) {
  		        return this[0].textContent.trim();
  		      }
  		      return null;
  		    }

  		    for (var i = 0; i < this.length; i += 1) {
  		      this[i].textContent = text;
  		    }
  		    return this;
  		  }
  		  function is(selector) {
  		    var el = this[0];
  		    var compareWith;
  		    var i;
  		    if (!el || typeof selector === 'undefined') { return false; }
  		    if (typeof selector === 'string') {
  		      if (el.matches) { return el.matches(selector); }
  		      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
  		      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

  		      compareWith = $(selector);
  		      for (i = 0; i < compareWith.length; i += 1) {
  		        if (compareWith[i] === el) { return true; }
  		      }
  		      return false;
  		    } else if (selector === doc) { return el === doc; }
  		    else if (selector === win) { return el === win; }

  		    if (selector.nodeType || selector instanceof Dom7) {
  		      compareWith = selector.nodeType ? [selector] : selector;
  		      for (i = 0; i < compareWith.length; i += 1) {
  		        if (compareWith[i] === el) { return true; }
  		      }
  		      return false;
  		    }
  		    return false;
  		  }
  		  function index() {
  		    var child = this[0];
  		    var i;
  		    if (child) {
  		      i = 0;
  		      // eslint-disable-next-line
  		      while ((child = child.previousSibling) !== null) {
  		        if (child.nodeType === 1) { i += 1; }
  		      }
  		      return i;
  		    }
  		    return undefined;
  		  }
  		  // eslint-disable-next-line
  		  function eq(index) {
  		    if (typeof index === 'undefined') { return this; }
  		    var length = this.length;
  		    var returnIndex;
  		    if (index > length - 1) {
  		      return new Dom7([]);
  		    }
  		    if (index < 0) {
  		      returnIndex = length + index;
  		      if (returnIndex < 0) { return new Dom7([]); }
  		      return new Dom7([this[returnIndex]]);
  		    }
  		    return new Dom7([this[index]]);
  		  }
  		  function append() {
  		    var args = [], len = arguments.length;
  		    while ( len-- ) args[ len ] = arguments[ len ];

  		    var newChild;

  		    for (var k = 0; k < args.length; k += 1) {
  		      newChild = args[k];
  		      for (var i = 0; i < this.length; i += 1) {
  		        if (typeof newChild === 'string') {
  		          var tempDiv = doc.createElement('div');
  		          tempDiv.innerHTML = newChild;
  		          while (tempDiv.firstChild) {
  		            this[i].appendChild(tempDiv.firstChild);
  		          }
  		        } else if (newChild instanceof Dom7) {
  		          for (var j = 0; j < newChild.length; j += 1) {
  		            this[i].appendChild(newChild[j]);
  		          }
  		        } else {
  		          this[i].appendChild(newChild);
  		        }
  		      }
  		    }

  		    return this;
  		  }
  		  function prepend(newChild) {
  		    var i;
  		    var j;
  		    for (i = 0; i < this.length; i += 1) {
  		      if (typeof newChild === 'string') {
  		        var tempDiv = doc.createElement('div');
  		        tempDiv.innerHTML = newChild;
  		        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
  		          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
  		        }
  		      } else if (newChild instanceof Dom7) {
  		        for (j = 0; j < newChild.length; j += 1) {
  		          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
  		        }
  		      } else {
  		        this[i].insertBefore(newChild, this[i].childNodes[0]);
  		      }
  		    }
  		    return this;
  		  }
  		  function next(selector) {
  		    if (this.length > 0) {
  		      if (selector) {
  		        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
  		          return new Dom7([this[0].nextElementSibling]);
  		        }
  		        return new Dom7([]);
  		      }

  		      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
  		      return new Dom7([]);
  		    }
  		    return new Dom7([]);
  		  }
  		  function nextAll(selector) {
  		    var nextEls = [];
  		    var el = this[0];
  		    if (!el) { return new Dom7([]); }
  		    while (el.nextElementSibling) {
  		      var next = el.nextElementSibling; // eslint-disable-line
  		      if (selector) {
  		        if ($(next).is(selector)) { nextEls.push(next); }
  		      } else { nextEls.push(next); }
  		      el = next;
  		    }
  		    return new Dom7(nextEls);
  		  }
  		  function prev(selector) {
  		    if (this.length > 0) {
  		      var el = this[0];
  		      if (selector) {
  		        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
  		          return new Dom7([el.previousElementSibling]);
  		        }
  		        return new Dom7([]);
  		      }

  		      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
  		      return new Dom7([]);
  		    }
  		    return new Dom7([]);
  		  }
  		  function prevAll(selector) {
  		    var prevEls = [];
  		    var el = this[0];
  		    if (!el) { return new Dom7([]); }
  		    while (el.previousElementSibling) {
  		      var prev = el.previousElementSibling; // eslint-disable-line
  		      if (selector) {
  		        if ($(prev).is(selector)) { prevEls.push(prev); }
  		      } else { prevEls.push(prev); }
  		      el = prev;
  		    }
  		    return new Dom7(prevEls);
  		  }
  		  function parent(selector) {
  		    var parents = []; // eslint-disable-line
  		    for (var i = 0; i < this.length; i += 1) {
  		      if (this[i].parentNode !== null) {
  		        if (selector) {
  		          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
  		        } else {
  		          parents.push(this[i].parentNode);
  		        }
  		      }
  		    }
  		    return $(unique(parents));
  		  }
  		  function parents(selector) {
  		    var parents = []; // eslint-disable-line
  		    for (var i = 0; i < this.length; i += 1) {
  		      var parent = this[i].parentNode; // eslint-disable-line
  		      while (parent) {
  		        if (selector) {
  		          if ($(parent).is(selector)) { parents.push(parent); }
  		        } else {
  		          parents.push(parent);
  		        }
  		        parent = parent.parentNode;
  		      }
  		    }
  		    return $(unique(parents));
  		  }
  		  function closest(selector) {
  		    var closest = this; // eslint-disable-line
  		    if (typeof selector === 'undefined') {
  		      return new Dom7([]);
  		    }
  		    if (!closest.is(selector)) {
  		      closest = closest.parents(selector).eq(0);
  		    }
  		    return closest;
  		  }
  		  function find(selector) {
  		    var foundElements = [];
  		    for (var i = 0; i < this.length; i += 1) {
  		      var found = this[i].querySelectorAll(selector);
  		      for (var j = 0; j < found.length; j += 1) {
  		        foundElements.push(found[j]);
  		      }
  		    }
  		    return new Dom7(foundElements);
  		  }
  		  function children(selector) {
  		    var children = []; // eslint-disable-line
  		    for (var i = 0; i < this.length; i += 1) {
  		      var childNodes = this[i].childNodes;

  		      for (var j = 0; j < childNodes.length; j += 1) {
  		        if (!selector) {
  		          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
  		        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
  		          children.push(childNodes[j]);
  		        }
  		      }
  		    }
  		    return new Dom7(unique(children));
  		  }
  		  function remove() {
  		    for (var i = 0; i < this.length; i += 1) {
  		      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
  		    }
  		    return this;
  		  }
  		  function add() {
  		    var args = [], len = arguments.length;
  		    while ( len-- ) args[ len ] = arguments[ len ];

  		    var dom = this;
  		    var i;
  		    var j;
  		    for (i = 0; i < args.length; i += 1) {
  		      var toAdd = $(args[i]);
  		      for (j = 0; j < toAdd.length; j += 1) {
  		        dom[dom.length] = toAdd[j];
  		        dom.length += 1;
  		      }
  		    }
  		    return dom;
  		  }

  		  var Methods = {
  		    addClass: addClass,
  		    removeClass: removeClass,
  		    hasClass: hasClass,
  		    toggleClass: toggleClass,
  		    attr: attr,
  		    removeAttr: removeAttr,
  		    data: data,
  		    transform: transform,
  		    transition: transition,
  		    on: on,
  		    off: off,
  		    trigger: trigger,
  		    transitionEnd: transitionEnd,
  		    outerWidth: outerWidth,
  		    outerHeight: outerHeight,
  		    offset: offset,
  		    css: css,
  		    each: each,
  		    html: html,
  		    text: text,
  		    is: is,
  		    index: index,
  		    eq: eq,
  		    append: append,
  		    prepend: prepend,
  		    next: next,
  		    nextAll: nextAll,
  		    prev: prev,
  		    prevAll: prevAll,
  		    parent: parent,
  		    parents: parents,
  		    closest: closest,
  		    find: find,
  		    children: children,
  		    remove: remove,
  		    add: add,
  		    styles: styles,
  		  };

  		  Object.keys(Methods).forEach(function (methodName) {
  		    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  		  });

  		  var Utils = {
  		    deleteProps: function deleteProps(obj) {
  		      var object = obj;
  		      Object.keys(object).forEach(function (key) {
  		        try {
  		          object[key] = null;
  		        } catch (e) {
  		          // no getter for object
  		        }
  		        try {
  		          delete object[key];
  		        } catch (e) {
  		          // something got wrong
  		        }
  		      });
  		    },
  		    nextTick: function nextTick(callback, delay) {
  		      if ( delay === void 0 ) delay = 0;

  		      return setTimeout(callback, delay);
  		    },
  		    now: function now() {
  		      return Date.now();
  		    },
  		    getTranslate: function getTranslate(el, axis) {
  		      if ( axis === void 0 ) axis = 'x';

  		      var matrix;
  		      var curTransform;
  		      var transformMatrix;

  		      var curStyle = win.getComputedStyle(el, null);

  		      if (win.WebKitCSSMatrix) {
  		        curTransform = curStyle.transform || curStyle.webkitTransform;
  		        if (curTransform.split(',').length > 6) {
  		          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
  		        }
  		        // Some old versions of Webkit choke when 'none' is passed; pass
  		        // empty string instead in this case
  		        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  		      } else {
  		        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
  		        matrix = transformMatrix.toString().split(',');
  		      }

  		      if (axis === 'x') {
  		        // Latest Chrome and webkits Fix
  		        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
  		        // Crazy IE10 Matrix
  		        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
  		        // Normal Browsers
  		        else { curTransform = parseFloat(matrix[4]); }
  		      }
  		      if (axis === 'y') {
  		        // Latest Chrome and webkits Fix
  		        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
  		        // Crazy IE10 Matrix
  		        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
  		        // Normal Browsers
  		        else { curTransform = parseFloat(matrix[5]); }
  		      }
  		      return curTransform || 0;
  		    },
  		    parseUrlQuery: function parseUrlQuery(url) {
  		      var query = {};
  		      var urlToParse = url || win.location.href;
  		      var i;
  		      var params;
  		      var param;
  		      var length;
  		      if (typeof urlToParse === 'string' && urlToParse.length) {
  		        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
  		        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
  		        length = params.length;

  		        for (i = 0; i < length; i += 1) {
  		          param = params[i].replace(/#\S+/g, '').split('=');
  		          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
  		        }
  		      }
  		      return query;
  		    },
  		    isObject: function isObject(o) {
  		      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
  		    },
  		    extend: function extend() {
  		      var args = [], len$1 = arguments.length;
  		      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

  		      var to = Object(args[0]);
  		      for (var i = 1; i < args.length; i += 1) {
  		        var nextSource = args[i];
  		        if (nextSource !== undefined && nextSource !== null) {
  		          var keysArray = Object.keys(Object(nextSource));
  		          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
  		            var nextKey = keysArray[nextIndex];
  		            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
  		            if (desc !== undefined && desc.enumerable) {
  		              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
  		                Utils.extend(to[nextKey], nextSource[nextKey]);
  		              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
  		                to[nextKey] = {};
  		                Utils.extend(to[nextKey], nextSource[nextKey]);
  		              } else {
  		                to[nextKey] = nextSource[nextKey];
  		              }
  		            }
  		          }
  		        }
  		      }
  		      return to;
  		    },
  		  };

  		  var Support = (function Support() {
  		    var testDiv = doc.createElement('div');
  		    return {
  		      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
  		        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
  		      }()),

  		      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || ('maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0)),
  		      prefixedPointerEvents: !!win.navigator.msPointerEnabled,

  		      transition: (function checkTransition() {
  		        var style = testDiv.style;
  		        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
  		      }()),
  		      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
  		        var style = testDiv.style;
  		        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
  		      }()),

  		      flexbox: (function checkFlexbox() {
  		        var style = testDiv.style;
  		        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
  		        for (var i = 0; i < styles.length; i += 1) {
  		          if (styles[i] in style) { return true; }
  		        }
  		        return false;
  		      }()),

  		      observer: (function checkObserver() {
  		        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
  		      }()),

  		      passiveListener: (function checkPassiveListener() {
  		        var supportsPassive = false;
  		        try {
  		          var opts = Object.defineProperty({}, 'passive', {
  		            // eslint-disable-next-line
  		            get: function get() {
  		              supportsPassive = true;
  		            },
  		          });
  		          win.addEventListener('testPassiveListener', null, opts);
  		        } catch (e) {
  		          // No support
  		        }
  		        return supportsPassive;
  		      }()),

  		      gestures: (function checkGestures() {
  		        return 'ongesturestart' in win;
  		      }()),
  		    };
  		  }());

  		  var Browser = (function Browser() {
  		    function isSafari() {
  		      var ua = win.navigator.userAgent.toLowerCase();
  		      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
  		    }
  		    return {
  		      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
  		      isEdge: !!win.navigator.userAgent.match(/Edge/g),
  		      isSafari: isSafari(),
  		      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
  		    };
  		  }());

  		  var SwiperClass = function SwiperClass(params) {
  		    if ( params === void 0 ) params = {};

  		    var self = this;
  		    self.params = params;

  		    // Events
  		    self.eventsListeners = {};

  		    if (self.params && self.params.on) {
  		      Object.keys(self.params.on).forEach(function (eventName) {
  		        self.on(eventName, self.params.on[eventName]);
  		      });
  		    }
  		  };

  		  var staticAccessors = { components: { configurable: true } };

  		  SwiperClass.prototype.on = function on (events, handler, priority) {
  		    var self = this;
  		    if (typeof handler !== 'function') { return self; }
  		    var method = priority ? 'unshift' : 'push';
  		    events.split(' ').forEach(function (event) {
  		      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
  		      self.eventsListeners[event][method](handler);
  		    });
  		    return self;
  		  };

  		  SwiperClass.prototype.once = function once (events, handler, priority) {
  		    var self = this;
  		    if (typeof handler !== 'function') { return self; }
  		    function onceHandler() {
  		        var args = [], len = arguments.length;
  		        while ( len-- ) args[ len ] = arguments[ len ];

  		      handler.apply(self, args);
  		      self.off(events, onceHandler);
  		      if (onceHandler.f7proxy) {
  		        delete onceHandler.f7proxy;
  		      }
  		    }
  		    onceHandler.f7proxy = handler;
  		    return self.on(events, onceHandler, priority);
  		  };

  		  SwiperClass.prototype.off = function off (events, handler) {
  		    var self = this;
  		    if (!self.eventsListeners) { return self; }
  		    events.split(' ').forEach(function (event) {
  		      if (typeof handler === 'undefined') {
  		        self.eventsListeners[event] = [];
  		      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
  		        self.eventsListeners[event].forEach(function (eventHandler, index) {
  		          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
  		            self.eventsListeners[event].splice(index, 1);
  		          }
  		        });
  		      }
  		    });
  		    return self;
  		  };

  		  SwiperClass.prototype.emit = function emit () {
  		      var args = [], len = arguments.length;
  		      while ( len-- ) args[ len ] = arguments[ len ];

  		    var self = this;
  		    if (!self.eventsListeners) { return self; }
  		    var events;
  		    var data;
  		    var context;
  		    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
  		      events = args[0];
  		      data = args.slice(1, args.length);
  		      context = self;
  		    } else {
  		      events = args[0].events;
  		      data = args[0].data;
  		      context = args[0].context || self;
  		    }
  		    var eventsArray = Array.isArray(events) ? events : events.split(' ');
  		    eventsArray.forEach(function (event) {
  		      if (self.eventsListeners && self.eventsListeners[event]) {
  		        var handlers = [];
  		        self.eventsListeners[event].forEach(function (eventHandler) {
  		          handlers.push(eventHandler);
  		        });
  		        handlers.forEach(function (eventHandler) {
  		          eventHandler.apply(context, data);
  		        });
  		      }
  		    });
  		    return self;
  		  };

  		  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
  		    var instance = this;
  		    if (!instance.modules) { return; }
  		    Object.keys(instance.modules).forEach(function (moduleName) {
  		      var module = instance.modules[moduleName];
  		      // Extend params
  		      if (module.params) {
  		        Utils.extend(instanceParams, module.params);
  		      }
  		    });
  		  };

  		  SwiperClass.prototype.useModules = function useModules (modulesParams) {
  		      if ( modulesParams === void 0 ) modulesParams = {};

  		    var instance = this;
  		    if (!instance.modules) { return; }
  		    Object.keys(instance.modules).forEach(function (moduleName) {
  		      var module = instance.modules[moduleName];
  		      var moduleParams = modulesParams[moduleName] || {};
  		      // Extend instance methods and props
  		      if (module.instance) {
  		        Object.keys(module.instance).forEach(function (modulePropName) {
  		          var moduleProp = module.instance[modulePropName];
  		          if (typeof moduleProp === 'function') {
  		            instance[modulePropName] = moduleProp.bind(instance);
  		          } else {
  		            instance[modulePropName] = moduleProp;
  		          }
  		        });
  		      }
  		      // Add event listeners
  		      if (module.on && instance.on) {
  		        Object.keys(module.on).forEach(function (moduleEventName) {
  		          instance.on(moduleEventName, module.on[moduleEventName]);
  		        });
  		      }

  		      // Module create callback
  		      if (module.create) {
  		        module.create.bind(instance)(moduleParams);
  		      }
  		    });
  		  };

  		  staticAccessors.components.set = function (components) {
  		    var Class = this;
  		    if (!Class.use) { return; }
  		    Class.use(components);
  		  };

  		  SwiperClass.installModule = function installModule (module) {
  		      var params = [], len = arguments.length - 1;
  		      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

  		    var Class = this;
  		    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
  		    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
  		    Class.prototype.modules[name] = module;
  		    // Prototype
  		    if (module.proto) {
  		      Object.keys(module.proto).forEach(function (key) {
  		        Class.prototype[key] = module.proto[key];
  		      });
  		    }
  		    // Class
  		    if (module.static) {
  		      Object.keys(module.static).forEach(function (key) {
  		        Class[key] = module.static[key];
  		      });
  		    }
  		    // Callback
  		    if (module.install) {
  		      module.install.apply(Class, params);
  		    }
  		    return Class;
  		  };

  		  SwiperClass.use = function use (module) {
  		      var params = [], len = arguments.length - 1;
  		      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

  		    var Class = this;
  		    if (Array.isArray(module)) {
  		      module.forEach(function (m) { return Class.installModule(m); });
  		      return Class;
  		    }
  		    return Class.installModule.apply(Class, [ module ].concat( params ));
  		  };

  		  Object.defineProperties( SwiperClass, staticAccessors );

  		  function updateSize () {
  		    var swiper = this;
  		    var width;
  		    var height;
  		    var $el = swiper.$el;
  		    if (typeof swiper.params.width !== 'undefined') {
  		      width = swiper.params.width;
  		    } else {
  		      width = $el[0].clientWidth;
  		    }
  		    if (typeof swiper.params.height !== 'undefined') {
  		      height = swiper.params.height;
  		    } else {
  		      height = $el[0].clientHeight;
  		    }
  		    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
  		      return;
  		    }

  		    // Subtract paddings
  		    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
  		    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

  		    Utils.extend(swiper, {
  		      width: width,
  		      height: height,
  		      size: swiper.isHorizontal() ? width : height,
  		    });
  		  }

  		  function updateSlides () {
  		    var swiper = this;
  		    var params = swiper.params;

  		    var $wrapperEl = swiper.$wrapperEl;
  		    var swiperSize = swiper.size;
  		    var rtl = swiper.rtlTranslate;
  		    var wrongRTL = swiper.wrongRTL;
  		    var isVirtual = swiper.virtual && params.virtual.enabled;
  		    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  		    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
  		    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  		    var snapGrid = [];
  		    var slidesGrid = [];
  		    var slidesSizesGrid = [];

  		    var offsetBefore = params.slidesOffsetBefore;
  		    if (typeof offsetBefore === 'function') {
  		      offsetBefore = params.slidesOffsetBefore.call(swiper);
  		    }

  		    var offsetAfter = params.slidesOffsetAfter;
  		    if (typeof offsetAfter === 'function') {
  		      offsetAfter = params.slidesOffsetAfter.call(swiper);
  		    }

  		    var previousSnapGridLength = swiper.snapGrid.length;
  		    var previousSlidesGridLength = swiper.snapGrid.length;

  		    var spaceBetween = params.spaceBetween;
  		    var slidePosition = -offsetBefore;
  		    var prevSlideSize = 0;
  		    var index = 0;
  		    if (typeof swiperSize === 'undefined') {
  		      return;
  		    }
  		    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
  		      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
  		    }

  		    swiper.virtualSize = -spaceBetween;

  		    // reset margins
  		    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
  		    else { slides.css({ marginRight: '', marginBottom: '' }); }

  		    var slidesNumberEvenToRows;
  		    if (params.slidesPerColumn > 1) {
  		      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
  		        slidesNumberEvenToRows = slidesLength;
  		      } else {
  		        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
  		      }
  		      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
  		        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
  		      }
  		    }

  		    // Calc slides
  		    var slideSize;
  		    var slidesPerColumn = params.slidesPerColumn;
  		    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  		    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
  		    for (var i = 0; i < slidesLength; i += 1) {
  		      slideSize = 0;
  		      var slide = slides.eq(i);
  		      if (params.slidesPerColumn > 1) {
  		        // Set slides order
  		        var newSlideOrderIndex = (void 0);
  		        var column = (void 0);
  		        var row = (void 0);
  		        if (
  		          (params.slidesPerColumnFill === 'column')
  		          || (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1)
  		        ) {
  		          if (params.slidesPerColumnFill === 'column') {
  		            column = Math.floor(i / slidesPerColumn);
  		            row = i - (column * slidesPerColumn);
  		            if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
  		              row += 1;
  		              if (row >= slidesPerColumn) {
  		                row = 0;
  		                column += 1;
  		              }
  		            }
  		          } else {
  		            var groupIndex = Math.floor(i / params.slidesPerGroup);
  		            row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
  		            column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
  		          }
  		          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
  		          slide
  		            .css({
  		              '-webkit-box-ordinal-group': newSlideOrderIndex,
  		              '-moz-box-ordinal-group': newSlideOrderIndex,
  		              '-ms-flex-order': newSlideOrderIndex,
  		              '-webkit-order': newSlideOrderIndex,
  		              order: newSlideOrderIndex,
  		            });
  		        } else {
  		          row = Math.floor(i / slidesPerRow);
  		          column = i - (row * slidesPerRow);
  		        }
  		        slide
  		          .css(
  		            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
  		            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
  		          )
  		          .attr('data-swiper-column', column)
  		          .attr('data-swiper-row', row);
  		      }
  		      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

  		      if (params.slidesPerView === 'auto') {
  		        var slideStyles = win.getComputedStyle(slide[0], null);
  		        var currentTransform = slide[0].style.transform;
  		        var currentWebKitTransform = slide[0].style.webkitTransform;
  		        if (currentTransform) {
  		          slide[0].style.transform = 'none';
  		        }
  		        if (currentWebKitTransform) {
  		          slide[0].style.webkitTransform = 'none';
  		        }
  		        if (params.roundLengths) {
  		          slideSize = swiper.isHorizontal()
  		            ? slide.outerWidth(true)
  		            : slide.outerHeight(true);
  		        } else {
  		          // eslint-disable-next-line
  		          if (swiper.isHorizontal()) {
  		            var width = parseFloat(slideStyles.getPropertyValue('width'));
  		            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
  		            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
  		            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
  		            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
  		            var boxSizing = slideStyles.getPropertyValue('box-sizing');
  		            if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
  		              slideSize = width + marginLeft + marginRight;
  		            } else {
  		              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
  		            }
  		          } else {
  		            var height = parseFloat(slideStyles.getPropertyValue('height'));
  		            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
  		            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
  		            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
  		            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
  		            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
  		            if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
  		              slideSize = height + marginTop + marginBottom;
  		            } else {
  		              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
  		            }
  		          }
  		        }
  		        if (currentTransform) {
  		          slide[0].style.transform = currentTransform;
  		        }
  		        if (currentWebKitTransform) {
  		          slide[0].style.webkitTransform = currentWebKitTransform;
  		        }
  		        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
  		      } else {
  		        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
  		        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

  		        if (slides[i]) {
  		          if (swiper.isHorizontal()) {
  		            slides[i].style.width = slideSize + "px";
  		          } else {
  		            slides[i].style.height = slideSize + "px";
  		          }
  		        }
  		      }
  		      if (slides[i]) {
  		        slides[i].swiperSlideSize = slideSize;
  		      }
  		      slidesSizesGrid.push(slideSize);


  		      if (params.centeredSlides) {
  		        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
  		        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
  		        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
  		        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
  		        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
  		        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
  		        slidesGrid.push(slidePosition);
  		      } else {
  		        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
  		        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
  		        slidesGrid.push(slidePosition);
  		        slidePosition = slidePosition + slideSize + spaceBetween;
  		      }

  		      swiper.virtualSize += slideSize + spaceBetween;

  		      prevSlideSize = slideSize;

  		      index += 1;
  		    }
  		    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  		    var newSlidesGrid;

  		    if (
  		      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
  		      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
  		    }
  		    if (!Support.flexbox || params.setWrapperSize) {
  		      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
  		      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
  		    }

  		    if (params.slidesPerColumn > 1) {
  		      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
  		      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
  		      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
  		      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
  		      if (params.centeredSlides) {
  		        newSlidesGrid = [];
  		        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
  		          var slidesGridItem = snapGrid[i$1];
  		          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
  		          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
  		        }
  		        snapGrid = newSlidesGrid;
  		      }
  		    }

  		    // Remove last grid elements depending on width
  		    if (!params.centeredSlides) {
  		      newSlidesGrid = [];
  		      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
  		        var slidesGridItem$1 = snapGrid[i$2];
  		        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
  		        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
  		          newSlidesGrid.push(slidesGridItem$1);
  		        }
  		      }
  		      snapGrid = newSlidesGrid;
  		      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
  		        snapGrid.push(swiper.virtualSize - swiperSize);
  		      }
  		    }
  		    if (snapGrid.length === 0) { snapGrid = [0]; }

  		    if (params.spaceBetween !== 0) {
  		      if (swiper.isHorizontal()) {
  		        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
  		        else { slides.css({ marginRight: (spaceBetween + "px") }); }
  		      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
  		    }

  		    if (params.centerInsufficientSlides) {
  		      var allSlidesSize = 0;
  		      slidesSizesGrid.forEach(function (slideSizeValue) {
  		        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
  		      });
  		      allSlidesSize -= params.spaceBetween;
  		      if (allSlidesSize < swiperSize) {
  		        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
  		        snapGrid.forEach(function (snap, snapIndex) {
  		          snapGrid[snapIndex] = snap - allSlidesOffset;
  		        });
  		        slidesGrid.forEach(function (snap, snapIndex) {
  		          slidesGrid[snapIndex] = snap + allSlidesOffset;
  		        });
  		      }
  		    }

  		    Utils.extend(swiper, {
  		      slides: slides,
  		      snapGrid: snapGrid,
  		      slidesGrid: slidesGrid,
  		      slidesSizesGrid: slidesSizesGrid,
  		    });

  		    if (slidesLength !== previousSlidesLength) {
  		      swiper.emit('slidesLengthChange');
  		    }
  		    if (snapGrid.length !== previousSnapGridLength) {
  		      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
  		      swiper.emit('snapGridLengthChange');
  		    }
  		    if (slidesGrid.length !== previousSlidesGridLength) {
  		      swiper.emit('slidesGridLengthChange');
  		    }

  		    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
  		      swiper.updateSlidesOffset();
  		    }
  		  }

  		  function updateAutoHeight (speed) {
  		    var swiper = this;
  		    var activeSlides = [];
  		    var newHeight = 0;
  		    var i;
  		    if (typeof speed === 'number') {
  		      swiper.setTransition(speed);
  		    } else if (speed === true) {
  		      swiper.setTransition(swiper.params.speed);
  		    }
  		    // Find slides currently in view
  		    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
  		      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
  		        var index = swiper.activeIndex + i;
  		        if (index > swiper.slides.length) { break; }
  		        activeSlides.push(swiper.slides.eq(index)[0]);
  		      }
  		    } else {
  		      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
  		    }

  		    // Find new height from highest slide in view
  		    for (i = 0; i < activeSlides.length; i += 1) {
  		      if (typeof activeSlides[i] !== 'undefined') {
  		        var height = activeSlides[i].offsetHeight;
  		        newHeight = height > newHeight ? height : newHeight;
  		      }
  		    }

  		    // Update Height
  		    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  		  }

  		  function updateSlidesOffset () {
  		    var swiper = this;
  		    var slides = swiper.slides;
  		    for (var i = 0; i < slides.length; i += 1) {
  		      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  		    }
  		  }

  		  function updateSlidesProgress (translate) {
  		    if ( translate === void 0 ) translate = (this && this.translate) || 0;

  		    var swiper = this;
  		    var params = swiper.params;

  		    var slides = swiper.slides;
  		    var rtl = swiper.rtlTranslate;

  		    if (slides.length === 0) { return; }
  		    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

  		    var offsetCenter = -translate;
  		    if (rtl) { offsetCenter = translate; }

  		    // Visible Slides
  		    slides.removeClass(params.slideVisibleClass);

  		    swiper.visibleSlidesIndexes = [];
  		    swiper.visibleSlides = [];

  		    for (var i = 0; i < slides.length; i += 1) {
  		      var slide = slides[i];
  		      var slideProgress = (
  		        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
  		      ) / (slide.swiperSlideSize + params.spaceBetween);
  		      if (params.watchSlidesVisibility) {
  		        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
  		        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
  		        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
  		                  || (slideAfter > 1 && slideAfter <= swiper.size)
  		                  || (slideBefore <= 0 && slideAfter >= swiper.size);
  		        if (isVisible) {
  		          swiper.visibleSlides.push(slide);
  		          swiper.visibleSlidesIndexes.push(i);
  		          slides.eq(i).addClass(params.slideVisibleClass);
  		        }
  		      }
  		      slide.progress = rtl ? -slideProgress : slideProgress;
  		    }
  		    swiper.visibleSlides = $(swiper.visibleSlides);
  		  }

  		  function updateProgress (translate) {
  		    if ( translate === void 0 ) translate = (this && this.translate) || 0;

  		    var swiper = this;
  		    var params = swiper.params;

  		    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  		    var progress = swiper.progress;
  		    var isBeginning = swiper.isBeginning;
  		    var isEnd = swiper.isEnd;
  		    var wasBeginning = isBeginning;
  		    var wasEnd = isEnd;
  		    if (translatesDiff === 0) {
  		      progress = 0;
  		      isBeginning = true;
  		      isEnd = true;
  		    } else {
  		      progress = (translate - swiper.minTranslate()) / (translatesDiff);
  		      isBeginning = progress <= 0;
  		      isEnd = progress >= 1;
  		    }
  		    Utils.extend(swiper, {
  		      progress: progress,
  		      isBeginning: isBeginning,
  		      isEnd: isEnd,
  		    });

  		    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

  		    if (isBeginning && !wasBeginning) {
  		      swiper.emit('reachBeginning toEdge');
  		    }
  		    if (isEnd && !wasEnd) {
  		      swiper.emit('reachEnd toEdge');
  		    }
  		    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
  		      swiper.emit('fromEdge');
  		    }

  		    swiper.emit('progress', progress);
  		  }

  		  function updateSlidesClasses () {
  		    var swiper = this;

  		    var slides = swiper.slides;
  		    var params = swiper.params;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    var activeIndex = swiper.activeIndex;
  		    var realIndex = swiper.realIndex;
  		    var isVirtual = swiper.virtual && params.virtual.enabled;

  		    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

  		    var activeSlide;
  		    if (isVirtual) {
  		      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
  		    } else {
  		      activeSlide = slides.eq(activeIndex);
  		    }

  		    // Active classes
  		    activeSlide.addClass(params.slideActiveClass);

  		    if (params.loop) {
  		      // Duplicate to all looped slides
  		      if (activeSlide.hasClass(params.slideDuplicateClass)) {
  		        $wrapperEl
  		          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
  		          .addClass(params.slideDuplicateActiveClass);
  		      } else {
  		        $wrapperEl
  		          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
  		          .addClass(params.slideDuplicateActiveClass);
  		      }
  		    }
  		    // Next Slide
  		    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
  		    if (params.loop && nextSlide.length === 0) {
  		      nextSlide = slides.eq(0);
  		      nextSlide.addClass(params.slideNextClass);
  		    }
  		    // Prev Slide
  		    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
  		    if (params.loop && prevSlide.length === 0) {
  		      prevSlide = slides.eq(-1);
  		      prevSlide.addClass(params.slidePrevClass);
  		    }
  		    if (params.loop) {
  		      // Duplicate to all looped slides
  		      if (nextSlide.hasClass(params.slideDuplicateClass)) {
  		        $wrapperEl
  		          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
  		          .addClass(params.slideDuplicateNextClass);
  		      } else {
  		        $wrapperEl
  		          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
  		          .addClass(params.slideDuplicateNextClass);
  		      }
  		      if (prevSlide.hasClass(params.slideDuplicateClass)) {
  		        $wrapperEl
  		          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
  		          .addClass(params.slideDuplicatePrevClass);
  		      } else {
  		        $wrapperEl
  		          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
  		          .addClass(params.slideDuplicatePrevClass);
  		      }
  		    }
  		  }

  		  function updateActiveIndex (newActiveIndex) {
  		    var swiper = this;
  		    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  		    var slidesGrid = swiper.slidesGrid;
  		    var snapGrid = swiper.snapGrid;
  		    var params = swiper.params;
  		    var previousIndex = swiper.activeIndex;
  		    var previousRealIndex = swiper.realIndex;
  		    var previousSnapIndex = swiper.snapIndex;
  		    var activeIndex = newActiveIndex;
  		    var snapIndex;
  		    if (typeof activeIndex === 'undefined') {
  		      for (var i = 0; i < slidesGrid.length; i += 1) {
  		        if (typeof slidesGrid[i + 1] !== 'undefined') {
  		          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
  		            activeIndex = i;
  		          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
  		            activeIndex = i + 1;
  		          }
  		        } else if (translate >= slidesGrid[i]) {
  		          activeIndex = i;
  		        }
  		      }
  		      // Normalize slideIndex
  		      if (params.normalizeSlideIndex) {
  		        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
  		      }
  		    }
  		    if (snapGrid.indexOf(translate) >= 0) {
  		      snapIndex = snapGrid.indexOf(translate);
  		    } else {
  		      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
  		    }
  		    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
  		    if (activeIndex === previousIndex) {
  		      if (snapIndex !== previousSnapIndex) {
  		        swiper.snapIndex = snapIndex;
  		        swiper.emit('snapIndexChange');
  		      }
  		      return;
  		    }

  		    // Get real index
  		    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

  		    Utils.extend(swiper, {
  		      snapIndex: snapIndex,
  		      realIndex: realIndex,
  		      previousIndex: previousIndex,
  		      activeIndex: activeIndex,
  		    });
  		    swiper.emit('activeIndexChange');
  		    swiper.emit('snapIndexChange');
  		    if (previousRealIndex !== realIndex) {
  		      swiper.emit('realIndexChange');
  		    }
  		    if (swiper.initialized || swiper.runCallbacksOnInit) {
  		      swiper.emit('slideChange');
  		    }
  		  }

  		  function updateClickedSlide (e) {
  		    var swiper = this;
  		    var params = swiper.params;
  		    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
  		    var slideFound = false;
  		    if (slide) {
  		      for (var i = 0; i < swiper.slides.length; i += 1) {
  		        if (swiper.slides[i] === slide) { slideFound = true; }
  		      }
  		    }

  		    if (slide && slideFound) {
  		      swiper.clickedSlide = slide;
  		      if (swiper.virtual && swiper.params.virtual.enabled) {
  		        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
  		      } else {
  		        swiper.clickedIndex = $(slide).index();
  		      }
  		    } else {
  		      swiper.clickedSlide = undefined;
  		      swiper.clickedIndex = undefined;
  		      return;
  		    }
  		    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
  		      swiper.slideToClickedSlide();
  		    }
  		  }

  		  var update = {
  		    updateSize: updateSize,
  		    updateSlides: updateSlides,
  		    updateAutoHeight: updateAutoHeight,
  		    updateSlidesOffset: updateSlidesOffset,
  		    updateSlidesProgress: updateSlidesProgress,
  		    updateProgress: updateProgress,
  		    updateSlidesClasses: updateSlidesClasses,
  		    updateActiveIndex: updateActiveIndex,
  		    updateClickedSlide: updateClickedSlide,
  		  };

  		  function getTranslate (axis) {
  		    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

  		    var swiper = this;

  		    var params = swiper.params;
  		    var rtl = swiper.rtlTranslate;
  		    var translate = swiper.translate;
  		    var $wrapperEl = swiper.$wrapperEl;

  		    if (params.virtualTranslate) {
  		      return rtl ? -translate : translate;
  		    }

  		    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
  		    if (rtl) { currentTranslate = -currentTranslate; }

  		    return currentTranslate || 0;
  		  }

  		  function setTranslate (translate, byController) {
  		    var swiper = this;
  		    var rtl = swiper.rtlTranslate;
  		    var params = swiper.params;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    var progress = swiper.progress;
  		    var x = 0;
  		    var y = 0;
  		    var z = 0;

  		    if (swiper.isHorizontal()) {
  		      x = rtl ? -translate : translate;
  		    } else {
  		      y = translate;
  		    }

  		    if (params.roundLengths) {
  		      x = Math.floor(x);
  		      y = Math.floor(y);
  		    }

  		    if (!params.virtualTranslate) {
  		      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
  		      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
  		    }
  		    swiper.previousTranslate = swiper.translate;
  		    swiper.translate = swiper.isHorizontal() ? x : y;

  		    // Check if we need to update progress
  		    var newProgress;
  		    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  		    if (translatesDiff === 0) {
  		      newProgress = 0;
  		    } else {
  		      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
  		    }
  		    if (newProgress !== progress) {
  		      swiper.updateProgress(translate);
  		    }

  		    swiper.emit('setTranslate', swiper.translate, byController);
  		  }

  		  function minTranslate () {
  		    return (-this.snapGrid[0]);
  		  }

  		  function maxTranslate () {
  		    return (-this.snapGrid[this.snapGrid.length - 1]);
  		  }

  		  var translate = {
  		    getTranslate: getTranslate,
  		    setTranslate: setTranslate,
  		    minTranslate: minTranslate,
  		    maxTranslate: maxTranslate,
  		  };

  		  function setTransition (duration, byController) {
  		    var swiper = this;

  		    swiper.$wrapperEl.transition(duration);

  		    swiper.emit('setTransition', duration, byController);
  		  }

  		  function transitionStart (runCallbacks, direction) {
  		    if ( runCallbacks === void 0 ) runCallbacks = true;

  		    var swiper = this;
  		    var activeIndex = swiper.activeIndex;
  		    var params = swiper.params;
  		    var previousIndex = swiper.previousIndex;
  		    if (params.autoHeight) {
  		      swiper.updateAutoHeight();
  		    }

  		    var dir = direction;
  		    if (!dir) {
  		      if (activeIndex > previousIndex) { dir = 'next'; }
  		      else if (activeIndex < previousIndex) { dir = 'prev'; }
  		      else { dir = 'reset'; }
  		    }

  		    swiper.emit('transitionStart');

  		    if (runCallbacks && activeIndex !== previousIndex) {
  		      if (dir === 'reset') {
  		        swiper.emit('slideResetTransitionStart');
  		        return;
  		      }
  		      swiper.emit('slideChangeTransitionStart');
  		      if (dir === 'next') {
  		        swiper.emit('slideNextTransitionStart');
  		      } else {
  		        swiper.emit('slidePrevTransitionStart');
  		      }
  		    }
  		  }

  		  function transitionEnd$1 (runCallbacks, direction) {
  		    if ( runCallbacks === void 0 ) runCallbacks = true;

  		    var swiper = this;
  		    var activeIndex = swiper.activeIndex;
  		    var previousIndex = swiper.previousIndex;
  		    swiper.animating = false;
  		    swiper.setTransition(0);

  		    var dir = direction;
  		    if (!dir) {
  		      if (activeIndex > previousIndex) { dir = 'next'; }
  		      else if (activeIndex < previousIndex) { dir = 'prev'; }
  		      else { dir = 'reset'; }
  		    }

  		    swiper.emit('transitionEnd');

  		    if (runCallbacks && activeIndex !== previousIndex) {
  		      if (dir === 'reset') {
  		        swiper.emit('slideResetTransitionEnd');
  		        return;
  		      }
  		      swiper.emit('slideChangeTransitionEnd');
  		      if (dir === 'next') {
  		        swiper.emit('slideNextTransitionEnd');
  		      } else {
  		        swiper.emit('slidePrevTransitionEnd');
  		      }
  		    }
  		  }

  		  var transition$1 = {
  		    setTransition: setTransition,
  		    transitionStart: transitionStart,
  		    transitionEnd: transitionEnd$1,
  		  };

  		  function slideTo (index, speed, runCallbacks, internal) {
  		    if ( index === void 0 ) index = 0;
  		    if ( speed === void 0 ) speed = this.params.speed;
  		    if ( runCallbacks === void 0 ) runCallbacks = true;

  		    var swiper = this;
  		    var slideIndex = index;
  		    if (slideIndex < 0) { slideIndex = 0; }

  		    var params = swiper.params;
  		    var snapGrid = swiper.snapGrid;
  		    var slidesGrid = swiper.slidesGrid;
  		    var previousIndex = swiper.previousIndex;
  		    var activeIndex = swiper.activeIndex;
  		    var rtl = swiper.rtlTranslate;
  		    if (swiper.animating && params.preventInteractionOnTransition) {
  		      return false;
  		    }

  		    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
  		    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

  		    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
  		      swiper.emit('beforeSlideChangeStart');
  		    }

  		    var translate = -snapGrid[snapIndex];

  		    // Update progress
  		    swiper.updateProgress(translate);

  		    // Normalize slideIndex
  		    if (params.normalizeSlideIndex) {
  		      for (var i = 0; i < slidesGrid.length; i += 1) {
  		        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
  		          slideIndex = i;
  		        }
  		      }
  		    }
  		    // Directions locks
  		    if (swiper.initialized && slideIndex !== activeIndex) {
  		      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
  		        return false;
  		      }
  		      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
  		        if ((activeIndex || 0) !== slideIndex) { return false; }
  		      }
  		    }

  		    var direction;
  		    if (slideIndex > activeIndex) { direction = 'next'; }
  		    else if (slideIndex < activeIndex) { direction = 'prev'; }
  		    else { direction = 'reset'; }


  		    // Update Index
  		    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
  		      swiper.updateActiveIndex(slideIndex);
  		      // Update Height
  		      if (params.autoHeight) {
  		        swiper.updateAutoHeight();
  		      }
  		      swiper.updateSlidesClasses();
  		      if (params.effect !== 'slide') {
  		        swiper.setTranslate(translate);
  		      }
  		      if (direction !== 'reset') {
  		        swiper.transitionStart(runCallbacks, direction);
  		        swiper.transitionEnd(runCallbacks, direction);
  		      }
  		      return false;
  		    }

  		    if (speed === 0 || !Support.transition) {
  		      swiper.setTransition(0);
  		      swiper.setTranslate(translate);
  		      swiper.updateActiveIndex(slideIndex);
  		      swiper.updateSlidesClasses();
  		      swiper.emit('beforeTransitionStart', speed, internal);
  		      swiper.transitionStart(runCallbacks, direction);
  		      swiper.transitionEnd(runCallbacks, direction);
  		    } else {
  		      swiper.setTransition(speed);
  		      swiper.setTranslate(translate);
  		      swiper.updateActiveIndex(slideIndex);
  		      swiper.updateSlidesClasses();
  		      swiper.emit('beforeTransitionStart', speed, internal);
  		      swiper.transitionStart(runCallbacks, direction);
  		      if (!swiper.animating) {
  		        swiper.animating = true;
  		        if (!swiper.onSlideToWrapperTransitionEnd) {
  		          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
  		            if (!swiper || swiper.destroyed) { return; }
  		            if (e.target !== this) { return; }
  		            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  		            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  		            swiper.onSlideToWrapperTransitionEnd = null;
  		            delete swiper.onSlideToWrapperTransitionEnd;
  		            swiper.transitionEnd(runCallbacks, direction);
  		          };
  		        }
  		        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  		        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  		      }
  		    }

  		    return true;
  		  }

  		  function slideToLoop (index, speed, runCallbacks, internal) {
  		    if ( index === void 0 ) index = 0;
  		    if ( speed === void 0 ) speed = this.params.speed;
  		    if ( runCallbacks === void 0 ) runCallbacks = true;

  		    var swiper = this;
  		    var newIndex = index;
  		    if (swiper.params.loop) {
  		      newIndex += swiper.loopedSlides;
  		    }

  		    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  		  }

  		  /* eslint no-unused-vars: "off" */
  		  function slideNext (speed, runCallbacks, internal) {
  		    if ( speed === void 0 ) speed = this.params.speed;
  		    if ( runCallbacks === void 0 ) runCallbacks = true;

  		    var swiper = this;
  		    var params = swiper.params;
  		    var animating = swiper.animating;
  		    if (params.loop) {
  		      if (animating) { return false; }
  		      swiper.loopFix();
  		      // eslint-disable-next-line
  		      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  		      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  		    }
  		    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  		  }

  		  /* eslint no-unused-vars: "off" */
  		  function slidePrev (speed, runCallbacks, internal) {
  		    if ( speed === void 0 ) speed = this.params.speed;
  		    if ( runCallbacks === void 0 ) runCallbacks = true;

  		    var swiper = this;
  		    var params = swiper.params;
  		    var animating = swiper.animating;
  		    var snapGrid = swiper.snapGrid;
  		    var slidesGrid = swiper.slidesGrid;
  		    var rtlTranslate = swiper.rtlTranslate;

  		    if (params.loop) {
  		      if (animating) { return false; }
  		      swiper.loopFix();
  		      // eslint-disable-next-line
  		      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  		    }
  		    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  		    function normalize(val) {
  		      if (val < 0) { return -Math.floor(Math.abs(val)); }
  		      return Math.floor(val);
  		    }
  		    var normalizedTranslate = normalize(translate);
  		    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
  		    slidesGrid.map(function (val) { return normalize(val); });

  		    snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
  		    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  		    var prevIndex;
  		    if (typeof prevSnap !== 'undefined') {
  		      prevIndex = slidesGrid.indexOf(prevSnap);
  		      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
  		    }
  		    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  		  }

  		  /* eslint no-unused-vars: "off" */
  		  function slideReset (speed, runCallbacks, internal) {
  		    if ( speed === void 0 ) speed = this.params.speed;
  		    if ( runCallbacks === void 0 ) runCallbacks = true;

  		    var swiper = this;
  		    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  		  }

  		  /* eslint no-unused-vars: "off" */
  		  function slideToClosest (speed, runCallbacks, internal) {
  		    if ( speed === void 0 ) speed = this.params.speed;
  		    if ( runCallbacks === void 0 ) runCallbacks = true;

  		    var swiper = this;
  		    var index = swiper.activeIndex;
  		    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

  		    if (snapIndex < swiper.snapGrid.length - 1) {
  		      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  		      var currentSnap = swiper.snapGrid[snapIndex];
  		      var nextSnap = swiper.snapGrid[snapIndex + 1];

  		      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
  		        index = swiper.params.slidesPerGroup;
  		      }
  		    }

  		    return swiper.slideTo(index, speed, runCallbacks, internal);
  		  }

  		  function slideToClickedSlide () {
  		    var swiper = this;
  		    var params = swiper.params;
  		    var $wrapperEl = swiper.$wrapperEl;

  		    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  		    var slideToIndex = swiper.clickedIndex;
  		    var realIndex;
  		    if (params.loop) {
  		      if (swiper.animating) { return; }
  		      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
  		      if (params.centeredSlides) {
  		        if (
  		          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
  		          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
  		        ) {
  		          swiper.loopFix();
  		          slideToIndex = $wrapperEl
  		            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
  		            .eq(0)
  		            .index();

  		          Utils.nextTick(function () {
  		            swiper.slideTo(slideToIndex);
  		          });
  		        } else {
  		          swiper.slideTo(slideToIndex);
  		        }
  		      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
  		        swiper.loopFix();
  		        slideToIndex = $wrapperEl
  		          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
  		          .eq(0)
  		          .index();

  		        Utils.nextTick(function () {
  		          swiper.slideTo(slideToIndex);
  		        });
  		      } else {
  		        swiper.slideTo(slideToIndex);
  		      }
  		    } else {
  		      swiper.slideTo(slideToIndex);
  		    }
  		  }

  		  var slide = {
  		    slideTo: slideTo,
  		    slideToLoop: slideToLoop,
  		    slideNext: slideNext,
  		    slidePrev: slidePrev,
  		    slideReset: slideReset,
  		    slideToClosest: slideToClosest,
  		    slideToClickedSlide: slideToClickedSlide,
  		  };

  		  function loopCreate () {
  		    var swiper = this;
  		    var params = swiper.params;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    // Remove duplicated slides
  		    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

  		    var slides = $wrapperEl.children(("." + (params.slideClass)));

  		    if (params.loopFillGroupWithBlank) {
  		      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
  		      if (blankSlidesNum !== params.slidesPerGroup) {
  		        for (var i = 0; i < blankSlidesNum; i += 1) {
  		          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
  		          $wrapperEl.append(blankNode);
  		        }
  		        slides = $wrapperEl.children(("." + (params.slideClass)));
  		      }
  		    }

  		    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

  		    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
  		    swiper.loopedSlides += params.loopAdditionalSlides;
  		    if (swiper.loopedSlides > slides.length) {
  		      swiper.loopedSlides = slides.length;
  		    }

  		    var prependSlides = [];
  		    var appendSlides = [];
  		    slides.each(function (index, el) {
  		      var slide = $(el);
  		      if (index < swiper.loopedSlides) { appendSlides.push(el); }
  		      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
  		      slide.attr('data-swiper-slide-index', index);
  		    });
  		    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
  		      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
  		    }
  		    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
  		      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
  		    }
  		  }

  		  function loopFix () {
  		    var swiper = this;
  		    var params = swiper.params;
  		    var activeIndex = swiper.activeIndex;
  		    var slides = swiper.slides;
  		    var loopedSlides = swiper.loopedSlides;
  		    var allowSlidePrev = swiper.allowSlidePrev;
  		    var allowSlideNext = swiper.allowSlideNext;
  		    var snapGrid = swiper.snapGrid;
  		    var rtl = swiper.rtlTranslate;
  		    var newIndex;
  		    swiper.allowSlidePrev = true;
  		    swiper.allowSlideNext = true;

  		    var snapTranslate = -snapGrid[activeIndex];
  		    var diff = snapTranslate - swiper.getTranslate();


  		    // Fix For Negative Oversliding
  		    if (activeIndex < loopedSlides) {
  		      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
  		      newIndex += loopedSlides;
  		      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
  		      if (slideChanged && diff !== 0) {
  		        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
  		      }
  		    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
  		      // Fix For Positive Oversliding
  		      newIndex = -slides.length + activeIndex + loopedSlides;
  		      newIndex += loopedSlides;
  		      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
  		      if (slideChanged$1 && diff !== 0) {
  		        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
  		      }
  		    }
  		    swiper.allowSlidePrev = allowSlidePrev;
  		    swiper.allowSlideNext = allowSlideNext;
  		  }

  		  function loopDestroy () {
  		    var swiper = this;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    var params = swiper.params;
  		    var slides = swiper.slides;
  		    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
  		    slides.removeAttr('data-swiper-slide-index');
  		  }

  		  var loop = {
  		    loopCreate: loopCreate,
  		    loopFix: loopFix,
  		    loopDestroy: loopDestroy,
  		  };

  		  function setGrabCursor (moving) {
  		    var swiper = this;
  		    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
  		    var el = swiper.el;
  		    el.style.cursor = 'move';
  		    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  		    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  		    el.style.cursor = moving ? 'grabbing' : 'grab';
  		  }

  		  function unsetGrabCursor () {
  		    var swiper = this;
  		    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
  		    swiper.el.style.cursor = '';
  		  }

  		  var grabCursor = {
  		    setGrabCursor: setGrabCursor,
  		    unsetGrabCursor: unsetGrabCursor,
  		  };

  		  function appendSlide (slides) {
  		    var swiper = this;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    var params = swiper.params;
  		    if (params.loop) {
  		      swiper.loopDestroy();
  		    }
  		    if (typeof slides === 'object' && 'length' in slides) {
  		      for (var i = 0; i < slides.length; i += 1) {
  		        if (slides[i]) { $wrapperEl.append(slides[i]); }
  		      }
  		    } else {
  		      $wrapperEl.append(slides);
  		    }
  		    if (params.loop) {
  		      swiper.loopCreate();
  		    }
  		    if (!(params.observer && Support.observer)) {
  		      swiper.update();
  		    }
  		  }

  		  function prependSlide (slides) {
  		    var swiper = this;
  		    var params = swiper.params;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    var activeIndex = swiper.activeIndex;

  		    if (params.loop) {
  		      swiper.loopDestroy();
  		    }
  		    var newActiveIndex = activeIndex + 1;
  		    if (typeof slides === 'object' && 'length' in slides) {
  		      for (var i = 0; i < slides.length; i += 1) {
  		        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
  		      }
  		      newActiveIndex = activeIndex + slides.length;
  		    } else {
  		      $wrapperEl.prepend(slides);
  		    }
  		    if (params.loop) {
  		      swiper.loopCreate();
  		    }
  		    if (!(params.observer && Support.observer)) {
  		      swiper.update();
  		    }
  		    swiper.slideTo(newActiveIndex, 0, false);
  		  }

  		  function addSlide (index, slides) {
  		    var swiper = this;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    var params = swiper.params;
  		    var activeIndex = swiper.activeIndex;
  		    var activeIndexBuffer = activeIndex;
  		    if (params.loop) {
  		      activeIndexBuffer -= swiper.loopedSlides;
  		      swiper.loopDestroy();
  		      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
  		    }
  		    var baseLength = swiper.slides.length;
  		    if (index <= 0) {
  		      swiper.prependSlide(slides);
  		      return;
  		    }
  		    if (index >= baseLength) {
  		      swiper.appendSlide(slides);
  		      return;
  		    }
  		    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

  		    var slidesBuffer = [];
  		    for (var i = baseLength - 1; i >= index; i -= 1) {
  		      var currentSlide = swiper.slides.eq(i);
  		      currentSlide.remove();
  		      slidesBuffer.unshift(currentSlide);
  		    }

  		    if (typeof slides === 'object' && 'length' in slides) {
  		      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
  		        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
  		      }
  		      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  		    } else {
  		      $wrapperEl.append(slides);
  		    }

  		    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
  		      $wrapperEl.append(slidesBuffer[i$2]);
  		    }

  		    if (params.loop) {
  		      swiper.loopCreate();
  		    }
  		    if (!(params.observer && Support.observer)) {
  		      swiper.update();
  		    }
  		    if (params.loop) {
  		      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  		    } else {
  		      swiper.slideTo(newActiveIndex, 0, false);
  		    }
  		  }

  		  function removeSlide (slidesIndexes) {
  		    var swiper = this;
  		    var params = swiper.params;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    var activeIndex = swiper.activeIndex;

  		    var activeIndexBuffer = activeIndex;
  		    if (params.loop) {
  		      activeIndexBuffer -= swiper.loopedSlides;
  		      swiper.loopDestroy();
  		      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
  		    }
  		    var newActiveIndex = activeIndexBuffer;
  		    var indexToRemove;

  		    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
  		      for (var i = 0; i < slidesIndexes.length; i += 1) {
  		        indexToRemove = slidesIndexes[i];
  		        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
  		        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
  		      }
  		      newActiveIndex = Math.max(newActiveIndex, 0);
  		    } else {
  		      indexToRemove = slidesIndexes;
  		      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
  		      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
  		      newActiveIndex = Math.max(newActiveIndex, 0);
  		    }

  		    if (params.loop) {
  		      swiper.loopCreate();
  		    }

  		    if (!(params.observer && Support.observer)) {
  		      swiper.update();
  		    }
  		    if (params.loop) {
  		      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  		    } else {
  		      swiper.slideTo(newActiveIndex, 0, false);
  		    }
  		  }

  		  function removeAllSlides () {
  		    var swiper = this;

  		    var slidesIndexes = [];
  		    for (var i = 0; i < swiper.slides.length; i += 1) {
  		      slidesIndexes.push(i);
  		    }
  		    swiper.removeSlide(slidesIndexes);
  		  }

  		  var manipulation = {
  		    appendSlide: appendSlide,
  		    prependSlide: prependSlide,
  		    addSlide: addSlide,
  		    removeSlide: removeSlide,
  		    removeAllSlides: removeAllSlides,
  		  };

  		  var Device = (function Device() {
  		    var ua = win.navigator.userAgent;

  		    var device = {
  		      ios: false,
  		      android: false,
  		      androidChrome: false,
  		      desktop: false,
  		      windows: false,
  		      iphone: false,
  		      ipod: false,
  		      ipad: false,
  		      cordova: win.cordova || win.phonegap,
  		      phonegap: win.cordova || win.phonegap,
  		    };

  		    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  		    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  		    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  		    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  		    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


  		    // Windows
  		    if (windows) {
  		      device.os = 'windows';
  		      device.osVersion = windows[2];
  		      device.windows = true;
  		    }
  		    // Android
  		    if (android && !windows) {
  		      device.os = 'android';
  		      device.osVersion = android[2];
  		      device.android = true;
  		      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
  		    }
  		    if (ipad || iphone || ipod) {
  		      device.os = 'ios';
  		      device.ios = true;
  		    }
  		    // iOS
  		    if (iphone && !ipod) {
  		      device.osVersion = iphone[2].replace(/_/g, '.');
  		      device.iphone = true;
  		    }
  		    if (ipad) {
  		      device.osVersion = ipad[2].replace(/_/g, '.');
  		      device.ipad = true;
  		    }
  		    if (ipod) {
  		      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
  		      device.iphone = true;
  		    }
  		    // iOS 8+ changed UA
  		    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
  		      if (device.osVersion.split('.')[0] === '10') {
  		        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
  		      }
  		    }

  		    // Desktop
  		    device.desktop = !(device.os || device.android || device.webView);

  		    // Webview
  		    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

  		    // Minimal UI
  		    if (device.os && device.os === 'ios') {
  		      var osVersionArr = device.osVersion.split('.');
  		      var metaViewport = doc.querySelector('meta[name="viewport"]');
  		      device.minimalUi = !device.webView
  		        && (ipod || iphone)
  		        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
  		        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
  		    }

  		    // Pixel Ratio
  		    device.pixelRatio = win.devicePixelRatio || 1;

  		    // Export object
  		    return device;
  		  }());

  		  function onTouchStart (event) {
  		    var swiper = this;
  		    var data = swiper.touchEventsData;
  		    var params = swiper.params;
  		    var touches = swiper.touches;
  		    if (swiper.animating && params.preventInteractionOnTransition) {
  		      return;
  		    }
  		    var e = event;
  		    if (e.originalEvent) { e = e.originalEvent; }
  		    data.isTouchEvent = e.type === 'touchstart';
  		    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
  		    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
  		    if (data.isTouched && data.isMoved) { return; }
  		    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
  		      swiper.allowClick = true;
  		      return;
  		    }
  		    if (params.swipeHandler) {
  		      if (!$(e).closest(params.swipeHandler)[0]) { return; }
  		    }

  		    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  		    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  		    var startX = touches.currentX;
  		    var startY = touches.currentY;

  		    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

  		    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  		    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  		    if (
  		      edgeSwipeDetection
  		      && ((startX <= edgeSwipeThreshold)
  		      || (startX >= win.screen.width - edgeSwipeThreshold))
  		    ) {
  		      return;
  		    }

  		    Utils.extend(data, {
  		      isTouched: true,
  		      isMoved: false,
  		      allowTouchCallbacks: true,
  		      isScrolling: undefined,
  		      startMoving: undefined,
  		    });

  		    touches.startX = startX;
  		    touches.startY = startY;
  		    data.touchStartTime = Utils.now();
  		    swiper.allowClick = true;
  		    swiper.updateSize();
  		    swiper.swipeDirection = undefined;
  		    if (params.threshold > 0) { data.allowThresholdMove = false; }
  		    if (e.type !== 'touchstart') {
  		      var preventDefault = true;
  		      if ($(e.target).is(data.formElements)) { preventDefault = false; }
  		      if (
  		        doc.activeElement
  		        && $(doc.activeElement).is(data.formElements)
  		        && doc.activeElement !== e.target
  		      ) {
  		        doc.activeElement.blur();
  		      }

  		      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  		      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
  		        e.preventDefault();
  		      }
  		    }
  		    swiper.emit('touchStart', e);
  		  }

  		  function onTouchMove (event) {
  		    var swiper = this;
  		    var data = swiper.touchEventsData;
  		    var params = swiper.params;
  		    var touches = swiper.touches;
  		    var rtl = swiper.rtlTranslate;
  		    var e = event;
  		    if (e.originalEvent) { e = e.originalEvent; }
  		    if (!data.isTouched) {
  		      if (data.startMoving && data.isScrolling) {
  		        swiper.emit('touchMoveOpposite', e);
  		      }
  		      return;
  		    }
  		    if (data.isTouchEvent && e.type === 'mousemove') { return; }
  		    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
  		    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
  		    if (e.preventedByNestedSwiper) {
  		      touches.startX = pageX;
  		      touches.startY = pageY;
  		      return;
  		    }
  		    if (!swiper.allowTouchMove) {
  		      // isMoved = true;
  		      swiper.allowClick = false;
  		      if (data.isTouched) {
  		        Utils.extend(touches, {
  		          startX: pageX,
  		          startY: pageY,
  		          currentX: pageX,
  		          currentY: pageY,
  		        });
  		        data.touchStartTime = Utils.now();
  		      }
  		      return;
  		    }
  		    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
  		      if (swiper.isVertical()) {
  		        // Vertical
  		        if (
  		          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
  		          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
  		        ) {
  		          data.isTouched = false;
  		          data.isMoved = false;
  		          return;
  		        }
  		      } else if (
  		        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
  		        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
  		      ) {
  		        return;
  		      }
  		    }
  		    if (data.isTouchEvent && doc.activeElement) {
  		      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
  		        data.isMoved = true;
  		        swiper.allowClick = false;
  		        return;
  		      }
  		    }
  		    if (data.allowTouchCallbacks) {
  		      swiper.emit('touchMove', e);
  		    }
  		    if (e.targetTouches && e.targetTouches.length > 1) { return; }

  		    touches.currentX = pageX;
  		    touches.currentY = pageY;

  		    var diffX = touches.currentX - touches.startX;
  		    var diffY = touches.currentY - touches.startY;
  		    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

  		    if (typeof data.isScrolling === 'undefined') {
  		      var touchAngle;
  		      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
  		        data.isScrolling = false;
  		      } else {
  		        // eslint-disable-next-line
  		        if ((diffX * diffX) + (diffY * diffY) >= 25) {
  		          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
  		          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
  		        }
  		      }
  		    }
  		    if (data.isScrolling) {
  		      swiper.emit('touchMoveOpposite', e);
  		    }
  		    if (typeof data.startMoving === 'undefined') {
  		      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
  		        data.startMoving = true;
  		      }
  		    }
  		    if (data.isScrolling) {
  		      data.isTouched = false;
  		      return;
  		    }
  		    if (!data.startMoving) {
  		      return;
  		    }
  		    swiper.allowClick = false;
  		    e.preventDefault();
  		    if (params.touchMoveStopPropagation && !params.nested) {
  		      e.stopPropagation();
  		    }

  		    if (!data.isMoved) {
  		      if (params.loop) {
  		        swiper.loopFix();
  		      }
  		      data.startTranslate = swiper.getTranslate();
  		      swiper.setTransition(0);
  		      if (swiper.animating) {
  		        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
  		      }
  		      data.allowMomentumBounce = false;
  		      // Grab Cursor
  		      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
  		        swiper.setGrabCursor(true);
  		      }
  		      swiper.emit('sliderFirstMove', e);
  		    }
  		    swiper.emit('sliderMove', e);
  		    data.isMoved = true;

  		    var diff = swiper.isHorizontal() ? diffX : diffY;
  		    touches.diff = diff;

  		    diff *= params.touchRatio;
  		    if (rtl) { diff = -diff; }

  		    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  		    data.currentTranslate = diff + data.startTranslate;

  		    var disableParentSwiper = true;
  		    var resistanceRatio = params.resistanceRatio;
  		    if (params.touchReleaseOnEdges) {
  		      resistanceRatio = 0;
  		    }
  		    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
  		      disableParentSwiper = false;
  		      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
  		    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
  		      disableParentSwiper = false;
  		      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
  		    }

  		    if (disableParentSwiper) {
  		      e.preventedByNestedSwiper = true;
  		    }

  		    // Directions locks
  		    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
  		      data.currentTranslate = data.startTranslate;
  		    }
  		    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
  		      data.currentTranslate = data.startTranslate;
  		    }


  		    // Threshold
  		    if (params.threshold > 0) {
  		      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
  		        if (!data.allowThresholdMove) {
  		          data.allowThresholdMove = true;
  		          touches.startX = touches.currentX;
  		          touches.startY = touches.currentY;
  		          data.currentTranslate = data.startTranslate;
  		          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
  		          return;
  		        }
  		      } else {
  		        data.currentTranslate = data.startTranslate;
  		        return;
  		      }
  		    }

  		    if (!params.followFinger) { return; }

  		    // Update active index in free mode
  		    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
  		      swiper.updateActiveIndex();
  		      swiper.updateSlidesClasses();
  		    }
  		    if (params.freeMode) {
  		      // Velocity
  		      if (data.velocities.length === 0) {
  		        data.velocities.push({
  		          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
  		          time: data.touchStartTime,
  		        });
  		      }
  		      data.velocities.push({
  		        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
  		        time: Utils.now(),
  		      });
  		    }
  		    // Update progress
  		    swiper.updateProgress(data.currentTranslate);
  		    // Update translate
  		    swiper.setTranslate(data.currentTranslate);
  		  }

  		  function onTouchEnd (event) {
  		    var swiper = this;
  		    var data = swiper.touchEventsData;

  		    var params = swiper.params;
  		    var touches = swiper.touches;
  		    var rtl = swiper.rtlTranslate;
  		    var $wrapperEl = swiper.$wrapperEl;
  		    var slidesGrid = swiper.slidesGrid;
  		    var snapGrid = swiper.snapGrid;
  		    var e = event;
  		    if (e.originalEvent) { e = e.originalEvent; }
  		    if (data.allowTouchCallbacks) {
  		      swiper.emit('touchEnd', e);
  		    }
  		    data.allowTouchCallbacks = false;
  		    if (!data.isTouched) {
  		      if (data.isMoved && params.grabCursor) {
  		        swiper.setGrabCursor(false);
  		      }
  		      data.isMoved = false;
  		      data.startMoving = false;
  		      return;
  		    }
  		    // Return Grab Cursor
  		    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
  		      swiper.setGrabCursor(false);
  		    }

  		    // Time diff
  		    var touchEndTime = Utils.now();
  		    var timeDiff = touchEndTime - data.touchStartTime;

  		    // Tap, doubleTap, Click
  		    if (swiper.allowClick) {
  		      swiper.updateClickedSlide(e);
  		      swiper.emit('tap', e);
  		      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
  		        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
  		        data.clickTimeout = Utils.nextTick(function () {
  		          if (!swiper || swiper.destroyed) { return; }
  		          swiper.emit('click', e);
  		        }, 300);
  		      }
  		      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
  		        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
  		        swiper.emit('doubleTap', e);
  		      }
  		    }

  		    data.lastClickTime = Utils.now();
  		    Utils.nextTick(function () {
  		      if (!swiper.destroyed) { swiper.allowClick = true; }
  		    });

  		    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
  		      data.isTouched = false;
  		      data.isMoved = false;
  		      data.startMoving = false;
  		      return;
  		    }
  		    data.isTouched = false;
  		    data.isMoved = false;
  		    data.startMoving = false;

  		    var currentPos;
  		    if (params.followFinger) {
  		      currentPos = rtl ? swiper.translate : -swiper.translate;
  		    } else {
  		      currentPos = -data.currentTranslate;
  		    }

  		    if (params.freeMode) {
  		      if (currentPos < -swiper.minTranslate()) {
  		        swiper.slideTo(swiper.activeIndex);
  		        return;
  		      }
  		      if (currentPos > -swiper.maxTranslate()) {
  		        if (swiper.slides.length < snapGrid.length) {
  		          swiper.slideTo(snapGrid.length - 1);
  		        } else {
  		          swiper.slideTo(swiper.slides.length - 1);
  		        }
  		        return;
  		      }

  		      if (params.freeModeMomentum) {
  		        if (data.velocities.length > 1) {
  		          var lastMoveEvent = data.velocities.pop();
  		          var velocityEvent = data.velocities.pop();

  		          var distance = lastMoveEvent.position - velocityEvent.position;
  		          var time = lastMoveEvent.time - velocityEvent.time;
  		          swiper.velocity = distance / time;
  		          swiper.velocity /= 2;
  		          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
  		            swiper.velocity = 0;
  		          }
  		          // this implies that the user stopped moving a finger then released.
  		          // There would be no events with distance zero, so the last event is stale.
  		          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
  		            swiper.velocity = 0;
  		          }
  		        } else {
  		          swiper.velocity = 0;
  		        }
  		        swiper.velocity *= params.freeModeMomentumVelocityRatio;

  		        data.velocities.length = 0;
  		        var momentumDuration = 1000 * params.freeModeMomentumRatio;
  		        var momentumDistance = swiper.velocity * momentumDuration;

  		        var newPosition = swiper.translate + momentumDistance;
  		        if (rtl) { newPosition = -newPosition; }

  		        var doBounce = false;
  		        var afterBouncePosition;
  		        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
  		        var needsLoopFix;
  		        if (newPosition < swiper.maxTranslate()) {
  		          if (params.freeModeMomentumBounce) {
  		            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
  		              newPosition = swiper.maxTranslate() - bounceAmount;
  		            }
  		            afterBouncePosition = swiper.maxTranslate();
  		            doBounce = true;
  		            data.allowMomentumBounce = true;
  		          } else {
  		            newPosition = swiper.maxTranslate();
  		          }
  		          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
  		        } else if (newPosition > swiper.minTranslate()) {
  		          if (params.freeModeMomentumBounce) {
  		            if (newPosition - swiper.minTranslate() > bounceAmount) {
  		              newPosition = swiper.minTranslate() + bounceAmount;
  		            }
  		            afterBouncePosition = swiper.minTranslate();
  		            doBounce = true;
  		            data.allowMomentumBounce = true;
  		          } else {
  		            newPosition = swiper.minTranslate();
  		          }
  		          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
  		        } else if (params.freeModeSticky) {
  		          var nextSlide;
  		          for (var j = 0; j < snapGrid.length; j += 1) {
  		            if (snapGrid[j] > -newPosition) {
  		              nextSlide = j;
  		              break;
  		            }
  		          }

  		          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
  		            newPosition = snapGrid[nextSlide];
  		          } else {
  		            newPosition = snapGrid[nextSlide - 1];
  		          }
  		          newPosition = -newPosition;
  		        }
  		        if (needsLoopFix) {
  		          swiper.once('transitionEnd', function () {
  		            swiper.loopFix();
  		          });
  		        }
  		        // Fix duration
  		        if (swiper.velocity !== 0) {
  		          if (rtl) {
  		            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
  		          } else {
  		            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
  		          }
  		        } else if (params.freeModeSticky) {
  		          swiper.slideToClosest();
  		          return;
  		        }

  		        if (params.freeModeMomentumBounce && doBounce) {
  		          swiper.updateProgress(afterBouncePosition);
  		          swiper.setTransition(momentumDuration);
  		          swiper.setTranslate(newPosition);
  		          swiper.transitionStart(true, swiper.swipeDirection);
  		          swiper.animating = true;
  		          $wrapperEl.transitionEnd(function () {
  		            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
  		            swiper.emit('momentumBounce');

  		            swiper.setTransition(params.speed);
  		            swiper.setTranslate(afterBouncePosition);
  		            $wrapperEl.transitionEnd(function () {
  		              if (!swiper || swiper.destroyed) { return; }
  		              swiper.transitionEnd();
  		            });
  		          });
  		        } else if (swiper.velocity) {
  		          swiper.updateProgress(newPosition);
  		          swiper.setTransition(momentumDuration);
  		          swiper.setTranslate(newPosition);
  		          swiper.transitionStart(true, swiper.swipeDirection);
  		          if (!swiper.animating) {
  		            swiper.animating = true;
  		            $wrapperEl.transitionEnd(function () {
  		              if (!swiper || swiper.destroyed) { return; }
  		              swiper.transitionEnd();
  		            });
  		          }
  		        } else {
  		          swiper.updateProgress(newPosition);
  		        }

  		        swiper.updateActiveIndex();
  		        swiper.updateSlidesClasses();
  		      } else if (params.freeModeSticky) {
  		        swiper.slideToClosest();
  		        return;
  		      }

  		      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
  		        swiper.updateProgress();
  		        swiper.updateActiveIndex();
  		        swiper.updateSlidesClasses();
  		      }
  		      return;
  		    }

  		    // Find current slide
  		    var stopIndex = 0;
  		    var groupSize = swiper.slidesSizesGrid[0];
  		    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
  		      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
  		        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
  		          stopIndex = i;
  		          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
  		        }
  		      } else if (currentPos >= slidesGrid[i]) {
  		        stopIndex = i;
  		        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
  		      }
  		    }

  		    // Find current slide size
  		    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

  		    if (timeDiff > params.longSwipesMs) {
  		      // Long touches
  		      if (!params.longSwipes) {
  		        swiper.slideTo(swiper.activeIndex);
  		        return;
  		      }
  		      if (swiper.swipeDirection === 'next') {
  		        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
  		        else { swiper.slideTo(stopIndex); }
  		      }
  		      if (swiper.swipeDirection === 'prev') {
  		        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
  		        else { swiper.slideTo(stopIndex); }
  		      }
  		    } else {
  		      // Short swipes
  		      if (!params.shortSwipes) {
  		        swiper.slideTo(swiper.activeIndex);
  		        return;
  		      }
  		      if (swiper.swipeDirection === 'next') {
  		        swiper.slideTo(stopIndex + params.slidesPerGroup);
  		      }
  		      if (swiper.swipeDirection === 'prev') {
  		        swiper.slideTo(stopIndex);
  		      }
  		    }
  		  }

  		  function onResize () {
  		    var swiper = this;

  		    var params = swiper.params;
  		    var el = swiper.el;

  		    if (el && el.offsetWidth === 0) { return; }

  		    // Breakpoints
  		    if (params.breakpoints) {
  		      swiper.setBreakpoint();
  		    }

  		    // Save locks
  		    var allowSlideNext = swiper.allowSlideNext;
  		    var allowSlidePrev = swiper.allowSlidePrev;
  		    var snapGrid = swiper.snapGrid;

  		    // Disable locks on resize
  		    swiper.allowSlideNext = true;
  		    swiper.allowSlidePrev = true;

  		    swiper.updateSize();
  		    swiper.updateSlides();

  		    if (params.freeMode) {
  		      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
  		      swiper.setTranslate(newTranslate);
  		      swiper.updateActiveIndex();
  		      swiper.updateSlidesClasses();

  		      if (params.autoHeight) {
  		        swiper.updateAutoHeight();
  		      }
  		    } else {
  		      swiper.updateSlidesClasses();
  		      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
  		        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  		      } else {
  		        swiper.slideTo(swiper.activeIndex, 0, false, true);
  		      }
  		    }
  		    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
  		      swiper.autoplay.run();
  		    }
  		    // Return locks after resize
  		    swiper.allowSlidePrev = allowSlidePrev;
  		    swiper.allowSlideNext = allowSlideNext;

  		    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
  		      swiper.checkOverflow();
  		    }
  		  }

  		  function onClick (e) {
  		    var swiper = this;
  		    if (!swiper.allowClick) {
  		      if (swiper.params.preventClicks) { e.preventDefault(); }
  		      if (swiper.params.preventClicksPropagation && swiper.animating) {
  		        e.stopPropagation();
  		        e.stopImmediatePropagation();
  		      }
  		    }
  		  }

  		  function attachEvents() {
  		    var swiper = this;
  		    var params = swiper.params;
  		    var touchEvents = swiper.touchEvents;
  		    var el = swiper.el;
  		    var wrapperEl = swiper.wrapperEl;

  		    {
  		      swiper.onTouchStart = onTouchStart.bind(swiper);
  		      swiper.onTouchMove = onTouchMove.bind(swiper);
  		      swiper.onTouchEnd = onTouchEnd.bind(swiper);
  		    }

  		    swiper.onClick = onClick.bind(swiper);

  		    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  		    var capture = !!params.nested;

  		    // Touch Events
  		    {
  		      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
  		        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
  		        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
  		        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  		      } else {
  		        if (Support.touch) {
  		          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
  		          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
  		          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
  		          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
  		        }
  		        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
  		          target.addEventListener('mousedown', swiper.onTouchStart, false);
  		          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
  		          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
  		        }
  		      }
  		      // Prevent Links Clicks
  		      if (params.preventClicks || params.preventClicksPropagation) {
  		        target.addEventListener('click', swiper.onClick, true);
  		      }
  		    }

  		    // Resize handler
  		    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
  		  }

  		  function detachEvents() {
  		    var swiper = this;

  		    var params = swiper.params;
  		    var touchEvents = swiper.touchEvents;
  		    var el = swiper.el;
  		    var wrapperEl = swiper.wrapperEl;

  		    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  		    var capture = !!params.nested;

  		    // Touch Events
  		    {
  		      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
  		        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
  		        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
  		        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  		      } else {
  		        if (Support.touch) {
  		          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
  		          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
  		          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
  		          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
  		        }
  		        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
  		          target.removeEventListener('mousedown', swiper.onTouchStart, false);
  		          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
  		          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
  		        }
  		      }
  		      // Prevent Links Clicks
  		      if (params.preventClicks || params.preventClicksPropagation) {
  		        target.removeEventListener('click', swiper.onClick, true);
  		      }
  		    }

  		    // Resize handler
  		    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  		  }

  		  var events = {
  		    attachEvents: attachEvents,
  		    detachEvents: detachEvents,
  		  };

  		  function setBreakpoint () {
  		    var swiper = this;
  		    var activeIndex = swiper.activeIndex;
  		    var initialized = swiper.initialized;
  		    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
  		    var params = swiper.params;
  		    var breakpoints = params.breakpoints;
  		    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }

  		    // Set breakpoint for window width and update parameters
  		    var breakpoint = swiper.getBreakpoint(breakpoints);

  		    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
  		      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  		      if (breakpointOnlyParams) {
  		        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
  		          var paramValue = breakpointOnlyParams[param];
  		          if (typeof paramValue === 'undefined') { return; }
  		          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
  		            breakpointOnlyParams[param] = 'auto';
  		          } else if (param === 'slidesPerView') {
  		            breakpointOnlyParams[param] = parseFloat(paramValue);
  		          } else {
  		            breakpointOnlyParams[param] = parseInt(paramValue, 10);
  		          }
  		        });
  		      }

  		      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  		      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  		      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  		      if (directionChanged && initialized) {
  		        swiper.changeDirection();
  		      }

  		      Utils.extend(swiper.params, breakpointParams);

  		      Utils.extend(swiper, {
  		        allowTouchMove: swiper.params.allowTouchMove,
  		        allowSlideNext: swiper.params.allowSlideNext,
  		        allowSlidePrev: swiper.params.allowSlidePrev,
  		      });

  		      swiper.currentBreakpoint = breakpoint;

  		      if (needsReLoop && initialized) {
  		        swiper.loopDestroy();
  		        swiper.loopCreate();
  		        swiper.updateSlides();
  		        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
  		      }

  		      swiper.emit('breakpoint', breakpointParams);
  		    }
  		  }

  		  function getBreakpoint (breakpoints) {
  		    var swiper = this;
  		    // Get breakpoint for window width
  		    if (!breakpoints) { return undefined; }
  		    var breakpoint = false;
  		    var points = [];
  		    Object.keys(breakpoints).forEach(function (point) {
  		      points.push(point);
  		    });
  		    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
  		    for (var i = 0; i < points.length; i += 1) {
  		      var point = points[i];
  		      if (swiper.params.breakpointsInverse) {
  		        if (point <= win.innerWidth) {
  		          breakpoint = point;
  		        }
  		      } else if (point >= win.innerWidth && !breakpoint) {
  		        breakpoint = point;
  		      }
  		    }
  		    return breakpoint || 'max';
  		  }

  		  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  		  function addClasses () {
  		    var swiper = this;
  		    var classNames = swiper.classNames;
  		    var params = swiper.params;
  		    var rtl = swiper.rtl;
  		    var $el = swiper.$el;
  		    var suffixes = [];

  		    suffixes.push('initialized');
  		    suffixes.push(params.direction);

  		    if (params.freeMode) {
  		      suffixes.push('free-mode');
  		    }
  		    if (!Support.flexbox) {
  		      suffixes.push('no-flexbox');
  		    }
  		    if (params.autoHeight) {
  		      suffixes.push('autoheight');
  		    }
  		    if (rtl) {
  		      suffixes.push('rtl');
  		    }
  		    if (params.slidesPerColumn > 1) {
  		      suffixes.push('multirow');
  		    }
  		    if (Device.android) {
  		      suffixes.push('android');
  		    }
  		    if (Device.ios) {
  		      suffixes.push('ios');
  		    }
  		    // WP8 Touch Events Fix
  		    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
  		      suffixes.push(("wp8-" + (params.direction)));
  		    }

  		    suffixes.forEach(function (suffix) {
  		      classNames.push(params.containerModifierClass + suffix);
  		    });

  		    $el.addClass(classNames.join(' '));
  		  }

  		  function removeClasses () {
  		    var swiper = this;
  		    var $el = swiper.$el;
  		    var classNames = swiper.classNames;

  		    $el.removeClass(classNames.join(' '));
  		  }

  		  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  		  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
  		    var image;
  		    function onReady() {
  		      if (callback) { callback(); }
  		    }
  		    if (!imageEl.complete || !checkForComplete) {
  		      if (src) {
  		        image = new win.Image();
  		        image.onload = onReady;
  		        image.onerror = onReady;
  		        if (sizes) {
  		          image.sizes = sizes;
  		        }
  		        if (srcset) {
  		          image.srcset = srcset;
  		        }
  		        if (src) {
  		          image.src = src;
  		        }
  		      } else {
  		        onReady();
  		      }
  		    } else {
  		      // image already loaded...
  		      onReady();
  		    }
  		  }

  		  function preloadImages () {
  		    var swiper = this;
  		    swiper.imagesToLoad = swiper.$el.find('img');
  		    function onReady() {
  		      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
  		      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
  		      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
  		        if (swiper.params.updateOnImagesReady) { swiper.update(); }
  		        swiper.emit('imagesReady');
  		      }
  		    }
  		    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
  		      var imageEl = swiper.imagesToLoad[i];
  		      swiper.loadImage(
  		        imageEl,
  		        imageEl.currentSrc || imageEl.getAttribute('src'),
  		        imageEl.srcset || imageEl.getAttribute('srcset'),
  		        imageEl.sizes || imageEl.getAttribute('sizes'),
  		        true,
  		        onReady
  		      );
  		    }
  		  }

  		  var images = {
  		    loadImage: loadImage,
  		    preloadImages: preloadImages,
  		  };

  		  function checkOverflow() {
  		    var swiper = this;
  		    var wasLocked = swiper.isLocked;

  		    swiper.isLocked = swiper.snapGrid.length === 1;
  		    swiper.allowSlideNext = !swiper.isLocked;
  		    swiper.allowSlidePrev = !swiper.isLocked;

  		    // events
  		    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

  		    if (wasLocked && wasLocked !== swiper.isLocked) {
  		      swiper.isEnd = false;
  		      swiper.navigation.update();
  		    }
  		  }

  		  var checkOverflow$1 = { checkOverflow: checkOverflow };

  		  var defaults = {
  		    init: true,
  		    direction: 'horizontal',
  		    touchEventsTarget: 'container',
  		    initialSlide: 0,
  		    speed: 300,
  		    //
  		    preventInteractionOnTransition: false,

  		    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
  		    edgeSwipeDetection: false,
  		    edgeSwipeThreshold: 20,

  		    // Free mode
  		    freeMode: false,
  		    freeModeMomentum: true,
  		    freeModeMomentumRatio: 1,
  		    freeModeMomentumBounce: true,
  		    freeModeMomentumBounceRatio: 1,
  		    freeModeMomentumVelocityRatio: 1,
  		    freeModeSticky: false,
  		    freeModeMinimumVelocity: 0.02,

  		    // Autoheight
  		    autoHeight: false,

  		    // Set wrapper width
  		    setWrapperSize: false,

  		    // Virtual Translate
  		    virtualTranslate: false,

  		    // Effects
  		    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  		    // Breakpoints
  		    breakpoints: undefined,
  		    breakpointsInverse: false,

  		    // Slides grid
  		    spaceBetween: 0,
  		    slidesPerView: 1,
  		    slidesPerColumn: 1,
  		    slidesPerColumnFill: 'column',
  		    slidesPerGroup: 1,
  		    centeredSlides: false,
  		    slidesOffsetBefore: 0, // in px
  		    slidesOffsetAfter: 0, // in px
  		    normalizeSlideIndex: true,
  		    centerInsufficientSlides: false,

  		    // Disable swiper and hide navigation when container not overflow
  		    watchOverflow: false,

  		    // Round length
  		    roundLengths: false,

  		    // Touches
  		    touchRatio: 1,
  		    touchAngle: 45,
  		    simulateTouch: true,
  		    shortSwipes: true,
  		    longSwipes: true,
  		    longSwipesRatio: 0.5,
  		    longSwipesMs: 300,
  		    followFinger: true,
  		    allowTouchMove: true,
  		    threshold: 0,
  		    touchMoveStopPropagation: true,
  		    touchStartPreventDefault: true,
  		    touchStartForcePreventDefault: false,
  		    touchReleaseOnEdges: false,

  		    // Unique Navigation Elements
  		    uniqueNavElements: true,

  		    // Resistance
  		    resistance: true,
  		    resistanceRatio: 0.85,

  		    // Progress
  		    watchSlidesProgress: false,
  		    watchSlidesVisibility: false,

  		    // Cursor
  		    grabCursor: false,

  		    // Clicks
  		    preventClicks: true,
  		    preventClicksPropagation: true,
  		    slideToClickedSlide: false,

  		    // Images
  		    preloadImages: true,
  		    updateOnImagesReady: true,

  		    // loop
  		    loop: false,
  		    loopAdditionalSlides: 0,
  		    loopedSlides: null,
  		    loopFillGroupWithBlank: false,

  		    // Swiping/no swiping
  		    allowSlidePrev: true,
  		    allowSlideNext: true,
  		    swipeHandler: null, // '.swipe-handler',
  		    noSwiping: true,
  		    noSwipingClass: 'swiper-no-swiping',
  		    noSwipingSelector: null,

  		    // Passive Listeners
  		    passiveListeners: true,

  		    // NS
  		    containerModifierClass: 'swiper-container-', // NEW
  		    slideClass: 'swiper-slide',
  		    slideBlankClass: 'swiper-slide-invisible-blank',
  		    slideActiveClass: 'swiper-slide-active',
  		    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  		    slideVisibleClass: 'swiper-slide-visible',
  		    slideDuplicateClass: 'swiper-slide-duplicate',
  		    slideNextClass: 'swiper-slide-next',
  		    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  		    slidePrevClass: 'swiper-slide-prev',
  		    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  		    wrapperClass: 'swiper-wrapper',

  		    // Callbacks
  		    runCallbacksOnInit: true,
  		  };

  		  /* eslint no-param-reassign: "off" */

  		  var prototypes = {
  		    update: update,
  		    translate: translate,
  		    transition: transition$1,
  		    slide: slide,
  		    loop: loop,
  		    grabCursor: grabCursor,
  		    manipulation: manipulation,
  		    events: events,
  		    breakpoints: breakpoints,
  		    checkOverflow: checkOverflow$1,
  		    classes: classes,
  		    images: images,
  		  };

  		  var extendedDefaults = {};

  		  var Swiper = /*@__PURE__*/(function (SwiperClass) {
  		    function Swiper() {
  		      var assign;

  		      var args = [], len = arguments.length;
  		      while ( len-- ) args[ len ] = arguments[ len ];
  		      var el;
  		      var params;
  		      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
  		        params = args[0];
  		      } else {
  		        (assign = args, el = assign[0], params = assign[1]);
  		      }
  		      if (!params) { params = {}; }

  		      params = Utils.extend({}, params);
  		      if (el && !params.el) { params.el = el; }

  		      SwiperClass.call(this, params);

  		      Object.keys(prototypes).forEach(function (prototypeGroup) {
  		        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
  		          if (!Swiper.prototype[protoMethod]) {
  		            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  		          }
  		        });
  		      });

  		      // Swiper Instance
  		      var swiper = this;
  		      if (typeof swiper.modules === 'undefined') {
  		        swiper.modules = {};
  		      }
  		      Object.keys(swiper.modules).forEach(function (moduleName) {
  		        var module = swiper.modules[moduleName];
  		        if (module.params) {
  		          var moduleParamName = Object.keys(module.params)[0];
  		          var moduleParams = module.params[moduleParamName];
  		          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
  		          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
  		          if (params[moduleParamName] === true) {
  		            params[moduleParamName] = { enabled: true };
  		          }
  		          if (
  		            typeof params[moduleParamName] === 'object'
  		            && !('enabled' in params[moduleParamName])
  		          ) {
  		            params[moduleParamName].enabled = true;
  		          }
  		          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
  		        }
  		      });

  		      // Extend defaults with modules params
  		      var swiperParams = Utils.extend({}, defaults);
  		      swiper.useModulesParams(swiperParams);

  		      // Extend defaults with passed params
  		      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
  		      swiper.originalParams = Utils.extend({}, swiper.params);
  		      swiper.passedParams = Utils.extend({}, params);

  		      // Save Dom lib
  		      swiper.$ = $;

  		      // Find el
  		      var $el = $(swiper.params.el);
  		      el = $el[0];

  		      if (!el) {
  		        return undefined;
  		      }

  		      if ($el.length > 1) {
  		        var swipers = [];
  		        $el.each(function (index, containerEl) {
  		          var newParams = Utils.extend({}, params, { el: containerEl });
  		          swipers.push(new Swiper(newParams));
  		        });
  		        return swipers;
  		      }

  		      el.swiper = swiper;
  		      $el.data('swiper', swiper);

  		      // Find Wrapper
  		      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

  		      // Extend Swiper
  		      Utils.extend(swiper, {
  		        $el: $el,
  		        el: el,
  		        $wrapperEl: $wrapperEl,
  		        wrapperEl: $wrapperEl[0],

  		        // Classes
  		        classNames: [],

  		        // Slides
  		        slides: $(),
  		        slidesGrid: [],
  		        snapGrid: [],
  		        slidesSizesGrid: [],

  		        // isDirection
  		        isHorizontal: function isHorizontal() {
  		          return swiper.params.direction === 'horizontal';
  		        },
  		        isVertical: function isVertical() {
  		          return swiper.params.direction === 'vertical';
  		        },
  		        // RTL
  		        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
  		        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
  		        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

  		        // Indexes
  		        activeIndex: 0,
  		        realIndex: 0,

  		        //
  		        isBeginning: true,
  		        isEnd: false,

  		        // Props
  		        translate: 0,
  		        previousTranslate: 0,
  		        progress: 0,
  		        velocity: 0,
  		        animating: false,

  		        // Locks
  		        allowSlideNext: swiper.params.allowSlideNext,
  		        allowSlidePrev: swiper.params.allowSlidePrev,

  		        // Touch Events
  		        touchEvents: (function touchEvents() {
  		          var touch = ['touchstart', 'touchmove', 'touchend'];
  		          var desktop = ['mousedown', 'mousemove', 'mouseup'];
  		          if (Support.pointerEvents) {
  		            desktop = ['pointerdown', 'pointermove', 'pointerup'];
  		          } else if (Support.prefixedPointerEvents) {
  		            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
  		          }
  		          swiper.touchEventsTouch = {
  		            start: touch[0],
  		            move: touch[1],
  		            end: touch[2],
  		          };
  		          swiper.touchEventsDesktop = {
  		            start: desktop[0],
  		            move: desktop[1],
  		            end: desktop[2],
  		          };
  		          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
  		        }()),
  		        touchEventsData: {
  		          isTouched: undefined,
  		          isMoved: undefined,
  		          allowTouchCallbacks: undefined,
  		          touchStartTime: undefined,
  		          isScrolling: undefined,
  		          currentTranslate: undefined,
  		          startTranslate: undefined,
  		          allowThresholdMove: undefined,
  		          // Form elements to match
  		          formElements: 'input, select, option, textarea, button, video',
  		          // Last click time
  		          lastClickTime: Utils.now(),
  		          clickTimeout: undefined,
  		          // Velocities
  		          velocities: [],
  		          allowMomentumBounce: undefined,
  		          isTouchEvent: undefined,
  		          startMoving: undefined,
  		        },

  		        // Clicks
  		        allowClick: true,

  		        // Touches
  		        allowTouchMove: swiper.params.allowTouchMove,

  		        touches: {
  		          startX: 0,
  		          startY: 0,
  		          currentX: 0,
  		          currentY: 0,
  		          diff: 0,
  		        },

  		        // Images
  		        imagesToLoad: [],
  		        imagesLoaded: 0,

  		      });

  		      // Install Modules
  		      swiper.useModules();

  		      // Init
  		      if (swiper.params.init) {
  		        swiper.init();
  		      }

  		      // Return app instance
  		      return swiper;
  		    }

  		    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
  		    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
  		    Swiper.prototype.constructor = Swiper;

  		    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

  		    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
  		      var swiper = this;
  		      var params = swiper.params;
  		      var slides = swiper.slides;
  		      var slidesGrid = swiper.slidesGrid;
  		      var swiperSize = swiper.size;
  		      var activeIndex = swiper.activeIndex;
  		      var spv = 1;
  		      if (params.centeredSlides) {
  		        var slideSize = slides[activeIndex].swiperSlideSize;
  		        var breakLoop;
  		        for (var i = activeIndex + 1; i < slides.length; i += 1) {
  		          if (slides[i] && !breakLoop) {
  		            slideSize += slides[i].swiperSlideSize;
  		            spv += 1;
  		            if (slideSize > swiperSize) { breakLoop = true; }
  		          }
  		        }
  		        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
  		          if (slides[i$1] && !breakLoop) {
  		            slideSize += slides[i$1].swiperSlideSize;
  		            spv += 1;
  		            if (slideSize > swiperSize) { breakLoop = true; }
  		          }
  		        }
  		      } else {
  		        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
  		          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
  		            spv += 1;
  		          }
  		        }
  		      }
  		      return spv;
  		    };

  		    Swiper.prototype.update = function update () {
  		      var swiper = this;
  		      if (!swiper || swiper.destroyed) { return; }
  		      var snapGrid = swiper.snapGrid;
  		      var params = swiper.params;
  		      // Breakpoints
  		      if (params.breakpoints) {
  		        swiper.setBreakpoint();
  		      }
  		      swiper.updateSize();
  		      swiper.updateSlides();
  		      swiper.updateProgress();
  		      swiper.updateSlidesClasses();

  		      function setTranslate() {
  		        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
  		        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
  		        swiper.setTranslate(newTranslate);
  		        swiper.updateActiveIndex();
  		        swiper.updateSlidesClasses();
  		      }
  		      var translated;
  		      if (swiper.params.freeMode) {
  		        setTranslate();
  		        if (swiper.params.autoHeight) {
  		          swiper.updateAutoHeight();
  		        }
  		      } else {
  		        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
  		          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  		        } else {
  		          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
  		        }
  		        if (!translated) {
  		          setTranslate();
  		        }
  		      }
  		      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
  		        swiper.checkOverflow();
  		      }
  		      swiper.emit('update');
  		    };

  		    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
  		      if ( needUpdate === void 0 ) needUpdate = true;

  		      var swiper = this;
  		      var currentDirection = swiper.params.direction;
  		      if (!newDirection) {
  		        // eslint-disable-next-line
  		        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
  		      }
  		      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
  		        return swiper;
  		      }

  		      swiper.$el
  		        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection + " wp8-" + currentDirection))
  		        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));

  		      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
  		        swiper.$el.addClass(((swiper.params.containerModifierClass) + "wp8-" + newDirection));
  		      }

  		      swiper.params.direction = newDirection;

  		      swiper.slides.each(function (slideIndex, slideEl) {
  		        if (newDirection === 'vertical') {
  		          slideEl.style.width = '';
  		        } else {
  		          slideEl.style.height = '';
  		        }
  		      });

  		      swiper.emit('changeDirection');
  		      if (needUpdate) { swiper.update(); }

  		      return swiper;
  		    };

  		    Swiper.prototype.init = function init () {
  		      var swiper = this;
  		      if (swiper.initialized) { return; }

  		      swiper.emit('beforeInit');

  		      // Set breakpoint
  		      if (swiper.params.breakpoints) {
  		        swiper.setBreakpoint();
  		      }

  		      // Add Classes
  		      swiper.addClasses();

  		      // Create loop
  		      if (swiper.params.loop) {
  		        swiper.loopCreate();
  		      }

  		      // Update size
  		      swiper.updateSize();

  		      // Update slides
  		      swiper.updateSlides();

  		      if (swiper.params.watchOverflow) {
  		        swiper.checkOverflow();
  		      }

  		      // Set Grab Cursor
  		      if (swiper.params.grabCursor) {
  		        swiper.setGrabCursor();
  		      }

  		      if (swiper.params.preloadImages) {
  		        swiper.preloadImages();
  		      }

  		      // Slide To Initial Slide
  		      if (swiper.params.loop) {
  		        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
  		      } else {
  		        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
  		      }

  		      // Attach events
  		      swiper.attachEvents();

  		      // Init Flag
  		      swiper.initialized = true;

  		      // Emit
  		      swiper.emit('init');
  		    };

  		    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
  		      if ( deleteInstance === void 0 ) deleteInstance = true;
  		      if ( cleanStyles === void 0 ) cleanStyles = true;

  		      var swiper = this;
  		      var params = swiper.params;
  		      var $el = swiper.$el;
  		      var $wrapperEl = swiper.$wrapperEl;
  		      var slides = swiper.slides;

  		      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
  		        return null;
  		      }

  		      swiper.emit('beforeDestroy');

  		      // Init Flag
  		      swiper.initialized = false;

  		      // Detach events
  		      swiper.detachEvents();

  		      // Destroy loop
  		      if (params.loop) {
  		        swiper.loopDestroy();
  		      }

  		      // Cleanup styles
  		      if (cleanStyles) {
  		        swiper.removeClasses();
  		        $el.removeAttr('style');
  		        $wrapperEl.removeAttr('style');
  		        if (slides && slides.length) {
  		          slides
  		            .removeClass([
  		              params.slideVisibleClass,
  		              params.slideActiveClass,
  		              params.slideNextClass,
  		              params.slidePrevClass ].join(' '))
  		            .removeAttr('style')
  		            .removeAttr('data-swiper-slide-index')
  		            .removeAttr('data-swiper-column')
  		            .removeAttr('data-swiper-row');
  		        }
  		      }

  		      swiper.emit('destroy');

  		      // Detach emitter events
  		      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
  		        swiper.off(eventName);
  		      });

  		      if (deleteInstance !== false) {
  		        swiper.$el[0].swiper = null;
  		        swiper.$el.data('swiper', null);
  		        Utils.deleteProps(swiper);
  		      }
  		      swiper.destroyed = true;

  		      return null;
  		    };

  		    Swiper.extendDefaults = function extendDefaults (newDefaults) {
  		      Utils.extend(extendedDefaults, newDefaults);
  		    };

  		    staticAccessors.extendedDefaults.get = function () {
  		      return extendedDefaults;
  		    };

  		    staticAccessors.defaults.get = function () {
  		      return defaults;
  		    };

  		    staticAccessors.Class.get = function () {
  		      return SwiperClass;
  		    };

  		    staticAccessors.$.get = function () {
  		      return $;
  		    };

  		    Object.defineProperties( Swiper, staticAccessors );

  		    return Swiper;
  		  }(SwiperClass));

  		  var Device$1 = {
  		    name: 'device',
  		    proto: {
  		      device: Device,
  		    },
  		    static: {
  		      device: Device,
  		    },
  		  };

  		  var Support$1 = {
  		    name: 'support',
  		    proto: {
  		      support: Support,
  		    },
  		    static: {
  		      support: Support,
  		    },
  		  };

  		  var Browser$1 = {
  		    name: 'browser',
  		    proto: {
  		      browser: Browser,
  		    },
  		    static: {
  		      browser: Browser,
  		    },
  		  };

  		  var Resize = {
  		    name: 'resize',
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        resize: {
  		          resizeHandler: function resizeHandler() {
  		            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
  		            swiper.emit('beforeResize');
  		            swiper.emit('resize');
  		          },
  		          orientationChangeHandler: function orientationChangeHandler() {
  		            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
  		            swiper.emit('orientationchange');
  		          },
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        // Emit resize
  		        win.addEventListener('resize', swiper.resize.resizeHandler);

  		        // Emit orientationchange
  		        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        win.removeEventListener('resize', swiper.resize.resizeHandler);
  		        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
  		      },
  		    },
  		  };

  		  var Observer = {
  		    func: win.MutationObserver || win.WebkitMutationObserver,
  		    attach: function attach(target, options) {
  		      if ( options === void 0 ) options = {};

  		      var swiper = this;

  		      var ObserverFunc = Observer.func;
  		      var observer = new ObserverFunc(function (mutations) {
  		        // The observerUpdate event should only be triggered
  		        // once despite the number of mutations.  Additional
  		        // triggers are redundant and are very costly
  		        if (mutations.length === 1) {
  		          swiper.emit('observerUpdate', mutations[0]);
  		          return;
  		        }
  		        var observerUpdate = function observerUpdate() {
  		          swiper.emit('observerUpdate', mutations[0]);
  		        };

  		        if (win.requestAnimationFrame) {
  		          win.requestAnimationFrame(observerUpdate);
  		        } else {
  		          win.setTimeout(observerUpdate, 0);
  		        }
  		      });

  		      observer.observe(target, {
  		        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
  		        childList: typeof options.childList === 'undefined' ? true : options.childList,
  		        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
  		      });

  		      swiper.observer.observers.push(observer);
  		    },
  		    init: function init() {
  		      var swiper = this;
  		      if (!Support.observer || !swiper.params.observer) { return; }
  		      if (swiper.params.observeParents) {
  		        var containerParents = swiper.$el.parents();
  		        for (var i = 0; i < containerParents.length; i += 1) {
  		          swiper.observer.attach(containerParents[i]);
  		        }
  		      }
  		      // Observe container
  		      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

  		      // Observe wrapper
  		      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
  		    },
  		    destroy: function destroy() {
  		      var swiper = this;
  		      swiper.observer.observers.forEach(function (observer) {
  		        observer.disconnect();
  		      });
  		      swiper.observer.observers = [];
  		    },
  		  };

  		  var Observer$1 = {
  		    name: 'observer',
  		    params: {
  		      observer: false,
  		      observeParents: false,
  		      observeSlideChildren: false,
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        observer: {
  		          init: Observer.init.bind(swiper),
  		          attach: Observer.attach.bind(swiper),
  		          destroy: Observer.destroy.bind(swiper),
  		          observers: [],
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        swiper.observer.init();
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        swiper.observer.destroy();
  		      },
  		    },
  		  };

  		  var Virtual = {
  		    update: function update(force) {
  		      var swiper = this;
  		      var ref = swiper.params;
  		      var slidesPerView = ref.slidesPerView;
  		      var slidesPerGroup = ref.slidesPerGroup;
  		      var centeredSlides = ref.centeredSlides;
  		      var ref$1 = swiper.params.virtual;
  		      var addSlidesBefore = ref$1.addSlidesBefore;
  		      var addSlidesAfter = ref$1.addSlidesAfter;
  		      var ref$2 = swiper.virtual;
  		      var previousFrom = ref$2.from;
  		      var previousTo = ref$2.to;
  		      var slides = ref$2.slides;
  		      var previousSlidesGrid = ref$2.slidesGrid;
  		      var renderSlide = ref$2.renderSlide;
  		      var previousOffset = ref$2.offset;
  		      swiper.updateActiveIndex();
  		      var activeIndex = swiper.activeIndex || 0;

  		      var offsetProp;
  		      if (swiper.rtlTranslate) { offsetProp = 'right'; }
  		      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

  		      var slidesAfter;
  		      var slidesBefore;
  		      if (centeredSlides) {
  		        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
  		        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
  		      } else {
  		        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
  		        slidesBefore = slidesPerGroup + addSlidesAfter;
  		      }
  		      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
  		      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
  		      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

  		      Utils.extend(swiper.virtual, {
  		        from: from,
  		        to: to,
  		        offset: offset,
  		        slidesGrid: swiper.slidesGrid,
  		      });

  		      function onRendered() {
  		        swiper.updateSlides();
  		        swiper.updateProgress();
  		        swiper.updateSlidesClasses();
  		        if (swiper.lazy && swiper.params.lazy.enabled) {
  		          swiper.lazy.load();
  		        }
  		      }

  		      if (previousFrom === from && previousTo === to && !force) {
  		        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
  		          swiper.slides.css(offsetProp, (offset + "px"));
  		        }
  		        swiper.updateProgress();
  		        return;
  		      }
  		      if (swiper.params.virtual.renderExternal) {
  		        swiper.params.virtual.renderExternal.call(swiper, {
  		          offset: offset,
  		          from: from,
  		          to: to,
  		          slides: (function getSlides() {
  		            var slidesToRender = [];
  		            for (var i = from; i <= to; i += 1) {
  		              slidesToRender.push(slides[i]);
  		            }
  		            return slidesToRender;
  		          }()),
  		        });
  		        onRendered();
  		        return;
  		      }
  		      var prependIndexes = [];
  		      var appendIndexes = [];
  		      if (force) {
  		        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
  		      } else {
  		        for (var i = previousFrom; i <= previousTo; i += 1) {
  		          if (i < from || i > to) {
  		            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
  		          }
  		        }
  		      }
  		      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
  		        if (i$1 >= from && i$1 <= to) {
  		          if (typeof previousTo === 'undefined' || force) {
  		            appendIndexes.push(i$1);
  		          } else {
  		            if (i$1 > previousTo) { appendIndexes.push(i$1); }
  		            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
  		          }
  		        }
  		      }
  		      appendIndexes.forEach(function (index) {
  		        swiper.$wrapperEl.append(renderSlide(slides[index], index));
  		      });
  		      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
  		        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
  		      });
  		      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
  		      onRendered();
  		    },
  		    renderSlide: function renderSlide(slide, index) {
  		      var swiper = this;
  		      var params = swiper.params.virtual;
  		      if (params.cache && swiper.virtual.cache[index]) {
  		        return swiper.virtual.cache[index];
  		      }
  		      var $slideEl = params.renderSlide
  		        ? $(params.renderSlide.call(swiper, slide, index))
  		        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
  		      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
  		      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
  		      return $slideEl;
  		    },
  		    appendSlide: function appendSlide(slides) {
  		      var swiper = this;
  		      if (typeof slides === 'object' && 'length' in slides) {
  		        for (var i = 0; i < slides.length; i += 1) {
  		          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
  		        }
  		      } else {
  		        swiper.virtual.slides.push(slides);
  		      }
  		      swiper.virtual.update(true);
  		    },
  		    prependSlide: function prependSlide(slides) {
  		      var swiper = this;
  		      var activeIndex = swiper.activeIndex;
  		      var newActiveIndex = activeIndex + 1;
  		      var numberOfNewSlides = 1;

  		      if (Array.isArray(slides)) {
  		        for (var i = 0; i < slides.length; i += 1) {
  		          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
  		        }
  		        newActiveIndex = activeIndex + slides.length;
  		        numberOfNewSlides = slides.length;
  		      } else {
  		        swiper.virtual.slides.unshift(slides);
  		      }
  		      if (swiper.params.virtual.cache) {
  		        var cache = swiper.virtual.cache;
  		        var newCache = {};
  		        Object.keys(cache).forEach(function (cachedIndex) {
  		          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
  		        });
  		        swiper.virtual.cache = newCache;
  		      }
  		      swiper.virtual.update(true);
  		      swiper.slideTo(newActiveIndex, 0);
  		    },
  		    removeSlide: function removeSlide(slidesIndexes) {
  		      var swiper = this;
  		      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
  		      var activeIndex = swiper.activeIndex;
  		      if (Array.isArray(slidesIndexes)) {
  		        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
  		          swiper.virtual.slides.splice(slidesIndexes[i], 1);
  		          if (swiper.params.virtual.cache) {
  		            delete swiper.virtual.cache[slidesIndexes[i]];
  		          }
  		          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
  		          activeIndex = Math.max(activeIndex, 0);
  		        }
  		      } else {
  		        swiper.virtual.slides.splice(slidesIndexes, 1);
  		        if (swiper.params.virtual.cache) {
  		          delete swiper.virtual.cache[slidesIndexes];
  		        }
  		        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
  		        activeIndex = Math.max(activeIndex, 0);
  		      }
  		      swiper.virtual.update(true);
  		      swiper.slideTo(activeIndex, 0);
  		    },
  		    removeAllSlides: function removeAllSlides() {
  		      var swiper = this;
  		      swiper.virtual.slides = [];
  		      if (swiper.params.virtual.cache) {
  		        swiper.virtual.cache = {};
  		      }
  		      swiper.virtual.update(true);
  		      swiper.slideTo(0, 0);
  		    },
  		  };

  		  var Virtual$1 = {
  		    name: 'virtual',
  		    params: {
  		      virtual: {
  		        enabled: false,
  		        slides: [],
  		        cache: true,
  		        renderSlide: null,
  		        renderExternal: null,
  		        addSlidesBefore: 0,
  		        addSlidesAfter: 0,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        virtual: {
  		          update: Virtual.update.bind(swiper),
  		          appendSlide: Virtual.appendSlide.bind(swiper),
  		          prependSlide: Virtual.prependSlide.bind(swiper),
  		          removeSlide: Virtual.removeSlide.bind(swiper),
  		          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
  		          renderSlide: Virtual.renderSlide.bind(swiper),
  		          slides: swiper.params.virtual.slides,
  		          cache: {},
  		        },
  		      });
  		    },
  		    on: {
  		      beforeInit: function beforeInit() {
  		        var swiper = this;
  		        if (!swiper.params.virtual.enabled) { return; }
  		        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
  		        var overwriteParams = {
  		          watchSlidesProgress: true,
  		        };
  		        Utils.extend(swiper.params, overwriteParams);
  		        Utils.extend(swiper.originalParams, overwriteParams);

  		        if (!swiper.params.initialSlide) {
  		          swiper.virtual.update();
  		        }
  		      },
  		      setTranslate: function setTranslate() {
  		        var swiper = this;
  		        if (!swiper.params.virtual.enabled) { return; }
  		        swiper.virtual.update();
  		      },
  		    },
  		  };

  		  var Keyboard = {
  		    handle: function handle(event) {
  		      var swiper = this;
  		      var rtl = swiper.rtlTranslate;
  		      var e = event;
  		      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
  		      var kc = e.keyCode || e.charCode;
  		      // Directions locks
  		      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
  		        return false;
  		      }
  		      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
  		        return false;
  		      }
  		      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
  		        return undefined;
  		      }
  		      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
  		        return undefined;
  		      }
  		      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
  		        var inView = false;
  		        // Check that swiper should be inside of visible area of window
  		        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
  		          return undefined;
  		        }
  		        var windowWidth = win.innerWidth;
  		        var windowHeight = win.innerHeight;
  		        var swiperOffset = swiper.$el.offset();
  		        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
  		        var swiperCoord = [
  		          [swiperOffset.left, swiperOffset.top],
  		          [swiperOffset.left + swiper.width, swiperOffset.top],
  		          [swiperOffset.left, swiperOffset.top + swiper.height],
  		          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
  		        for (var i = 0; i < swiperCoord.length; i += 1) {
  		          var point = swiperCoord[i];
  		          if (
  		            point[0] >= 0 && point[0] <= windowWidth
  		            && point[1] >= 0 && point[1] <= windowHeight
  		          ) {
  		            inView = true;
  		          }
  		        }
  		        if (!inView) { return undefined; }
  		      }
  		      if (swiper.isHorizontal()) {
  		        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
  		          if (e.preventDefault) { e.preventDefault(); }
  		          else { e.returnValue = false; }
  		        }
  		        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
  		        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
  		      } else {
  		        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
  		          if (e.preventDefault) { e.preventDefault(); }
  		          else { e.returnValue = false; }
  		        }
  		        if (kc === 34 || kc === 40) { swiper.slideNext(); }
  		        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
  		      }
  		      swiper.emit('keyPress', kc);
  		      return undefined;
  		    },
  		    enable: function enable() {
  		      var swiper = this;
  		      if (swiper.keyboard.enabled) { return; }
  		      $(doc).on('keydown', swiper.keyboard.handle);
  		      swiper.keyboard.enabled = true;
  		    },
  		    disable: function disable() {
  		      var swiper = this;
  		      if (!swiper.keyboard.enabled) { return; }
  		      $(doc).off('keydown', swiper.keyboard.handle);
  		      swiper.keyboard.enabled = false;
  		    },
  		  };

  		  var Keyboard$1 = {
  		    name: 'keyboard',
  		    params: {
  		      keyboard: {
  		        enabled: false,
  		        onlyInViewport: true,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        keyboard: {
  		          enabled: false,
  		          enable: Keyboard.enable.bind(swiper),
  		          disable: Keyboard.disable.bind(swiper),
  		          handle: Keyboard.handle.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        if (swiper.params.keyboard.enabled) {
  		          swiper.keyboard.enable();
  		        }
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        if (swiper.keyboard.enabled) {
  		          swiper.keyboard.disable();
  		        }
  		      },
  		    },
  		  };

  		  function isEventSupported() {
  		    var eventName = 'onwheel';
  		    var isSupported = eventName in doc;

  		    if (!isSupported) {
  		      var element = doc.createElement('div');
  		      element.setAttribute(eventName, 'return;');
  		      isSupported = typeof element[eventName] === 'function';
  		    }

  		    if (!isSupported
  		      && doc.implementation
  		      && doc.implementation.hasFeature
  		      // always returns true in newer browsers as per the standard.
  		      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  		      && doc.implementation.hasFeature('', '') !== true
  		    ) {
  		      // This is the only way to test support for the `wheel` event in IE9+.
  		      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
  		    }

  		    return isSupported;
  		  }
  		  var Mousewheel = {
  		    lastScrollTime: Utils.now(),
  		    event: (function getEvent() {
  		      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
  		      return isEventSupported() ? 'wheel' : 'mousewheel';
  		    }()),
  		    normalize: function normalize(e) {
  		      // Reasonable defaults
  		      var PIXEL_STEP = 10;
  		      var LINE_HEIGHT = 40;
  		      var PAGE_HEIGHT = 800;

  		      var sX = 0;
  		      var sY = 0; // spinX, spinY
  		      var pX = 0;
  		      var pY = 0; // pixelX, pixelY

  		      // Legacy
  		      if ('detail' in e) {
  		        sY = e.detail;
  		      }
  		      if ('wheelDelta' in e) {
  		        sY = -e.wheelDelta / 120;
  		      }
  		      if ('wheelDeltaY' in e) {
  		        sY = -e.wheelDeltaY / 120;
  		      }
  		      if ('wheelDeltaX' in e) {
  		        sX = -e.wheelDeltaX / 120;
  		      }

  		      // side scrolling on FF with DOMMouseScroll
  		      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
  		        sX = sY;
  		        sY = 0;
  		      }

  		      pX = sX * PIXEL_STEP;
  		      pY = sY * PIXEL_STEP;

  		      if ('deltaY' in e) {
  		        pY = e.deltaY;
  		      }
  		      if ('deltaX' in e) {
  		        pX = e.deltaX;
  		      }

  		      if ((pX || pY) && e.deltaMode) {
  		        if (e.deltaMode === 1) { // delta in LINE units
  		          pX *= LINE_HEIGHT;
  		          pY *= LINE_HEIGHT;
  		        } else { // delta in PAGE units
  		          pX *= PAGE_HEIGHT;
  		          pY *= PAGE_HEIGHT;
  		        }
  		      }

  		      // Fall-back if spin cannot be determined
  		      if (pX && !sX) {
  		        sX = (pX < 1) ? -1 : 1;
  		      }
  		      if (pY && !sY) {
  		        sY = (pY < 1) ? -1 : 1;
  		      }

  		      return {
  		        spinX: sX,
  		        spinY: sY,
  		        pixelX: pX,
  		        pixelY: pY,
  		      };
  		    },
  		    handleMouseEnter: function handleMouseEnter() {
  		      var swiper = this;
  		      swiper.mouseEntered = true;
  		    },
  		    handleMouseLeave: function handleMouseLeave() {
  		      var swiper = this;
  		      swiper.mouseEntered = false;
  		    },
  		    handle: function handle(event) {
  		      var e = event;
  		      var swiper = this;
  		      var params = swiper.params.mousewheel;

  		      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

  		      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
  		      var delta = 0;
  		      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

  		      var data = Mousewheel.normalize(e);

  		      if (params.forceToAxis) {
  		        if (swiper.isHorizontal()) {
  		          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
  		          else { return true; }
  		        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
  		        else { return true; }
  		      } else {
  		        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
  		      }

  		      if (delta === 0) { return true; }

  		      if (params.invert) { delta = -delta; }

  		      if (!swiper.params.freeMode) {
  		        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
  		          if (delta < 0) {
  		            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
  		              swiper.slideNext();
  		              swiper.emit('scroll', e);
  		            } else if (params.releaseOnEdges) { return true; }
  		          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
  		            swiper.slidePrev();
  		            swiper.emit('scroll', e);
  		          } else if (params.releaseOnEdges) { return true; }
  		        }
  		        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
  		      } else {
  		        // Freemode or scrollContainer:
  		        if (swiper.params.loop) {
  		          swiper.loopFix();
  		        }
  		        var position = swiper.getTranslate() + (delta * params.sensitivity);
  		        var wasBeginning = swiper.isBeginning;
  		        var wasEnd = swiper.isEnd;

  		        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
  		        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

  		        swiper.setTransition(0);
  		        swiper.setTranslate(position);
  		        swiper.updateProgress();
  		        swiper.updateActiveIndex();
  		        swiper.updateSlidesClasses();

  		        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
  		          swiper.updateSlidesClasses();
  		        }

  		        if (swiper.params.freeModeSticky) {
  		          clearTimeout(swiper.mousewheel.timeout);
  		          swiper.mousewheel.timeout = Utils.nextTick(function () {
  		            swiper.slideToClosest();
  		          }, 300);
  		        }
  		        // Emit event
  		        swiper.emit('scroll', e);

  		        // Stop autoplay
  		        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
  		        // Return page scroll on edge positions
  		        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
  		      }

  		      if (e.preventDefault) { e.preventDefault(); }
  		      else { e.returnValue = false; }
  		      return false;
  		    },
  		    enable: function enable() {
  		      var swiper = this;
  		      if (!Mousewheel.event) { return false; }
  		      if (swiper.mousewheel.enabled) { return false; }
  		      var target = swiper.$el;
  		      if (swiper.params.mousewheel.eventsTarged !== 'container') {
  		        target = $(swiper.params.mousewheel.eventsTarged);
  		      }
  		      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
  		      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
  		      target.on(Mousewheel.event, swiper.mousewheel.handle);
  		      swiper.mousewheel.enabled = true;
  		      return true;
  		    },
  		    disable: function disable() {
  		      var swiper = this;
  		      if (!Mousewheel.event) { return false; }
  		      if (!swiper.mousewheel.enabled) { return false; }
  		      var target = swiper.$el;
  		      if (swiper.params.mousewheel.eventsTarged !== 'container') {
  		        target = $(swiper.params.mousewheel.eventsTarged);
  		      }
  		      target.off(Mousewheel.event, swiper.mousewheel.handle);
  		      swiper.mousewheel.enabled = false;
  		      return true;
  		    },
  		  };

  		  var Mousewheel$1 = {
  		    name: 'mousewheel',
  		    params: {
  		      mousewheel: {
  		        enabled: false,
  		        releaseOnEdges: false,
  		        invert: false,
  		        forceToAxis: false,
  		        sensitivity: 1,
  		        eventsTarged: 'container',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        mousewheel: {
  		          enabled: false,
  		          enable: Mousewheel.enable.bind(swiper),
  		          disable: Mousewheel.disable.bind(swiper),
  		          handle: Mousewheel.handle.bind(swiper),
  		          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
  		          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
  		          lastScrollTime: Utils.now(),
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
  		      },
  		    },
  		  };

  		  var Navigation = {
  		    update: function update() {
  		      // Update Navigation Buttons
  		      var swiper = this;
  		      var params = swiper.params.navigation;

  		      if (swiper.params.loop) { return; }
  		      var ref = swiper.navigation;
  		      var $nextEl = ref.$nextEl;
  		      var $prevEl = ref.$prevEl;

  		      if ($prevEl && $prevEl.length > 0) {
  		        if (swiper.isBeginning) {
  		          $prevEl.addClass(params.disabledClass);
  		        } else {
  		          $prevEl.removeClass(params.disabledClass);
  		        }
  		        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  		      }
  		      if ($nextEl && $nextEl.length > 0) {
  		        if (swiper.isEnd) {
  		          $nextEl.addClass(params.disabledClass);
  		        } else {
  		          $nextEl.removeClass(params.disabledClass);
  		        }
  		        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  		      }
  		    },
  		    onPrevClick: function onPrevClick(e) {
  		      var swiper = this;
  		      e.preventDefault();
  		      if (swiper.isBeginning && !swiper.params.loop) { return; }
  		      swiper.slidePrev();
  		    },
  		    onNextClick: function onNextClick(e) {
  		      var swiper = this;
  		      e.preventDefault();
  		      if (swiper.isEnd && !swiper.params.loop) { return; }
  		      swiper.slideNext();
  		    },
  		    init: function init() {
  		      var swiper = this;
  		      var params = swiper.params.navigation;
  		      if (!(params.nextEl || params.prevEl)) { return; }

  		      var $nextEl;
  		      var $prevEl;
  		      if (params.nextEl) {
  		        $nextEl = $(params.nextEl);
  		        if (
  		          swiper.params.uniqueNavElements
  		          && typeof params.nextEl === 'string'
  		          && $nextEl.length > 1
  		          && swiper.$el.find(params.nextEl).length === 1
  		        ) {
  		          $nextEl = swiper.$el.find(params.nextEl);
  		        }
  		      }
  		      if (params.prevEl) {
  		        $prevEl = $(params.prevEl);
  		        if (
  		          swiper.params.uniqueNavElements
  		          && typeof params.prevEl === 'string'
  		          && $prevEl.length > 1
  		          && swiper.$el.find(params.prevEl).length === 1
  		        ) {
  		          $prevEl = swiper.$el.find(params.prevEl);
  		        }
  		      }

  		      if ($nextEl && $nextEl.length > 0) {
  		        $nextEl.on('click', swiper.navigation.onNextClick);
  		      }
  		      if ($prevEl && $prevEl.length > 0) {
  		        $prevEl.on('click', swiper.navigation.onPrevClick);
  		      }

  		      Utils.extend(swiper.navigation, {
  		        $nextEl: $nextEl,
  		        nextEl: $nextEl && $nextEl[0],
  		        $prevEl: $prevEl,
  		        prevEl: $prevEl && $prevEl[0],
  		      });
  		    },
  		    destroy: function destroy() {
  		      var swiper = this;
  		      var ref = swiper.navigation;
  		      var $nextEl = ref.$nextEl;
  		      var $prevEl = ref.$prevEl;
  		      if ($nextEl && $nextEl.length) {
  		        $nextEl.off('click', swiper.navigation.onNextClick);
  		        $nextEl.removeClass(swiper.params.navigation.disabledClass);
  		      }
  		      if ($prevEl && $prevEl.length) {
  		        $prevEl.off('click', swiper.navigation.onPrevClick);
  		        $prevEl.removeClass(swiper.params.navigation.disabledClass);
  		      }
  		    },
  		  };

  		  var Navigation$1 = {
  		    name: 'navigation',
  		    params: {
  		      navigation: {
  		        nextEl: null,
  		        prevEl: null,

  		        hideOnClick: false,
  		        disabledClass: 'swiper-button-disabled',
  		        hiddenClass: 'swiper-button-hidden',
  		        lockClass: 'swiper-button-lock',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        navigation: {
  		          init: Navigation.init.bind(swiper),
  		          update: Navigation.update.bind(swiper),
  		          destroy: Navigation.destroy.bind(swiper),
  		          onNextClick: Navigation.onNextClick.bind(swiper),
  		          onPrevClick: Navigation.onPrevClick.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        swiper.navigation.init();
  		        swiper.navigation.update();
  		      },
  		      toEdge: function toEdge() {
  		        var swiper = this;
  		        swiper.navigation.update();
  		      },
  		      fromEdge: function fromEdge() {
  		        var swiper = this;
  		        swiper.navigation.update();
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        swiper.navigation.destroy();
  		      },
  		      click: function click(e) {
  		        var swiper = this;
  		        var ref = swiper.navigation;
  		        var $nextEl = ref.$nextEl;
  		        var $prevEl = ref.$prevEl;
  		        if (
  		          swiper.params.navigation.hideOnClick
  		          && !$(e.target).is($prevEl)
  		          && !$(e.target).is($nextEl)
  		        ) {
  		          var isHidden;
  		          if ($nextEl) {
  		            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
  		          } else if ($prevEl) {
  		            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
  		          }
  		          if (isHidden === true) {
  		            swiper.emit('navigationShow', swiper);
  		          } else {
  		            swiper.emit('navigationHide', swiper);
  		          }
  		          if ($nextEl) {
  		            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
  		          }
  		          if ($prevEl) {
  		            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
  		          }
  		        }
  		      },
  		    },
  		  };

  		  var Pagination = {
  		    update: function update() {
  		      // Render || Update Pagination bullets/items
  		      var swiper = this;
  		      var rtl = swiper.rtl;
  		      var params = swiper.params.pagination;
  		      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
  		      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
  		      var $el = swiper.pagination.$el;
  		      // Current/Total
  		      var current;
  		      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
  		      if (swiper.params.loop) {
  		        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
  		        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
  		          current -= (slidesLength - (swiper.loopedSlides * 2));
  		        }
  		        if (current > total - 1) { current -= total; }
  		        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
  		      } else if (typeof swiper.snapIndex !== 'undefined') {
  		        current = swiper.snapIndex;
  		      } else {
  		        current = swiper.activeIndex || 0;
  		      }
  		      // Types
  		      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
  		        var bullets = swiper.pagination.bullets;
  		        var firstIndex;
  		        var lastIndex;
  		        var midIndex;
  		        if (params.dynamicBullets) {
  		          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
  		          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
  		          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
  		            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
  		            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
  		              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
  		            } else if (swiper.pagination.dynamicBulletIndex < 0) {
  		              swiper.pagination.dynamicBulletIndex = 0;
  		            }
  		          }
  		          firstIndex = current - swiper.pagination.dynamicBulletIndex;
  		          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
  		          midIndex = (lastIndex + firstIndex) / 2;
  		        }
  		        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
  		        if ($el.length > 1) {
  		          bullets.each(function (index, bullet) {
  		            var $bullet = $(bullet);
  		            var bulletIndex = $bullet.index();
  		            if (bulletIndex === current) {
  		              $bullet.addClass(params.bulletActiveClass);
  		            }
  		            if (params.dynamicBullets) {
  		              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
  		                $bullet.addClass(((params.bulletActiveClass) + "-main"));
  		              }
  		              if (bulletIndex === firstIndex) {
  		                $bullet
  		                  .prev()
  		                  .addClass(((params.bulletActiveClass) + "-prev"))
  		                  .prev()
  		                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
  		              }
  		              if (bulletIndex === lastIndex) {
  		                $bullet
  		                  .next()
  		                  .addClass(((params.bulletActiveClass) + "-next"))
  		                  .next()
  		                  .addClass(((params.bulletActiveClass) + "-next-next"));
  		              }
  		            }
  		          });
  		        } else {
  		          var $bullet = bullets.eq(current);
  		          $bullet.addClass(params.bulletActiveClass);
  		          if (params.dynamicBullets) {
  		            var $firstDisplayedBullet = bullets.eq(firstIndex);
  		            var $lastDisplayedBullet = bullets.eq(lastIndex);
  		            for (var i = firstIndex; i <= lastIndex; i += 1) {
  		              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
  		            }
  		            $firstDisplayedBullet
  		              .prev()
  		              .addClass(((params.bulletActiveClass) + "-prev"))
  		              .prev()
  		              .addClass(((params.bulletActiveClass) + "-prev-prev"));
  		            $lastDisplayedBullet
  		              .next()
  		              .addClass(((params.bulletActiveClass) + "-next"))
  		              .next()
  		              .addClass(((params.bulletActiveClass) + "-next-next"));
  		          }
  		        }
  		        if (params.dynamicBullets) {
  		          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
  		          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
  		          var offsetProp = rtl ? 'right' : 'left';
  		          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
  		        }
  		      }
  		      if (params.type === 'fraction') {
  		        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
  		        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
  		      }
  		      if (params.type === 'progressbar') {
  		        var progressbarDirection;
  		        if (params.progressbarOpposite) {
  		          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
  		        } else {
  		          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
  		        }
  		        var scale = (current + 1) / total;
  		        var scaleX = 1;
  		        var scaleY = 1;
  		        if (progressbarDirection === 'horizontal') {
  		          scaleX = scale;
  		        } else {
  		          scaleY = scale;
  		        }
  		        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
  		      }
  		      if (params.type === 'custom' && params.renderCustom) {
  		        $el.html(params.renderCustom(swiper, current + 1, total));
  		        swiper.emit('paginationRender', swiper, $el[0]);
  		      } else {
  		        swiper.emit('paginationUpdate', swiper, $el[0]);
  		      }
  		      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  		    },
  		    render: function render() {
  		      // Render Container
  		      var swiper = this;
  		      var params = swiper.params.pagination;
  		      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
  		      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

  		      var $el = swiper.pagination.$el;
  		      var paginationHTML = '';
  		      if (params.type === 'bullets') {
  		        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
  		        for (var i = 0; i < numberOfBullets; i += 1) {
  		          if (params.renderBullet) {
  		            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
  		          } else {
  		            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
  		          }
  		        }
  		        $el.html(paginationHTML);
  		        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
  		      }
  		      if (params.type === 'fraction') {
  		        if (params.renderFraction) {
  		          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
  		        } else {
  		          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
  		          + ' / '
  		          + "<span class=\"" + (params.totalClass) + "\"></span>";
  		        }
  		        $el.html(paginationHTML);
  		      }
  		      if (params.type === 'progressbar') {
  		        if (params.renderProgressbar) {
  		          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
  		        } else {
  		          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
  		        }
  		        $el.html(paginationHTML);
  		      }
  		      if (params.type !== 'custom') {
  		        swiper.emit('paginationRender', swiper.pagination.$el[0]);
  		      }
  		    },
  		    init: function init() {
  		      var swiper = this;
  		      var params = swiper.params.pagination;
  		      if (!params.el) { return; }

  		      var $el = $(params.el);
  		      if ($el.length === 0) { return; }

  		      if (
  		        swiper.params.uniqueNavElements
  		        && typeof params.el === 'string'
  		        && $el.length > 1
  		        && swiper.$el.find(params.el).length === 1
  		      ) {
  		        $el = swiper.$el.find(params.el);
  		      }

  		      if (params.type === 'bullets' && params.clickable) {
  		        $el.addClass(params.clickableClass);
  		      }

  		      $el.addClass(params.modifierClass + params.type);

  		      if (params.type === 'bullets' && params.dynamicBullets) {
  		        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
  		        swiper.pagination.dynamicBulletIndex = 0;
  		        if (params.dynamicMainBullets < 1) {
  		          params.dynamicMainBullets = 1;
  		        }
  		      }
  		      if (params.type === 'progressbar' && params.progressbarOpposite) {
  		        $el.addClass(params.progressbarOppositeClass);
  		      }

  		      if (params.clickable) {
  		        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
  		          e.preventDefault();
  		          var index = $(this).index() * swiper.params.slidesPerGroup;
  		          if (swiper.params.loop) { index += swiper.loopedSlides; }
  		          swiper.slideTo(index);
  		        });
  		      }

  		      Utils.extend(swiper.pagination, {
  		        $el: $el,
  		        el: $el[0],
  		      });
  		    },
  		    destroy: function destroy() {
  		      var swiper = this;
  		      var params = swiper.params.pagination;
  		      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
  		      var $el = swiper.pagination.$el;

  		      $el.removeClass(params.hiddenClass);
  		      $el.removeClass(params.modifierClass + params.type);
  		      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
  		      if (params.clickable) {
  		        $el.off('click', ("." + (params.bulletClass)));
  		      }
  		    },
  		  };

  		  var Pagination$1 = {
  		    name: 'pagination',
  		    params: {
  		      pagination: {
  		        el: null,
  		        bulletElement: 'span',
  		        clickable: false,
  		        hideOnClick: false,
  		        renderBullet: null,
  		        renderProgressbar: null,
  		        renderFraction: null,
  		        renderCustom: null,
  		        progressbarOpposite: false,
  		        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
  		        dynamicBullets: false,
  		        dynamicMainBullets: 1,
  		        formatFractionCurrent: function (number) { return number; },
  		        formatFractionTotal: function (number) { return number; },
  		        bulletClass: 'swiper-pagination-bullet',
  		        bulletActiveClass: 'swiper-pagination-bullet-active',
  		        modifierClass: 'swiper-pagination-', // NEW
  		        currentClass: 'swiper-pagination-current',
  		        totalClass: 'swiper-pagination-total',
  		        hiddenClass: 'swiper-pagination-hidden',
  		        progressbarFillClass: 'swiper-pagination-progressbar-fill',
  		        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
  		        clickableClass: 'swiper-pagination-clickable', // NEW
  		        lockClass: 'swiper-pagination-lock',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        pagination: {
  		          init: Pagination.init.bind(swiper),
  		          render: Pagination.render.bind(swiper),
  		          update: Pagination.update.bind(swiper),
  		          destroy: Pagination.destroy.bind(swiper),
  		          dynamicBulletIndex: 0,
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        swiper.pagination.init();
  		        swiper.pagination.render();
  		        swiper.pagination.update();
  		      },
  		      activeIndexChange: function activeIndexChange() {
  		        var swiper = this;
  		        if (swiper.params.loop) {
  		          swiper.pagination.update();
  		        } else if (typeof swiper.snapIndex === 'undefined') {
  		          swiper.pagination.update();
  		        }
  		      },
  		      snapIndexChange: function snapIndexChange() {
  		        var swiper = this;
  		        if (!swiper.params.loop) {
  		          swiper.pagination.update();
  		        }
  		      },
  		      slidesLengthChange: function slidesLengthChange() {
  		        var swiper = this;
  		        if (swiper.params.loop) {
  		          swiper.pagination.render();
  		          swiper.pagination.update();
  		        }
  		      },
  		      snapGridLengthChange: function snapGridLengthChange() {
  		        var swiper = this;
  		        if (!swiper.params.loop) {
  		          swiper.pagination.render();
  		          swiper.pagination.update();
  		        }
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        swiper.pagination.destroy();
  		      },
  		      click: function click(e) {
  		        var swiper = this;
  		        if (
  		          swiper.params.pagination.el
  		          && swiper.params.pagination.hideOnClick
  		          && swiper.pagination.$el.length > 0
  		          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
  		        ) {
  		          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
  		          if (isHidden === true) {
  		            swiper.emit('paginationShow', swiper);
  		          } else {
  		            swiper.emit('paginationHide', swiper);
  		          }
  		          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
  		        }
  		      },
  		    },
  		  };

  		  var Scrollbar = {
  		    setTranslate: function setTranslate() {
  		      var swiper = this;
  		      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
  		      var scrollbar = swiper.scrollbar;
  		      var rtl = swiper.rtlTranslate;
  		      var progress = swiper.progress;
  		      var dragSize = scrollbar.dragSize;
  		      var trackSize = scrollbar.trackSize;
  		      var $dragEl = scrollbar.$dragEl;
  		      var $el = scrollbar.$el;
  		      var params = swiper.params.scrollbar;

  		      var newSize = dragSize;
  		      var newPos = (trackSize - dragSize) * progress;
  		      if (rtl) {
  		        newPos = -newPos;
  		        if (newPos > 0) {
  		          newSize = dragSize - newPos;
  		          newPos = 0;
  		        } else if (-newPos + dragSize > trackSize) {
  		          newSize = trackSize + newPos;
  		        }
  		      } else if (newPos < 0) {
  		        newSize = dragSize + newPos;
  		        newPos = 0;
  		      } else if (newPos + dragSize > trackSize) {
  		        newSize = trackSize - newPos;
  		      }
  		      if (swiper.isHorizontal()) {
  		        if (Support.transforms3d) {
  		          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
  		        } else {
  		          $dragEl.transform(("translateX(" + newPos + "px)"));
  		        }
  		        $dragEl[0].style.width = newSize + "px";
  		      } else {
  		        if (Support.transforms3d) {
  		          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
  		        } else {
  		          $dragEl.transform(("translateY(" + newPos + "px)"));
  		        }
  		        $dragEl[0].style.height = newSize + "px";
  		      }
  		      if (params.hide) {
  		        clearTimeout(swiper.scrollbar.timeout);
  		        $el[0].style.opacity = 1;
  		        swiper.scrollbar.timeout = setTimeout(function () {
  		          $el[0].style.opacity = 0;
  		          $el.transition(400);
  		        }, 1000);
  		      }
  		    },
  		    setTransition: function setTransition(duration) {
  		      var swiper = this;
  		      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
  		      swiper.scrollbar.$dragEl.transition(duration);
  		    },
  		    updateSize: function updateSize() {
  		      var swiper = this;
  		      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

  		      var scrollbar = swiper.scrollbar;
  		      var $dragEl = scrollbar.$dragEl;
  		      var $el = scrollbar.$el;

  		      $dragEl[0].style.width = '';
  		      $dragEl[0].style.height = '';
  		      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

  		      var divider = swiper.size / swiper.virtualSize;
  		      var moveDivider = divider * (trackSize / swiper.size);
  		      var dragSize;
  		      if (swiper.params.scrollbar.dragSize === 'auto') {
  		        dragSize = trackSize * divider;
  		      } else {
  		        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
  		      }

  		      if (swiper.isHorizontal()) {
  		        $dragEl[0].style.width = dragSize + "px";
  		      } else {
  		        $dragEl[0].style.height = dragSize + "px";
  		      }

  		      if (divider >= 1) {
  		        $el[0].style.display = 'none';
  		      } else {
  		        $el[0].style.display = '';
  		      }
  		      if (swiper.params.scrollbar.hide) {
  		        $el[0].style.opacity = 0;
  		      }
  		      Utils.extend(scrollbar, {
  		        trackSize: trackSize,
  		        divider: divider,
  		        moveDivider: moveDivider,
  		        dragSize: dragSize,
  		      });
  		      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
  		    },
  		    getPointerPosition: function getPointerPosition(e) {
  		      var swiper = this;
  		      if (swiper.isHorizontal()) {
  		        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
  		      }
  		      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
  		    },
  		    setDragPosition: function setDragPosition(e) {
  		      var swiper = this;
  		      var scrollbar = swiper.scrollbar;
  		      var rtl = swiper.rtlTranslate;
  		      var $el = scrollbar.$el;
  		      var dragSize = scrollbar.dragSize;
  		      var trackSize = scrollbar.trackSize;
  		      var dragStartPos = scrollbar.dragStartPos;

  		      var positionRatio;
  		      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
  		        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
  		      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
  		      if (rtl) {
  		        positionRatio = 1 - positionRatio;
  		      }

  		      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

  		      swiper.updateProgress(position);
  		      swiper.setTranslate(position);
  		      swiper.updateActiveIndex();
  		      swiper.updateSlidesClasses();
  		    },
  		    onDragStart: function onDragStart(e) {
  		      var swiper = this;
  		      var params = swiper.params.scrollbar;
  		      var scrollbar = swiper.scrollbar;
  		      var $wrapperEl = swiper.$wrapperEl;
  		      var $el = scrollbar.$el;
  		      var $dragEl = scrollbar.$dragEl;
  		      swiper.scrollbar.isTouched = true;
  		      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
  		        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
  		      e.preventDefault();
  		      e.stopPropagation();

  		      $wrapperEl.transition(100);
  		      $dragEl.transition(100);
  		      scrollbar.setDragPosition(e);

  		      clearTimeout(swiper.scrollbar.dragTimeout);

  		      $el.transition(0);
  		      if (params.hide) {
  		        $el.css('opacity', 1);
  		      }
  		      swiper.emit('scrollbarDragStart', e);
  		    },
  		    onDragMove: function onDragMove(e) {
  		      var swiper = this;
  		      var scrollbar = swiper.scrollbar;
  		      var $wrapperEl = swiper.$wrapperEl;
  		      var $el = scrollbar.$el;
  		      var $dragEl = scrollbar.$dragEl;

  		      if (!swiper.scrollbar.isTouched) { return; }
  		      if (e.preventDefault) { e.preventDefault(); }
  		      else { e.returnValue = false; }
  		      scrollbar.setDragPosition(e);
  		      $wrapperEl.transition(0);
  		      $el.transition(0);
  		      $dragEl.transition(0);
  		      swiper.emit('scrollbarDragMove', e);
  		    },
  		    onDragEnd: function onDragEnd(e) {
  		      var swiper = this;

  		      var params = swiper.params.scrollbar;
  		      var scrollbar = swiper.scrollbar;
  		      var $el = scrollbar.$el;

  		      if (!swiper.scrollbar.isTouched) { return; }
  		      swiper.scrollbar.isTouched = false;
  		      if (params.hide) {
  		        clearTimeout(swiper.scrollbar.dragTimeout);
  		        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
  		          $el.css('opacity', 0);
  		          $el.transition(400);
  		        }, 1000);
  		      }
  		      swiper.emit('scrollbarDragEnd', e);
  		      if (params.snapOnRelease) {
  		        swiper.slideToClosest();
  		      }
  		    },
  		    enableDraggable: function enableDraggable() {
  		      var swiper = this;
  		      if (!swiper.params.scrollbar.el) { return; }
  		      var scrollbar = swiper.scrollbar;
  		      var touchEventsTouch = swiper.touchEventsTouch;
  		      var touchEventsDesktop = swiper.touchEventsDesktop;
  		      var params = swiper.params;
  		      var $el = scrollbar.$el;
  		      var target = $el[0];
  		      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
  		      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
  		      if (!Support.touch) {
  		        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
  		        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
  		        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
  		      } else {
  		        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
  		        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
  		        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
  		      }
  		    },
  		    disableDraggable: function disableDraggable() {
  		      var swiper = this;
  		      if (!swiper.params.scrollbar.el) { return; }
  		      var scrollbar = swiper.scrollbar;
  		      var touchEventsTouch = swiper.touchEventsTouch;
  		      var touchEventsDesktop = swiper.touchEventsDesktop;
  		      var params = swiper.params;
  		      var $el = scrollbar.$el;
  		      var target = $el[0];
  		      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
  		      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
  		      if (!Support.touch) {
  		        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
  		        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
  		        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
  		      } else {
  		        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
  		        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
  		        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
  		      }
  		    },
  		    init: function init() {
  		      var swiper = this;
  		      if (!swiper.params.scrollbar.el) { return; }
  		      var scrollbar = swiper.scrollbar;
  		      var $swiperEl = swiper.$el;
  		      var params = swiper.params.scrollbar;

  		      var $el = $(params.el);
  		      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
  		        $el = $swiperEl.find(params.el);
  		      }

  		      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
  		      if ($dragEl.length === 0) {
  		        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
  		        $el.append($dragEl);
  		      }

  		      Utils.extend(scrollbar, {
  		        $el: $el,
  		        el: $el[0],
  		        $dragEl: $dragEl,
  		        dragEl: $dragEl[0],
  		      });

  		      if (params.draggable) {
  		        scrollbar.enableDraggable();
  		      }
  		    },
  		    destroy: function destroy() {
  		      var swiper = this;
  		      swiper.scrollbar.disableDraggable();
  		    },
  		  };

  		  var Scrollbar$1 = {
  		    name: 'scrollbar',
  		    params: {
  		      scrollbar: {
  		        el: null,
  		        dragSize: 'auto',
  		        hide: false,
  		        draggable: false,
  		        snapOnRelease: true,
  		        lockClass: 'swiper-scrollbar-lock',
  		        dragClass: 'swiper-scrollbar-drag',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        scrollbar: {
  		          init: Scrollbar.init.bind(swiper),
  		          destroy: Scrollbar.destroy.bind(swiper),
  		          updateSize: Scrollbar.updateSize.bind(swiper),
  		          setTranslate: Scrollbar.setTranslate.bind(swiper),
  		          setTransition: Scrollbar.setTransition.bind(swiper),
  		          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
  		          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
  		          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
  		          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
  		          onDragStart: Scrollbar.onDragStart.bind(swiper),
  		          onDragMove: Scrollbar.onDragMove.bind(swiper),
  		          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
  		          isTouched: false,
  		          timeout: null,
  		          dragTimeout: null,
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        swiper.scrollbar.init();
  		        swiper.scrollbar.updateSize();
  		        swiper.scrollbar.setTranslate();
  		      },
  		      update: function update() {
  		        var swiper = this;
  		        swiper.scrollbar.updateSize();
  		      },
  		      resize: function resize() {
  		        var swiper = this;
  		        swiper.scrollbar.updateSize();
  		      },
  		      observerUpdate: function observerUpdate() {
  		        var swiper = this;
  		        swiper.scrollbar.updateSize();
  		      },
  		      setTranslate: function setTranslate() {
  		        var swiper = this;
  		        swiper.scrollbar.setTranslate();
  		      },
  		      setTransition: function setTransition(duration) {
  		        var swiper = this;
  		        swiper.scrollbar.setTransition(duration);
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        swiper.scrollbar.destroy();
  		      },
  		    },
  		  };

  		  var Parallax = {
  		    setTransform: function setTransform(el, progress) {
  		      var swiper = this;
  		      var rtl = swiper.rtl;

  		      var $el = $(el);
  		      var rtlFactor = rtl ? -1 : 1;

  		      var p = $el.attr('data-swiper-parallax') || '0';
  		      var x = $el.attr('data-swiper-parallax-x');
  		      var y = $el.attr('data-swiper-parallax-y');
  		      var scale = $el.attr('data-swiper-parallax-scale');
  		      var opacity = $el.attr('data-swiper-parallax-opacity');

  		      if (x || y) {
  		        x = x || '0';
  		        y = y || '0';
  		      } else if (swiper.isHorizontal()) {
  		        x = p;
  		        y = '0';
  		      } else {
  		        y = p;
  		        x = '0';
  		      }

  		      if ((x).indexOf('%') >= 0) {
  		        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
  		      } else {
  		        x = (x * progress * rtlFactor) + "px";
  		      }
  		      if ((y).indexOf('%') >= 0) {
  		        y = (parseInt(y, 10) * progress) + "%";
  		      } else {
  		        y = (y * progress) + "px";
  		      }

  		      if (typeof opacity !== 'undefined' && opacity !== null) {
  		        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
  		        $el[0].style.opacity = currentOpacity;
  		      }
  		      if (typeof scale === 'undefined' || scale === null) {
  		        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
  		      } else {
  		        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
  		        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
  		      }
  		    },
  		    setTranslate: function setTranslate() {
  		      var swiper = this;
  		      var $el = swiper.$el;
  		      var slides = swiper.slides;
  		      var progress = swiper.progress;
  		      var snapGrid = swiper.snapGrid;
  		      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
  		        .each(function (index, el) {
  		          swiper.parallax.setTransform(el, progress);
  		        });
  		      slides.each(function (slideIndex, slideEl) {
  		        var slideProgress = slideEl.progress;
  		        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
  		          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
  		        }
  		        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
  		        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
  		          .each(function (index, el) {
  		            swiper.parallax.setTransform(el, slideProgress);
  		          });
  		      });
  		    },
  		    setTransition: function setTransition(duration) {
  		      if ( duration === void 0 ) duration = this.params.speed;

  		      var swiper = this;
  		      var $el = swiper.$el;
  		      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
  		        .each(function (index, parallaxEl) {
  		          var $parallaxEl = $(parallaxEl);
  		          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
  		          if (duration === 0) { parallaxDuration = 0; }
  		          $parallaxEl.transition(parallaxDuration);
  		        });
  		    },
  		  };

  		  var Parallax$1 = {
  		    name: 'parallax',
  		    params: {
  		      parallax: {
  		        enabled: false,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        parallax: {
  		          setTransform: Parallax.setTransform.bind(swiper),
  		          setTranslate: Parallax.setTranslate.bind(swiper),
  		          setTransition: Parallax.setTransition.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      beforeInit: function beforeInit() {
  		        var swiper = this;
  		        if (!swiper.params.parallax.enabled) { return; }
  		        swiper.params.watchSlidesProgress = true;
  		        swiper.originalParams.watchSlidesProgress = true;
  		      },
  		      init: function init() {
  		        var swiper = this;
  		        if (!swiper.params.parallax.enabled) { return; }
  		        swiper.parallax.setTranslate();
  		      },
  		      setTranslate: function setTranslate() {
  		        var swiper = this;
  		        if (!swiper.params.parallax.enabled) { return; }
  		        swiper.parallax.setTranslate();
  		      },
  		      setTransition: function setTransition(duration) {
  		        var swiper = this;
  		        if (!swiper.params.parallax.enabled) { return; }
  		        swiper.parallax.setTransition(duration);
  		      },
  		    },
  		  };

  		  var Zoom = {
  		    // Calc Scale From Multi-touches
  		    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
  		      if (e.targetTouches.length < 2) { return 1; }
  		      var x1 = e.targetTouches[0].pageX;
  		      var y1 = e.targetTouches[0].pageY;
  		      var x2 = e.targetTouches[1].pageX;
  		      var y2 = e.targetTouches[1].pageY;
  		      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
  		      return distance;
  		    },
  		    // Events
  		    onGestureStart: function onGestureStart(e) {
  		      var swiper = this;
  		      var params = swiper.params.zoom;
  		      var zoom = swiper.zoom;
  		      var gesture = zoom.gesture;
  		      zoom.fakeGestureTouched = false;
  		      zoom.fakeGestureMoved = false;
  		      if (!Support.gestures) {
  		        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
  		          return;
  		        }
  		        zoom.fakeGestureTouched = true;
  		        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
  		      }
  		      if (!gesture.$slideEl || !gesture.$slideEl.length) {
  		        gesture.$slideEl = $(e.target).closest('.swiper-slide');
  		        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
  		        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
  		        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
  		        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
  		        if (gesture.$imageWrapEl.length === 0) {
  		          gesture.$imageEl = undefined;
  		          return;
  		        }
  		      }
  		      gesture.$imageEl.transition(0);
  		      swiper.zoom.isScaling = true;
  		    },
  		    onGestureChange: function onGestureChange(e) {
  		      var swiper = this;
  		      var params = swiper.params.zoom;
  		      var zoom = swiper.zoom;
  		      var gesture = zoom.gesture;
  		      if (!Support.gestures) {
  		        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
  		          return;
  		        }
  		        zoom.fakeGestureMoved = true;
  		        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
  		      }
  		      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
  		      if (Support.gestures) {
  		        zoom.scale = e.scale * zoom.currentScale;
  		      } else {
  		        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
  		      }
  		      if (zoom.scale > gesture.maxRatio) {
  		        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
  		      }
  		      if (zoom.scale < params.minRatio) {
  		        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
  		      }
  		      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
  		    },
  		    onGestureEnd: function onGestureEnd(e) {
  		      var swiper = this;
  		      var params = swiper.params.zoom;
  		      var zoom = swiper.zoom;
  		      var gesture = zoom.gesture;
  		      if (!Support.gestures) {
  		        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
  		          return;
  		        }
  		        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
  		          return;
  		        }
  		        zoom.fakeGestureTouched = false;
  		        zoom.fakeGestureMoved = false;
  		      }
  		      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
  		      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
  		      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
  		      zoom.currentScale = zoom.scale;
  		      zoom.isScaling = false;
  		      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
  		    },
  		    onTouchStart: function onTouchStart(e) {
  		      var swiper = this;
  		      var zoom = swiper.zoom;
  		      var gesture = zoom.gesture;
  		      var image = zoom.image;
  		      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
  		      if (image.isTouched) { return; }
  		      if (Device.android) { e.preventDefault(); }
  		      image.isTouched = true;
  		      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  		      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  		    },
  		    onTouchMove: function onTouchMove(e) {
  		      var swiper = this;
  		      var zoom = swiper.zoom;
  		      var gesture = zoom.gesture;
  		      var image = zoom.image;
  		      var velocity = zoom.velocity;
  		      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
  		      swiper.allowClick = false;
  		      if (!image.isTouched || !gesture.$slideEl) { return; }

  		      if (!image.isMoved) {
  		        image.width = gesture.$imageEl[0].offsetWidth;
  		        image.height = gesture.$imageEl[0].offsetHeight;
  		        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
  		        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
  		        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
  		        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
  		        gesture.$imageWrapEl.transition(0);
  		        if (swiper.rtl) {
  		          image.startX = -image.startX;
  		          image.startY = -image.startY;
  		        }
  		      }
  		      // Define if we need image drag
  		      var scaledWidth = image.width * zoom.scale;
  		      var scaledHeight = image.height * zoom.scale;

  		      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

  		      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
  		      image.maxX = -image.minX;
  		      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
  		      image.maxY = -image.minY;

  		      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
  		      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

  		      if (!image.isMoved && !zoom.isScaling) {
  		        if (
  		          swiper.isHorizontal()
  		          && (
  		            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
  		            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
  		          )
  		        ) {
  		          image.isTouched = false;
  		          return;
  		        } if (
  		          !swiper.isHorizontal()
  		          && (
  		            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
  		            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
  		          )
  		        ) {
  		          image.isTouched = false;
  		          return;
  		        }
  		      }
  		      e.preventDefault();
  		      e.stopPropagation();

  		      image.isMoved = true;
  		      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
  		      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

  		      if (image.currentX < image.minX) {
  		        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
  		      }
  		      if (image.currentX > image.maxX) {
  		        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
  		      }

  		      if (image.currentY < image.minY) {
  		        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
  		      }
  		      if (image.currentY > image.maxY) {
  		        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
  		      }

  		      // Velocity
  		      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
  		      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
  		      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
  		      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
  		      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
  		      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
  		      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
  		      velocity.prevPositionX = image.touchesCurrent.x;
  		      velocity.prevPositionY = image.touchesCurrent.y;
  		      velocity.prevTime = Date.now();

  		      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
  		    },
  		    onTouchEnd: function onTouchEnd() {
  		      var swiper = this;
  		      var zoom = swiper.zoom;
  		      var gesture = zoom.gesture;
  		      var image = zoom.image;
  		      var velocity = zoom.velocity;
  		      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
  		      if (!image.isTouched || !image.isMoved) {
  		        image.isTouched = false;
  		        image.isMoved = false;
  		        return;
  		      }
  		      image.isTouched = false;
  		      image.isMoved = false;
  		      var momentumDurationX = 300;
  		      var momentumDurationY = 300;
  		      var momentumDistanceX = velocity.x * momentumDurationX;
  		      var newPositionX = image.currentX + momentumDistanceX;
  		      var momentumDistanceY = velocity.y * momentumDurationY;
  		      var newPositionY = image.currentY + momentumDistanceY;

  		      // Fix duration
  		      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
  		      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
  		      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

  		      image.currentX = newPositionX;
  		      image.currentY = newPositionY;

  		      // Define if we need image drag
  		      var scaledWidth = image.width * zoom.scale;
  		      var scaledHeight = image.height * zoom.scale;
  		      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
  		      image.maxX = -image.minX;
  		      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
  		      image.maxY = -image.minY;
  		      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
  		      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

  		      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
  		    },
  		    onTransitionEnd: function onTransitionEnd() {
  		      var swiper = this;
  		      var zoom = swiper.zoom;
  		      var gesture = zoom.gesture;
  		      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
  		        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
  		        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

  		        zoom.scale = 1;
  		        zoom.currentScale = 1;

  		        gesture.$slideEl = undefined;
  		        gesture.$imageEl = undefined;
  		        gesture.$imageWrapEl = undefined;
  		      }
  		    },
  		    // Toggle Zoom
  		    toggle: function toggle(e) {
  		      var swiper = this;
  		      var zoom = swiper.zoom;

  		      if (zoom.scale && zoom.scale !== 1) {
  		        // Zoom Out
  		        zoom.out();
  		      } else {
  		        // Zoom In
  		        zoom.in(e);
  		      }
  		    },
  		    in: function in$1(e) {
  		      var swiper = this;

  		      var zoom = swiper.zoom;
  		      var params = swiper.params.zoom;
  		      var gesture = zoom.gesture;
  		      var image = zoom.image;

  		      if (!gesture.$slideEl) {
  		        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
  		        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
  		        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
  		      }
  		      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

  		      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

  		      var touchX;
  		      var touchY;
  		      var offsetX;
  		      var offsetY;
  		      var diffX;
  		      var diffY;
  		      var translateX;
  		      var translateY;
  		      var imageWidth;
  		      var imageHeight;
  		      var scaledWidth;
  		      var scaledHeight;
  		      var translateMinX;
  		      var translateMinY;
  		      var translateMaxX;
  		      var translateMaxY;
  		      var slideWidth;
  		      var slideHeight;

  		      if (typeof image.touchesStart.x === 'undefined' && e) {
  		        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
  		        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
  		      } else {
  		        touchX = image.touchesStart.x;
  		        touchY = image.touchesStart.y;
  		      }

  		      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
  		      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
  		      if (e) {
  		        slideWidth = gesture.$slideEl[0].offsetWidth;
  		        slideHeight = gesture.$slideEl[0].offsetHeight;
  		        offsetX = gesture.$slideEl.offset().left;
  		        offsetY = gesture.$slideEl.offset().top;
  		        diffX = (offsetX + (slideWidth / 2)) - touchX;
  		        diffY = (offsetY + (slideHeight / 2)) - touchY;

  		        imageWidth = gesture.$imageEl[0].offsetWidth;
  		        imageHeight = gesture.$imageEl[0].offsetHeight;
  		        scaledWidth = imageWidth * zoom.scale;
  		        scaledHeight = imageHeight * zoom.scale;

  		        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
  		        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
  		        translateMaxX = -translateMinX;
  		        translateMaxY = -translateMinY;

  		        translateX = diffX * zoom.scale;
  		        translateY = diffY * zoom.scale;

  		        if (translateX < translateMinX) {
  		          translateX = translateMinX;
  		        }
  		        if (translateX > translateMaxX) {
  		          translateX = translateMaxX;
  		        }

  		        if (translateY < translateMinY) {
  		          translateY = translateMinY;
  		        }
  		        if (translateY > translateMaxY) {
  		          translateY = translateMaxY;
  		        }
  		      } else {
  		        translateX = 0;
  		        translateY = 0;
  		      }
  		      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
  		      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
  		    },
  		    out: function out() {
  		      var swiper = this;

  		      var zoom = swiper.zoom;
  		      var params = swiper.params.zoom;
  		      var gesture = zoom.gesture;

  		      if (!gesture.$slideEl) {
  		        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
  		        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
  		        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
  		      }
  		      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

  		      zoom.scale = 1;
  		      zoom.currentScale = 1;
  		      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
  		      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
  		      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
  		      gesture.$slideEl = undefined;
  		    },
  		    // Attach/Detach Events
  		    enable: function enable() {
  		      var swiper = this;
  		      var zoom = swiper.zoom;
  		      if (zoom.enabled) { return; }
  		      zoom.enabled = true;

  		      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

  		      // Scale image
  		      if (Support.gestures) {
  		        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
  		        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
  		        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
  		      } else if (swiper.touchEvents.start === 'touchstart') {
  		        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
  		        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
  		        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
  		      }

  		      // Move image
  		      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
  		    },
  		    disable: function disable() {
  		      var swiper = this;
  		      var zoom = swiper.zoom;
  		      if (!zoom.enabled) { return; }

  		      swiper.zoom.enabled = false;

  		      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

  		      // Scale image
  		      if (Support.gestures) {
  		        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
  		        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
  		        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
  		      } else if (swiper.touchEvents.start === 'touchstart') {
  		        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
  		        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
  		        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
  		      }

  		      // Move image
  		      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
  		    },
  		  };

  		  var Zoom$1 = {
  		    name: 'zoom',
  		    params: {
  		      zoom: {
  		        enabled: false,
  		        maxRatio: 3,
  		        minRatio: 1,
  		        toggle: true,
  		        containerClass: 'swiper-zoom-container',
  		        zoomedSlideClass: 'swiper-slide-zoomed',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      var zoom = {
  		        enabled: false,
  		        scale: 1,
  		        currentScale: 1,
  		        isScaling: false,
  		        gesture: {
  		          $slideEl: undefined,
  		          slideWidth: undefined,
  		          slideHeight: undefined,
  		          $imageEl: undefined,
  		          $imageWrapEl: undefined,
  		          maxRatio: 3,
  		        },
  		        image: {
  		          isTouched: undefined,
  		          isMoved: undefined,
  		          currentX: undefined,
  		          currentY: undefined,
  		          minX: undefined,
  		          minY: undefined,
  		          maxX: undefined,
  		          maxY: undefined,
  		          width: undefined,
  		          height: undefined,
  		          startX: undefined,
  		          startY: undefined,
  		          touchesStart: {},
  		          touchesCurrent: {},
  		        },
  		        velocity: {
  		          x: undefined,
  		          y: undefined,
  		          prevPositionX: undefined,
  		          prevPositionY: undefined,
  		          prevTime: undefined,
  		        },
  		      };

  		      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
  		        zoom[methodName] = Zoom[methodName].bind(swiper);
  		      });
  		      Utils.extend(swiper, {
  		        zoom: zoom,
  		      });

  		      var scale = 1;
  		      Object.defineProperty(swiper.zoom, 'scale', {
  		        get: function get() {
  		          return scale;
  		        },
  		        set: function set(value) {
  		          if (scale !== value) {
  		            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
  		            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
  		            swiper.emit('zoomChange', value, imageEl, slideEl);
  		          }
  		          scale = value;
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        if (swiper.params.zoom.enabled) {
  		          swiper.zoom.enable();
  		        }
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        swiper.zoom.disable();
  		      },
  		      touchStart: function touchStart(e) {
  		        var swiper = this;
  		        if (!swiper.zoom.enabled) { return; }
  		        swiper.zoom.onTouchStart(e);
  		      },
  		      touchEnd: function touchEnd(e) {
  		        var swiper = this;
  		        if (!swiper.zoom.enabled) { return; }
  		        swiper.zoom.onTouchEnd(e);
  		      },
  		      doubleTap: function doubleTap(e) {
  		        var swiper = this;
  		        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
  		          swiper.zoom.toggle(e);
  		        }
  		      },
  		      transitionEnd: function transitionEnd() {
  		        var swiper = this;
  		        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
  		          swiper.zoom.onTransitionEnd();
  		        }
  		      },
  		    },
  		  };

  		  var Lazy = {
  		    loadInSlide: function loadInSlide(index, loadInDuplicate) {
  		      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

  		      var swiper = this;
  		      var params = swiper.params.lazy;
  		      if (typeof index === 'undefined') { return; }
  		      if (swiper.slides.length === 0) { return; }
  		      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

  		      var $slideEl = isVirtual
  		        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
  		        : swiper.slides.eq(index);

  		      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
  		      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
  		        $images = $images.add($slideEl[0]);
  		      }
  		      if ($images.length === 0) { return; }

  		      $images.each(function (imageIndex, imageEl) {
  		        var $imageEl = $(imageEl);
  		        $imageEl.addClass(params.loadingClass);

  		        var background = $imageEl.attr('data-background');
  		        var src = $imageEl.attr('data-src');
  		        var srcset = $imageEl.attr('data-srcset');
  		        var sizes = $imageEl.attr('data-sizes');

  		        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
  		          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
  		          if (background) {
  		            $imageEl.css('background-image', ("url(\"" + background + "\")"));
  		            $imageEl.removeAttr('data-background');
  		          } else {
  		            if (srcset) {
  		              $imageEl.attr('srcset', srcset);
  		              $imageEl.removeAttr('data-srcset');
  		            }
  		            if (sizes) {
  		              $imageEl.attr('sizes', sizes);
  		              $imageEl.removeAttr('data-sizes');
  		            }
  		            if (src) {
  		              $imageEl.attr('src', src);
  		              $imageEl.removeAttr('data-src');
  		            }
  		          }

  		          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
  		          $slideEl.find(("." + (params.preloaderClass))).remove();
  		          if (swiper.params.loop && loadInDuplicate) {
  		            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
  		            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
  		              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
  		              swiper.lazy.loadInSlide(originalSlide.index(), false);
  		            } else {
  		              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
  		              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
  		            }
  		          }
  		          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
  		        });

  		        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
  		      });
  		    },
  		    load: function load() {
  		      var swiper = this;
  		      var $wrapperEl = swiper.$wrapperEl;
  		      var swiperParams = swiper.params;
  		      var slides = swiper.slides;
  		      var activeIndex = swiper.activeIndex;
  		      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
  		      var params = swiperParams.lazy;

  		      var slidesPerView = swiperParams.slidesPerView;
  		      if (slidesPerView === 'auto') {
  		        slidesPerView = 0;
  		      }

  		      function slideExist(index) {
  		        if (isVirtual) {
  		          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
  		            return true;
  		          }
  		        } else if (slides[index]) { return true; }
  		        return false;
  		      }
  		      function slideIndex(slideEl) {
  		        if (isVirtual) {
  		          return $(slideEl).attr('data-swiper-slide-index');
  		        }
  		        return $(slideEl).index();
  		      }

  		      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
  		      if (swiper.params.watchSlidesVisibility) {
  		        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
  		          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
  		          swiper.lazy.loadInSlide(index);
  		        });
  		      } else if (slidesPerView > 1) {
  		        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
  		          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
  		        }
  		      } else {
  		        swiper.lazy.loadInSlide(activeIndex);
  		      }
  		      if (params.loadPrevNext) {
  		        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
  		          var amount = params.loadPrevNextAmount;
  		          var spv = slidesPerView;
  		          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
  		          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
  		          // Next Slides
  		          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
  		            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
  		          }
  		          // Prev Slides
  		          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
  		            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
  		          }
  		        } else {
  		          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
  		          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

  		          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
  		          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
  		        }
  		      }
  		    },
  		  };

  		  var Lazy$1 = {
  		    name: 'lazy',
  		    params: {
  		      lazy: {
  		        enabled: false,
  		        loadPrevNext: false,
  		        loadPrevNextAmount: 1,
  		        loadOnTransitionStart: false,

  		        elementClass: 'swiper-lazy',
  		        loadingClass: 'swiper-lazy-loading',
  		        loadedClass: 'swiper-lazy-loaded',
  		        preloaderClass: 'swiper-lazy-preloader',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        lazy: {
  		          initialImageLoaded: false,
  		          load: Lazy.load.bind(swiper),
  		          loadInSlide: Lazy.loadInSlide.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      beforeInit: function beforeInit() {
  		        var swiper = this;
  		        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
  		          swiper.params.preloadImages = false;
  		        }
  		      },
  		      init: function init() {
  		        var swiper = this;
  		        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
  		          swiper.lazy.load();
  		        }
  		      },
  		      scroll: function scroll() {
  		        var swiper = this;
  		        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
  		          swiper.lazy.load();
  		        }
  		      },
  		      resize: function resize() {
  		        var swiper = this;
  		        if (swiper.params.lazy.enabled) {
  		          swiper.lazy.load();
  		        }
  		      },
  		      scrollbarDragMove: function scrollbarDragMove() {
  		        var swiper = this;
  		        if (swiper.params.lazy.enabled) {
  		          swiper.lazy.load();
  		        }
  		      },
  		      transitionStart: function transitionStart() {
  		        var swiper = this;
  		        if (swiper.params.lazy.enabled) {
  		          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
  		            swiper.lazy.load();
  		          }
  		        }
  		      },
  		      transitionEnd: function transitionEnd() {
  		        var swiper = this;
  		        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
  		          swiper.lazy.load();
  		        }
  		      },
  		    },
  		  };

  		  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  		  var Controller = {
  		    LinearSpline: function LinearSpline(x, y) {
  		      var binarySearch = (function search() {
  		        var maxIndex;
  		        var minIndex;
  		        var guess;
  		        return function (array, val) {
  		          minIndex = -1;
  		          maxIndex = array.length;
  		          while (maxIndex - minIndex > 1) {
  		            guess = maxIndex + minIndex >> 1;
  		            if (array[guess] <= val) {
  		              minIndex = guess;
  		            } else {
  		              maxIndex = guess;
  		            }
  		          }
  		          return maxIndex;
  		        };
  		      }());
  		      this.x = x;
  		      this.y = y;
  		      this.lastIndex = x.length - 1;
  		      // Given an x value (x2), return the expected y2 value:
  		      // (x1,y1) is the known point before given value,
  		      // (x3,y3) is the known point after given value.
  		      var i1;
  		      var i3;

  		      this.interpolate = function interpolate(x2) {
  		        if (!x2) { return 0; }

  		        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
  		        i3 = binarySearch(this.x, x2);
  		        i1 = i3 - 1;

  		        // We have our indexes i1 & i3, so we can calculate already:
  		        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
  		        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
  		      };
  		      return this;
  		    },
  		    // xxx: for now i will just save one spline function to to
  		    getInterpolateFunction: function getInterpolateFunction(c) {
  		      var swiper = this;
  		      if (!swiper.controller.spline) {
  		        swiper.controller.spline = swiper.params.loop
  		          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
  		          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
  		      }
  		    },
  		    setTranslate: function setTranslate(setTranslate$1, byController) {
  		      var swiper = this;
  		      var controlled = swiper.controller.control;
  		      var multiplier;
  		      var controlledTranslate;
  		      function setControlledTranslate(c) {
  		        // this will create an Interpolate function based on the snapGrids
  		        // x is the Grid of the scrolled scroller and y will be the controlled scroller
  		        // it makes sense to create this only once and recall it for the interpolation
  		        // the function does a lot of value caching for performance
  		        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
  		        if (swiper.params.controller.by === 'slide') {
  		          swiper.controller.getInterpolateFunction(c);
  		          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
  		          // but it did not work out
  		          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
  		        }

  		        if (!controlledTranslate || swiper.params.controller.by === 'container') {
  		          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
  		          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
  		        }

  		        if (swiper.params.controller.inverse) {
  		          controlledTranslate = c.maxTranslate() - controlledTranslate;
  		        }
  		        c.updateProgress(controlledTranslate);
  		        c.setTranslate(controlledTranslate, swiper);
  		        c.updateActiveIndex();
  		        c.updateSlidesClasses();
  		      }
  		      if (Array.isArray(controlled)) {
  		        for (var i = 0; i < controlled.length; i += 1) {
  		          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
  		            setControlledTranslate(controlled[i]);
  		          }
  		        }
  		      } else if (controlled instanceof Swiper && byController !== controlled) {
  		        setControlledTranslate(controlled);
  		      }
  		    },
  		    setTransition: function setTransition(duration, byController) {
  		      var swiper = this;
  		      var controlled = swiper.controller.control;
  		      var i;
  		      function setControlledTransition(c) {
  		        c.setTransition(duration, swiper);
  		        if (duration !== 0) {
  		          c.transitionStart();
  		          if (c.params.autoHeight) {
  		            Utils.nextTick(function () {
  		              c.updateAutoHeight();
  		            });
  		          }
  		          c.$wrapperEl.transitionEnd(function () {
  		            if (!controlled) { return; }
  		            if (c.params.loop && swiper.params.controller.by === 'slide') {
  		              c.loopFix();
  		            }
  		            c.transitionEnd();
  		          });
  		        }
  		      }
  		      if (Array.isArray(controlled)) {
  		        for (i = 0; i < controlled.length; i += 1) {
  		          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
  		            setControlledTransition(controlled[i]);
  		          }
  		        }
  		      } else if (controlled instanceof Swiper && byController !== controlled) {
  		        setControlledTransition(controlled);
  		      }
  		    },
  		  };
  		  var Controller$1 = {
  		    name: 'controller',
  		    params: {
  		      controller: {
  		        control: undefined,
  		        inverse: false,
  		        by: 'slide', // or 'container'
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        controller: {
  		          control: swiper.params.controller.control,
  		          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
  		          setTranslate: Controller.setTranslate.bind(swiper),
  		          setTransition: Controller.setTransition.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      update: function update() {
  		        var swiper = this;
  		        if (!swiper.controller.control) { return; }
  		        if (swiper.controller.spline) {
  		          swiper.controller.spline = undefined;
  		          delete swiper.controller.spline;
  		        }
  		      },
  		      resize: function resize() {
  		        var swiper = this;
  		        if (!swiper.controller.control) { return; }
  		        if (swiper.controller.spline) {
  		          swiper.controller.spline = undefined;
  		          delete swiper.controller.spline;
  		        }
  		      },
  		      observerUpdate: function observerUpdate() {
  		        var swiper = this;
  		        if (!swiper.controller.control) { return; }
  		        if (swiper.controller.spline) {
  		          swiper.controller.spline = undefined;
  		          delete swiper.controller.spline;
  		        }
  		      },
  		      setTranslate: function setTranslate(translate, byController) {
  		        var swiper = this;
  		        if (!swiper.controller.control) { return; }
  		        swiper.controller.setTranslate(translate, byController);
  		      },
  		      setTransition: function setTransition(duration, byController) {
  		        var swiper = this;
  		        if (!swiper.controller.control) { return; }
  		        swiper.controller.setTransition(duration, byController);
  		      },
  		    },
  		  };

  		  var a11y = {
  		    makeElFocusable: function makeElFocusable($el) {
  		      $el.attr('tabIndex', '0');
  		      return $el;
  		    },
  		    addElRole: function addElRole($el, role) {
  		      $el.attr('role', role);
  		      return $el;
  		    },
  		    addElLabel: function addElLabel($el, label) {
  		      $el.attr('aria-label', label);
  		      return $el;
  		    },
  		    disableEl: function disableEl($el) {
  		      $el.attr('aria-disabled', true);
  		      return $el;
  		    },
  		    enableEl: function enableEl($el) {
  		      $el.attr('aria-disabled', false);
  		      return $el;
  		    },
  		    onEnterKey: function onEnterKey(e) {
  		      var swiper = this;
  		      var params = swiper.params.a11y;
  		      if (e.keyCode !== 13) { return; }
  		      var $targetEl = $(e.target);
  		      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
  		        if (!(swiper.isEnd && !swiper.params.loop)) {
  		          swiper.slideNext();
  		        }
  		        if (swiper.isEnd) {
  		          swiper.a11y.notify(params.lastSlideMessage);
  		        } else {
  		          swiper.a11y.notify(params.nextSlideMessage);
  		        }
  		      }
  		      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
  		        if (!(swiper.isBeginning && !swiper.params.loop)) {
  		          swiper.slidePrev();
  		        }
  		        if (swiper.isBeginning) {
  		          swiper.a11y.notify(params.firstSlideMessage);
  		        } else {
  		          swiper.a11y.notify(params.prevSlideMessage);
  		        }
  		      }
  		      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
  		        $targetEl[0].click();
  		      }
  		    },
  		    notify: function notify(message) {
  		      var swiper = this;
  		      var notification = swiper.a11y.liveRegion;
  		      if (notification.length === 0) { return; }
  		      notification.html('');
  		      notification.html(message);
  		    },
  		    updateNavigation: function updateNavigation() {
  		      var swiper = this;

  		      if (swiper.params.loop) { return; }
  		      var ref = swiper.navigation;
  		      var $nextEl = ref.$nextEl;
  		      var $prevEl = ref.$prevEl;

  		      if ($prevEl && $prevEl.length > 0) {
  		        if (swiper.isBeginning) {
  		          swiper.a11y.disableEl($prevEl);
  		        } else {
  		          swiper.a11y.enableEl($prevEl);
  		        }
  		      }
  		      if ($nextEl && $nextEl.length > 0) {
  		        if (swiper.isEnd) {
  		          swiper.a11y.disableEl($nextEl);
  		        } else {
  		          swiper.a11y.enableEl($nextEl);
  		        }
  		      }
  		    },
  		    updatePagination: function updatePagination() {
  		      var swiper = this;
  		      var params = swiper.params.a11y;
  		      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
  		        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
  		          var $bulletEl = $(bulletEl);
  		          swiper.a11y.makeElFocusable($bulletEl);
  		          swiper.a11y.addElRole($bulletEl, 'button');
  		          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
  		        });
  		      }
  		    },
  		    init: function init() {
  		      var swiper = this;

  		      swiper.$el.append(swiper.a11y.liveRegion);

  		      // Navigation
  		      var params = swiper.params.a11y;
  		      var $nextEl;
  		      var $prevEl;
  		      if (swiper.navigation && swiper.navigation.$nextEl) {
  		        $nextEl = swiper.navigation.$nextEl;
  		      }
  		      if (swiper.navigation && swiper.navigation.$prevEl) {
  		        $prevEl = swiper.navigation.$prevEl;
  		      }
  		      if ($nextEl) {
  		        swiper.a11y.makeElFocusable($nextEl);
  		        swiper.a11y.addElRole($nextEl, 'button');
  		        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
  		        $nextEl.on('keydown', swiper.a11y.onEnterKey);
  		      }
  		      if ($prevEl) {
  		        swiper.a11y.makeElFocusable($prevEl);
  		        swiper.a11y.addElRole($prevEl, 'button');
  		        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
  		        $prevEl.on('keydown', swiper.a11y.onEnterKey);
  		      }

  		      // Pagination
  		      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
  		        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
  		      }
  		    },
  		    destroy: function destroy() {
  		      var swiper = this;
  		      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

  		      var $nextEl;
  		      var $prevEl;
  		      if (swiper.navigation && swiper.navigation.$nextEl) {
  		        $nextEl = swiper.navigation.$nextEl;
  		      }
  		      if (swiper.navigation && swiper.navigation.$prevEl) {
  		        $prevEl = swiper.navigation.$prevEl;
  		      }
  		      if ($nextEl) {
  		        $nextEl.off('keydown', swiper.a11y.onEnterKey);
  		      }
  		      if ($prevEl) {
  		        $prevEl.off('keydown', swiper.a11y.onEnterKey);
  		      }

  		      // Pagination
  		      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
  		        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
  		      }
  		    },
  		  };
  		  var A11y = {
  		    name: 'a11y',
  		    params: {
  		      a11y: {
  		        enabled: true,
  		        notificationClass: 'swiper-notification',
  		        prevSlideMessage: 'Previous slide',
  		        nextSlideMessage: 'Next slide',
  		        firstSlideMessage: 'This is the first slide',
  		        lastSlideMessage: 'This is the last slide',
  		        paginationBulletMessage: 'Go to slide {{index}}',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        a11y: {
  		          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
  		        },
  		      });
  		      Object.keys(a11y).forEach(function (methodName) {
  		        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        if (!swiper.params.a11y.enabled) { return; }
  		        swiper.a11y.init();
  		        swiper.a11y.updateNavigation();
  		      },
  		      toEdge: function toEdge() {
  		        var swiper = this;
  		        if (!swiper.params.a11y.enabled) { return; }
  		        swiper.a11y.updateNavigation();
  		      },
  		      fromEdge: function fromEdge() {
  		        var swiper = this;
  		        if (!swiper.params.a11y.enabled) { return; }
  		        swiper.a11y.updateNavigation();
  		      },
  		      paginationUpdate: function paginationUpdate() {
  		        var swiper = this;
  		        if (!swiper.params.a11y.enabled) { return; }
  		        swiper.a11y.updatePagination();
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        if (!swiper.params.a11y.enabled) { return; }
  		        swiper.a11y.destroy();
  		      },
  		    },
  		  };

  		  var History = {
  		    init: function init() {
  		      var swiper = this;
  		      if (!swiper.params.history) { return; }
  		      if (!win.history || !win.history.pushState) {
  		        swiper.params.history.enabled = false;
  		        swiper.params.hashNavigation.enabled = true;
  		        return;
  		      }
  		      var history = swiper.history;
  		      history.initialized = true;
  		      history.paths = History.getPathValues();
  		      if (!history.paths.key && !history.paths.value) { return; }
  		      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
  		      if (!swiper.params.history.replaceState) {
  		        win.addEventListener('popstate', swiper.history.setHistoryPopState);
  		      }
  		    },
  		    destroy: function destroy() {
  		      var swiper = this;
  		      if (!swiper.params.history.replaceState) {
  		        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
  		      }
  		    },
  		    setHistoryPopState: function setHistoryPopState() {
  		      var swiper = this;
  		      swiper.history.paths = History.getPathValues();
  		      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
  		    },
  		    getPathValues: function getPathValues() {
  		      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
  		      var total = pathArray.length;
  		      var key = pathArray[total - 2];
  		      var value = pathArray[total - 1];
  		      return { key: key, value: value };
  		    },
  		    setHistory: function setHistory(key, index) {
  		      var swiper = this;
  		      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
  		      var slide = swiper.slides.eq(index);
  		      var value = History.slugify(slide.attr('data-history'));
  		      if (!win.location.pathname.includes(key)) {
  		        value = key + "/" + value;
  		      }
  		      var currentState = win.history.state;
  		      if (currentState && currentState.value === value) {
  		        return;
  		      }
  		      if (swiper.params.history.replaceState) {
  		        win.history.replaceState({ value: value }, null, value);
  		      } else {
  		        win.history.pushState({ value: value }, null, value);
  		      }
  		    },
  		    slugify: function slugify(text) {
  		      return text.toString()
  		        .replace(/\s+/g, '-')
  		        .replace(/[^\w-]+/g, '')
  		        .replace(/--+/g, '-')
  		        .replace(/^-+/, '')
  		        .replace(/-+$/, '');
  		    },
  		    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
  		      var swiper = this;
  		      if (value) {
  		        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
  		          var slide = swiper.slides.eq(i);
  		          var slideHistory = History.slugify(slide.attr('data-history'));
  		          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
  		            var index = slide.index();
  		            swiper.slideTo(index, speed, runCallbacks);
  		          }
  		        }
  		      } else {
  		        swiper.slideTo(0, speed, runCallbacks);
  		      }
  		    },
  		  };

  		  var History$1 = {
  		    name: 'history',
  		    params: {
  		      history: {
  		        enabled: false,
  		        replaceState: false,
  		        key: 'slides',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        history: {
  		          init: History.init.bind(swiper),
  		          setHistory: History.setHistory.bind(swiper),
  		          setHistoryPopState: History.setHistoryPopState.bind(swiper),
  		          scrollToSlide: History.scrollToSlide.bind(swiper),
  		          destroy: History.destroy.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        if (swiper.params.history.enabled) {
  		          swiper.history.init();
  		        }
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        if (swiper.params.history.enabled) {
  		          swiper.history.destroy();
  		        }
  		      },
  		      transitionEnd: function transitionEnd() {
  		        var swiper = this;
  		        if (swiper.history.initialized) {
  		          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
  		        }
  		      },
  		    },
  		  };

  		  var HashNavigation = {
  		    onHashCange: function onHashCange() {
  		      var swiper = this;
  		      var newHash = doc.location.hash.replace('#', '');
  		      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
  		      if (newHash !== activeSlideHash) {
  		        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
  		        if (typeof newIndex === 'undefined') { return; }
  		        swiper.slideTo(newIndex);
  		      }
  		    },
  		    setHash: function setHash() {
  		      var swiper = this;
  		      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
  		      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
  		        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
  		      } else {
  		        var slide = swiper.slides.eq(swiper.activeIndex);
  		        var hash = slide.attr('data-hash') || slide.attr('data-history');
  		        doc.location.hash = hash || '';
  		      }
  		    },
  		    init: function init() {
  		      var swiper = this;
  		      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
  		      swiper.hashNavigation.initialized = true;
  		      var hash = doc.location.hash.replace('#', '');
  		      if (hash) {
  		        var speed = 0;
  		        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
  		          var slide = swiper.slides.eq(i);
  		          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
  		          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
  		            var index = slide.index();
  		            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
  		          }
  		        }
  		      }
  		      if (swiper.params.hashNavigation.watchState) {
  		        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
  		      }
  		    },
  		    destroy: function destroy() {
  		      var swiper = this;
  		      if (swiper.params.hashNavigation.watchState) {
  		        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
  		      }
  		    },
  		  };
  		  var HashNavigation$1 = {
  		    name: 'hash-navigation',
  		    params: {
  		      hashNavigation: {
  		        enabled: false,
  		        replaceState: false,
  		        watchState: false,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        hashNavigation: {
  		          initialized: false,
  		          init: HashNavigation.init.bind(swiper),
  		          destroy: HashNavigation.destroy.bind(swiper),
  		          setHash: HashNavigation.setHash.bind(swiper),
  		          onHashCange: HashNavigation.onHashCange.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        if (swiper.params.hashNavigation.enabled) {
  		          swiper.hashNavigation.init();
  		        }
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        if (swiper.params.hashNavigation.enabled) {
  		          swiper.hashNavigation.destroy();
  		        }
  		      },
  		      transitionEnd: function transitionEnd() {
  		        var swiper = this;
  		        if (swiper.hashNavigation.initialized) {
  		          swiper.hashNavigation.setHash();
  		        }
  		      },
  		    },
  		  };

  		  /* eslint no-underscore-dangle: "off" */

  		  var Autoplay = {
  		    run: function run() {
  		      var swiper = this;
  		      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
  		      var delay = swiper.params.autoplay.delay;
  		      if ($activeSlideEl.attr('data-swiper-autoplay')) {
  		        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
  		      }
  		      clearTimeout(swiper.autoplay.timeout);
  		      swiper.autoplay.timeout = Utils.nextTick(function () {
  		        if (swiper.params.autoplay.reverseDirection) {
  		          if (swiper.params.loop) {
  		            swiper.loopFix();
  		            swiper.slidePrev(swiper.params.speed, true, true);
  		            swiper.emit('autoplay');
  		          } else if (!swiper.isBeginning) {
  		            swiper.slidePrev(swiper.params.speed, true, true);
  		            swiper.emit('autoplay');
  		          } else if (!swiper.params.autoplay.stopOnLastSlide) {
  		            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
  		            swiper.emit('autoplay');
  		          } else {
  		            swiper.autoplay.stop();
  		          }
  		        } else if (swiper.params.loop) {
  		          swiper.loopFix();
  		          swiper.slideNext(swiper.params.speed, true, true);
  		          swiper.emit('autoplay');
  		        } else if (!swiper.isEnd) {
  		          swiper.slideNext(swiper.params.speed, true, true);
  		          swiper.emit('autoplay');
  		        } else if (!swiper.params.autoplay.stopOnLastSlide) {
  		          swiper.slideTo(0, swiper.params.speed, true, true);
  		          swiper.emit('autoplay');
  		        } else {
  		          swiper.autoplay.stop();
  		        }
  		      }, delay);
  		    },
  		    start: function start() {
  		      var swiper = this;
  		      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
  		      if (swiper.autoplay.running) { return false; }
  		      swiper.autoplay.running = true;
  		      swiper.emit('autoplayStart');
  		      swiper.autoplay.run();
  		      return true;
  		    },
  		    stop: function stop() {
  		      var swiper = this;
  		      if (!swiper.autoplay.running) { return false; }
  		      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

  		      if (swiper.autoplay.timeout) {
  		        clearTimeout(swiper.autoplay.timeout);
  		        swiper.autoplay.timeout = undefined;
  		      }
  		      swiper.autoplay.running = false;
  		      swiper.emit('autoplayStop');
  		      return true;
  		    },
  		    pause: function pause(speed) {
  		      var swiper = this;
  		      if (!swiper.autoplay.running) { return; }
  		      if (swiper.autoplay.paused) { return; }
  		      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
  		      swiper.autoplay.paused = true;
  		      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
  		        swiper.autoplay.paused = false;
  		        swiper.autoplay.run();
  		      } else {
  		        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
  		        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
  		      }
  		    },
  		  };

  		  var Autoplay$1 = {
  		    name: 'autoplay',
  		    params: {
  		      autoplay: {
  		        enabled: false,
  		        delay: 3000,
  		        waitForTransition: true,
  		        disableOnInteraction: true,
  		        stopOnLastSlide: false,
  		        reverseDirection: false,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        autoplay: {
  		          running: false,
  		          paused: false,
  		          run: Autoplay.run.bind(swiper),
  		          start: Autoplay.start.bind(swiper),
  		          stop: Autoplay.stop.bind(swiper),
  		          pause: Autoplay.pause.bind(swiper),
  		          onTransitionEnd: function onTransitionEnd(e) {
  		            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
  		            if (e.target !== this) { return; }
  		            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
  		            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
  		            swiper.autoplay.paused = false;
  		            if (!swiper.autoplay.running) {
  		              swiper.autoplay.stop();
  		            } else {
  		              swiper.autoplay.run();
  		            }
  		          },
  		        },
  		      });
  		    },
  		    on: {
  		      init: function init() {
  		        var swiper = this;
  		        if (swiper.params.autoplay.enabled) {
  		          swiper.autoplay.start();
  		        }
  		      },
  		      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
  		        var swiper = this;
  		        if (swiper.autoplay.running) {
  		          if (internal || !swiper.params.autoplay.disableOnInteraction) {
  		            swiper.autoplay.pause(speed);
  		          } else {
  		            swiper.autoplay.stop();
  		          }
  		        }
  		      },
  		      sliderFirstMove: function sliderFirstMove() {
  		        var swiper = this;
  		        if (swiper.autoplay.running) {
  		          if (swiper.params.autoplay.disableOnInteraction) {
  		            swiper.autoplay.stop();
  		          } else {
  		            swiper.autoplay.pause();
  		          }
  		        }
  		      },
  		      destroy: function destroy() {
  		        var swiper = this;
  		        if (swiper.autoplay.running) {
  		          swiper.autoplay.stop();
  		        }
  		      },
  		    },
  		  };

  		  var Fade = {
  		    setTranslate: function setTranslate() {
  		      var swiper = this;
  		      var slides = swiper.slides;
  		      for (var i = 0; i < slides.length; i += 1) {
  		        var $slideEl = swiper.slides.eq(i);
  		        var offset = $slideEl[0].swiperSlideOffset;
  		        var tx = -offset;
  		        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
  		        var ty = 0;
  		        if (!swiper.isHorizontal()) {
  		          ty = tx;
  		          tx = 0;
  		        }
  		        var slideOpacity = swiper.params.fadeEffect.crossFade
  		          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
  		          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
  		        $slideEl
  		          .css({
  		            opacity: slideOpacity,
  		          })
  		          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
  		      }
  		    },
  		    setTransition: function setTransition(duration) {
  		      var swiper = this;
  		      var slides = swiper.slides;
  		      var $wrapperEl = swiper.$wrapperEl;
  		      slides.transition(duration);
  		      if (swiper.params.virtualTranslate && duration !== 0) {
  		        var eventTriggered = false;
  		        slides.transitionEnd(function () {
  		          if (eventTriggered) { return; }
  		          if (!swiper || swiper.destroyed) { return; }
  		          eventTriggered = true;
  		          swiper.animating = false;
  		          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
  		          for (var i = 0; i < triggerEvents.length; i += 1) {
  		            $wrapperEl.trigger(triggerEvents[i]);
  		          }
  		        });
  		      }
  		    },
  		  };

  		  var EffectFade = {
  		    name: 'effect-fade',
  		    params: {
  		      fadeEffect: {
  		        crossFade: false,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        fadeEffect: {
  		          setTranslate: Fade.setTranslate.bind(swiper),
  		          setTransition: Fade.setTransition.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      beforeInit: function beforeInit() {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'fade') { return; }
  		        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
  		        var overwriteParams = {
  		          slidesPerView: 1,
  		          slidesPerColumn: 1,
  		          slidesPerGroup: 1,
  		          watchSlidesProgress: true,
  		          spaceBetween: 0,
  		          virtualTranslate: true,
  		        };
  		        Utils.extend(swiper.params, overwriteParams);
  		        Utils.extend(swiper.originalParams, overwriteParams);
  		      },
  		      setTranslate: function setTranslate() {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'fade') { return; }
  		        swiper.fadeEffect.setTranslate();
  		      },
  		      setTransition: function setTransition(duration) {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'fade') { return; }
  		        swiper.fadeEffect.setTransition(duration);
  		      },
  		    },
  		  };

  		  var Cube = {
  		    setTranslate: function setTranslate() {
  		      var swiper = this;
  		      var $el = swiper.$el;
  		      var $wrapperEl = swiper.$wrapperEl;
  		      var slides = swiper.slides;
  		      var swiperWidth = swiper.width;
  		      var swiperHeight = swiper.height;
  		      var rtl = swiper.rtlTranslate;
  		      var swiperSize = swiper.size;
  		      var params = swiper.params.cubeEffect;
  		      var isHorizontal = swiper.isHorizontal();
  		      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  		      var wrapperRotate = 0;
  		      var $cubeShadowEl;
  		      if (params.shadow) {
  		        if (isHorizontal) {
  		          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
  		          if ($cubeShadowEl.length === 0) {
  		            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
  		            $wrapperEl.append($cubeShadowEl);
  		          }
  		          $cubeShadowEl.css({ height: (swiperWidth + "px") });
  		        } else {
  		          $cubeShadowEl = $el.find('.swiper-cube-shadow');
  		          if ($cubeShadowEl.length === 0) {
  		            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
  		            $el.append($cubeShadowEl);
  		          }
  		        }
  		      }
  		      for (var i = 0; i < slides.length; i += 1) {
  		        var $slideEl = slides.eq(i);
  		        var slideIndex = i;
  		        if (isVirtual) {
  		          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
  		        }
  		        var slideAngle = slideIndex * 90;
  		        var round = Math.floor(slideAngle / 360);
  		        if (rtl) {
  		          slideAngle = -slideAngle;
  		          round = Math.floor(-slideAngle / 360);
  		        }
  		        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
  		        var tx = 0;
  		        var ty = 0;
  		        var tz = 0;
  		        if (slideIndex % 4 === 0) {
  		          tx = -round * 4 * swiperSize;
  		          tz = 0;
  		        } else if ((slideIndex - 1) % 4 === 0) {
  		          tx = 0;
  		          tz = -round * 4 * swiperSize;
  		        } else if ((slideIndex - 2) % 4 === 0) {
  		          tx = swiperSize + (round * 4 * swiperSize);
  		          tz = swiperSize;
  		        } else if ((slideIndex - 3) % 4 === 0) {
  		          tx = -swiperSize;
  		          tz = (3 * swiperSize) + (swiperSize * 4 * round);
  		        }
  		        if (rtl) {
  		          tx = -tx;
  		        }

  		        if (!isHorizontal) {
  		          ty = tx;
  		          tx = 0;
  		        }

  		        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
  		        if (progress <= 1 && progress > -1) {
  		          wrapperRotate = (slideIndex * 90) + (progress * 90);
  		          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
  		        }
  		        $slideEl.transform(transform);
  		        if (params.slideShadows) {
  		          // Set shadows
  		          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
  		          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
  		          if (shadowBefore.length === 0) {
  		            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
  		            $slideEl.append(shadowBefore);
  		          }
  		          if (shadowAfter.length === 0) {
  		            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
  		            $slideEl.append(shadowAfter);
  		          }
  		          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
  		          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
  		        }
  		      }
  		      $wrapperEl.css({
  		        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
  		        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
  		        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
  		        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
  		      });

  		      if (params.shadow) {
  		        if (isHorizontal) {
  		          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
  		        } else {
  		          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
  		          var multiplier = 1.5 - (
  		            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
  		            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
  		          );
  		          var scale1 = params.shadowScale;
  		          var scale2 = params.shadowScale / multiplier;
  		          var offset = params.shadowOffset;
  		          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
  		        }
  		      }
  		      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
  		      $wrapperEl
  		        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
  		    },
  		    setTransition: function setTransition(duration) {
  		      var swiper = this;
  		      var $el = swiper.$el;
  		      var slides = swiper.slides;
  		      slides
  		        .transition(duration)
  		        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
  		        .transition(duration);
  		      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
  		        $el.find('.swiper-cube-shadow').transition(duration);
  		      }
  		    },
  		  };

  		  var EffectCube = {
  		    name: 'effect-cube',
  		    params: {
  		      cubeEffect: {
  		        slideShadows: true,
  		        shadow: true,
  		        shadowOffset: 20,
  		        shadowScale: 0.94,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        cubeEffect: {
  		          setTranslate: Cube.setTranslate.bind(swiper),
  		          setTransition: Cube.setTransition.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      beforeInit: function beforeInit() {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'cube') { return; }
  		        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
  		        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
  		        var overwriteParams = {
  		          slidesPerView: 1,
  		          slidesPerColumn: 1,
  		          slidesPerGroup: 1,
  		          watchSlidesProgress: true,
  		          resistanceRatio: 0,
  		          spaceBetween: 0,
  		          centeredSlides: false,
  		          virtualTranslate: true,
  		        };
  		        Utils.extend(swiper.params, overwriteParams);
  		        Utils.extend(swiper.originalParams, overwriteParams);
  		      },
  		      setTranslate: function setTranslate() {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'cube') { return; }
  		        swiper.cubeEffect.setTranslate();
  		      },
  		      setTransition: function setTransition(duration) {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'cube') { return; }
  		        swiper.cubeEffect.setTransition(duration);
  		      },
  		    },
  		  };

  		  var Flip = {
  		    setTranslate: function setTranslate() {
  		      var swiper = this;
  		      var slides = swiper.slides;
  		      var rtl = swiper.rtlTranslate;
  		      for (var i = 0; i < slides.length; i += 1) {
  		        var $slideEl = slides.eq(i);
  		        var progress = $slideEl[0].progress;
  		        if (swiper.params.flipEffect.limitRotation) {
  		          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
  		        }
  		        var offset = $slideEl[0].swiperSlideOffset;
  		        var rotate = -180 * progress;
  		        var rotateY = rotate;
  		        var rotateX = 0;
  		        var tx = -offset;
  		        var ty = 0;
  		        if (!swiper.isHorizontal()) {
  		          ty = tx;
  		          tx = 0;
  		          rotateX = -rotateY;
  		          rotateY = 0;
  		        } else if (rtl) {
  		          rotateY = -rotateY;
  		        }

  		        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

  		        if (swiper.params.flipEffect.slideShadows) {
  		          // Set shadows
  		          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
  		          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
  		          if (shadowBefore.length === 0) {
  		            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
  		            $slideEl.append(shadowBefore);
  		          }
  		          if (shadowAfter.length === 0) {
  		            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
  		            $slideEl.append(shadowAfter);
  		          }
  		          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
  		          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
  		        }
  		        $slideEl
  		          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
  		      }
  		    },
  		    setTransition: function setTransition(duration) {
  		      var swiper = this;
  		      var slides = swiper.slides;
  		      var activeIndex = swiper.activeIndex;
  		      var $wrapperEl = swiper.$wrapperEl;
  		      slides
  		        .transition(duration)
  		        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
  		        .transition(duration);
  		      if (swiper.params.virtualTranslate && duration !== 0) {
  		        var eventTriggered = false;
  		        // eslint-disable-next-line
  		        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
  		          if (eventTriggered) { return; }
  		          if (!swiper || swiper.destroyed) { return; }
  		          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
  		          eventTriggered = true;
  		          swiper.animating = false;
  		          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
  		          for (var i = 0; i < triggerEvents.length; i += 1) {
  		            $wrapperEl.trigger(triggerEvents[i]);
  		          }
  		        });
  		      }
  		    },
  		  };

  		  var EffectFlip = {
  		    name: 'effect-flip',
  		    params: {
  		      flipEffect: {
  		        slideShadows: true,
  		        limitRotation: true,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        flipEffect: {
  		          setTranslate: Flip.setTranslate.bind(swiper),
  		          setTransition: Flip.setTransition.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      beforeInit: function beforeInit() {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'flip') { return; }
  		        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
  		        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
  		        var overwriteParams = {
  		          slidesPerView: 1,
  		          slidesPerColumn: 1,
  		          slidesPerGroup: 1,
  		          watchSlidesProgress: true,
  		          spaceBetween: 0,
  		          virtualTranslate: true,
  		        };
  		        Utils.extend(swiper.params, overwriteParams);
  		        Utils.extend(swiper.originalParams, overwriteParams);
  		      },
  		      setTranslate: function setTranslate() {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'flip') { return; }
  		        swiper.flipEffect.setTranslate();
  		      },
  		      setTransition: function setTransition(duration) {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'flip') { return; }
  		        swiper.flipEffect.setTransition(duration);
  		      },
  		    },
  		  };

  		  var Coverflow = {
  		    setTranslate: function setTranslate() {
  		      var swiper = this;
  		      var swiperWidth = swiper.width;
  		      var swiperHeight = swiper.height;
  		      var slides = swiper.slides;
  		      var $wrapperEl = swiper.$wrapperEl;
  		      var slidesSizesGrid = swiper.slidesSizesGrid;
  		      var params = swiper.params.coverflowEffect;
  		      var isHorizontal = swiper.isHorizontal();
  		      var transform = swiper.translate;
  		      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
  		      var rotate = isHorizontal ? params.rotate : -params.rotate;
  		      var translate = params.depth;
  		      // Each slide offset from center
  		      for (var i = 0, length = slides.length; i < length; i += 1) {
  		        var $slideEl = slides.eq(i);
  		        var slideSize = slidesSizesGrid[i];
  		        var slideOffset = $slideEl[0].swiperSlideOffset;
  		        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

  		        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
  		        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
  		        // var rotateZ = 0
  		        var translateZ = -translate * Math.abs(offsetMultiplier);

  		        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
  		        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

  		        // Fix for ultra small values
  		        if (Math.abs(translateX) < 0.001) { translateX = 0; }
  		        if (Math.abs(translateY) < 0.001) { translateY = 0; }
  		        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
  		        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
  		        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

  		        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

  		        $slideEl.transform(slideTransform);
  		        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
  		        if (params.slideShadows) {
  		          // Set shadows
  		          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
  		          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
  		          if ($shadowBeforeEl.length === 0) {
  		            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
  		            $slideEl.append($shadowBeforeEl);
  		          }
  		          if ($shadowAfterEl.length === 0) {
  		            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
  		            $slideEl.append($shadowAfterEl);
  		          }
  		          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
  		          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
  		        }
  		      }

  		      // Set correct perspective for IE10
  		      if (Support.pointerEvents || Support.prefixedPointerEvents) {
  		        var ws = $wrapperEl[0].style;
  		        ws.perspectiveOrigin = center + "px 50%";
  		      }
  		    },
  		    setTransition: function setTransition(duration) {
  		      var swiper = this;
  		      swiper.slides
  		        .transition(duration)
  		        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
  		        .transition(duration);
  		    },
  		  };

  		  var EffectCoverflow = {
  		    name: 'effect-coverflow',
  		    params: {
  		      coverflowEffect: {
  		        rotate: 50,
  		        stretch: 0,
  		        depth: 100,
  		        modifier: 1,
  		        slideShadows: true,
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        coverflowEffect: {
  		          setTranslate: Coverflow.setTranslate.bind(swiper),
  		          setTransition: Coverflow.setTransition.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      beforeInit: function beforeInit() {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'coverflow') { return; }

  		        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
  		        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

  		        swiper.params.watchSlidesProgress = true;
  		        swiper.originalParams.watchSlidesProgress = true;
  		      },
  		      setTranslate: function setTranslate() {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'coverflow') { return; }
  		        swiper.coverflowEffect.setTranslate();
  		      },
  		      setTransition: function setTransition(duration) {
  		        var swiper = this;
  		        if (swiper.params.effect !== 'coverflow') { return; }
  		        swiper.coverflowEffect.setTransition(duration);
  		      },
  		    },
  		  };

  		  var Thumbs = {
  		    init: function init() {
  		      var swiper = this;
  		      var ref = swiper.params;
  		      var thumbsParams = ref.thumbs;
  		      var SwiperClass = swiper.constructor;
  		      if (thumbsParams.swiper instanceof SwiperClass) {
  		        swiper.thumbs.swiper = thumbsParams.swiper;
  		        Utils.extend(swiper.thumbs.swiper.originalParams, {
  		          watchSlidesProgress: true,
  		          slideToClickedSlide: false,
  		        });
  		        Utils.extend(swiper.thumbs.swiper.params, {
  		          watchSlidesProgress: true,
  		          slideToClickedSlide: false,
  		        });
  		      } else if (Utils.isObject(thumbsParams.swiper)) {
  		        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
  		          watchSlidesVisibility: true,
  		          watchSlidesProgress: true,
  		          slideToClickedSlide: false,
  		        }));
  		        swiper.thumbs.swiperCreated = true;
  		      }
  		      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
  		      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
  		    },
  		    onThumbClick: function onThumbClick() {
  		      var swiper = this;
  		      var thumbsSwiper = swiper.thumbs.swiper;
  		      if (!thumbsSwiper) { return; }
  		      var clickedIndex = thumbsSwiper.clickedIndex;
  		      var clickedSlide = thumbsSwiper.clickedSlide;
  		      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
  		      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
  		      var slideToIndex;
  		      if (thumbsSwiper.params.loop) {
  		        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
  		      } else {
  		        slideToIndex = clickedIndex;
  		      }
  		      if (swiper.params.loop) {
  		        var currentIndex = swiper.activeIndex;
  		        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
  		          swiper.loopFix();
  		          // eslint-disable-next-line
  		          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  		          currentIndex = swiper.activeIndex;
  		        }
  		        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
  		        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
  		        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
  		        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
  		        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
  		        else { slideToIndex = prevIndex; }
  		      }
  		      swiper.slideTo(slideToIndex);
  		    },
  		    update: function update(initial) {
  		      var swiper = this;
  		      var thumbsSwiper = swiper.thumbs.swiper;
  		      if (!thumbsSwiper) { return; }

  		      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
  		        ? thumbsSwiper.slidesPerViewDynamic()
  		        : thumbsSwiper.params.slidesPerView;

  		      if (swiper.realIndex !== thumbsSwiper.realIndex) {
  		        var currentThumbsIndex = thumbsSwiper.activeIndex;
  		        var newThumbsIndex;
  		        if (thumbsSwiper.params.loop) {
  		          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
  		            thumbsSwiper.loopFix();
  		            // eslint-disable-next-line
  		            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
  		            currentThumbsIndex = thumbsSwiper.activeIndex;
  		          }
  		          // Find actual thumbs index to slide to
  		          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
  		          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
  		          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
  		          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
  		          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
  		          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
  		          else { newThumbsIndex = prevThumbsIndex; }
  		        } else {
  		          newThumbsIndex = swiper.realIndex;
  		        }
  		        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
  		          if (thumbsSwiper.params.centeredSlides) {
  		            if (newThumbsIndex > currentThumbsIndex) {
  		              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
  		            } else {
  		              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
  		            }
  		          } else if (newThumbsIndex > currentThumbsIndex) {
  		            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
  		          }
  		          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
  		        }
  		      }

  		      // Activate thumbs
  		      var thumbsToActivate = 1;
  		      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

  		      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
  		        thumbsToActivate = swiper.params.slidesPerView;
  		      }

  		      thumbsSwiper.slides.removeClass(thumbActiveClass);
  		      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
  		        for (var i = 0; i < thumbsToActivate; i += 1) {
  		          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
  		        }
  		      } else {
  		        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
  		          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
  		        }
  		      }
  		    },
  		  };
  		  var Thumbs$1 = {
  		    name: 'thumbs',
  		    params: {
  		      thumbs: {
  		        swiper: null,
  		        slideThumbActiveClass: 'swiper-slide-thumb-active',
  		        thumbsContainerClass: 'swiper-container-thumbs',
  		      },
  		    },
  		    create: function create() {
  		      var swiper = this;
  		      Utils.extend(swiper, {
  		        thumbs: {
  		          swiper: null,
  		          init: Thumbs.init.bind(swiper),
  		          update: Thumbs.update.bind(swiper),
  		          onThumbClick: Thumbs.onThumbClick.bind(swiper),
  		        },
  		      });
  		    },
  		    on: {
  		      beforeInit: function beforeInit() {
  		        var swiper = this;
  		        var ref = swiper.params;
  		        var thumbs = ref.thumbs;
  		        if (!thumbs || !thumbs.swiper) { return; }
  		        swiper.thumbs.init();
  		        swiper.thumbs.update(true);
  		      },
  		      slideChange: function slideChange() {
  		        var swiper = this;
  		        if (!swiper.thumbs.swiper) { return; }
  		        swiper.thumbs.update();
  		      },
  		      update: function update() {
  		        var swiper = this;
  		        if (!swiper.thumbs.swiper) { return; }
  		        swiper.thumbs.update();
  		      },
  		      resize: function resize() {
  		        var swiper = this;
  		        if (!swiper.thumbs.swiper) { return; }
  		        swiper.thumbs.update();
  		      },
  		      observerUpdate: function observerUpdate() {
  		        var swiper = this;
  		        if (!swiper.thumbs.swiper) { return; }
  		        swiper.thumbs.update();
  		      },
  		      setTransition: function setTransition(duration) {
  		        var swiper = this;
  		        var thumbsSwiper = swiper.thumbs.swiper;
  		        if (!thumbsSwiper) { return; }
  		        thumbsSwiper.setTransition(duration);
  		      },
  		      beforeDestroy: function beforeDestroy() {
  		        var swiper = this;
  		        var thumbsSwiper = swiper.thumbs.swiper;
  		        if (!thumbsSwiper) { return; }
  		        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
  		          thumbsSwiper.destroy();
  		        }
  		      },
  		    },
  		  };

  		  // Swiper Class

  		  var components = [
  		    Device$1,
  		    Support$1,
  		    Browser$1,
  		    Resize,
  		    Observer$1,
  		    Virtual$1,
  		    Keyboard$1,
  		    Mousewheel$1,
  		    Navigation$1,
  		    Pagination$1,
  		    Scrollbar$1,
  		    Parallax$1,
  		    Zoom$1,
  		    Lazy$1,
  		    Controller$1,
  		    A11y,
  		    History$1,
  		    HashNavigation$1,
  		    Autoplay$1,
  		    EffectFade,
  		    EffectCube,
  		    EffectFlip,
  		    EffectCoverflow,
  		    Thumbs$1
  		  ];

  		  if (typeof Swiper.use === 'undefined') {
  		    Swiper.use = Swiper.Class.use;
  		    Swiper.installModule = Swiper.Class.installModule;
  		  }

  		  Swiper.use(components);

  		  return Swiper;

  		})); 
  	} (swiper));
  	return swiper.exports;
  }

  (function (module, exports) {
  	!function(e,t){module.exports=t(requireSwiper());}(commonjsGlobal,function(e){return function(e){function t(i){if(n[i])return n[i].exports;var s=n[i]={i:i,l:!1,exports:{}};return e[i].call(s.exports,s,s.exports,t),s.l=!0,s.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:i});},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=4)}([function(t,n){t.exports=e;},function(e,t){e.exports=function(e,t,n,i,s,r){var o,a=e=e||{},u=typeof e.default;"object"!==u&&"function"!==u||(o=e,a=e.default);var p="function"==typeof a?a.options:a;t&&(p.render=t.render,p.staticRenderFns=t.staticRenderFns,p._compiled=!0),n&&(p.functional=!0),s&&(p._scopeId=s);var l;if(r?(l=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),i&&i.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r);},p._ssrRegister=l):i&&(l=i),l){var c=p.functional,d=c?p.render:p.beforeCreate;c?(p._injectStyles=l,p.render=function(e,t){return l.call(t),d(e,t)}):p.beforeCreate=d?[].concat(d,l):[l];}return {esModule:o,exports:a,options:p}};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),s=n.n(i),r=n(8),o=n(1),a=o(s.a,r.a,!1,null,null,null);t.default=a.exports;},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var i=n(6),s=n.n(i),r=n(7),o=n(1),a=o(s.a,r.a,!1,null,null,null);t.default=a.exports;},function(e,t,n){function i(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.install=t.swiperSlide=t.swiper=t.Swiper=void 0;var s=n(0),r=i(s),o=n(2),a=i(o),u=n(3),p=i(u),l=window.Swiper||r.default,c=p.default,d=a.default,f=function(e,t){t&&(p.default.props.globalOptions.default=function(){return t}),e.component(p.default.name,p.default),e.component(a.default.name,a.default);},h={Swiper:l,swiper:c,swiperSlide:d,install:f};t.default=h,t.Swiper=l,t.swiper=c,t.swiperSlide=d,t.install=f;},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"swiper-slide",data:function(){return {slideClass:"swiper-slide"}},ready:function(){this.update();},mounted:function(){this.update(),this.$parent&&this.$parent.options&&this.$parent.options.slideClass&&(this.slideClass=this.$parent.options.slideClass);},updated:function(){this.update();},attached:function(){this.update();},methods:{update:function(){this.$parent&&this.$parent.swiper&&this.$parent.update();}}};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),s=function(e){return e&&e.__esModule?e:{default:e}}(i),r=window.Swiper||s.default;"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(e,t){if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var n=Object(e),i=1;i<arguments.length;i++){var s=arguments[i];if(null!=s)for(var r in s)Object.prototype.hasOwnProperty.call(s,r)&&(n[r]=s[r]);}return n},writable:!0,configurable:!0});var o=["beforeDestroy","slideChange","slideChangeTransitionStart","slideChangeTransitionEnd","slideNextTransitionStart","slideNextTransitionEnd","slidePrevTransitionStart","slidePrevTransitionEnd","transitionStart","transitionEnd","touchStart","touchMove","touchMoveOpposite","sliderMove","touchEnd","click","tap","doubleTap","imagesReady","progress","reachBeginning","reachEnd","fromEdge","setTranslate","setTransition","resize"];t.default={name:"swiper",props:{options:{type:Object,default:function(){return {}}},globalOptions:{type:Object,required:!1,default:function(){return {}}}},data:function(){return {swiper:null,classes:{wrapperClass:"swiper-wrapper"}}},ready:function(){this.swiper||this.mountInstance();},mounted:function(){if(!this.swiper){var e=!1;for(var t in this.classes)this.classes.hasOwnProperty(t)&&this.options[t]&&(e=!0,this.classes[t]=this.options[t]);e?this.$nextTick(this.mountInstance):this.mountInstance();}},activated:function(){this.update();},updated:function(){this.update();},beforeDestroy:function(){this.$nextTick(function(){this.swiper&&(this.swiper.destroy&&this.swiper.destroy(),delete this.swiper);});},methods:{update:function(){this.swiper&&(this.swiper.update&&this.swiper.update(),this.swiper.navigation&&this.swiper.navigation.update(),this.swiper.pagination&&this.swiper.pagination.render(),this.swiper.pagination&&this.swiper.pagination.update());},mountInstance:function(){var e=Object.assign({},this.globalOptions,this.options);this.swiper=new r(this.$el,e),this.bindEvents(),this.$emit("ready",this.swiper);},bindEvents:function(){var e=this,t=this;o.forEach(function(n){e.swiper.on(n,function(){t.$emit.apply(t,[n].concat(Array.prototype.slice.call(arguments))),t.$emit.apply(t,[n.replace(/([A-Z])/g,"-$1").toLowerCase()].concat(Array.prototype.slice.call(arguments)));});});}}};},function(e,t,n){var i=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"swiper-container"},[e._t("parallax-bg"),e._v(" "),n("div",{class:e.classes.wrapperClass},[e._t("default")],2),e._v(" "),e._t("pagination"),e._v(" "),e._t("button-prev"),e._v(" "),e._t("button-next"),e._v(" "),e._t("scrollbar")],2)},s=[],r={render:i,staticRenderFns:s};t.a=r;},function(e,t,n){var i=function(){var e=this,t=e.$createElement;return (e._self._c||t)("div",{class:e.slideClass},[e._t("default")],2)},s=[],r={render:i,staticRenderFns:s};t.a=r;}])}); 
  } (vueAwesomeSwiper));

  var vueAwesomeSwiperExports = vueAwesomeSwiper.exports;

  function imgURL(src, size) {
    var center = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!src || typeof src === 'undefined') return; // Remove any current image size then add the new image size

    var count = (src.match(/\.jpg|\.png|\.gif|\.jpeg/g) || []).length;
    var centerVal = '';

    if (center) {
      centerVal = '_crop_center';
    }

    if (src === null) {
      return;
    }

    if (count > 1) {
      return src;
    }

    return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.').replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
      return '_' + size + centerVal + match;
    });
  }

  function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  Vue$1.use(Vuex);
  Vue$1.config.devtools = true;
  var CartFreeSample = Vue$1.component('cart-free-sample', {
    delimiters: ['%{', '}'],
    props: ['itemCount'],
    template: "\n    <aside\n      class=\"cart-sample\"\n      v-if=\"!sampleInCart\"\n    >\n      <header class=\"cart-sample-header\">\n        <h2 class=\"cart-sample-header__title\">CHOOSE A FREE SAMPLE</h2>\n      </header>\n\n      <swiper\n        class=\"cart-sample__items\"\n        ref=\"swiper\"\n        :options=\"swiperOption\"\n        v-if=\"items.length\"\n      >\n        <swiper-slide v-for=\"(item, index) in items\" :key=\"item.id\" class=\"cart-sample__item\">\n          <div class=\"cart-sample__item-inner\">\n            <div class=\"cart-sample__image-holder\">\n              <img\n                class=\"cart-sample__image\"\n                :src=\"imgURL(item.images.length ? item.images[0].src : null, 'x258', false) || noImage\"\n                :alt=\"item.title + ' Product Image'\"\n              />\n            </div>\n\n            <p class=\"cart-sample__name\">%{ item.title }</p>\n          </div>\n\n          <button\n            type=\"button\"\n            class=\"cart-sample__button\"\n            :disabled=\"!item.variants[0].available\"\n            v-on:click=\"addToCart(item.variants[0].id)\"\n          >Add</button>\n        </swiper-slide>\n\n        <button type=\"button\" class=\"cart-sample__nav cart-sample__nav--prev\" slot=\"button-prev\">\n          <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"11px\" height=\"19px\" viewBox=\"0 0 11 19\" xml:space=\"preserve\">\n            <polygon points=\"9.463,18.839 10.877,17.425 2.951,9.5 10.877,1.575 9.463,0.161 0.123,9.5 \"/>\n          </svg>\n        </button>\n\n        <button type=\"button\" class=\"cart-sample__nav cart-sample__nav--next\" slot=\"button-next\">\n          <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"11px\" height=\"19px\" viewBox=\"0 0 11 19\" xml:space=\"preserve\">\n            <polygon points=\"1.537,18.839 0.123,17.425 8.049,9.5 0.123,1.575 1.537,0.161 10.877,9.5 \"/>\n          </svg>\n        </button>\n      </swiper>\n    </aside>\n  ",
    components: {
      swiper: vueAwesomeSwiperExports.swiper,
      swiperSlide: vueAwesomeSwiperExports.swiperSlide
    },
    data: function data() {
      return {
        items: [],
        noImage: null,
        sampleInCart: false,
        swiperOption: {
          breakpoints: {
            768: {
              freeMode: false,
              slidesPerView: 2,
              spaceBetween: 0
            },
            1400: {
              freeMode: false,
              slidesPerView: 3,
              spaceBetween: 0
            }
          },
          freeMode: true,
          loop: false,
          navigation: {
            nextEl: '.cart-sample__nav--next',
            prevEl: '.cart-sample__nav--prev'
          },
          roundLengths: true,
          slidesPerView: 'auto',
          spaceBetween: 18
        },
        title: null
      };
    },
    methods: _objectSpread$7(_objectSpread$7({}, mapActions(['addItem'])), {}, {
      addToCart: function addToCart(variantId) {
        this.addItem({
          id: variantId,
          quantity: 1
        });
      },
      fetchCollection: function fetchCollection() {
        var _this = this;

        if (window.freeSample.collection) {
          this.title = window.freeSample.title;
          $.getJSON("/collections/".concat(window.freeSample.collection, "/products.json"), function (response) {
            if (response.products.length) {
              _this.items = response.products;
            }
          });
        }
      },
      imgURL: imgURL,
      sampleInCartCheck: function sampleInCartCheck() {
        var items = this.shoppingCartItems;
        var index = Object.keys(items).findIndex(function (key) {
          return items[key].type.toLowerCase() === 'sample';
        });
        this.sampleInCart = index >= 0;
      }
    }),
    computed: _objectSpread$7(_objectSpread$7({}, mapGetters(['shoppingCart'])), {}, {
      shoppingCartItems: function shoppingCartItems() {
        return this.shoppingCart.items;
      }
    }),
    watch: {
      itemCount: function itemCount() {
        this.sampleInCartCheck();
      }
    },
    created: function created() {
      if (window.freeSample.collection) {
        this.fetchCollection();
      }

      this.noImage = window.minicart.noImage;
    },
    mounted: function mounted() {
      this.sampleInCartCheck();
    }
  });

  function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  Vue$1.use(Vuex);
  Vue$1.config.devtools = true;
  var CartRecommended = Vue$1.component('cart-recommended', {
    delimiters: ['%{', '}'],
    filters: {
      toUSD: function toUSD(amount) {
        return Shopify.formatMoney(amount, '${{amount}}');
      }
    },
    template: "\n\t\t\t<aside\n        class=\"cart-recommended\"\n        v-if=\"ready\"\n      >\n        <header\n          v-if=\"title\"\n          class=\"cart-recommended-header\"\n        >\n          <h2 class=\"cart-recommended-header__title\">%{ title }</h2>\n        </header>\n\n        <swiper\n          class=\"cart-recommended__items\"\n          ref=\"swiper\"\n          :options=\"swiperOption\"\n          v-if=\"items.length\"\n        >\n          <swiper-slide v-for=\"(item, index) in items\" :key=\"item.id\" class=\"cart-recommended__item\">\n            <div class=\"cart-recommended__columns\">\n              <div class=\"cart-recommended__column cart-recommended__column--image\">\n                <a :href=\"'/products/' + item.handle\" class=\"cart-recommended__image-holder\">\n                  <img\n                    class=\"cart-recommended__image\"\n                    :src=\"imgURL(item.featured_image, 'x304', false)\"\n                    :alt=\"item.title + ' Product Image'\"\n                  />\n                </a>\n              </div>\n\n              <div class=\"cart-recommended__column cart-recommended__column--content\">\n                <a\n                  v-if=\"item.product_title\"\n                  :href=\"'/products/' + item.handle\"\n                  class=\"cart-recommended__name\"\n                  v-html=\"item.product_title\"\n                ></a>\n                <a\n                  v-else\n                  :href=\"'/products/' + item.handle\"\n                  class=\"cart-recommended__name\"\n                ><h3>%{ item.title }</h3></a>\n\n                <div class=\"cart-recommended__price\">%{ item.price | toUSD }</div>\n\n                <button\n                  type=\"button\"\n                  class=\"cart-recommended__button\"\n                  :disabled=\"!item.variants[0].available\"\n                  v-on:click=\"addToCart(item.variants[0].id)\"\n                >Add</button>\n              </div>\n            </div>\n          </swiper-slide>\n        </swiper>\n      </aside>\n\t\t",
    components: {
      swiper: vueAwesomeSwiperExports.swiper,
      swiperSlide: vueAwesomeSwiperExports.swiperSlide
    },
    data: function data() {
      return {
        ready: false,
        items: [],
        swiperOption: {
          freeMode: false,
          loop: false,
          roundLengths: true,
          slidesPerView: 1,
          spaceBetween: 0
        },
        title: null
      };
    },
    computed: _objectSpread$6({}, mapGetters(['shoppingCart'])),
    methods: _objectSpread$6(_objectSpread$6({}, mapActions(['addItem'])), {}, {
      addToCart: function addToCart(variantId) {
        this.addItem({
          id: variantId,
          quantity: 1
        });
      },
      checkReady: function checkReady() {
        var items = this.items;
        var index = Object.keys(items).findIndex(function (key) {
          return items[key] === null;
        });
        this.ready = index < 0;
      },
      fetchCollection: function fetchCollection() {
        var _this = this;

        if (window.recommended.collection) {
          this.title = window.recommended.title;
          if (!this.shoppingCart.items) return false;
          var cartProductIds = Object.values(this.shoppingCart.items).map(function (item) {
            return item.productId;
          });
          var recommendedProducts = window.recommended.collection.filter(function (item) {
            return !cartProductIds.includes(item.id);
          });
          recommendedProducts.forEach(function (product, i) {
            _this.items.push(null);

            $.get("/products/".concat(product.handle, "?view=meta.json"), function (data) {
              data = JSON.parse(data);
              var title = data.metafields.product_short_name === undefined ? null : "<h3>".concat(data.metafields.product_short_name, "</h3>");
              var subtitle = data.metafields.product_subtitle === undefined ? null : data.metafields.product_subtitle;

              if (subtitle) {
                title += subtitle;
              }

              data.product.product_title = title;

              _this.$set(_this.items, i, data.product);

              _this.$nextTick(function () {
                _this.checkReady();
              });
            });
          });
        }
      },
      imgURL: imgURL
    }),
    created: function created() {
      if (window.recommended.collection) {
        this.fetchCollection();
      }
    }
  });

  var axios$3 = {exports: {}};

  var bind$2 = function bind(fn, thisArg) {
    return function wrap() {
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }
      return fn.apply(thisArg, args);
    };
  };

  var bind$1 = bind$2;

  /*global toString:true*/

  // utils is a library of generic helper functions non-specific to axios

  var toString = Object.prototype.toString;

  /**
   * Determine if a value is an Array
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an Array, otherwise false
   */
  function isArray(val) {
    return toString.call(val) === '[object Array]';
  }

  /**
   * Determine if a value is undefined
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if the value is undefined, otherwise false
   */
  function isUndefined(val) {
    return typeof val === 'undefined';
  }

  /**
   * Determine if a value is a Buffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Buffer, otherwise false
   */
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
      && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
  }

  /**
   * Determine if a value is an ArrayBuffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an ArrayBuffer, otherwise false
   */
  function isArrayBuffer(val) {
    return toString.call(val) === '[object ArrayBuffer]';
  }

  /**
   * Determine if a value is a FormData
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an FormData, otherwise false
   */
  function isFormData(val) {
    return (typeof FormData !== 'undefined') && (val instanceof FormData);
  }

  /**
   * Determine if a value is a view on an ArrayBuffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
   */
  function isArrayBufferView(val) {
    var result;
    if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
      result = ArrayBuffer.isView(val);
    } else {
      result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
    }
    return result;
  }

  /**
   * Determine if a value is a String
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a String, otherwise false
   */
  function isString(val) {
    return typeof val === 'string';
  }

  /**
   * Determine if a value is a Number
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Number, otherwise false
   */
  function isNumber(val) {
    return typeof val === 'number';
  }

  /**
   * Determine if a value is an Object
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an Object, otherwise false
   */
  function isObject(val) {
    return val !== null && typeof val === 'object';
  }

  /**
   * Determine if a value is a plain Object
   *
   * @param {Object} val The value to test
   * @return {boolean} True if value is a plain Object, otherwise false
   */
  function isPlainObject(val) {
    if (toString.call(val) !== '[object Object]') {
      return false;
    }

    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
  }

  /**
   * Determine if a value is a Date
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Date, otherwise false
   */
  function isDate(val) {
    return toString.call(val) === '[object Date]';
  }

  /**
   * Determine if a value is a File
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a File, otherwise false
   */
  function isFile(val) {
    return toString.call(val) === '[object File]';
  }

  /**
   * Determine if a value is a Blob
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Blob, otherwise false
   */
  function isBlob(val) {
    return toString.call(val) === '[object Blob]';
  }

  /**
   * Determine if a value is a Function
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Function, otherwise false
   */
  function isFunction(val) {
    return toString.call(val) === '[object Function]';
  }

  /**
   * Determine if a value is a Stream
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Stream, otherwise false
   */
  function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
  }

  /**
   * Determine if a value is a URLSearchParams object
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a URLSearchParams object, otherwise false
   */
  function isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
  }

  /**
   * Trim excess whitespace off the beginning and end of a string
   *
   * @param {String} str The String to trim
   * @returns {String} The String freed of excess whitespace
   */
  function trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
  }

  /**
   * Determine if we're running in a standard browser environment
   *
   * This allows axios to run in a web worker, and react-native.
   * Both environments support XMLHttpRequest, but not fully standard globals.
   *
   * web workers:
   *  typeof window -> undefined
   *  typeof document -> undefined
   *
   * react-native:
   *  navigator.product -> 'ReactNative'
   * nativescript
   *  navigator.product -> 'NativeScript' or 'NS'
   */
  function isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                             navigator.product === 'NativeScript' ||
                                             navigator.product === 'NS')) {
      return false;
    }
    return (
      typeof window !== 'undefined' &&
      typeof document !== 'undefined'
    );
  }

  /**
   * Iterate over an Array or an Object invoking a function for each item.
   *
   * If `obj` is an Array callback will be called passing
   * the value, index, and complete array for each item.
   *
   * If 'obj' is an Object callback will be called passing
   * the value, key, and complete object for each property.
   *
   * @param {Object|Array} obj The object to iterate
   * @param {Function} fn The callback to invoke for each item
   */
  function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
      return;
    }

    // Force an array if not already something iterable
    if (typeof obj !== 'object') {
      /*eslint no-param-reassign:0*/
      obj = [obj];
    }

    if (isArray(obj)) {
      // Iterate over array values
      for (var i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      // Iterate over object keys
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          fn.call(null, obj[key], key, obj);
        }
      }
    }
  }

  /**
   * Accepts varargs expecting each argument to be an object, then
   * immutably merges the properties of each object and returns result.
   *
   * When multiple objects contain the same key the later object in
   * the arguments list will take precedence.
   *
   * Example:
   *
   * ```js
   * var result = merge({foo: 123}, {foo: 456});
   * console.log(result.foo); // outputs 456
   * ```
   *
   * @param {Object} obj1 Object to merge
   * @returns {Object} Result of all merge properties
   */
  function merge(/* obj1, obj2, obj3, ... */) {
    var result = {};
    function assignValue(val, key) {
      if (isPlainObject(result[key]) && isPlainObject(val)) {
        result[key] = merge(result[key], val);
      } else if (isPlainObject(val)) {
        result[key] = merge({}, val);
      } else if (isArray(val)) {
        result[key] = val.slice();
      } else {
        result[key] = val;
      }
    }

    for (var i = 0, l = arguments.length; i < l; i++) {
      forEach(arguments[i], assignValue);
    }
    return result;
  }

  /**
   * Extends object a by mutably adding to it the properties of object b.
   *
   * @param {Object} a The object to be extended
   * @param {Object} b The object to copy properties from
   * @param {Object} thisArg The object to bind function to
   * @return {Object} The resulting value of object a
   */
  function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
      if (thisArg && typeof val === 'function') {
        a[key] = bind$1(val, thisArg);
      } else {
        a[key] = val;
      }
    });
    return a;
  }

  /**
   * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
   *
   * @param {string} content with BOM
   * @return {string} content value without BOM
   */
  function stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) {
      content = content.slice(1);
    }
    return content;
  }

  var utils$9 = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM
  };

  var utils$8 = utils$9;

  function encode(val) {
    return encodeURIComponent(val).
      replace(/%3A/gi, ':').
      replace(/%24/g, '$').
      replace(/%2C/gi, ',').
      replace(/%20/g, '+').
      replace(/%5B/gi, '[').
      replace(/%5D/gi, ']');
  }

  /**
   * Build a URL by appending params to the end
   *
   * @param {string} url The base of the url (e.g., http://www.google.com)
   * @param {object} [params] The params to be appended
   * @returns {string} The formatted url
   */
  var buildURL$1 = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/
    if (!params) {
      return url;
    }

    var serializedParams;
    if (paramsSerializer) {
      serializedParams = paramsSerializer(params);
    } else if (utils$8.isURLSearchParams(params)) {
      serializedParams = params.toString();
    } else {
      var parts = [];

      utils$8.forEach(params, function serialize(val, key) {
        if (val === null || typeof val === 'undefined') {
          return;
        }

        if (utils$8.isArray(val)) {
          key = key + '[]';
        } else {
          val = [val];
        }

        utils$8.forEach(val, function parseValue(v) {
          if (utils$8.isDate(v)) {
            v = v.toISOString();
          } else if (utils$8.isObject(v)) {
            v = JSON.stringify(v);
          }
          parts.push(encode(key) + '=' + encode(v));
        });
      });

      serializedParams = parts.join('&');
    }

    if (serializedParams) {
      var hashmarkIndex = url.indexOf('#');
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }

      url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }

    return url;
  };

  var utils$7 = utils$9;

  function InterceptorManager$1() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  InterceptorManager$1.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
      fulfilled: fulfilled,
      rejected: rejected
    });
    return this.handlers.length - 1;
  };

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   */
  InterceptorManager$1.prototype.eject = function eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  };

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   */
  InterceptorManager$1.prototype.forEach = function forEach(fn) {
    utils$7.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  };

  var InterceptorManager_1 = InterceptorManager$1;

  var utils$6 = utils$9;

  /**
   * Transform the data for a request or a response
   *
   * @param {Object|String} data The data to be transformed
   * @param {Array} headers The headers for the request or response
   * @param {Array|Function} fns A single function or Array of functions
   * @returns {*} The resulting transformed data
   */
  var transformData$1 = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/
    utils$6.forEach(fns, function transform(fn) {
      data = fn(data, headers);
    });

    return data;
  };

  var isCancel$1;
  var hasRequiredIsCancel;

  function requireIsCancel () {
  	if (hasRequiredIsCancel) return isCancel$1;
  	hasRequiredIsCancel = 1;

  	isCancel$1 = function isCancel(value) {
  	  return !!(value && value.__CANCEL__);
  	};
  	return isCancel$1;
  }

  // shim for using process in browser
  // based off https://github.com/defunctzombie/node-process/blob/master/browser.js

  function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout () {
      throw new Error('clearTimeout has not been defined');
  }
  var cachedSetTimeout = defaultSetTimout;
  var cachedClearTimeout = defaultClearTimeout;
  if (typeof global$1.setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
  }
  if (typeof global$1.clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
  }

  function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
      } catch(e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
          } catch(e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
          }
      }


  }
  function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
      } catch (e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
          } catch (e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
          }
      }



  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
      if (!draining || !currentQueue) {
          return;
      }
      draining = false;
      if (currentQueue.length) {
          queue = currentQueue.concat(queue);
      } else {
          queueIndex = -1;
      }
      if (queue.length) {
          drainQueue();
      }
  }

  function drainQueue() {
      if (draining) {
          return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;

      var len = queue.length;
      while(len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
              if (currentQueue) {
                  currentQueue[queueIndex].run();
              }
          }
          queueIndex = -1;
          len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
  }
  function nextTick(fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
          }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
      }
  }
  // v8 likes predictible objects
  function Item(fun, array) {
      this.fun = fun;
      this.array = array;
  }
  Item.prototype.run = function () {
      this.fun.apply(null, this.array);
  };
  var title = 'browser';
  var platform = 'browser';
  var browser = true;
  var env = {};
  var argv = [];
  var version = ''; // empty string to avoid regexp issues
  var versions = {};
  var release = {};
  var config = {};

  function noop() {}

  var on = noop;
  var addListener = noop;
  var once = noop;
  var off = noop;
  var removeListener = noop;
  var removeAllListeners = noop;
  var emit = noop;

  function binding(name) {
      throw new Error('process.binding is not supported');
  }

  function cwd () { return '/' }
  function chdir (dir) {
      throw new Error('process.chdir is not supported');
  }function umask() { return 0; }

  // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
  var performance = global$1.performance || {};
  var performanceNow =
    performance.now        ||
    performance.mozNow     ||
    performance.msNow      ||
    performance.oNow       ||
    performance.webkitNow  ||
    function(){ return (new Date()).getTime() };

  // generate timestamp or delta
  // see http://nodejs.org/api/process.html#process_process_hrtime
  function hrtime(previousTimestamp){
    var clocktime = performanceNow.call(performance)*1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor((clocktime%1)*1e9);
    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];
      if (nanoseconds<0) {
        seconds--;
        nanoseconds += 1e9;
      }
    }
    return [seconds,nanoseconds]
  }

  var startTime = new Date();
  function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
  }

  var browser$1 = {
    nextTick: nextTick,
    title: title,
    browser: browser,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config,
    uptime: uptime
  };

  var utils$5 = utils$9;

  var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
    utils$5.forEach(headers, function processHeader(value, name) {
      if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
        headers[normalizedName] = value;
        delete headers[name];
      }
    });
  };

  var enhanceError;
  var hasRequiredEnhanceError;

  function requireEnhanceError () {
  	if (hasRequiredEnhanceError) return enhanceError;
  	hasRequiredEnhanceError = 1;

  	/**
  	 * Update an Error with the specified config, error code, and response.
  	 *
  	 * @param {Error} error The error to update.
  	 * @param {Object} config The config.
  	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
  	 * @param {Object} [request] The request.
  	 * @param {Object} [response] The response.
  	 * @returns {Error} The error.
  	 */
  	enhanceError = function enhanceError(error, config, code, request, response) {
  	  error.config = config;
  	  if (code) {
  	    error.code = code;
  	  }

  	  error.request = request;
  	  error.response = response;
  	  error.isAxiosError = true;

  	  error.toJSON = function toJSON() {
  	    return {
  	      // Standard
  	      message: this.message,
  	      name: this.name,
  	      // Microsoft
  	      description: this.description,
  	      number: this.number,
  	      // Mozilla
  	      fileName: this.fileName,
  	      lineNumber: this.lineNumber,
  	      columnNumber: this.columnNumber,
  	      stack: this.stack,
  	      // Axios
  	      config: this.config,
  	      code: this.code
  	    };
  	  };
  	  return error;
  	};
  	return enhanceError;
  }

  var createError;
  var hasRequiredCreateError;

  function requireCreateError () {
  	if (hasRequiredCreateError) return createError;
  	hasRequiredCreateError = 1;

  	var enhanceError = requireEnhanceError();

  	/**
  	 * Create an Error with the specified message, config, error code, request and response.
  	 *
  	 * @param {string} message The error message.
  	 * @param {Object} config The config.
  	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
  	 * @param {Object} [request] The request.
  	 * @param {Object} [response] The response.
  	 * @returns {Error} The created error.
  	 */
  	createError = function createError(message, config, code, request, response) {
  	  var error = new Error(message);
  	  return enhanceError(error, config, code, request, response);
  	};
  	return createError;
  }

  var settle;
  var hasRequiredSettle;

  function requireSettle () {
  	if (hasRequiredSettle) return settle;
  	hasRequiredSettle = 1;

  	var createError = requireCreateError();

  	/**
  	 * Resolve or reject a Promise based on response status.
  	 *
  	 * @param {Function} resolve A function that resolves the promise.
  	 * @param {Function} reject A function that rejects the promise.
  	 * @param {object} response The response.
  	 */
  	settle = function settle(resolve, reject, response) {
  	  var validateStatus = response.config.validateStatus;
  	  if (!response.status || !validateStatus || validateStatus(response.status)) {
  	    resolve(response);
  	  } else {
  	    reject(createError(
  	      'Request failed with status code ' + response.status,
  	      response.config,
  	      null,
  	      response.request,
  	      response
  	    ));
  	  }
  	};
  	return settle;
  }

  var cookies;
  var hasRequiredCookies;

  function requireCookies () {
  	if (hasRequiredCookies) return cookies;
  	hasRequiredCookies = 1;

  	var utils = utils$9;

  	cookies = (
  	  utils.isStandardBrowserEnv() ?

  	  // Standard browser envs support document.cookie
  	    (function standardBrowserEnv() {
  	      return {
  	        write: function write(name, value, expires, path, domain, secure) {
  	          var cookie = [];
  	          cookie.push(name + '=' + encodeURIComponent(value));

  	          if (utils.isNumber(expires)) {
  	            cookie.push('expires=' + new Date(expires).toGMTString());
  	          }

  	          if (utils.isString(path)) {
  	            cookie.push('path=' + path);
  	          }

  	          if (utils.isString(domain)) {
  	            cookie.push('domain=' + domain);
  	          }

  	          if (secure === true) {
  	            cookie.push('secure');
  	          }

  	          document.cookie = cookie.join('; ');
  	        },

  	        read: function read(name) {
  	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
  	          return (match ? decodeURIComponent(match[3]) : null);
  	        },

  	        remove: function remove(name) {
  	          this.write(name, '', Date.now() - 86400000);
  	        }
  	      };
  	    })() :

  	  // Non standard browser env (web workers, react-native) lack needed support.
  	    (function nonStandardBrowserEnv() {
  	      return {
  	        write: function write() {},
  	        read: function read() { return null; },
  	        remove: function remove() {}
  	      };
  	    })()
  	);
  	return cookies;
  }

  var isAbsoluteURL;
  var hasRequiredIsAbsoluteURL;

  function requireIsAbsoluteURL () {
  	if (hasRequiredIsAbsoluteURL) return isAbsoluteURL;
  	hasRequiredIsAbsoluteURL = 1;

  	/**
  	 * Determines whether the specified URL is absolute
  	 *
  	 * @param {string} url The URL to test
  	 * @returns {boolean} True if the specified URL is absolute, otherwise false
  	 */
  	isAbsoluteURL = function isAbsoluteURL(url) {
  	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  	  // by any combination of letters, digits, plus, period, or hyphen.
  	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
  	};
  	return isAbsoluteURL;
  }

  var combineURLs;
  var hasRequiredCombineURLs;

  function requireCombineURLs () {
  	if (hasRequiredCombineURLs) return combineURLs;
  	hasRequiredCombineURLs = 1;

  	/**
  	 * Creates a new URL by combining the specified URLs
  	 *
  	 * @param {string} baseURL The base URL
  	 * @param {string} relativeURL The relative URL
  	 * @returns {string} The combined URL
  	 */
  	combineURLs = function combineURLs(baseURL, relativeURL) {
  	  return relativeURL
  	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
  	    : baseURL;
  	};
  	return combineURLs;
  }

  var buildFullPath;
  var hasRequiredBuildFullPath;

  function requireBuildFullPath () {
  	if (hasRequiredBuildFullPath) return buildFullPath;
  	hasRequiredBuildFullPath = 1;

  	var isAbsoluteURL = requireIsAbsoluteURL();
  	var combineURLs = requireCombineURLs();

  	/**
  	 * Creates a new URL by combining the baseURL with the requestedURL,
  	 * only when the requestedURL is not already an absolute URL.
  	 * If the requestURL is absolute, this function returns the requestedURL untouched.
  	 *
  	 * @param {string} baseURL The base URL
  	 * @param {string} requestedURL Absolute or relative URL to combine
  	 * @returns {string} The combined full path
  	 */
  	buildFullPath = function buildFullPath(baseURL, requestedURL) {
  	  if (baseURL && !isAbsoluteURL(requestedURL)) {
  	    return combineURLs(baseURL, requestedURL);
  	  }
  	  return requestedURL;
  	};
  	return buildFullPath;
  }

  var parseHeaders;
  var hasRequiredParseHeaders;

  function requireParseHeaders () {
  	if (hasRequiredParseHeaders) return parseHeaders;
  	hasRequiredParseHeaders = 1;

  	var utils = utils$9;

  	// Headers whose duplicates are ignored by node
  	// c.f. https://nodejs.org/api/http.html#http_message_headers
  	var ignoreDuplicateOf = [
  	  'age', 'authorization', 'content-length', 'content-type', 'etag',
  	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  	  'referer', 'retry-after', 'user-agent'
  	];

  	/**
  	 * Parse headers into an object
  	 *
  	 * ```
  	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
  	 * Content-Type: application/json
  	 * Connection: keep-alive
  	 * Transfer-Encoding: chunked
  	 * ```
  	 *
  	 * @param {String} headers Headers needing to be parsed
  	 * @returns {Object} Headers parsed into an object
  	 */
  	parseHeaders = function parseHeaders(headers) {
  	  var parsed = {};
  	  var key;
  	  var val;
  	  var i;

  	  if (!headers) { return parsed; }

  	  utils.forEach(headers.split('\n'), function parser(line) {
  	    i = line.indexOf(':');
  	    key = utils.trim(line.substr(0, i)).toLowerCase();
  	    val = utils.trim(line.substr(i + 1));

  	    if (key) {
  	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
  	        return;
  	      }
  	      if (key === 'set-cookie') {
  	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
  	      } else {
  	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
  	      }
  	    }
  	  });

  	  return parsed;
  	};
  	return parseHeaders;
  }

  var isURLSameOrigin;
  var hasRequiredIsURLSameOrigin;

  function requireIsURLSameOrigin () {
  	if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
  	hasRequiredIsURLSameOrigin = 1;

  	var utils = utils$9;

  	isURLSameOrigin = (
  	  utils.isStandardBrowserEnv() ?

  	  // Standard browser envs have full support of the APIs needed to test
  	  // whether the request URL is of the same origin as current location.
  	    (function standardBrowserEnv() {
  	      var msie = /(msie|trident)/i.test(navigator.userAgent);
  	      var urlParsingNode = document.createElement('a');
  	      var originURL;

  	      /**
  	    * Parse a URL to discover it's components
  	    *
  	    * @param {String} url The URL to be parsed
  	    * @returns {Object}
  	    */
  	      function resolveURL(url) {
  	        var href = url;

  	        if (msie) {
  	        // IE needs attribute set twice to normalize properties
  	          urlParsingNode.setAttribute('href', href);
  	          href = urlParsingNode.href;
  	        }

  	        urlParsingNode.setAttribute('href', href);

  	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
  	        return {
  	          href: urlParsingNode.href,
  	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
  	          host: urlParsingNode.host,
  	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
  	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
  	          hostname: urlParsingNode.hostname,
  	          port: urlParsingNode.port,
  	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
  	            urlParsingNode.pathname :
  	            '/' + urlParsingNode.pathname
  	        };
  	      }

  	      originURL = resolveURL(window.location.href);

  	      /**
  	    * Determine if a URL shares the same origin as the current location
  	    *
  	    * @param {String} requestURL The URL to test
  	    * @returns {boolean} True if URL shares the same origin, otherwise false
  	    */
  	      return function isURLSameOrigin(requestURL) {
  	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
  	        return (parsed.protocol === originURL.protocol &&
  	            parsed.host === originURL.host);
  	      };
  	    })() :

  	  // Non standard browser envs (web workers, react-native) lack needed support.
  	    (function nonStandardBrowserEnv() {
  	      return function isURLSameOrigin() {
  	        return true;
  	      };
  	    })()
  	);
  	return isURLSameOrigin;
  }

  var xhr;
  var hasRequiredXhr;

  function requireXhr () {
  	if (hasRequiredXhr) return xhr;
  	hasRequiredXhr = 1;

  	var utils = utils$9;
  	var settle = requireSettle();
  	var cookies = requireCookies();
  	var buildURL = buildURL$1;
  	var buildFullPath = requireBuildFullPath();
  	var parseHeaders = requireParseHeaders();
  	var isURLSameOrigin = requireIsURLSameOrigin();
  	var createError = requireCreateError();

  	xhr = function xhrAdapter(config) {
  	  return new Promise(function dispatchXhrRequest(resolve, reject) {
  	    var requestData = config.data;
  	    var requestHeaders = config.headers;

  	    if (utils.isFormData(requestData)) {
  	      delete requestHeaders['Content-Type']; // Let the browser set it
  	    }

  	    var request = new XMLHttpRequest();

  	    // HTTP basic authentication
  	    if (config.auth) {
  	      var username = config.auth.username || '';
  	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
  	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
  	    }

  	    var fullPath = buildFullPath(config.baseURL, config.url);
  	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

  	    // Set the request timeout in MS
  	    request.timeout = config.timeout;

  	    // Listen for ready state
  	    request.onreadystatechange = function handleLoad() {
  	      if (!request || request.readyState !== 4) {
  	        return;
  	      }

  	      // The request errored out and we didn't get a response, this will be
  	      // handled by onerror instead
  	      // With one exception: request that using file: protocol, most browsers
  	      // will return status as 0 even though it's a successful request
  	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
  	        return;
  	      }

  	      // Prepare the response
  	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
  	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
  	      var response = {
  	        data: responseData,
  	        status: request.status,
  	        statusText: request.statusText,
  	        headers: responseHeaders,
  	        config: config,
  	        request: request
  	      };

  	      settle(resolve, reject, response);

  	      // Clean up request
  	      request = null;
  	    };

  	    // Handle browser request cancellation (as opposed to a manual cancellation)
  	    request.onabort = function handleAbort() {
  	      if (!request) {
  	        return;
  	      }

  	      reject(createError('Request aborted', config, 'ECONNABORTED', request));

  	      // Clean up request
  	      request = null;
  	    };

  	    // Handle low level network errors
  	    request.onerror = function handleError() {
  	      // Real errors are hidden from us by the browser
  	      // onerror should only fire if it's a network error
  	      reject(createError('Network Error', config, null, request));

  	      // Clean up request
  	      request = null;
  	    };

  	    // Handle timeout
  	    request.ontimeout = function handleTimeout() {
  	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
  	      if (config.timeoutErrorMessage) {
  	        timeoutErrorMessage = config.timeoutErrorMessage;
  	      }
  	      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
  	        request));

  	      // Clean up request
  	      request = null;
  	    };

  	    // Add xsrf header
  	    // This is only done if running in a standard browser environment.
  	    // Specifically not if we're in a web worker, or react-native.
  	    if (utils.isStandardBrowserEnv()) {
  	      // Add xsrf header
  	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
  	        cookies.read(config.xsrfCookieName) :
  	        undefined;

  	      if (xsrfValue) {
  	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
  	      }
  	    }

  	    // Add headers to the request
  	    if ('setRequestHeader' in request) {
  	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
  	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
  	          // Remove Content-Type if data is undefined
  	          delete requestHeaders[key];
  	        } else {
  	          // Otherwise add header to the request
  	          request.setRequestHeader(key, val);
  	        }
  	      });
  	    }

  	    // Add withCredentials to request if needed
  	    if (!utils.isUndefined(config.withCredentials)) {
  	      request.withCredentials = !!config.withCredentials;
  	    }

  	    // Add responseType to request if needed
  	    if (config.responseType) {
  	      try {
  	        request.responseType = config.responseType;
  	      } catch (e) {
  	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
  	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
  	        if (config.responseType !== 'json') {
  	          throw e;
  	        }
  	      }
  	    }

  	    // Handle progress if needed
  	    if (typeof config.onDownloadProgress === 'function') {
  	      request.addEventListener('progress', config.onDownloadProgress);
  	    }

  	    // Not all browsers support upload events
  	    if (typeof config.onUploadProgress === 'function' && request.upload) {
  	      request.upload.addEventListener('progress', config.onUploadProgress);
  	    }

  	    if (config.cancelToken) {
  	      // Handle cancellation
  	      config.cancelToken.promise.then(function onCanceled(cancel) {
  	        if (!request) {
  	          return;
  	        }

  	        request.abort();
  	        reject(cancel);
  	        // Clean up request
  	        request = null;
  	      });
  	    }

  	    if (!requestData) {
  	      requestData = null;
  	    }

  	    // Send the request
  	    request.send(requestData);
  	  });
  	};
  	return xhr;
  }

  var utils$4 = utils$9;
  var normalizeHeaderName = normalizeHeaderName$1;

  var DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };

  function setContentTypeIfUnset(headers, value) {
    if (!utils$4.isUndefined(headers) && utils$4.isUndefined(headers['Content-Type'])) {
      headers['Content-Type'] = value;
    }
  }

  function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') {
      // For browsers use XHR adapter
      adapter = requireXhr();
    } else if (typeof browser$1 !== 'undefined' && Object.prototype.toString.call(browser$1) === '[object process]') {
      // For node use HTTP adapter
      adapter = requireXhr();
    }
    return adapter;
  }

  var defaults$2 = {
    adapter: getDefaultAdapter(),

    transformRequest: [function transformRequest(data, headers) {
      normalizeHeaderName(headers, 'Accept');
      normalizeHeaderName(headers, 'Content-Type');
      if (utils$4.isFormData(data) ||
        utils$4.isArrayBuffer(data) ||
        utils$4.isBuffer(data) ||
        utils$4.isStream(data) ||
        utils$4.isFile(data) ||
        utils$4.isBlob(data)
      ) {
        return data;
      }
      if (utils$4.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils$4.isURLSearchParams(data)) {
        setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
        return data.toString();
      }
      if (utils$4.isObject(data)) {
        setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
        return JSON.stringify(data);
      }
      return data;
    }],

    transformResponse: [function transformResponse(data) {
      /*eslint no-param-reassign:0*/
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) { /* Ignore */ }
      }
      return data;
    }],

    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    maxContentLength: -1,
    maxBodyLength: -1,

    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    }
  };

  defaults$2.headers = {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  };

  utils$4.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
    defaults$2.headers[method] = {};
  });

  utils$4.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    defaults$2.headers[method] = utils$4.merge(DEFAULT_CONTENT_TYPE);
  });

  var defaults_1 = defaults$2;

  var utils$3 = utils$9;
  var transformData = transformData$1;
  var isCancel = requireIsCancel();
  var defaults$1 = defaults_1;

  /**
   * Throws a `Cancel` if cancellation has been requested.
   */
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
  }

  /**
   * Dispatch a request to the server using the configured adapter.
   *
   * @param {object} config The config that is to be used for the request
   * @returns {Promise} The Promise to be fulfilled
   */
  var dispatchRequest$1 = function dispatchRequest(config) {
    throwIfCancellationRequested(config);

    // Ensure headers exist
    config.headers = config.headers || {};

    // Transform request data
    config.data = transformData(
      config.data,
      config.headers,
      config.transformRequest
    );

    // Flatten headers
    config.headers = utils$3.merge(
      config.headers.common || {},
      config.headers[config.method] || {},
      config.headers
    );

    utils$3.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      function cleanHeaderConfig(method) {
        delete config.headers[method];
      }
    );

    var adapter = config.adapter || defaults$1.adapter;

    return adapter(config).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config);

      // Transform response data
      response.data = transformData(
        response.data,
        response.headers,
        config.transformResponse
      );

      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config);

        // Transform response data
        if (reason && reason.response) {
          reason.response.data = transformData(
            reason.response.data,
            reason.response.headers,
            config.transformResponse
          );
        }
      }

      return Promise.reject(reason);
    });
  };

  var utils$2 = utils$9;

  /**
   * Config-specific merge-function which creates a new config-object
   * by merging two configuration objects together.
   *
   * @param {Object} config1
   * @param {Object} config2
   * @returns {Object} New object resulting from merging config2 to config1
   */
  var mergeConfig$2 = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};

    var valueFromConfig2Keys = ['url', 'method', 'data'];
    var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
    var defaultToConfig2Keys = [
      'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
      'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
      'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
      'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
      'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
    ];
    var directMergeKeys = ['validateStatus'];

    function getMergedValue(target, source) {
      if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
        return utils$2.merge(target, source);
      } else if (utils$2.isPlainObject(source)) {
        return utils$2.merge({}, source);
      } else if (utils$2.isArray(source)) {
        return source.slice();
      }
      return source;
    }

    function mergeDeepProperties(prop) {
      if (!utils$2.isUndefined(config2[prop])) {
        config[prop] = getMergedValue(config1[prop], config2[prop]);
      } else if (!utils$2.isUndefined(config1[prop])) {
        config[prop] = getMergedValue(undefined, config1[prop]);
      }
    }

    utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
      if (!utils$2.isUndefined(config2[prop])) {
        config[prop] = getMergedValue(undefined, config2[prop]);
      }
    });

    utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

    utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
      if (!utils$2.isUndefined(config2[prop])) {
        config[prop] = getMergedValue(undefined, config2[prop]);
      } else if (!utils$2.isUndefined(config1[prop])) {
        config[prop] = getMergedValue(undefined, config1[prop]);
      }
    });

    utils$2.forEach(directMergeKeys, function merge(prop) {
      if (prop in config2) {
        config[prop] = getMergedValue(config1[prop], config2[prop]);
      } else if (prop in config1) {
        config[prop] = getMergedValue(undefined, config1[prop]);
      }
    });

    var axiosKeys = valueFromConfig2Keys
      .concat(mergeDeepPropertiesKeys)
      .concat(defaultToConfig2Keys)
      .concat(directMergeKeys);

    var otherKeys = Object
      .keys(config1)
      .concat(Object.keys(config2))
      .filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
      });

    utils$2.forEach(otherKeys, mergeDeepProperties);

    return config;
  };

  var utils$1 = utils$9;
  var buildURL = buildURL$1;
  var InterceptorManager = InterceptorManager_1;
  var dispatchRequest = dispatchRequest$1;
  var mergeConfig$1 = mergeConfig$2;

  /**
   * Create a new instance of Axios
   *
   * @param {Object} instanceConfig The default config for the instance
   */
  function Axios$1(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {Object} config The config specific for this request (merged with this.defaults)
   */
  Axios$1.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
      config = arguments[1] || {};
      config.url = arguments[0];
    } else {
      config = config || {};
    }

    config = mergeConfig$1(this.defaults, config);

    // Set config.method
    if (config.method) {
      config.method = config.method.toLowerCase();
    } else if (this.defaults.method) {
      config.method = this.defaults.method.toLowerCase();
    } else {
      config.method = 'get';
    }

    // Hook up interceptors middleware
    var chain = [dispatchRequest, undefined];
    var promise = Promise.resolve(config);

    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      chain.push(interceptor.fulfilled, interceptor.rejected);
    });

    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  };

  Axios$1.prototype.getUri = function getUri(config) {
    config = mergeConfig$1(this.defaults, config);
    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
  };

  // Provide aliases for supported request methods
  utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
    /*eslint func-names:0*/
    Axios$1.prototype[method] = function(url, config) {
      return this.request(mergeConfig$1(config || {}, {
        method: method,
        url: url,
        data: (config || {}).data
      }));
    };
  });

  utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    /*eslint func-names:0*/
    Axios$1.prototype[method] = function(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method: method,
        url: url,
        data: data
      }));
    };
  });

  var Axios_1 = Axios$1;

  var Cancel_1;
  var hasRequiredCancel;

  function requireCancel () {
  	if (hasRequiredCancel) return Cancel_1;
  	hasRequiredCancel = 1;

  	/**
  	 * A `Cancel` is an object that is thrown when an operation is canceled.
  	 *
  	 * @class
  	 * @param {string=} message The message.
  	 */
  	function Cancel(message) {
  	  this.message = message;
  	}

  	Cancel.prototype.toString = function toString() {
  	  return 'Cancel' + (this.message ? ': ' + this.message : '');
  	};

  	Cancel.prototype.__CANCEL__ = true;

  	Cancel_1 = Cancel;
  	return Cancel_1;
  }

  var CancelToken_1;
  var hasRequiredCancelToken;

  function requireCancelToken () {
  	if (hasRequiredCancelToken) return CancelToken_1;
  	hasRequiredCancelToken = 1;

  	var Cancel = requireCancel();

  	/**
  	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
  	 *
  	 * @class
  	 * @param {Function} executor The executor function.
  	 */
  	function CancelToken(executor) {
  	  if (typeof executor !== 'function') {
  	    throw new TypeError('executor must be a function.');
  	  }

  	  var resolvePromise;
  	  this.promise = new Promise(function promiseExecutor(resolve) {
  	    resolvePromise = resolve;
  	  });

  	  var token = this;
  	  executor(function cancel(message) {
  	    if (token.reason) {
  	      // Cancellation has already been requested
  	      return;
  	    }

  	    token.reason = new Cancel(message);
  	    resolvePromise(token.reason);
  	  });
  	}

  	/**
  	 * Throws a `Cancel` if cancellation has been requested.
  	 */
  	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  	  if (this.reason) {
  	    throw this.reason;
  	  }
  	};

  	/**
  	 * Returns an object that contains a new `CancelToken` and a function that, when called,
  	 * cancels the `CancelToken`.
  	 */
  	CancelToken.source = function source() {
  	  var cancel;
  	  var token = new CancelToken(function executor(c) {
  	    cancel = c;
  	  });
  	  return {
  	    token: token,
  	    cancel: cancel
  	  };
  	};

  	CancelToken_1 = CancelToken;
  	return CancelToken_1;
  }

  var spread;
  var hasRequiredSpread;

  function requireSpread () {
  	if (hasRequiredSpread) return spread;
  	hasRequiredSpread = 1;

  	/**
  	 * Syntactic sugar for invoking a function and expanding an array for arguments.
  	 *
  	 * Common use case would be to use `Function.prototype.apply`.
  	 *
  	 *  ```js
  	 *  function f(x, y, z) {}
  	 *  var args = [1, 2, 3];
  	 *  f.apply(null, args);
  	 *  ```
  	 *
  	 * With `spread` this example can be re-written.
  	 *
  	 *  ```js
  	 *  spread(function(x, y, z) {})([1, 2, 3]);
  	 *  ```
  	 *
  	 * @param {Function} callback
  	 * @returns {Function}
  	 */
  	spread = function spread(callback) {
  	  return function wrap(arr) {
  	    return callback.apply(null, arr);
  	  };
  	};
  	return spread;
  }

  var isAxiosError;
  var hasRequiredIsAxiosError;

  function requireIsAxiosError () {
  	if (hasRequiredIsAxiosError) return isAxiosError;
  	hasRequiredIsAxiosError = 1;

  	/**
  	 * Determines whether the payload is an error thrown by Axios
  	 *
  	 * @param {*} payload The value to test
  	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
  	 */
  	isAxiosError = function isAxiosError(payload) {
  	  return (typeof payload === 'object') && (payload.isAxiosError === true);
  	};
  	return isAxiosError;
  }

  var utils = utils$9;
  var bind = bind$2;
  var Axios = Axios_1;
  var mergeConfig = mergeConfig$2;
  var defaults = defaults_1;

  /**
   * Create an instance of Axios
   *
   * @param {Object} defaultConfig The default config for the instance
   * @return {Axios} A new instance of Axios
   */
  function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context);

    // Copy axios.prototype to instance
    utils.extend(instance, Axios.prototype, context);

    // Copy context to instance
    utils.extend(instance, context);

    return instance;
  }

  // Create the default instance to be exported
  var axios$2 = createInstance(defaults);

  // Expose Axios class to allow class inheritance
  axios$2.Axios = Axios;

  // Factory for creating new instances
  axios$2.create = function create(instanceConfig) {
    return createInstance(mergeConfig(axios$2.defaults, instanceConfig));
  };

  // Expose Cancel & CancelToken
  axios$2.Cancel = requireCancel();
  axios$2.CancelToken = requireCancelToken();
  axios$2.isCancel = requireIsCancel();

  // Expose all/spread
  axios$2.all = function all(promises) {
    return Promise.all(promises);
  };
  axios$2.spread = requireSpread();

  // Expose isAxiosError
  axios$2.isAxiosError = requireIsAxiosError();

  axios$3.exports = axios$2;

  // Allow use of default import syntax in TypeScript
  axios$3.exports.default = axios$2;

  var axiosExports = axios$3.exports;

  var axios = axiosExports;

  var axios$1 = /*@__PURE__*/getDefaultExportFromCjs(axios);

  function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  var normalizeShopifyCart = function normalizeShopifyCart(shopifyCart) {
    var cartInfo = {
      item_count: shopifyCart.item_count,
      items_subtotal_price: shopifyCart.items_subtotal_price,
      note: shopifyCart.note,
      total_discount: shopifyCart.total_discount,
      total_price: shopifyCart.total_price
    };
    var cartItemsObj = {};
    shopifyCart.items.forEach(function (itemObj) {
      cartItemsObj[itemObj.key] = {
        final_line_price: itemObj.final_line_price,
        id: itemObj.variant_id,
        image: itemObj.image,
        key: itemObj.key,
        options_with_values: itemObj.options_with_values,
        price: itemObj.discounted_price > 0 ? itemObj.discounted_price : itemObj.price,
        productId: itemObj.product_id,
        properties: itemObj.properties,
        quantity: itemObj.quantity,
        requires_shipping: itemObj.requires_shipping,
        selling_plan_allocation: itemObj.selling_plan_allocation,
        sku: itemObj.sku,
        tags: itemObj.tags,
        title: itemObj.product_title,
        type: itemObj.product_type,
        url: itemObj.url,
        variant: itemObj.variant_title
      };
    });
    return _objectSpread$5(_objectSpread$5({}, cartInfo), {}, {
      items: cartItemsObj
    });
  };

  var normalizeShopifyProduct = function normalizeShopifyProduct(shopifyProduct) {
    return _defineProperty$1({}, shopifyProduct.key, {
      final_line_price: shopifyProduct.price,
      id: shopifyProduct.variant_id,
      image: shopifyProduct.image,
      key: shopifyProduct.key,
      options_with_values: shopifyProduct.options_with_values,
      price: shopifyProduct.discounted_price > 0 ? shopifyProduct.discounted_price : shopifyProduct.price,
      productId: shopifyProduct.product_id,
      properties: shopifyProduct.properties,
      quantity: shopifyProduct.quantity,
      requires_shipping: shopifyProduct.requires_shipping,
      selling_plan_allocation: shopifyProduct.selling_plan_allocation,
      sku: shopifyProduct.sku,
      tags: shopifyProduct.tags,
      title: shopifyProduct.product_title,
      type: shopifyProduct.product_type,
      url: shopifyProduct.url,
      variant: shopifyProduct.variant_title
    });
  };

  function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  Vue$1.use(Vuex);
  Vue$1.config.productionTip = false; // Rebuy Integration
  // this comes after any change to cart, either add or update

  document.addEventListener('rebuy:cart.change', function (event) {
    if (event.detail && event.detail.cart && event.detail.cart.cart) {
      store.commit('initCart', normalizeShopifyCart(event.detail.cart.cart));
    } else {
      // if rebuy doesn't provide cart, just refresh the cart
      store.dispatch('refreshCart');
    }
  });
  var store = new Vuex.Store({
    state: {
      shoppingCart: {
        items: []
      },
      isFetching: false,
      isOpen: false,
      shippingThreshold: typeof window.freeShipping !== 'undefined' && window.freeShipping !== '' ? window.freeShipping.amount : null,
      discountMessage: null,
      minicartMessage: null
    },
    mutations: {
      initCart: function initCart(state, payload) {
        return state.shoppingCart = payload;
      },
      updateCartItem: function updateCartItem(state, payload) {
        var key = payload.key,
            quantity = payload.quantity;
        state.shoppingCart.items[key].quantity = quantity;

        if (quantity < 1) {
          delete state.shoppingCart.items[key];
        }

        return state;
      },
      addCartItem: function addCartItem(state, payload) {
        state.shoppingCart.items = _objectSpread$4(_objectSpread$4({}, payload), state.shoppingCart.items);
        return state;
      },
      toggleCart: function toggleCart(state, payload) {
        state.isOpen = payload;
      },
      toggleFetching: function toggleFetching(state) {
        state.isFetching = !state.isFetching;
        return state;
      },
      updateDiscount: function updateDiscount(state, payload) {
        this.state.discountMessage = payload.message;
        return state;
      },
      setMinicartMessage: function setMinicartMessage(state, payload) {
        this.state.minicartMessage = payload;
        return state;
      }
    },
    actions: {
      initCart: function initCart(_ref, payload) {
        var commit = _ref.commit;

        // patch for
        if (payload && payload.items) {
          commit('initCart', payload.items);

          if (payload.toggleCart) {
            commit('toggleCart', true);
          }

          return;
        }

        axios$1.get('/cart.js').then(function (res) {
          commit('initCart', normalizeShopifyCart(res.data));

          if (payload.toggleCart) {
            commit('toggleCart', true);
          }

          var event = new CustomEvent('cart.initCart', {
            detail: res.data
          });
          document.dispatchEvent(event);
        })["catch"](function (error) {
          return error.message;
        });
      },
      clearCart: function clearCart(_ref2) {
        var commit = _ref2.commit;
        axios$1.post('/cart/clear.js').then(function (res) {
          commit('initCart', normalizeShopifyCart(res.data));
          var event = new CustomEvent('cart.clearCart', {
            detail: res.data
          });
          document.dispatchEvent(event);
        })["catch"](function (error) {
          return error.message;
        });
      },
      updateItem: function updateItem(_ref3, payload) {
        var commit = _ref3.commit,
            state = _ref3.state;
        if (state.isFetching) return;
        commit('toggleFetching');
        var item = payload.item,
            action = payload.action;
        var key = item.key,
            quantity = item.quantity;
        var newQty = action === 'increase' ? quantity + 1 : action === 'decrease' ? quantity - 1 : action === 'clear' ? 0 : payload.$event.target.value;
        axios$1.post('/cart/change.js', {
          id: key.toString(),
          quantity: newQty.toString()
        }).then(function (response) {
          var responseQty = newQty; // Use the quantity from the response

          var updatedQty = response.data.items.find(function (cartItem) {
            return cartItem.key === item.key;
          });

          if (updatedQty) {
            responseQty = updatedQty.quantity;
          }

          commit('updateCartItem', {
            key: key,
            quantity: responseQty
          });
          commit('toggleFetching');
          var obj = response.data;
          obj.updated_item = payload.item;
          var event = new CustomEvent('cart.updateItem', {
            detail: obj
          });
          document.dispatchEvent(event);
        })["catch"](function (error) {
          var description = error.response.data.description;

          if (description.includes('is already sold out')) {
            commit('setMinicartMessage', description);
            setTimeout(function () {
              commit('setMinicartMessage', null);
            }, 5000);
          }

          commit('toggleFetching');
          return error.message;
        });
      },
      addItem: function addItem(_ref4, payload) {
        var commit = _ref4.commit,
            state = _ref4.state;
        if (state.isFetching) return;
        commit('toggleFetching');
        axios$1.post('/cart/add.js', payload, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (response) {
          commit('addCartItem', normalizeShopifyProduct(response.data));
          commit('toggleFetching');
          commit('toggleCart', true);
          document.body.classList.toggle('noscroll');
          var event = new CustomEvent('cart.addItem', {
            detail: response.data
          });
          document.dispatchEvent(event);
        })["catch"](function (error) {
          commit('toggleFetching');
          return error.message;
        });
      },
      addItems: function addItems(_ref5, payload) {
        var commit = _ref5.commit,
            state = _ref5.state;
        if (state.isFetching) return; // added to prevent race condition for cart refresh

        var completedData = [];
        var completedQueue = [];
        Shopify.queue = [];
        commit('toggleFetching');
        payload.forEach(function (item) {
          Shopify.queue.push(item);
          completedQueue.push(true);
        });
        Shopify.queue = Shopify.queue.reverse();

        Shopify.moveAlong = function () {
          if (!Shopify.queue.length) return;
          var item = Shopify.queue.shift();
          axios$1.post('/cart/add.js', item).then(function (response) {
            commit('addCartItem', normalizeShopifyProduct(response.data));
            commit('toggleFetching');
            commit('toggleCart', true);
            document.body.classList.toggle('noscroll'); // added to prevent race condition for cart refresh

            completedData.push(response.data);
            completedQueue.shift();
            Shopify.moveAlong();
          })["catch"](function (error) {
            commit('toggleFetching'); // added to prevent race condition for cart refresh

            if (completedQueue.length) {
              completedQueue.shift();
            }

            if (Shopify.queue.length) {
              Shopify.moveAlong();
            }

            return error.message;
          });
        };

        Shopify.moveAlong(); // added to prevent race condition for cart refresh

        var checkCompletion = function checkCompletion() {
          if (completedQueue.length !== 0) {
            window.setTimeout(checkCompletion, 100);
          } else {
            completedData.forEach(function (value) {
              var event = new CustomEvent('cart.addItem', {
                detail: value
              });
              document.dispatchEvent(event);
            });
          }
        };

        checkCompletion();
      },
      refreshCart: function refreshCart(_ref6) {
        var commit = _ref6.commit;
        commit('toggleFetching');
        axios$1.get('/cart.js').then(function (res) {
          commit('toggleFetching');
          commit('initCart', normalizeShopifyCart(res.data));
        })["catch"](function (error) {
          commit('toggleFetching');
          return error.message;
        });
      },
      toggleCart: function toggleCart(_ref7, payload) {
        var commit = _ref7.commit;
        commit('toggleCart', payload);
      },
      addDiscount: function addDiscount(_ref8, payload) {
        var commit = _ref8.commit,
            state = _ref8.state;

        if (!state.isFetching) {
          commit('toggleFetching');
          axios$1 // CORS error here, is this actually allowed from consumer site? request redirects base url to randco-core.myshopify.com
          .get("/admin/discount_codes/lookup.json?code=".concat(payload)).then(function () {
            commit('updateDiscount', {
              message: "Your discount (".concat(payload, ") will be applied at checkout.")
            });
            axios$1.get("/discount/".concat(payload, "?redirect=/cart")).then(function () {
              console.log('discount applied at checkout');
            })["catch"](function (err) {
              console.log(err);
            });
          })["catch"](function (err) {
            if (err) {
              console.log(err);
              commit('updateDiscount', {
                message: 'The code you entered was not valid.'
              });
            }
          });
        }
      }
    },
    getters: {
      minicartMessage: function minicartMessage(state) {
        return state.minicartMessage;
      },
      isFetching: function isFetching(state) {
        return state.isFetching;
      },
      isOpen: function isOpen(state) {
        return state.isOpen;
      },
      discountMessage: function discountMessage(state) {
        return state.discountMessage;
      },
      shoppingCart: function shoppingCart(state) {
        return state.shoppingCart;
      },
      shippingThreshold: function shippingThreshold(state) {
        return state.shippingThreshold;
      },
      cartTotal: function cartTotal(state) {
        var items = state.shoppingCart.items;
        var total = 0;

        if (items) {
          Object.keys(items).forEach(function (key) {
            total += items[key].final_line_price;
          });
        }

        return total;
      },
      cartItemCount: function cartItemCount(state) {
        var items = state.shoppingCart.items;
        var size = 0;

        if (items) {
          Object.keys(items).forEach(function (key) {
            size += items[key].quantity;
          });
        } else {
          return size;
        }

        return size;
      }
    }
  });

  function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  Vue$1.use(Vuex);
  Vue$1.config.productionTip = false;

  if (document.querySelector('[data-cart]') !== null) {
    new Vue$1({
      delimiters: ['${', '}'],
      el: '[data-cart]',
      name: 'Cart',
      store: store,
      filters: {
        toUSD: function toUSD(amount) {
          return Shopify.formatMoney(amount, '${{amount}}');
        }
      },
      components: {
        CartFreeSample: CartFreeSample,
        CartRecommended: CartRecommended
      },
      data: function data() {
        return {
          continueShoppingURL: '/collections/all',
          discount: {
            code: '',
            display: false,
            text: ''
          },
          messages: {
            message: null,
            qualifies: null
          },
          noImage: null,
          productTitles: {}
        };
      },
      computed: _objectSpread$3(_objectSpread$3({}, mapGetters(['shoppingCart', 'cartTotal', 'cartItemCount', 'isOpen', 'shippingThreshold', 'isFetching', 'discountMessage', 'minicartMessage'])), {}, {
        progressBar: function progressBar() {
          var percentage = 100 * parseFloat(this.cartTotal) / parseFloat(this.shippingThreshold);
          var width = percentage < 100 ? "".concat(percentage, "%") : '100%';
          return width;
        },
        shippingDifference: function shippingDifference() {
          if (this.shippingThreshold === null) return false;
          var threshold = (parseInt(this.shippingThreshold) / 100).toFixed(2);
          var cartTotal = (this.cartTotal / 100).toFixed(2);
          var amount = parseInt(threshold) - parseInt(cartTotal);
          return amount.toFixed(2);
        }
      }),
      methods: _objectSpread$3(_objectSpread$3({}, mapActions(['initCart', 'toggleCart', 'updateItem', 'addDiscount', 'addItem'])), {}, {
        afterPayStyles: function afterPayStyles() {
          // Shadow root
          var afterpay = this.$refs.afterpay;

          if (afterpay) {
            var root = afterpay.shadowRoot;

            if (root) {
              var styles = "\n              :host {\n                margin-block-end: 0 !important;\n                margin-block-start: 0 !important;\n              }\n\n              .afterpay-link {\n                display: block !important;\n                font-size: 0 !important;\n                height: 100% !important;\n                left: 0 !important;\n                opacity: 0 !important;\n                outline: 0 none transparent !important;\n                position: absolute !important;\n                top: 0 !important;\n                width: 100% !important;\n              }\n\n              .afterpay-logo {\n                height: 20px !important;\n                margin: 0 !important;\n                min-height: 20px !important;\n                min-width: 101px !important;\n                position: relative !important;\n                width: 101px !important;\n              }\n\n              .afterpay-logo:after {\n                background-image: url('".concat(window.afterpayLogo, "');\n                background-position: center;\n                background-repeat: no-repeat;\n                background-size: cover;\n                content: '';\n                display: block;\n                height: 100%;\n                width: 100%;\n              }\n\n              .afterpay-logo svg {\n                display: none;\n              }\n\n              .afterpay-logo-link {\n                margin: 3px 0;\n                position: relative;\n              }\n\n              .afterpay-main-text {\n                margin: 3px 0;\n                padding-right: 6px;\n              }\n\n              .afterpay-paragraph {\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-orient: horizontal;\n                -webkit-box-direction: normal;\n                -ms-flex-flow: row wrap;\n                flex-flow: row wrap;\n                font-size: 15px;\n                line-height: 1;\n                position: relative;\n              }\n            ");
              $('<style>').text(styles).appendTo(root);
            }
          }
        },
        applyDiscount: function applyDiscount() {
          var _this = this;

          var code = this.discount.code;

          if (code !== '') {
            this.discount.display = true;
            this.discount.text = code;
            api.set('discount_code', code, {
              path: '/'
            });
            window.setTimeout(function () {
              _this.$store.dispatch('initCart');
            }, 100);
          } else {
            this.discount.display = false;
            this.discount.text = '';
            api.remove('discount_code', {
              path: '/'
            });
          }
        },
        clearDiscount: function clearDiscount() {
          var _this2 = this;

          this.discount.code = '';
          this.discount.display = false;
          this.discount.text = '';
          api.remove('discount_code', {
            path: '/'
          });
          this.$store.commit('updateDiscount', {
            message: ''
          });
          window.setTimeout(function () {
            _this2.$store.dispatch('initCart');
          }, 100);
        },
        continueShopping: function continueShopping() {
          var continueShoppingURL = window.continueShoppingURL;

          if (typeof continueShoppingURL !== 'undefined' && Storage !== undefined) {
            if (continueShoppingURL) {
              sessionStorage.collection = continueShoppingURL;

              if (sessionStorage.collection) {
                this.continueShoppingURL = sessionStorage.collection;
              }
            } else if (sessionStorage.collection) {
              this.continueShoppingURL = sessionStorage.collection;
            }
          }
        },
        emptyProperties: function emptyProperties(obj) {
          if (!obj) {
            return true;
          }

          return Object.keys(obj).length === 0 && obj.constructor === Object;
        },
        events: function events() {
          var _this3 = this;

          var announcementClose = document.querySelector('[data-announcement-close]');

          if (announcementClose) {
            announcementClose.addEventListener('closed', function () {
              _this3.stickySummary();
            });
          }

          window.addEventListener('load', function () {
            _this3.stickySummary();
          });
          window.addEventListener('resize', function () {
            _this3.stickySummary();
          });
        },
        fetchDiscount: function fetchDiscount() {
          var code = api.get('discount_code');

          if (code) {
            this.discount.code = code;
            this.discount.display = true;
            this.discount.text = code;
          }
        },
        imgURL: imgURL,
        itemUpdated: function itemUpdated() {
          this.updated = true;
        },
        message: function message() {
          this.messages.message = window.messages.message;
          this.messages.qualifies = window.messages.qualifies;
        },
        messageFormat: function messageFormat(string, value) {
          return string.replace('<$X>', this.$options.filters.toUSD(value));
        },
        stickySummary: debounce$1(function () {
          var header = $('[data-header]');
          var summary = $('[data-cart-summary]');

          if ($('html').hasClass('csspositionsticky')) {
            if (window.innerWidth >= 1024) {
              summary.css('top', "".concat(header.height(), "px"));
            } else {
              summary.css('top', '');
            }
          }
        }, 250),
        updateTitles: function updateTitles() {
          var _this4 = this;

          var items = this.shoppingCart.items;
          if (!items || this.emptyProperties(items)) return;
          Object.keys(items).forEach(function (key) {
            var url = items[key].url.split('?')[0];

            if (!_this4.productTitles.hasOwnProperty(items[key].productId)) {
              $.get("".concat(url, "?view=meta.json"), function (data) {
                data = JSON.parse(data);

                _this4.$set(_this4.productTitles, items[key].productId, {
                  title: data.metafields.product_short_name || data.product.title,
                  subTitle: data.metafields.product_subtitle || ''
                });
              });
            }
          });
        }
      }),
      created: function created() {
        if (typeof window.messages !== 'undefined') {
          this.message();
        }

        this.fetchDiscount();
        this.noImage = window.cart_images.noImage;
      },
      mounted: function mounted() {
        this.events();
        this.continueShopping();
        this.store.dispatch('initCart', {
          items: window.Cart.items
        });
      },
      updated: function updated() {
        if (window.lazy) {
          window.lazy.update();
        }
      },
      watch: {
        cartTotal: function cartTotal() {
          var _this5 = this;

          this.$nextTick(function () {
            _this5.afterPayStyles();
          });
        },
        shoppingCart: function shoppingCart() {
          var _this6 = this;

          this.$nextTick(function () {
            _this6.updateTitles();
          });
        }
      }
    });
  }

  function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  Vue$1.use(Vuex);
  Vue$1.config.devtools = true;
  var FreeSample = Vue$1.component('free-sample', {
    delimiters: ['%{', '}'],
    template: "\n    <aside\n      class=\"minicart-sample\"\n      v-if=\"!sampleInCart\"\n    >\n      <header\n        v-if=\"title\"\n        class=\"minicart-sample-header\"\n      >\n        <h2 class=\"minicart-sample-header__title\">%{ title }</h2>\n      </header>\n\n      <swiper\n        class=\"minicart-sample__items\"\n        ref=\"swiper\"\n        :options=\"swiperOption\"\n        v-if=\"items.length\"\n      >\n        <swiper-slide v-for=\"(item, index) in items\" :key=\"item.id\" class=\"minicart-sample__item\">\n          <div class=\"minicart-sample__image-holder\">\n            <img\n              class=\"minicart-sample__image vue-lazy\"\n              :data-src=\"imgURL(item.images.length ? item.images[0].src : null, 'x258', false) || noImage\"\n              :alt=\"item.title + ' Product Image'\"\n            />\n          </div>\n\n          <p class=\"minicart-sample__name\">%{ item.title }</p>\n\n          <button\n            type=\"button\"\n            class=\"minicart-sample__button\"\n            :disabled=\"!item.variants[0].available || sampleInCartByVariant(item.variants[0].id)\"\n            v-on:click=\"addToCart(item.variants[0].id)\"\n            :tabindex=\"isOpen ? 0 : -1\">\n            <span v-if=\"!item.variants[0].available\">Sold Out</span>\n            <span v-else-if=\"sampleInCartByVariant(item.variants[0].id)\">Added</span>\n            <span v-else>Add</span>\n          </button>\n        </swiper-slide>\n      </swiper>\n    </aside>\n  ",
    components: {
      swiper: vueAwesomeSwiperExports.swiper,
      swiperSlide: vueAwesomeSwiperExports.swiperSlide
    },
    data: function data() {
      return {
        maxSamples: 1,
        items: [],
        noImage: null,
        sampleInCart: false,
        swiperOption: {
          freeMode: true,
          loop: false,
          roundLengths: true,
          slidesPerView: 'auto',
          spaceBetween: 18
        },
        title: null
      };
    },
    methods: _objectSpread$2(_objectSpread$2({}, mapActions(['addItem'])), {}, {
      addToCart: function addToCart(variantId) {
        this.addItem({
          id: variantId,
          quantity: 1
        });
      },
      fetchCollection: function fetchCollection() {
        var _this = this;

        if (window.freeSample.collection) {
          this.title = window.freeSample.title;
          this.maxSamples = window.freeSample.max || 1;
          $.getJSON("/collections/".concat(window.freeSample.collection, "/products.json"), function (response) {
            if (response.products.length) {
              _this.items = response.products;
            }
          });
        }
      },
      imgURL: imgURL,
      sampleInCartCheck: function sampleInCartCheck() {
        var items = this.shoppingCartItems;
        var samples = Object.values(items).filter(function (item) {
          return item.type.toLowerCase() === 'sample';
        });
        this.sampleInCart = samples.length >= this.maxSamples;
      },
      sampleInCartByVariant: function sampleInCartByVariant(variantId) {
        var items = this.shoppingCartItems;
        var samples = Object.values(items).filter(function (item) {
          return item.id === variantId;
        });
        return samples.length > 0;
      }
    }),
    computed: _objectSpread$2(_objectSpread$2({}, mapGetters(['shoppingCart', 'cartItemCount', 'isOpen'])), {}, {
      shoppingCartItems: function shoppingCartItems() {
        return this.shoppingCart.items;
      }
    }),
    watch: {
      cartItemCount: function cartItemCount() {
        this.sampleInCartCheck();
      }
    },
    created: function created() {
      if (window.freeSample.collection) {
        this.fetchCollection();
      }

      this.noImage = window.minicart.noImage;
    },
    mounted: function mounted() {
      this.sampleInCartCheck();
    },
    updated: function updated() {
      if (window.lazy) {
        window.lazy.update();
      }
    }
  });

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  Vue$1.use(Vuex);
  Vue$1.config.devtools = true;
  var MinicartRecommended = Vue$1.component('minicart-recommended', {
    delimiters: ['%{', '}'],
    filters: {
      toUSD: function toUSD(amount) {
        return Shopify.formatMoney(amount, '${{amount}}');
      }
    },
    template: "\n    <aside\n      class=\"minicart-recommended\"\n      v-if=\"ready\"\n    >\n      <header\n        v-if=\"title\"\n        class=\"minicart-recommended-header\"\n      >\n        <h2 class=\"minicart-recommended-header__title\">%{ title }</h2>\n      </header>\n\n      <swiper\n        class=\"minicart-recommended__items\"\n        ref=\"swiper\"\n        :options=\"swiperOption\"\n        v-if=\"items.length\"\n      >\n        <swiper-slide v-for=\"(item, index) in items\" :key=\"item.id\" class=\"minicart-recommended__item\">\n          <div class=\"minicart-recommended__columns\">\n            <div class=\"minicart-recommended__column minicart-recommended__column--image\">\n              <a\n                :href=\"'/products/' + item.handle\" class=\"minicart-recommended__image-holder\"\n                :tabindex=\"isOpen ? 0 : -1\"\n              >\n                <img\n                  class=\"minicart-recommended__image vue-lazy\"\n                  :data-src=\"imgURL(item.featured_image, 'x148', false)\"\n                  :alt=\"item.title + ' Product Image'\"\n                />\n              </a>\n            </div>\n\n            <div class=\"minicart-recommended__column minicart-recommended__column--content\">\n              <a\n                v-if=\"item.product_title\"\n                :href=\"'/products/' + item.handle\"\n                class=\"minicart-recommended__name\"\n                v-html=\"item.product_title\"\n                :tabindex=\"isOpen ? 0 : -1\"\n              ></a>\n              <a\n                v-else\n                :href=\"'/products/' + item.handle\"\n                class=\"minicart-recommended__name\"\n                :tabindex=\"isOpen ? 0 : -1\"\n              ><h3>%{ item.title }</h3></a>\n\n              <div class=\"minicart-recommended__price\">%{ item.price | toUSD }</div>\n\n              <button\n                type=\"button\"\n                class=\"minicart-recommended__button\"\n                :disabled=\"!item.variants[0].available\"\n                v-on:click=\"addToCart(item.variants[0].id)\"\n                :tabindex=\"isOpen ? 0 : -1\"\n              >Add to Bag</button>\n            </div>\n          </div>\n        </swiper-slide>\n      </swiper>\n    </aside>\n  ",
    components: {
      swiper: vueAwesomeSwiperExports.swiper,
      swiperSlide: vueAwesomeSwiperExports.swiperSlide
    },
    data: function data() {
      return {
        ready: false,
        items: [],
        swiperOption: {
          freeMode: false,
          loop: false,
          roundLengths: true,
          slidesPerView: 1,
          spaceBetween: 0
        },
        title: null
      };
    },
    computed: _objectSpread$1({}, mapGetters(['shoppingCart', 'isOpen'])),
    methods: _objectSpread$1(_objectSpread$1({}, mapActions(['addItem'])), {}, {
      addToCart: function addToCart(variantId) {
        this.addItem({
          id: variantId,
          quantity: 1
        });
      },
      checkReady: function checkReady() {
        var items = this.items;
        var index = Object.keys(items).findIndex(function (key) {
          return items[key] === null;
        });
        this.ready = index < 0;
      },
      fetchCollection: function fetchCollection() {
        var _this = this;

        if (window.recommended.collection) {
          this.title = window.recommended.title;
          if (!this.shoppingCart.items) return false;
          var cartProductIds = Object.values(this.shoppingCart.items).map(function (item) {
            return item.productId;
          });
          var recommendedProducts = window.recommended.collection.filter(function (item) {
            return !cartProductIds.includes(item.id);
          });
          recommendedProducts.forEach(function (product, i) {
            _this.items.push(null);

            var data = window.product_metafields[product.handle] || {};
            var title = data.accentuate.product_short_name === undefined ? null : "<h3>".concat(data.accentuate.product_short_name, "</h3>");
            var subtitle = data.accentuate.product_subtitle === undefined ? null : data.accentuate.product_subtitle;

            if (subtitle) {
              title += subtitle;
            }

            var oldTitle = window.products[product.handle].title;
            window.products[product.handle].title = title;

            _this.$set(_this.items, i, window.products[product.handle]);

            window.products[product.handle].title = oldTitle;

            _this.$nextTick(function () {
              _this.checkReady();
            });
          });
        }
      },
      imgURL: imgURL
    }),
    created: function created() {
      if (window.recommended.collection) {
        this.fetchCollection();
      }
    },
    updated: function updated() {
      if (window.lazy) {
        window.lazy.update();
      }
    }
  });

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  Vue$1.use(Vuex);
  Vue$1.config.productionTip = false;
  Vue$1.config.ignoredElements = ['additional-checkout-buttons'];

  if (document.querySelector('[data-minicart]') !== null) {
    var AdditionalCheckoutButtons = Vue$1.component('additional-checkout-buttons', {
      template: "\n\t\t\t<div\n\t\t\t\tclass=\"additional-checkout-buttons additional-checkout-buttons--vertical\"\n\t\t\t\tv-if=\"content\"\n\t\t\t\tv-html=\"content\"\n\t\t\t></div>\n\t\t",
      data: function data() {
        return {
          content: null
        };
      },
      methods: {
        displayButtons: function displayButtons() {
          if (typeof window.additionalCheckoutButtons !== 'undefined') {
            if (window.additionalCheckoutButtons.enable) {
              this.content = window.additionalCheckoutButtons.content;
            }
          }
        }
      },
      created: function created() {
        this.displayButtons();
      }
    });
    var VueMinicart = new Vue$1({
      delimiters: ['${', '}'],
      el: '[data-minicart]',
      name: 'Minicart',
      store: store,
      filters: {
        toUSD: function toUSD(amount) {
          return Shopify.formatMoney(amount, '${{amount}}');
        }
      },
      components: {
        AdditionalCheckoutButtons: AdditionalCheckoutButtons,
        FreeSample: FreeSample,
        MinicartRecommended: MinicartRecommended
      },
      data: function data() {
        return {
          checkoutURL: '/checkout',
          continueShoppingURL: '/collections/all',
          messages: {
            message: null,
            qualifies: null
          },
          noImage: null,
          productTitles: {},
          discount: {
            code: '',
            display: false,
            text: ''
          }
        };
      },
      computed: _objectSpread(_objectSpread({}, mapGetters(['shoppingCart', 'cartTotal', 'cartItemCount', 'isOpen', 'shippingThreshold', 'isFetching', 'discountMessage', 'minicartMessage', 'addDiscount'])), {}, {
        getCheckoutUrl: function getCheckoutUrl() {
          if (this.discount.code !== '') {
            return this.checkoutURL + '?discount=' + this.discount.code.toString().trim();
          }

          return this.checkoutURL;
        },
        progressBar: function progressBar() {
          var percentage = 100 * parseFloat(this.cartTotal) / parseFloat(this.shippingThreshold);
          var width = percentage < 100 ? "".concat(percentage, "%") : '100%';
          return width;
        },
        shippingDifference: function shippingDifference() {
          if (this.shippingThreshold === null) return false;
          var threshold = (parseInt(this.shippingThreshold) / 100).toFixed(2);
          var cartTotal = (this.cartTotal / 100).toFixed(2);
          var amount = parseInt(threshold) - parseInt(cartTotal);
          return amount.toFixed(2);
        }
      }),
      methods: _objectSpread(_objectSpread({}, mapActions(['initCart', 'toggleCart', 'updateItem', 'addDiscount', 'addItem'])), {}, {
        applyDiscount: function applyDiscount() {
          var _this = this;

          var code = this.discount.code;

          if (code !== '') {
            this.discount.display = true;
            this.discount.text = code;
            api.set('discount_code', code, {
              path: '/'
            });
            window.setTimeout(function () {
              _this.$store.dispatch('initCart');
            }, 100);
            this.$store.commit('updateDiscount', {
              message: "Your discount (".concat(code, ") will be applied at checkout.")
            });
          } else {
            this.discount.display = false;
            this.discount.text = '';
            api.remove('discount_code', {
              path: '/'
            });
          }
        },
        clearDiscount: function clearDiscount() {
          var _this2 = this;

          this.discount.code = '';
          this.discount.display = false;
          this.discount.text = '';
          api.remove('discount_code', {
            path: '/'
          });
          this.$store.commit('updateDiscount', {
            message: ''
          });
          window.setTimeout(function () {
            _this2.$store.dispatch('initCart');
          }, 100);
        },
        clearSamplesOnEmptyCart: function clearSamplesOnEmptyCart() {
          if (this.shoppingCart && this.shoppingCart.items) {
            var cartItems = Object.values(this.shoppingCart.items || {});
            var items = cartItems.filter(function (x) {
              return x.type.toLowerCase() !== 'sample';
            });
            var samples = cartItems.filter(function (x) {
              return x.type.toLowerCase() === 'sample';
            });

            if (items.length === 0 && samples.length > 0) {
              this.$store.dispatch('clearCart');
            }
          }
        },
        afterPayStyles: function afterPayStyles() {
          // Shadow root
          var afterpay = this.$refs.afterpay;

          if (afterpay) {
            var root = afterpay.shadowRoot;

            if (root) {
              var styles = "\n              :host {\n                margin-block-end: 0 !important;\n                margin-block-start: 0 !important;\n              }\n\n              .afterpay-link {\n                display: block !important;\n                font-size: 0 !important;\n                height: 100% !important;\n                left: 0 !important;\n                opacity: 0 !important;\n                outline: 0 none transparent !important;\n                position: absolute !important;\n                top: 0 !important;\n                width: 100% !important;\n              }\n\n              .afterpay-logo {\n                height: 20px !important;\n                margin: 0 !important;\n                min-height: 20px !important;\n                min-width: 101px !important;\n                position: relative !important;\n                width: 101px !important;\n              }\n\n              .afterpay-logo:after {\n                background-image: url('".concat(window.afterpayLogo, "');\n                background-position: center;\n                background-repeat: no-repeat;\n                background-size: cover;\n                content: '';\n                display: block;\n                height: 100%;\n                width: 100%;\n              }\n\n              .afterpay-logo svg {\n                display: none;\n              }\n\n              .afterpay-logo-link {\n                margin: 3px 0;\n                position: relative;\n              }\n\n              .afterpay-main-text {\n                margin: 3px 0;\n                padding-right: 6px;\n              }\n\n              .afterpay-paragraph {\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-orient: horizontal;\n                -webkit-box-direction: normal;\n                -ms-flex-flow: row wrap;\n                flex-flow: row wrap;\n                font-size: 15px;\n                line-height: 1;\n                position: relative;\n              }\n            ");
              $('<style>').text(styles).appendTo(root);
            }
          }
        },
        continueShopping: function continueShopping() {
          var continueShoppingURL = window.continueShoppingURL;

          if (typeof continueShoppingURL !== 'undefined' && Storage !== undefined) {
            if (continueShoppingURL) {
              sessionStorage.collection = continueShoppingURL;

              if (sessionStorage.collection) {
                this.continueShoppingURL = sessionStorage.collection;
              }
            } else if (sessionStorage.collection) {
              this.continueShoppingURL = sessionStorage.collection;
            }
          }
        },
        emptyProperties: function emptyProperties(obj) {
          if (!obj) {
            return true;
          }

          return Object.keys(obj).length === 0 && obj.constructor === Object;
        },
        imgURL: imgURL,
        itemUpdated: function itemUpdated() {
          this.updated = true;
        },
        message: function message() {
          this.messages.message = window.messages.message;
          this.messages.qualifies = window.messages.qualifies;
        },
        messageFormat: function messageFormat(string, value) {
          return string.replace('<$X>', this.$options.filters.toUSD(value));
        },
        updateTitles: function updateTitles() {
          var _this3 = this;

          var items = this.shoppingCart.items;
          if (!items || this.emptyProperties(items)) return;
          Object.keys(items).forEach(function (key) {
            if (key === undefined || key === 'undefined') return;
            var url = items[key].url.split('?')[0];

            if (!_this3.productTitles.hasOwnProperty(items[key].productId)) {
              var data = window.product_metafields[url.split('/')[2]] || {};

              _this3.$set(_this3.productTitles, items[key].productId, {
                title: data.accentuate.product_short_name || window.products[url.split('/')[2]].title,
                subTitle: data.accentuate.product_subtitle || ''
              });
            }
          });
        }
      }),
      created: function created() {
        if (typeof window.messages !== 'undefined') {
          this.message();
        }

        this.noImage = window.minicart.noImage;
      },
      mounted: function mounted() {
        var _this4 = this;

        this.continueShopping();
        this.initCart();
        $(document).on('keyup', function (e) {
          if (e.key === 'Escape') {
            _this4.toggleCart();
          }
        });
      },
      updated: function updated() {
        if (window.lazy) {
          window.lazy.update();
        }
      },
      watch: {
        cartTotal: function cartTotal() {
          var _this5 = this;

          this.$nextTick(function () {
            _this5.afterPayStyles();

            _this5.clearSamplesOnEmptyCart();
          });
        },
        cartItemCount: function cartItemCount() {
          var _this6 = this;

          this.$nextTick(function () {
            _this6.updateTitles();
          });
        },
        isOpen: function isOpen(value) {
          var _this7 = this;

          this.$nextTick(function () {
            var button = _this7.$refs["continue"];
            var close = _this7.$refs.close;
            var main = document.querySelector('main');

            if (value) {
              _this7.activeElement = document.activeElement;
              main.setAttribute('aria-hidden', 'true');
              document.body.classList.add('minicart-active');

              if (_this7.cartItemCount > 0 && button) {
                button.focus();
              } else if (close) {
                close.focus();
              }
            } else {
              main.setAttribute('aria-hidden', 'false');

              if (_this7.activeElement) {
                _this7.activeElement.focus();

                _this7.activeElement = null;
              }

              if (document.body.classList.contains('minicart-active')) {
                document.body.classList.remove('minicart-active');
              }
            }
          });
        }
      }
    });
    window.VueMinicart = VueMinicart;
  }

  Vue$3.config.productionTip = false;

})();
